/**
 * Generated
 * Do not edit manually.
 * chat-back-end
 * OpenAPI spec version: 7.3.0
 */
import { useMutation, useQuery } from 'react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import type {
  AgentItem,
  DeleteActivityNotesNotesActivityNoteId200,
  DeleteAgentsEntityIdNotesPanel200,
  DeleteAgentsUserId200,
  DeleteAgentsUserIdExternalCredentialsExternalSystemCode200,
  DeleteAttachmentTypesAttachmentTypeId200,
  DeleteCallsCallId200,
  DeleteCallsCallOutcomesCallOutcomeId200,
  DeleteCallsCallTypesCallTypeId200,
  DeleteCandidatesCandidateIdAttachmentsAttachmentId200,
  DeleteCandidatesCandidateIdEducationEducationId200,
  DeleteCandidatesCandidateIdInterimWorkHistoryInterimWorkHistoryId200,
  DeleteCandidatesCandidateIdLanguagesCandidateLanguageId200,
  DeleteCandidatesCandidateIdResumesResumeId200,
  DeleteCandidatesCandidateIdWorkHistoryWorkHistoryId200,
  DeleteCandidatesEntityIdNotesPanel200,
  DeleteCandidatesEntityIdNotesPdf200,
  DeleteCandidatesId200,
  DeleteCandidatesListsEntityListId200,
  DeleteCompaniesCompanyId200,
  DeleteCompaniesEntityIdNotesPanel200,
  DeleteCompaniesListsEntityListId200,
  DeleteContactsEntityIdNotesPanel200,
  DeleteContactsId200,
  DeleteContactsListsEntityListId200,
  DeleteEmailsTemplatesEmailTemplateId200,
  DeleteEntityGroupsEntityGroupId200,
  DeleteEvaBotCampaignsEvaBotCampaignId200,
  DeleteEvaSkillsCodeToneOfVoiceIntent200,
  DeleteImagesImageId200,
  DeleteInterviewSchedulingId200,
  DeleteJobsEntityIdNotesPanel200,
  DeleteJobsJobId200,
  DeleteJobsJobIdAttachmentsAttachmentId200,
  DeleteJobsJobIdLanguagesJobRequiredLanguageId200,
  DeleteJobsJobIdMatchFiltersJobFilterId200,
  DeleteJobsListsEntityListId200,
  DeleteMyCandidateProfileAttachmentsAttachmentId200,
  DeleteMyCandidateProfileEducationEducationId200,
  DeleteMyCandidateProfileLanguagesCandidateLanguageId200,
  DeleteMyCandidateProfileResumesResumeId200,
  DeleteMyCandidateProfileWorkHistoryWorkHistoryId200,
  DeleteMyNylas200,
  DeletePipelinesListsEntityListId200,
  DeletePipelinesPipelineId200,
  DeleteStopWordsStopWordId200,
  DeleteTagsTagId200,
  EvaBotCampaign,
  GetAgents200,
  GetAgentsCustomFieldsModel200,
  GetAgentsEditOptions200,
  GetAgentsEntityIdCustomFields200,
  GetAgentsParams,
  GetAgentsSearch200,
  GetAgentsSearchParams,
  GetAgentsUserIdTags200,
  GetAttachmentTypes200,
  GetCallsAgentCalls200,
  GetCallsAgentsOnline200,
  GetCallsCallOutcomes200,
  GetCallsCallTypes200,
  GetCandidatesCandidateId200,
  GetCandidatesCandidateIdResumesResumeIdParse200,
  GetCandidatesCandidateIdShareableProfile200,
  GetCandidatesCatererId200,
  GetCandidatesCustomFieldsModel200,
  GetCandidatesCvLibraryId200,
  GetCandidatesEMedCareersId200,
  GetCandidatesEditOptions200,
  GetCandidatesEntityIdCustomFields200,
  GetCandidatesFilterOptions200,
  GetCandidatesId200,
  GetCandidatesIdGdprArchive200,
  GetCandidatesIdShareableProfile200,
  GetCandidatesJobsiteId200,
  GetCandidatesLists200,
  GetCandidatesListsEntityListId200,
  GetCandidatesListsEntityListIdCandidates200,
  GetCandidatesReedId200,
  GetCandidatesSearchAddToJob200,
  GetCandidatesSearchAddToJobParams,
  GetCandidatesTotaljobsGroupId200,
  GetCandidatesTotaljobsId200,
  GetCandidatesUserIdTags200,
  GetCbeSettings200,
  GetCbeSettingsConstants200,
  GetCbeSettingsCvPdf200,
  GetCbeSettingsCvPdfRandomCandidate200,
  GetCbeSettingsMatchSubscriptions200,
  GetCbeSettingsPublicJobBodyTemplate200,
  GetCbeSettingsQuotas200,
  GetCbeSettingsQuotasEditModel200,
  GetCbeSettingsTermsAndConditions200,
  GetChatsFilterOptions200,
  GetChatsId200,
  GetChatsIdMessages200,
  GetChatsSearch200,
  GetChatsUnreadCounters200,
  GetCompanies200,
  GetCompaniesCompanyId200,
  GetCompaniesCustomFieldsModel200,
  GetCompaniesEditOptions200,
  GetCompaniesEntityIdCustomFields200,
  GetCompaniesFilterOptions200,
  GetCompaniesLists200,
  GetCompaniesListsEntityListId200,
  GetCompaniesListsEntityListIdCompanies200,
  GetContacts200,
  GetContactsCustomFieldsModel200,
  GetContactsEditOptions200,
  GetContactsEntityIdCustomFields200,
  GetContactsFilterOptions200,
  GetContactsId200,
  GetContactsLists200,
  GetContactsListsEntityListId200,
  GetContactsListsEntityListIdContacts200,
  GetContactsUserIdTags200,
  GetEmailsReceivedReceivedEmailId200,
  GetEmailsReceivedReceivedEmailIdAttachmentsAttachmentId200,
  GetEmailsSentSentEmailId200,
  GetEmailsSentSentEmailIdAttachmentsAttachmentId200,
  GetEmailsTags200,
  GetEmailsTemplatesEmailTemplateId200,
  GetEmploymentTypes200,
  GetEntityGroups200,
  GetEntityLists200,
  GetEntityListsParams,
  GetEvaBotCampaigns200,
  GetEvaBotCampaignsEditOptions200,
  GetEvaBotCampaignsEvaBotCampaignId200,
  GetEvaBotCampaignsEvaBotCampaignIdListCandidates200,
  GetEvaBotCampaignsEvaBotCampaignIdListCandidatesParams,
  GetEvaBotCampaignsEvaBotCampaignIdVisualisation200,
  GetEvaBotCampaignsEvaBotCampaignIdVisualisations200,
  GetEvaBotCampaignsParams,
  GetEvaOnboarding200,
  GetEvaOnboardingEditOptions200,
  GetEvaSkills200,
  GetEvaSkillsCode200,
  GetEvaVisualisations200,
  GetEvaVisualisationsVisualisationId200,
  GetFacebookWebhook200,
  GetIntegrationsLastUnrecognised200,
  GetInterviewSchedulingCompanies200,
  GetInterviewSchedulingContactId200,
  GetJobs200,
  GetJobsCustomFieldsModel200,
  GetJobsEditOptions200,
  GetJobsEntityIdCustomFields200,
  GetJobsFeed200,
  GetJobsFilterOptions200,
  GetJobsJobId200,
  GetJobsJobIdImages200,
  GetJobsJobIdMatchCandidatesCatererDefaultFilter200,
  GetJobsJobIdMatchCandidatesCvLibraryDefaultFilter200,
  GetJobsJobIdMatchCandidatesDefaultFilter200,
  GetJobsJobIdMatchCandidatesEMedCareersDefaultFilter200,
  GetJobsJobIdMatchCandidatesJobsiteDefaultFilter200,
  GetJobsJobIdMatchCandidatesMatchGptDefaultFilter200,
  GetJobsJobIdMatchCandidatesMatchGptFilterOptions200,
  GetJobsJobIdMatchCandidatesReedDefaultFilter200,
  GetJobsJobIdMatchCandidatesTotaljobsDefaultFilter200,
  GetJobsJobIdMatchCandidatesTotaljobsGroupDefaultFilter200,
  GetJobsJobIdMatchPipelinesEditOptions200,
  GetJobsJobIdTags200,
  GetJobsLists200,
  GetJobsListsEntityListId200,
  GetJobsListsEntityListIdJobs200,
  GetJobsMatchCandidatesCatererFilterOptions200,
  GetJobsMatchCandidatesCvLibraryFilterOptions200,
  GetJobsMatchCandidatesEMedCareersFilterOptions200,
  GetJobsMatchCandidatesJobsiteFilterOptions200,
  GetJobsMatchCandidatesReedFilterOptions200,
  GetJobsMatchCandidatesTotaljobsFilterOptions200,
  GetJobsMatchCandidatesTotaljobsGroupFilterOptions200,
  GetJobsParams,
  GetJobsPipelinesFilterOptions200,
  GetJobsScoresCandidate200,
  GetMyAgentProfile200,
  GetMyCandidateJobsJobId200,
  GetMyCandidateJobsWorkflows200,
  GetMyCandidateProfile200,
  GetMyCandidateProfileCustomFields200,
  GetMyCandidateProfileCustomFieldsModel200,
  GetMyCandidateProfileEditOptions200,
  GetMyCandidateProfileResumesResumeIdParse200,
  GetMyContactProfile200,
  GetMyGdpr200,
  GetMyPipelines200,
  GetMyReqUser200,
  GetMyWebchats200,
  GetMyWebchatsMessages200,
  GetMyWebchatsRead200,
  GetNotifications200,
  GetNotificationsCounters200,
  GetNylasOauth200,
  GetNylasOauthCallback200,
  GetNylasWebhookAccountExpire200,
  GetNylasWebhookMessageCreated200,
  GetOmnichats200,
  GetOmnichatsConversationId200,
  GetOmnichatsConversationIdMessages200,
  GetOmnichatsUsersCandidateUserId200,
  GetOmnichatsUsersContactUserId200,
  GetPhonesFormatPhone200,
  GetPipelinesCustomFieldsModel200,
  GetPipelinesEntityIdCustomFields200,
  GetPipelinesLists200,
  GetPipelinesListsEntityListId200,
  GetPipelinesListsEntityListIdPipelines200,
  GetPipelinesSettingsMy200,
  GetPublicJobsCodePipelinesEditOptions200,
  GetPublicJobsMyCode200,
  GetRecognitionIntents200,
  GetSettings200,
  GetStopWords200,
  GetStopWordsStopWordId200,
  GetTags200,
  GetTagsParams,
  GetUtilsClearAuthInformationUserId200,
  GetUtilsElasticIndexesStatus200,
  GetUtilsElasticTasks200,
  GetV2NylasOauth200,
  GetV2NylasOauthExchange200,
  GetV2NylasWebhookGrantWebhook200,
  GetV2NylasWebhookMessageTrackingWebhook200,
  GetV2NylasWebhookMessageWebhook200,
  GetWebchatsMessages200,
  GetWebhooksLastUnrecognised200,
  GetZipRecruiterJobsFeed200,
  Notification,
  Pipeline,
  Placement,
  PostActivityLogActivityTypeId200,
  PostActivityLogActivityTypeIdBody,
  PostActivityNotesNotes200,
  PostActivityNotesNotesBody,
  PostActivityNotesNotesSearch200,
  PostActivityNotesNotesSearchBody,
  PostActivityNotesOmnichatOmnichatId200,
  PostActivityNotesOmnichatOmnichatIdBody,
  PostAgentsBody,
  PostAgentsCustomFieldsValidate200,
  PostAgentsCustomFieldsValidateBody,
  PostAgentsSearchBody,
  PostAgentsUserIdChangeVisibility200,
  PostAgentsUserIdChangeVisibilityBody,
  PostAgentsUserIdDeactivate200,
  PostAgentsUserIdDeactivateBody,
  PostAgentsUserIdExternalCredentialsExternalSystemCode200,
  PostAgentsUserIdExternalCredentialsExternalSystemCodeBody,
  PostAgentsUserIdReactivate200,
  PostAgentsUserIdReactivateBody,
  PostAgentsUserIdResendInvite200,
  PostAgentsUserIdResendInviteBody,
  PostAgentsUserIdResetPassword200,
  PostAgentsUserIdResetPasswordBody,
  PostAttachmentTypes200,
  PostAttachmentTypesAttachmentTypeIdDisable200,
  PostAttachmentTypesAttachmentTypeIdDisableBody,
  PostAttachmentTypesAttachmentTypeIdEnable200,
  PostAttachmentTypesAttachmentTypeIdEnableBody,
  PostAttachmentTypesAttachmentTypeIdUserGroups200,
  PostAttachmentTypesAttachmentTypeIdUserGroupsBody,
  PostAttachmentTypesBody,
  PostCalls200,
  PostCallsBody,
  PostCallsCallIdLink200,
  PostCallsCallIdLinkBody,
  PostCallsCallOutcomes200,
  PostCallsCallOutcomesBody,
  PostCallsCallTypes200,
  PostCallsCallTypesBody,
  PostCallsLookup200,
  PostCallsLookupBody,
  PostCandidates200,
  PostCandidatesBody,
  PostCandidatesCandidateIdAttachments200,
  PostCandidatesCandidateIdAttachmentsAttachmentIdSign200,
  PostCandidatesCandidateIdAvatar200,
  PostCandidatesCandidateIdChatbotPause200,
  PostCandidatesCandidateIdChatbotResume200,
  PostCandidatesCandidateIdEducation200,
  PostCandidatesCandidateIdInterimWorkHistory200,
  PostCandidatesCandidateIdLanguages200,
  PostCandidatesCandidateIdResumes200,
  PostCandidatesCandidateIdResumesResumeIdSign200,
  PostCandidatesCandidateIdValidate200,
  PostCandidatesCandidateIdWorkHistory200,
  PostCandidatesCatererIdImport200,
  PostCandidatesCatererIdImportBody,
  PostCandidatesCustomFieldsValidate200,
  PostCandidatesCustomFieldsValidateBody,
  PostCandidatesCvLibraryIdImport200,
  PostCandidatesEMedCareersIdImport200,
  PostCandidatesEntityIdLists200,
  PostCandidatesEntityIdListsBody,
  PostCandidatesIdForget200,
  PostCandidatesIdForgetReactivate200,
  PostCandidatesIdInterimAvailability200,
  PostCandidatesIdStar200,
  PostCandidatesIdUnstar200,
  PostCandidatesImportCv200,
  PostCandidatesImportCvBody,
  PostCandidatesJobsiteIdImport200,
  PostCandidatesJobsiteIdImportBody,
  PostCandidatesLists200,
  PostCandidatesListsBody,
  PostCandidatesListsEntityListIdAdd200,
  PostCandidatesListsEntityListIdAddBody,
  PostCandidatesListsEntityListIdCreateNewEntity200,
  PostCandidatesListsEntityListIdCreateNewEntityBody,
  PostCandidatesListsEntityListIdRemove200,
  PostCandidatesListsEntityListIdRemoveBody,
  PostCandidatesListsEntityListIdReorder200,
  PostCandidatesListsEntityListIdReorderBody,
  PostCandidatesListsEntityListIdUserGroups200,
  PostCandidatesListsEntityListIdUserGroupsBody,
  PostCandidatesPdfResume200,
  PostCandidatesPdfResumeBody,
  PostCandidatesReedIdImport200,
  PostCandidatesSearch200,
  PostCandidatesSearchBody,
  PostCandidatesShareJobs200,
  PostCandidatesShareJobsBody,
  PostCandidatesTotaljobsGroupIdImport200,
  PostCandidatesTotaljobsGroupIdImportBody,
  PostCandidatesTotaljobsIdImport200,
  PostCbeSettingsCrudsDefaultsEntitiesType200,
  PostCbeSettingsCrudsDefaultsEntitiesTypeBody,
  PostCbeSettingsCvPdf200,
  PostCbeSettingsCvPdfBody,
  PostCbeSettingsCvPdfPath200,
  PostCbeSettingsCvPdfPathBody,
  PostCbeSettingsLogosLogoType200,
  PostCbeSettingsLogosLogoTypeBody,
  PostCbeSettingsTrackUsage200,
  PostCbeSettingsTrackUsageBody,
  PostChatsSendFbMessage200,
  PostChatsSendLlMessage200,
  PostChatsSendSms200,
  PostCompanies200,
  PostCompaniesCompanyIdAvatar200,
  PostCompaniesCustomFieldsValidate200,
  PostCompaniesEntityIdLists200,
  PostCompaniesLists200,
  PostCompaniesListsEntityListIdAdd200,
  PostCompaniesListsEntityListIdCreateNewEntity200,
  PostCompaniesListsEntityListIdRemove200,
  PostCompaniesListsEntityListIdReorder200,
  PostCompaniesListsEntityListIdUserGroups200,
  PostCompaniesSearch200,
  PostContactUserIdDeactivate200,
  PostContactUserIdDeactivateBody,
  PostContactUserIdReactivate200,
  PostContactUserIdReactivateBody,
  PostContacts200,
  PostContactsCustomFieldsValidate200,
  PostContactsEntityIdLists200,
  PostContactsIdForget200,
  PostContactsIdForgetReactivate200,
  PostContactsIdInterimAvailability200,
  PostContactsLists200,
  PostContactsListsEntityListIdAdd200,
  PostContactsListsEntityListIdCreateNewEntity200,
  PostContactsListsEntityListIdRemove200,
  PostContactsListsEntityListIdReorder200,
  PostContactsListsEntityListIdUserGroups200,
  PostContactsResumeSend200,
  PostContactsResumeSendBody,
  PostContactsSearch200,
  PostContactsUserIdDeactivate200,
  PostContactsUserIdReactivate200,
  PostEmailsPreview200,
  PostEmailsPreviewBody,
  PostEmailsPreviewEdited200,
  PostEmailsPreviewEditedBody,
  PostEmailsSearch200,
  PostEmailsSearchBody,
  PostEmailsSend200,
  PostEmailsSendAutomaticEmailBody,
  PostEmailsSendBody,
  PostEmailsSendEmailToHrAgent200,
  PostEmailsSendEmailToHrAgentBody,
  PostEmailsSendResume200,
  PostEmailsSendResumeBody,
  PostEmailsSendToCandidate200,
  PostEmailsSendToCandidateBody,
  PostEmailsSendToContact200,
  PostEmailsSendToContactBody,
  PostEmailsTemplates200,
  PostEmailsTemplatesBody,
  PostEmailsTemplatesEmailTemplateIdClone200,
  PostEmailsTemplatesSearch200,
  PostEmailsTemplatesSearchBody,
  PostEmploymentTypesEmploymentTypeIdActivate200,
  PostEmploymentTypesEmploymentTypeIdDeactivate200,
  PostEntityGroups200,
  PostEntityGroupsEntityGroupIdChildren200,
  PostEntityGroupsEntityGroupIdChildrenBody,
  PostEvaBotCampaignsBody,
  PostEvaBotCampaignsEvaBotCampaignIdCandidatesSearch200,
  PostEvaSkillsCodeToneOfVoiceIntent200,
  PostEventStreamSearch200,
  PostEventStreamSearchBody,
  PostExternalResetCache200,
  PostExternalSubscription200,
  PostFacebookWebhook200,
  PostFacebookWebhookDevel200,
  PostFeedbacks200,
  PostFeedbacksBody,
  PostFilesUrl200,
  PostIntegrationsActivityNotesNotes200,
  PostIntegrationsActivityNotesNotesBody,
  PostIntegrationsAgents200,
  PostIntegrationsAgentsBody,
  PostIntegrationsCandidates200,
  PostIntegrationsCandidatesBody,
  PostIntegrationsCandidatesInternal200,
  PostIntegrationsCandidatesInternalBody,
  PostIntegrationsCompanies200,
  PostIntegrationsCompaniesBody,
  PostIntegrationsContacts200,
  PostIntegrationsContactsBody,
  PostIntegrationsEvaInitialiseWebchatIfNotDone200,
  PostIntegrationsEvaInitialiseWebchatIfNotDoneBody,
  PostIntegrationsJobRequests200,
  PostIntegrationsJobRequestsBody,
  PostIntegrationsJobs200,
  PostIntegrationsJobsBody,
  PostIntegrationsLanguagesNormalise200,
  PostIntegrationsLanguagesNormaliseBody,
  PostIntegrationsNationalitiesNormalise200,
  PostIntegrationsNationalitiesNormaliseBody,
  PostIntegrationsPhonesNormalise200,
  PostIntegrationsPhonesNormaliseBody,
  PostIntegrationsPipelines200,
  PostIntegrationsPipelinesBody,
  PostIntegrationsWorkflowStateMove200,
  PostIntegrationsWorkflowStateMoveBody,
  PostInterviewScheduling200,
  PostInterviewSchedulingCandidates200,
  PostInterviewSchedulingContacts200,
  PostJobs200,
  PostJobsBody,
  PostJobsCustomFieldsValidate200,
  PostJobsEntityIdLists200,
  PostJobsEntityIdListsBody,
  PostJobsJobIdAttachments200,
  PostJobsJobIdAttachmentsBody,
  PostJobsJobIdAvatar200,
  PostJobsJobIdAvatarBody,
  PostJobsJobIdClone200,
  PostJobsJobIdCloneBody,
  PostJobsJobIdExternalBroadbeanUrl200,
  PostJobsJobIdExternalBroadbeanUrlBody,
  PostJobsJobIdImages200,
  PostJobsJobIdImagesBody,
  PostJobsJobIdImagesOrder200,
  PostJobsJobIdImagesOrderBody,
  PostJobsJobIdInterimAvailability200,
  PostJobsJobIdInterimAvailabilityBody,
  PostJobsJobIdLanguages200,
  PostJobsJobIdLanguagesBody,
  PostJobsJobIdMatchCandidatesApplicationsMatchGptSearchAsync200,
  PostJobsJobIdMatchCandidatesApplicationsMatchGptSearchAsyncBody,
  PostJobsJobIdMatchCandidatesCatererExternalCandidateIdReject200,
  PostJobsJobIdMatchCandidatesCatererExternalCandidateIdRejectBody,
  PostJobsJobIdMatchCandidatesCatererSearch200,
  PostJobsJobIdMatchCandidatesCatererSearchBody,
  PostJobsJobIdMatchCandidatesCvLibraryExternalCandidateIdReject200,
  PostJobsJobIdMatchCandidatesCvLibraryExternalCandidateIdRejectBody,
  PostJobsJobIdMatchCandidatesCvLibrarySearch200,
  PostJobsJobIdMatchCandidatesCvLibrarySearchBody,
  PostJobsJobIdMatchCandidatesEMedCareersExternalCandidateIdReject200,
  PostJobsJobIdMatchCandidatesEMedCareersExternalCandidateIdRejectBody,
  PostJobsJobIdMatchCandidatesEMedCareersSearch200,
  PostJobsJobIdMatchCandidatesEMedCareersSearchBody,
  PostJobsJobIdMatchCandidatesJobsiteExternalCandidateIdReject200,
  PostJobsJobIdMatchCandidatesJobsiteExternalCandidateIdRejectBody,
  PostJobsJobIdMatchCandidatesJobsiteSearch200,
  PostJobsJobIdMatchCandidatesJobsiteSearchBody,
  PostJobsJobIdMatchCandidatesMatchGptExternalCandidateIdReject200,
  PostJobsJobIdMatchCandidatesMatchGptExternalCandidateIdRejectBody,
  PostJobsJobIdMatchCandidatesMatchGptSearch200,
  PostJobsJobIdMatchCandidatesMatchGptSearchAsync200,
  PostJobsJobIdMatchCandidatesMatchGptSearchAsyncBody,
  PostJobsJobIdMatchCandidatesMatchGptSearchBody,
  PostJobsJobIdMatchCandidatesReedExternalCandidateIdReject200,
  PostJobsJobIdMatchCandidatesReedExternalCandidateIdRejectBody,
  PostJobsJobIdMatchCandidatesReedSearch200,
  PostJobsJobIdMatchCandidatesReedSearchBody,
  PostJobsJobIdMatchCandidatesSearch200,
  PostJobsJobIdMatchCandidatesSearchBody,
  PostJobsJobIdMatchCandidatesSearchExplain200,
  PostJobsJobIdMatchCandidatesSearchExplainBody,
  PostJobsJobIdMatchCandidatesTotaljobsExternalCandidateIdReject200,
  PostJobsJobIdMatchCandidatesTotaljobsExternalCandidateIdRejectBody,
  PostJobsJobIdMatchCandidatesTotaljobsGroupExternalCandidateIdReject200,
  PostJobsJobIdMatchCandidatesTotaljobsGroupExternalCandidateIdRejectBody,
  PostJobsJobIdMatchCandidatesTotaljobsGroupSearch200,
  PostJobsJobIdMatchCandidatesTotaljobsGroupSearchBody,
  PostJobsJobIdMatchCandidatesTotaljobsSearch200,
  PostJobsJobIdMatchCandidatesTotaljobsSearchBody,
  PostJobsJobIdMatchFilters200,
  PostJobsJobIdMatchFiltersBody,
  PostJobsJobIdPrivateModeDisable200,
  PostJobsJobIdPrivateModeDisableBody,
  PostJobsJobIdPrivateModeEnable200,
  PostJobsJobIdPrivateModeEnableBody,
  PostJobsJobIdZipRecruiterPublish200,
  PostJobsJobIdZipRecruiterPublishBody,
  PostJobsJobIdZipRecruiterUnpublish200,
  PostJobsJobIdZipRecruiterUnpublishBody,
  PostJobsLists200,
  PostJobsListsEntityListIdAdd200,
  PostJobsListsEntityListIdCreateNewEntity200,
  PostJobsListsEntityListIdRemove200,
  PostJobsListsEntityListIdReorder200,
  PostJobsListsEntityListIdReorderBody,
  PostJobsListsEntityListIdUserGroups200,
  PostJobsListsEntityListIdUserGroupsBody,
  PostJobsMatchFeedbackSearch200,
  PostJobsMatchFeedbackSearchBody,
  PostJobsMatchPipelinesMove200,
  PostJobsMatchPipelinesMoveBody,
  PostJobsMatchPipelinesMoveEntryPoint200,
  PostJobsMatchPipelinesMoveEntryPointBody,
  PostJobsMatchSearch200,
  PostJobsMatchSearchBody,
  PostJobsMatchTransitionHistoryBody,
  PostJobsPipelinesSearch200,
  PostJobsPipelinesSearchBody,
  PostJobsRecommendedCandidateId200,
  PostJobsRecommendedMy200,
  PostJobsSearch200,
  PostJobsSearchBody,
  PostJobsTeamtailorPublish200,
  PostJobsTeamtailorPublishBody,
  PostJobsTeamtailorUnpublish200,
  PostJobsTeamtailorUnpublishBody,
  PostMyCandidateJobExternalApplicationLogBody,
  PostMyCandidateJobsApplyCode200,
  PostMyCandidateJobsApplyCodeBody,
  PostMyCandidateJobsSearch200,
  PostMyCandidateJobsSearchBody,
  PostMyCandidateProfileAttachments200,
  PostMyCandidateProfileAttachmentsBody,
  PostMyCandidateProfileAvatar200,
  PostMyCandidateProfileAvatarBody,
  PostMyCandidateProfileEducation200,
  PostMyCandidateProfileEducationBody,
  PostMyCandidateProfileForget200,
  PostMyCandidateProfileForgetBody,
  PostMyCandidateProfileLanguages200,
  PostMyCandidateProfileLanguagesBody,
  PostMyCandidateProfileResumes200,
  PostMyCandidateProfileResumesBody,
  PostMyCandidateProfileWorkHistory200,
  PostMyCandidateProfileWorkHistoryBody,
  PostMyGdpr200,
  PostMyGdprBody,
  PostMyWebchatsRead200,
  PostMyWebchatsReadBody,
  PostNotificationsBody,
  PostNotificationsMarkRead200,
  PostNotificationsMarkReadBody,
  PostNotificationsMarkUnread200,
  PostNotificationsMarkUnreadBody,
  PostNylasOauth200,
  PostNylasOauthBody,
  PostNylasWebhookAccountExpire200,
  PostNylasWebhookAccountExpireBody,
  PostNylasWebhookMessageCreated200,
  PostNylasWebhookMessageCreatedBody,
  PostOmnichatsConversationIdRead200,
  PostOmnichatsConversationIdReadBody,
  PostPeopleLookupImportLinkedIn200,
  PostPeopleLookupImportLinkedInBody,
  PostPeopleLookupLookupLinkedIn200,
  PostPeopleLookupLookupLinkedInBody,
  PostPhonesLookupDuplicates200,
  PostPhonesLookupDuplicatesBody,
  PostPipelines200,
  PostPipelinesBody,
  PostPipelinesCustomFieldsValidate200,
  PostPipelinesCustomFieldsValidateBody,
  PostPipelinesEntityIdLists200,
  PostPipelinesEntityIdListsBody,
  PostPipelinesJobApplyJobCode200,
  PostPipelinesJobApplyJobCodeBody,
  PostPipelinesLists200,
  PostPipelinesListsBody,
  PostPipelinesListsEntityListIdAdd200,
  PostPipelinesListsEntityListIdAddBody,
  PostPipelinesListsEntityListIdCreateNewEntity200,
  PostPipelinesListsEntityListIdCreateNewEntityBody,
  PostPipelinesListsEntityListIdRemove200,
  PostPipelinesListsEntityListIdRemoveBody,
  PostPipelinesListsEntityListIdReorder200,
  PostPipelinesListsEntityListIdReorderBody,
  PostPipelinesListsEntityListIdUserGroups200,
  PostPipelinesListsEntityListIdUserGroupsBody,
  PostPipelinesMarkRead200,
  PostPipelinesMarkReadBody,
  PostPipelinesMove200,
  PostPipelinesMoveBody,
  PostPipelinesMoveBulk200,
  PostPipelinesMoveBulkBody,
  PostPipelinesMoveManually200,
  PostPipelinesMoveManuallyBody,
  PostPipelinesPipelineIdMove200,
  PostPipelinesPipelineIdMoveBody,
  PostPipelinesSearch200,
  PostPipelinesSearchBody,
  PostPipelinesWorkflowProcessMoveManually200,
  PostPipelinesWorkflowProcessMoveManuallyBody,
  PostPostmarkBounce200,
  PostPostmarkBounceBody,
  PostPostmarkClick200,
  PostPostmarkClickBody,
  PostPostmarkInbound200,
  PostPostmarkOpens200,
  PostPostmarkOpensBody,
  PostPublicJobsApplyCode200,
  PostPublicJobsApplyCodeBody,
  PostPublicJobsSkillTaxonomiesTreesCode200,
  PostPublicJobsSkillTaxonomiesTreesCodeBody,
  PostRecognitionEvaRecognitionIdFeedback200,
  PostRecognitionEvaRecognitionIdFeedbackBody,
  PostRecognitionOmnichatIdConversationFeedback200,
  PostRecognitionOmnichatIdConversationFeedbackBody,
  PostSearchGlobal200,
  PostSearchGlobalBody,
  PostSmsSendAutomaticSms200,
  PostSmsSendAutomaticSmsBody,
  PostTags200,
  PostTagsBody,
  PostTwilioAction200,
  PostTwilioActionBody,
  PostTwilioConnect200,
  PostTwilioConnectBody,
  PostTwilioFallback200,
  PostTwilioFallbackBody,
  PostTwilioForwardTargetAgentId200,
  PostTwilioForwardTargetAgentIdBody,
  PostTwilioGenerate200,
  PostTwilioGenerateBody,
  PostTwilioReachability200,
  PostTwilioReachabilityBody,
  PostTwilioRedirectCall200,
  PostTwilioRedirectCallBody,
  PostTwilioSmsAction200,
  PostTwilioSmsActionBody,
  PostTwilioSmsConnect200,
  PostTwilioSmsConnectBody,
  PostTwilioSmsFallback200,
  PostTwilioSmsFallbackBody,
  PostTwilioSmsReachability200,
  PostTwilioSmsReachabilityBody,
  PostTwilioSmsStatus200,
  PostTwilioSmsStatusBody,
  PostTwilioStatus200,
  PostTwilioStatusBody,
  PostUtilsElasticAllTenantsTasksTask200,
  PostUtilsElasticTasksTask200,
  PostUtilsEvaGreetings200,
  PostUtilsEvaGreetingsBody,
  PostUtilsFailureTest200,
  PostUtilsFeatures200,
  PostUtilsFeaturesBody,
  PostUtilsResetCache200,
  PostUtilsResetCacheBody,
  PostUtilsResetGettingStartedPage200,
  PostUtilsResetGettingStartedPageBody,
  PostUtilsResetTenantsCache200,
  PostUtilsResetTenantsCacheBody,
  PostUtilsSetGettingStartedPageStaticPageId200,
  PostUtilsSetGettingStartedPageStaticPageIdBody,
  PostUtilsWorkerTaskTask200,
  PostUtilsWorkerTaskTaskBody,
  PostV2NylasOauth200,
  PostV2NylasOauthBody,
  PostV2NylasWebhookGrantWebhook200,
  PostV2NylasWebhookGrantWebhookBody,
  PostV2NylasWebhookMessageTrackingWebhook200,
  PostV2NylasWebhookMessageTrackingWebhookBody,
  PostV2NylasWebhookMessageWebhook200,
  PostV2NylasWebhookMessageWebhookBody,
  PostWebchatsRead200,
  PostWebchatsReadBody,
  PostZipRecruiterCandidateApply200,
  PostZipRecruiterCandidateApplyBody,
  PutActivityNotesNotesActivityNoteId200,
  PutAgentsCustomFieldsModel200,
  PutAgentsEntityIdCustomFields200,
  PutAgentsEntityIdCustomFieldsExtend200,
  PutAgentsEntityIdCustomFieldsExtendBody,
  PutAgentsEntityIdNotesPanel200,
  PutAgentsUserIdNotifications200,
  PutAttachmentTypesAttachmentTypeId200,
  PutCallsCallId200,
  PutCallsCallOutcomesCallOutcomeId200,
  PutCallsCallTypesCallTypeId200,
  PutCandidatesAttachmentsAttachmentId200,
  PutCandidatesCandidateIdConfirm200,
  PutCandidatesCandidateIdEducationEducationId200,
  PutCandidatesCandidateIdInterimWorkHistoryInterimWorkHistoryId200,
  PutCandidatesCandidateIdLanguagesCandidateLanguageId200,
  PutCandidatesCandidateIdWorkHistoryWorkHistoryId200,
  PutCandidatesCustomFieldsModel200,
  PutCandidatesEntityIdCustomFields200,
  PutCandidatesEntityIdCustomFieldsBody,
  PutCandidatesEntityIdCustomFieldsExtend200,
  PutCandidatesEntityIdCustomFieldsExtendBody,
  PutCandidatesEntityIdNotesPanel200,
  PutCandidatesEntityIdNotesPdf200,
  PutCandidatesId200,
  PutCandidatesIdConfirm200,
  PutCandidatesListsEntityListId200,
  PutCbeSettingsCandidateBranding200,
  PutCbeSettingsGeneral200,
  PutCbeSettingsMatchSubscriptions200,
  PutCbeSettingsPublicJobBodyTemplateBody,
  PutCbeSettingsQuotasCode200,
  PutCbeSettingsTermsAndConditions200,
  PutCbeSettingsUpdateConstants200,
  PutCompaniesCompanyId200,
  PutCompaniesCustomFieldsModel200,
  PutCompaniesEntityIdCustomFields200,
  PutCompaniesEntityIdCustomFieldsExtend200,
  PutCompaniesEntityIdCustomFieldsExtendBody,
  PutCompaniesEntityIdNotesPanel200,
  PutCompaniesListsEntityListId200,
  PutContactsCustomFieldsModel200,
  PutContactsEntityIdCustomFields200,
  PutContactsEntityIdCustomFieldsExtend200,
  PutContactsEntityIdCustomFieldsExtendBody,
  PutContactsEntityIdNotesPanel200,
  PutContactsId200,
  PutContactsListsEntityListId200,
  PutEmailsTemplatesEmailTemplateId200,
  PutEmailsTemplatesEmailTemplateIdBody,
  PutEmploymentTypesEmploymentTypeId200,
  PutEntityGroupsEntityGroupId200,
  PutEvaBotCampaignsEvaBotCampaignId200,
  PutEvaOnboarding200,
  PutIntegrationsActivityNotesNotesId200,
  PutIntegrationsActivityNotesNotesIdBody,
  PutIntegrationsAgentsUserId200,
  PutIntegrationsAgentsUserIdBody,
  PutIntegrationsCandidatesId200,
  PutIntegrationsCandidatesIdBody,
  PutIntegrationsCompaniesCompanyId200,
  PutIntegrationsCompaniesCompanyIdBody,
  PutIntegrationsContactsId200,
  PutIntegrationsContactsIdBody,
  PutIntegrationsEntityTypeEntityIdCustomFields200,
  PutIntegrationsEntityTypeEntityIdCustomFieldsBody,
  PutIntegrationsJobRequestsJobId200,
  PutIntegrationsJobRequestsJobIdBody,
  PutIntegrationsJobsJobId200,
  PutIntegrationsJobsJobIdBody,
  PutInterviewSchedulingId200,
  PutJobsCustomFieldsModel200,
  PutJobsEntityIdCustomFields200,
  PutJobsEntityIdCustomFieldsExtend200,
  PutJobsEntityIdCustomFieldsExtendBody,
  PutJobsEntityIdNotesPanel200,
  PutJobsJobId200,
  PutJobsJobIdBody,
  PutJobsJobIdLanguagesJobRequiredLanguageId200,
  PutJobsJobIdMatchFiltersJobFilterId200,
  PutJobsJobIdMatchFiltersJobFilterIdBody,
  PutJobsListsEntityListId200,
  PutJobsMatchFeedbackNegative200,
  PutJobsMatchFeedbackPositive200,
  PutJobsWorkflowProcessesWorkflowProcessIdParticipants200,
  PutJobsWorkflowProcessesWorkflowProcessIdParticipantsBody,
  PutMyAgentProfile200,
  PutMyAgentProfileBody,
  PutMyCandidateProfile200,
  PutMyCandidateProfileAttachmentsAttachmentId200,
  PutMyCandidateProfileBody,
  PutMyCandidateProfileCustomFields200,
  PutMyCandidateProfileCustomFieldsBody,
  PutMyCandidateProfileCustomFieldsExtend200,
  PutMyCandidateProfileCustomFieldsExtendBody,
  PutMyCandidateProfileEducationEducationId200,
  PutMyCandidateProfileLanguagesCandidateLanguageId200,
  PutMyCandidateProfileWorkHistoryWorkHistoryId200,
  PutMyCandidateSkillTaxonomiesSkillTaxonomyIdNote200,
  PutMyCandidateSkillTaxonomiesSkillTaxonomyIdNoteBody,
  PutMyCandidateSkillTaxonomiesSkillTaxonomyIdSkills200,
  PutMyCandidateSkillTaxonomiesSkillTaxonomyIdSkillsBody,
  PutMyContactProfile200,
  PutMyContactProfileBody,
  PutPipelinesCustomFieldsModel200,
  PutPipelinesEntityIdCustomFields200,
  PutPipelinesEntityIdCustomFieldsExtend200,
  PutPipelinesEntityIdCustomFieldsExtendBody,
  PutPipelinesListsEntityListId200,
  PutPipelinesMarkRead200,
  PutPipelinesPipelineIdCandidateCandidateIdMove200,
  PutPipelinesPipelineIdJobJobIdMove200,
  PutSettingsUpdateConstants200,
  PutSettingsUpdateConstantsBody,
  PutStopWordsStopWordId200,
  PutTagsTagId200,
  PutTagsTagIdBody,
  RequestBodyMyRecommendedJobs,
  RequestBodyStopWord,
  Status400,
  Status401,
  Status403,
  Status404,
  StopWord,
  Success,
} from './types';
import { customHttpClient } from '../customHttpClient';

/**
 * Get all elastic tasks
 */
export const getUtilsElasticTasks = (signal?: AbortSignal) => {
  return customHttpClient<GetUtilsElasticTasks200>({ url: `/utils/elastic/tasks`, method: 'GET', signal });
};

export const getGetUtilsElasticTasksQueryKey = () => {
  return [`/utils/elastic/tasks`] as const;
};

export const getGetUtilsElasticTasksQueryOptions = <
  TData = Awaited<ReturnType<typeof getUtilsElasticTasks>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getUtilsElasticTasks>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUtilsElasticTasksQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUtilsElasticTasks>>> = ({ signal }) =>
    getUtilsElasticTasks(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUtilsElasticTasks>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetUtilsElasticTasksQueryResult = NonNullable<Awaited<ReturnType<typeof getUtilsElasticTasks>>>;
export type GetUtilsElasticTasksQueryError = unknown;

export const useGetUtilsElasticTasks = <
  TData = Awaited<ReturnType<typeof getUtilsElasticTasks>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getUtilsElasticTasks>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetUtilsElasticTasksQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Execute elastic task
 */
export const postUtilsElasticTasksTask = (task: string) => {
  return customHttpClient<PostUtilsElasticTasksTask200>({ url: `/utils/elastic/tasks/${task}`, method: 'POST' });
};

export const getPostUtilsElasticTasksTaskMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postUtilsElasticTasksTask>>,
    TError,
    { task: string },
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<typeof postUtilsElasticTasksTask>>, TError, { task: string }, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUtilsElasticTasksTask>>, { task: string }> = (
    props,
  ) => {
    const { task } = props ?? {};

    return postUtilsElasticTasksTask(task);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostUtilsElasticTasksTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof postUtilsElasticTasksTask>>
>;

export type PostUtilsElasticTasksTaskMutationError = unknown;

export const usePostUtilsElasticTasksTask = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postUtilsElasticTasksTask>>,
    TError,
    { task: string },
    TContext
  >;
}) => {
  const mutationOptions = getPostUtilsElasticTasksTaskMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Execute elastic task on all tenants
 */
export const postUtilsElasticAllTenantsTasksTask = (task: string) => {
  return customHttpClient<PostUtilsElasticAllTenantsTasksTask200>({
    url: `/utils/elastic/all-tenants/tasks/${task}`,
    method: 'POST',
  });
};

export const getPostUtilsElasticAllTenantsTasksTaskMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postUtilsElasticAllTenantsTasksTask>>,
    TError,
    { task: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postUtilsElasticAllTenantsTasksTask>>,
  TError,
  { task: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postUtilsElasticAllTenantsTasksTask>>,
    { task: string }
  > = (props) => {
    const { task } = props ?? {};

    return postUtilsElasticAllTenantsTasksTask(task);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostUtilsElasticAllTenantsTasksTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof postUtilsElasticAllTenantsTasksTask>>
>;

export type PostUtilsElasticAllTenantsTasksTaskMutationError = unknown;

export const usePostUtilsElasticAllTenantsTasksTask = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postUtilsElasticAllTenantsTasksTask>>,
    TError,
    { task: string },
    TContext
  >;
}) => {
  const mutationOptions = getPostUtilsElasticAllTenantsTasksTaskMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Get status of all indexes
 */
export const getUtilsElasticIndexesStatus = (signal?: AbortSignal) => {
  return customHttpClient<GetUtilsElasticIndexesStatus200>({
    url: `/utils/elastic/indexes/status`,
    method: 'GET',
    signal,
  });
};

export const getGetUtilsElasticIndexesStatusQueryKey = () => {
  return [`/utils/elastic/indexes/status`] as const;
};

export const getGetUtilsElasticIndexesStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getUtilsElasticIndexesStatus>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getUtilsElasticIndexesStatus>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUtilsElasticIndexesStatusQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUtilsElasticIndexesStatus>>> = ({ signal }) =>
    getUtilsElasticIndexesStatus(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUtilsElasticIndexesStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetUtilsElasticIndexesStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUtilsElasticIndexesStatus>>
>;
export type GetUtilsElasticIndexesStatusQueryError = unknown;

export const useGetUtilsElasticIndexesStatus = <
  TData = Awaited<ReturnType<typeof getUtilsElasticIndexesStatus>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getUtilsElasticIndexesStatus>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetUtilsElasticIndexesStatusQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Create a feedback
 */
export const postFeedbacks = (postFeedbacksBody: PostFeedbacksBody) => {
  return customHttpClient<PostFeedbacks200>({
    url: `/feedbacks`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postFeedbacksBody,
  });
};

export const getPostFeedbacksMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFeedbacks>>,
    TError,
    { data: PostFeedbacksBody },
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<typeof postFeedbacks>>, TError, { data: PostFeedbacksBody }, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFeedbacks>>, { data: PostFeedbacksBody }> = (
    props,
  ) => {
    const { data } = props ?? {};

    return postFeedbacks(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostFeedbacksMutationResult = NonNullable<Awaited<ReturnType<typeof postFeedbacks>>>;
export type PostFeedbacksMutationBody = PostFeedbacksBody;
export type PostFeedbacksMutationError = unknown;

export const usePostFeedbacks = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFeedbacks>>,
    TError,
    { data: PostFeedbacksBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostFeedbacksMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Get skillTaxonomy trees by job code
 */
export const postPublicJobsSkillTaxonomiesTreesCode = (
  postPublicJobsSkillTaxonomiesTreesCodeBody: PostPublicJobsSkillTaxonomiesTreesCodeBody,
) => {
  return customHttpClient<PostPublicJobsSkillTaxonomiesTreesCode200>({
    url: `/public-jobs/skill-taxonomies/trees/:code`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postPublicJobsSkillTaxonomiesTreesCodeBody,
  });
};

export const getPostPublicJobsSkillTaxonomiesTreesCodeMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPublicJobsSkillTaxonomiesTreesCode>>,
    TError,
    { data: PostPublicJobsSkillTaxonomiesTreesCodeBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postPublicJobsSkillTaxonomiesTreesCode>>,
  TError,
  { data: PostPublicJobsSkillTaxonomiesTreesCodeBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postPublicJobsSkillTaxonomiesTreesCode>>,
    { data: PostPublicJobsSkillTaxonomiesTreesCodeBody }
  > = (props) => {
    const { data } = props ?? {};

    return postPublicJobsSkillTaxonomiesTreesCode(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostPublicJobsSkillTaxonomiesTreesCodeMutationResult = NonNullable<
  Awaited<ReturnType<typeof postPublicJobsSkillTaxonomiesTreesCode>>
>;
export type PostPublicJobsSkillTaxonomiesTreesCodeMutationBody = PostPublicJobsSkillTaxonomiesTreesCodeBody;
export type PostPublicJobsSkillTaxonomiesTreesCodeMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostPublicJobsSkillTaxonomiesTreesCode = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPublicJobsSkillTaxonomiesTreesCode>>,
    TError,
    { data: PostPublicJobsSkillTaxonomiesTreesCodeBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostPublicJobsSkillTaxonomiesTreesCodeMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Create positive feedback for synonym
 */
export const putJobsMatchFeedbackPositive = () => {
  return customHttpClient<PutJobsMatchFeedbackPositive200>({ url: `/jobs/match/feedback/positive`, method: 'PUT' });
};

export const getPutJobsMatchFeedbackPositiveMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putJobsMatchFeedbackPositive>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof putJobsMatchFeedbackPositive>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof putJobsMatchFeedbackPositive>>, void> = () => {
    return putJobsMatchFeedbackPositive();
  };

  return { mutationFn, ...mutationOptions };
};

export type PutJobsMatchFeedbackPositiveMutationResult = NonNullable<
  Awaited<ReturnType<typeof putJobsMatchFeedbackPositive>>
>;

export type PutJobsMatchFeedbackPositiveMutationError = unknown;

export const usePutJobsMatchFeedbackPositive = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putJobsMatchFeedbackPositive>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPutJobsMatchFeedbackPositiveMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Create negative feedback for synonym
 */
export const putJobsMatchFeedbackNegative = () => {
  return customHttpClient<PutJobsMatchFeedbackNegative200>({ url: `/jobs/match/feedback/negative`, method: 'PUT' });
};

export const getPutJobsMatchFeedbackNegativeMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putJobsMatchFeedbackNegative>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof putJobsMatchFeedbackNegative>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof putJobsMatchFeedbackNegative>>, void> = () => {
    return putJobsMatchFeedbackNegative();
  };

  return { mutationFn, ...mutationOptions };
};

export type PutJobsMatchFeedbackNegativeMutationResult = NonNullable<
  Awaited<ReturnType<typeof putJobsMatchFeedbackNegative>>
>;

export type PutJobsMatchFeedbackNegativeMutationError = unknown;

export const usePutJobsMatchFeedbackNegative = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putJobsMatchFeedbackNegative>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPutJobsMatchFeedbackNegativeMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Search feedback by synonyms
 */
export const postJobsMatchFeedbackSearch = (postJobsMatchFeedbackSearchBody: PostJobsMatchFeedbackSearchBody) => {
  return customHttpClient<PostJobsMatchFeedbackSearch200>({
    url: `/jobs/match/feedback/search`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postJobsMatchFeedbackSearchBody,
  });
};

export const getPostJobsMatchFeedbackSearchMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsMatchFeedbackSearch>>,
    TError,
    { data: PostJobsMatchFeedbackSearchBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postJobsMatchFeedbackSearch>>,
  TError,
  { data: PostJobsMatchFeedbackSearchBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postJobsMatchFeedbackSearch>>,
    { data: PostJobsMatchFeedbackSearchBody }
  > = (props) => {
    const { data } = props ?? {};

    return postJobsMatchFeedbackSearch(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostJobsMatchFeedbackSearchMutationResult = NonNullable<
  Awaited<ReturnType<typeof postJobsMatchFeedbackSearch>>
>;
export type PostJobsMatchFeedbackSearchMutationBody = PostJobsMatchFeedbackSearchBody;
export type PostJobsMatchFeedbackSearchMutationError = unknown;

export const usePostJobsMatchFeedbackSearch = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsMatchFeedbackSearch>>,
    TError,
    { data: PostJobsMatchFeedbackSearchBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostJobsMatchFeedbackSearchMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postJobsMatchTransitionHistory = (
  postJobsMatchTransitionHistoryBody: PostJobsMatchTransitionHistoryBody,
) => {
  return customHttpClient<Success>({
    url: `/jobs/match/transition-history`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postJobsMatchTransitionHistoryBody,
  });
};

export const getPostJobsMatchTransitionHistoryMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsMatchTransitionHistory>>,
    TError,
    { data: PostJobsMatchTransitionHistoryBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postJobsMatchTransitionHistory>>,
  TError,
  { data: PostJobsMatchTransitionHistoryBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postJobsMatchTransitionHistory>>,
    { data: PostJobsMatchTransitionHistoryBody }
  > = (props) => {
    const { data } = props ?? {};

    return postJobsMatchTransitionHistory(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostJobsMatchTransitionHistoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof postJobsMatchTransitionHistory>>
>;
export type PostJobsMatchTransitionHistoryMutationBody = PostJobsMatchTransitionHistoryBody;
export type PostJobsMatchTransitionHistoryMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostJobsMatchTransitionHistory = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsMatchTransitionHistory>>,
    TError,
    { data: PostJobsMatchTransitionHistoryBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostJobsMatchTransitionHistoryMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postEventStreamSearch = (postEventStreamSearchBody: PostEventStreamSearchBody) => {
  return customHttpClient<PostEventStreamSearch200>({
    url: `/event-stream/search`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postEventStreamSearchBody,
  });
};

export const getPostEventStreamSearchMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postEventStreamSearch>>,
    TError,
    { data: PostEventStreamSearchBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postEventStreamSearch>>,
  TError,
  { data: PostEventStreamSearchBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postEventStreamSearch>>,
    { data: PostEventStreamSearchBody }
  > = (props) => {
    const { data } = props ?? {};

    return postEventStreamSearch(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostEventStreamSearchMutationResult = NonNullable<Awaited<ReturnType<typeof postEventStreamSearch>>>;
export type PostEventStreamSearchMutationBody = PostEventStreamSearchBody;
export type PostEventStreamSearchMutationError = unknown;

export const usePostEventStreamSearch = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postEventStreamSearch>>,
    TError,
    { data: PostEventStreamSearchBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostEventStreamSearchMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postPostmarkBounce = (postPostmarkBounceBody: PostPostmarkBounceBody) => {
  return customHttpClient<PostPostmarkBounce200>({
    url: `/postmark/bounce`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postPostmarkBounceBody,
  });
};

export const getPostPostmarkBounceMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPostmarkBounce>>,
    TError,
    { data: PostPostmarkBounceBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postPostmarkBounce>>,
  TError,
  { data: PostPostmarkBounceBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postPostmarkBounce>>,
    { data: PostPostmarkBounceBody }
  > = (props) => {
    const { data } = props ?? {};

    return postPostmarkBounce(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostPostmarkBounceMutationResult = NonNullable<Awaited<ReturnType<typeof postPostmarkBounce>>>;
export type PostPostmarkBounceMutationBody = PostPostmarkBounceBody;
export type PostPostmarkBounceMutationError = unknown;

export const usePostPostmarkBounce = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPostmarkBounce>>,
    TError,
    { data: PostPostmarkBounceBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostPostmarkBounceMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postPostmarkOpens = (postPostmarkOpensBody: PostPostmarkOpensBody) => {
  return customHttpClient<PostPostmarkOpens200>({
    url: `/postmark/opens`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postPostmarkOpensBody,
  });
};

export const getPostPostmarkOpensMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPostmarkOpens>>,
    TError,
    { data: PostPostmarkOpensBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postPostmarkOpens>>,
  TError,
  { data: PostPostmarkOpensBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPostmarkOpens>>, { data: PostPostmarkOpensBody }> = (
    props,
  ) => {
    const { data } = props ?? {};

    return postPostmarkOpens(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostPostmarkOpensMutationResult = NonNullable<Awaited<ReturnType<typeof postPostmarkOpens>>>;
export type PostPostmarkOpensMutationBody = PostPostmarkOpensBody;
export type PostPostmarkOpensMutationError = unknown;

export const usePostPostmarkOpens = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPostmarkOpens>>,
    TError,
    { data: PostPostmarkOpensBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostPostmarkOpensMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postPostmarkClick = (postPostmarkClickBody: PostPostmarkClickBody) => {
  return customHttpClient<PostPostmarkClick200>({
    url: `/postmark/click`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postPostmarkClickBody,
  });
};

export const getPostPostmarkClickMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPostmarkClick>>,
    TError,
    { data: PostPostmarkClickBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postPostmarkClick>>,
  TError,
  { data: PostPostmarkClickBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPostmarkClick>>, { data: PostPostmarkClickBody }> = (
    props,
  ) => {
    const { data } = props ?? {};

    return postPostmarkClick(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostPostmarkClickMutationResult = NonNullable<Awaited<ReturnType<typeof postPostmarkClick>>>;
export type PostPostmarkClickMutationBody = PostPostmarkClickBody;
export type PostPostmarkClickMutationError = unknown;

export const usePostPostmarkClick = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPostmarkClick>>,
    TError,
    { data: PostPostmarkClickBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostPostmarkClickMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postPostmarkInbound = () => {
  return customHttpClient<PostPostmarkInbound200>({ url: `/postmark/inbound`, method: 'POST' });
};

export const getPostPostmarkInboundMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postPostmarkInbound>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof postPostmarkInbound>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPostmarkInbound>>, void> = () => {
    return postPostmarkInbound();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostPostmarkInboundMutationResult = NonNullable<Awaited<ReturnType<typeof postPostmarkInbound>>>;

export type PostPostmarkInboundMutationError = unknown;

export const usePostPostmarkInbound = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postPostmarkInbound>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPostPostmarkInboundMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getCandidatesListsEntityListId = (entityListId: number, signal?: AbortSignal) => {
  return customHttpClient<GetCandidatesListsEntityListId200>({
    url: `/candidates/lists/${entityListId}`,
    method: 'GET',
    signal,
  });
};

export const getGetCandidatesListsEntityListIdQueryKey = (entityListId: number) => {
  return [`/candidates/lists/${entityListId}`] as const;
};

export const getGetCandidatesListsEntityListIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getCandidatesListsEntityListId>>,
  TError = unknown,
>(
  entityListId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getCandidatesListsEntityListId>>, TError, TData> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCandidatesListsEntityListIdQueryKey(entityListId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCandidatesListsEntityListId>>> = ({ signal }) =>
    getCandidatesListsEntityListId(entityListId, signal);

  return { queryKey, queryFn, enabled: !!entityListId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCandidatesListsEntityListId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCandidatesListsEntityListIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCandidatesListsEntityListId>>
>;
export type GetCandidatesListsEntityListIdQueryError = unknown;

export const useGetCandidatesListsEntityListId = <
  TData = Awaited<ReturnType<typeof getCandidatesListsEntityListId>>,
  TError = unknown,
>(
  entityListId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getCandidatesListsEntityListId>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCandidatesListsEntityListIdQueryOptions(entityListId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const putCandidatesListsEntityListId = (entityListId: number) => {
  return customHttpClient<PutCandidatesListsEntityListId200>({
    url: `/candidates/lists/${entityListId}`,
    method: 'PUT',
  });
};

export const getPutCandidatesListsEntityListIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putCandidatesListsEntityListId>>,
    TError,
    { entityListId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putCandidatesListsEntityListId>>,
  TError,
  { entityListId: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putCandidatesListsEntityListId>>,
    { entityListId: number }
  > = (props) => {
    const { entityListId } = props ?? {};

    return putCandidatesListsEntityListId(entityListId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutCandidatesListsEntityListIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putCandidatesListsEntityListId>>
>;

export type PutCandidatesListsEntityListIdMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutCandidatesListsEntityListId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putCandidatesListsEntityListId>>,
    TError,
    { entityListId: number },
    TContext
  >;
}) => {
  const mutationOptions = getPutCandidatesListsEntityListIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteCandidatesListsEntityListId = (entityListId: number) => {
  return customHttpClient<DeleteCandidatesListsEntityListId200>({
    url: `/candidates/lists/${entityListId}`,
    method: 'DELETE',
  });
};

export const getDeleteCandidatesListsEntityListIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCandidatesListsEntityListId>>,
    TError,
    { entityListId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCandidatesListsEntityListId>>,
  TError,
  { entityListId: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCandidatesListsEntityListId>>,
    { entityListId: number }
  > = (props) => {
    const { entityListId } = props ?? {};

    return deleteCandidatesListsEntityListId(entityListId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCandidatesListsEntityListIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCandidatesListsEntityListId>>
>;

export type DeleteCandidatesListsEntityListIdMutationError = Status400 | Status401 | Status403 | Status404;

export const useDeleteCandidatesListsEntityListId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCandidatesListsEntityListId>>,
    TError,
    { entityListId: number },
    TContext
  >;
}) => {
  const mutationOptions = getDeleteCandidatesListsEntityListIdMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * global search by elastic search
 */
export const postSearchGlobal = (postSearchGlobalBody: PostSearchGlobalBody) => {
  return customHttpClient<PostSearchGlobal200>({
    url: `/search/global`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postSearchGlobalBody,
  });
};

export const getPostSearchGlobalMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSearchGlobal>>,
    TError,
    { data: PostSearchGlobalBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSearchGlobal>>,
  TError,
  { data: PostSearchGlobalBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSearchGlobal>>, { data: PostSearchGlobalBody }> = (
    props,
  ) => {
    const { data } = props ?? {};

    return postSearchGlobal(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostSearchGlobalMutationResult = NonNullable<Awaited<ReturnType<typeof postSearchGlobal>>>;
export type PostSearchGlobalMutationBody = PostSearchGlobalBody;
export type PostSearchGlobalMutationError = unknown;

export const usePostSearchGlobal = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSearchGlobal>>,
    TError,
    { data: PostSearchGlobalBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostSearchGlobalMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postContactUserIdDeactivate = (
  userId: number,
  postContactUserIdDeactivateBody: PostContactUserIdDeactivateBody,
) => {
  return customHttpClient<PostContactUserIdDeactivate200>({
    url: `/contact/${userId}/deactivate`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postContactUserIdDeactivateBody,
  });
};

export const getPostContactUserIdDeactivateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postContactUserIdDeactivate>>,
    TError,
    { userId: number; data: PostContactUserIdDeactivateBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postContactUserIdDeactivate>>,
  TError,
  { userId: number; data: PostContactUserIdDeactivateBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postContactUserIdDeactivate>>,
    { userId: number; data: PostContactUserIdDeactivateBody }
  > = (props) => {
    const { userId, data } = props ?? {};

    return postContactUserIdDeactivate(userId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostContactUserIdDeactivateMutationResult = NonNullable<
  Awaited<ReturnType<typeof postContactUserIdDeactivate>>
>;
export type PostContactUserIdDeactivateMutationBody = PostContactUserIdDeactivateBody;
export type PostContactUserIdDeactivateMutationError = unknown;

export const usePostContactUserIdDeactivate = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postContactUserIdDeactivate>>,
    TError,
    { userId: number; data: PostContactUserIdDeactivateBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostContactUserIdDeactivateMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postContactUserIdReactivate = (
  userId: number,
  postContactUserIdReactivateBody: PostContactUserIdReactivateBody,
) => {
  return customHttpClient<PostContactUserIdReactivate200>({
    url: `/contact/${userId}/reactivate`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postContactUserIdReactivateBody,
  });
};

export const getPostContactUserIdReactivateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postContactUserIdReactivate>>,
    TError,
    { userId: number; data: PostContactUserIdReactivateBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postContactUserIdReactivate>>,
  TError,
  { userId: number; data: PostContactUserIdReactivateBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postContactUserIdReactivate>>,
    { userId: number; data: PostContactUserIdReactivateBody }
  > = (props) => {
    const { userId, data } = props ?? {};

    return postContactUserIdReactivate(userId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostContactUserIdReactivateMutationResult = NonNullable<
  Awaited<ReturnType<typeof postContactUserIdReactivate>>
>;
export type PostContactUserIdReactivateMutationBody = PostContactUserIdReactivateBody;
export type PostContactUserIdReactivateMutationError = unknown;

export const usePostContactUserIdReactivate = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postContactUserIdReactivate>>,
    TError,
    { userId: number; data: PostContactUserIdReactivateBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostContactUserIdReactivateMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getMyAgentProfile = (signal?: AbortSignal) => {
  return customHttpClient<GetMyAgentProfile200>({ url: `/my/agent-profile`, method: 'GET', signal });
};

export const getGetMyAgentProfileQueryKey = () => {
  return [`/my/agent-profile`] as const;
};

export const getGetMyAgentProfileQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyAgentProfile>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMyAgentProfile>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyAgentProfileQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyAgentProfile>>> = ({ signal }) =>
    getMyAgentProfile(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyAgentProfile>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMyAgentProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getMyAgentProfile>>>;
export type GetMyAgentProfileQueryError = unknown;

export const useGetMyAgentProfile = <
  TData = Awaited<ReturnType<typeof getMyAgentProfile>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMyAgentProfile>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetMyAgentProfileQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const putMyAgentProfile = (putMyAgentProfileBody: PutMyAgentProfileBody) => {
  return customHttpClient<PutMyAgentProfile200>({
    url: `/my/agent-profile`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: putMyAgentProfileBody,
  });
};

export const getPutMyAgentProfileMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putMyAgentProfile>>,
    TError,
    { data: PutMyAgentProfileBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putMyAgentProfile>>,
  TError,
  { data: PutMyAgentProfileBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof putMyAgentProfile>>, { data: PutMyAgentProfileBody }> = (
    props,
  ) => {
    const { data } = props ?? {};

    return putMyAgentProfile(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutMyAgentProfileMutationResult = NonNullable<Awaited<ReturnType<typeof putMyAgentProfile>>>;
export type PutMyAgentProfileMutationBody = PutMyAgentProfileBody;
export type PutMyAgentProfileMutationError = unknown;

export const usePutMyAgentProfile = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putMyAgentProfile>>,
    TError,
    { data: PutMyAgentProfileBody },
    TContext
  >;
}) => {
  const mutationOptions = getPutMyAgentProfileMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getMyCandidateJobsJobId = (jobId: number, signal?: AbortSignal) => {
  return customHttpClient<GetMyCandidateJobsJobId200>({ url: `/my/candidate/jobs/${jobId}`, method: 'GET', signal });
};

export const getGetMyCandidateJobsJobIdQueryKey = (jobId: number) => {
  return [`/my/candidate/jobs/${jobId}`] as const;
};

export const getGetMyCandidateJobsJobIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyCandidateJobsJobId>>,
  TError = unknown,
>(
  jobId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getMyCandidateJobsJobId>>, TError, TData> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyCandidateJobsJobIdQueryKey(jobId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyCandidateJobsJobId>>> = ({ signal }) =>
    getMyCandidateJobsJobId(jobId, signal);

  return { queryKey, queryFn, enabled: !!jobId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyCandidateJobsJobId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMyCandidateJobsJobIdQueryResult = NonNullable<Awaited<ReturnType<typeof getMyCandidateJobsJobId>>>;
export type GetMyCandidateJobsJobIdQueryError = unknown;

export const useGetMyCandidateJobsJobId = <
  TData = Awaited<ReturnType<typeof getMyCandidateJobsJobId>>,
  TError = unknown,
>(
  jobId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getMyCandidateJobsJobId>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetMyCandidateJobsJobIdQueryOptions(jobId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postMyCandidateJobsSearch = (postMyCandidateJobsSearchBody: PostMyCandidateJobsSearchBody) => {
  return customHttpClient<PostMyCandidateJobsSearch200>({
    url: `/my/candidate/jobs/search`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postMyCandidateJobsSearchBody,
  });
};

export const getPostMyCandidateJobsSearchMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMyCandidateJobsSearch>>,
    TError,
    { data: PostMyCandidateJobsSearchBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMyCandidateJobsSearch>>,
  TError,
  { data: PostMyCandidateJobsSearchBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMyCandidateJobsSearch>>,
    { data: PostMyCandidateJobsSearchBody }
  > = (props) => {
    const { data } = props ?? {};

    return postMyCandidateJobsSearch(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMyCandidateJobsSearchMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMyCandidateJobsSearch>>
>;
export type PostMyCandidateJobsSearchMutationBody = PostMyCandidateJobsSearchBody;
export type PostMyCandidateJobsSearchMutationError = unknown;

export const usePostMyCandidateJobsSearch = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMyCandidateJobsSearch>>,
    TError,
    { data: PostMyCandidateJobsSearchBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostMyCandidateJobsSearchMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postMyCandidateJobsApplyCode = (
  code: string,
  postMyCandidateJobsApplyCodeBody: PostMyCandidateJobsApplyCodeBody,
) => {
  return customHttpClient<PostMyCandidateJobsApplyCode200>({
    url: `/my/candidate/jobs/apply/${code}`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postMyCandidateJobsApplyCodeBody,
  });
};

export const getPostMyCandidateJobsApplyCodeMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMyCandidateJobsApplyCode>>,
    TError,
    { code: string; data: PostMyCandidateJobsApplyCodeBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMyCandidateJobsApplyCode>>,
  TError,
  { code: string; data: PostMyCandidateJobsApplyCodeBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMyCandidateJobsApplyCode>>,
    { code: string; data: PostMyCandidateJobsApplyCodeBody }
  > = (props) => {
    const { code, data } = props ?? {};

    return postMyCandidateJobsApplyCode(code, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMyCandidateJobsApplyCodeMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMyCandidateJobsApplyCode>>
>;
export type PostMyCandidateJobsApplyCodeMutationBody = PostMyCandidateJobsApplyCodeBody;
export type PostMyCandidateJobsApplyCodeMutationError = unknown;

export const usePostMyCandidateJobsApplyCode = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMyCandidateJobsApplyCode>>,
    TError,
    { code: string; data: PostMyCandidateJobsApplyCodeBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostMyCandidateJobsApplyCodeMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getMyCandidateJobsWorkflows = (signal?: AbortSignal) => {
  return customHttpClient<GetMyCandidateJobsWorkflows200>({
    url: `/my/candidate/jobs/workflows`,
    method: 'GET',
    signal,
  });
};

export const getGetMyCandidateJobsWorkflowsQueryKey = () => {
  return [`/my/candidate/jobs/workflows`] as const;
};

export const getGetMyCandidateJobsWorkflowsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyCandidateJobsWorkflows>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMyCandidateJobsWorkflows>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyCandidateJobsWorkflowsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyCandidateJobsWorkflows>>> = ({ signal }) =>
    getMyCandidateJobsWorkflows(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyCandidateJobsWorkflows>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMyCandidateJobsWorkflowsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyCandidateJobsWorkflows>>
>;
export type GetMyCandidateJobsWorkflowsQueryError = unknown;

export const useGetMyCandidateJobsWorkflows = <
  TData = Awaited<ReturnType<typeof getMyCandidateJobsWorkflows>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMyCandidateJobsWorkflows>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetMyCandidateJobsWorkflowsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postMyCandidateJobExternalApplicationLog = (
  postMyCandidateJobExternalApplicationLogBody: PostMyCandidateJobExternalApplicationLogBody,
) => {
  return customHttpClient<Success>({
    url: `/my/candidate/job-external-application-log`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postMyCandidateJobExternalApplicationLogBody,
  });
};

export const getPostMyCandidateJobExternalApplicationLogMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMyCandidateJobExternalApplicationLog>>,
    TError,
    { data: PostMyCandidateJobExternalApplicationLogBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMyCandidateJobExternalApplicationLog>>,
  TError,
  { data: PostMyCandidateJobExternalApplicationLogBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMyCandidateJobExternalApplicationLog>>,
    { data: PostMyCandidateJobExternalApplicationLogBody }
  > = (props) => {
    const { data } = props ?? {};

    return postMyCandidateJobExternalApplicationLog(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMyCandidateJobExternalApplicationLogMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMyCandidateJobExternalApplicationLog>>
>;
export type PostMyCandidateJobExternalApplicationLogMutationBody = PostMyCandidateJobExternalApplicationLogBody;
export type PostMyCandidateJobExternalApplicationLogMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostMyCandidateJobExternalApplicationLog = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMyCandidateJobExternalApplicationLog>>,
    TError,
    { data: PostMyCandidateJobExternalApplicationLogBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostMyCandidateJobExternalApplicationLogMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putMyCandidateSkillTaxonomiesSkillTaxonomyIdNote = (
  skillTaxonomyId: number,
  putMyCandidateSkillTaxonomiesSkillTaxonomyIdNoteBody: PutMyCandidateSkillTaxonomiesSkillTaxonomyIdNoteBody,
) => {
  return customHttpClient<PutMyCandidateSkillTaxonomiesSkillTaxonomyIdNote200>({
    url: `/my/candidate/skill-taxonomies/${skillTaxonomyId}/note`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: putMyCandidateSkillTaxonomiesSkillTaxonomyIdNoteBody,
  });
};

export const getPutMyCandidateSkillTaxonomiesSkillTaxonomyIdNoteMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putMyCandidateSkillTaxonomiesSkillTaxonomyIdNote>>,
    TError,
    { skillTaxonomyId: number; data: PutMyCandidateSkillTaxonomiesSkillTaxonomyIdNoteBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putMyCandidateSkillTaxonomiesSkillTaxonomyIdNote>>,
  TError,
  { skillTaxonomyId: number; data: PutMyCandidateSkillTaxonomiesSkillTaxonomyIdNoteBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putMyCandidateSkillTaxonomiesSkillTaxonomyIdNote>>,
    { skillTaxonomyId: number; data: PutMyCandidateSkillTaxonomiesSkillTaxonomyIdNoteBody }
  > = (props) => {
    const { skillTaxonomyId, data } = props ?? {};

    return putMyCandidateSkillTaxonomiesSkillTaxonomyIdNote(skillTaxonomyId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutMyCandidateSkillTaxonomiesSkillTaxonomyIdNoteMutationResult = NonNullable<
  Awaited<ReturnType<typeof putMyCandidateSkillTaxonomiesSkillTaxonomyIdNote>>
>;
export type PutMyCandidateSkillTaxonomiesSkillTaxonomyIdNoteMutationBody =
  PutMyCandidateSkillTaxonomiesSkillTaxonomyIdNoteBody;
export type PutMyCandidateSkillTaxonomiesSkillTaxonomyIdNoteMutationError = unknown;

export const usePutMyCandidateSkillTaxonomiesSkillTaxonomyIdNote = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putMyCandidateSkillTaxonomiesSkillTaxonomyIdNote>>,
    TError,
    { skillTaxonomyId: number; data: PutMyCandidateSkillTaxonomiesSkillTaxonomyIdNoteBody },
    TContext
  >;
}) => {
  const mutationOptions = getPutMyCandidateSkillTaxonomiesSkillTaxonomyIdNoteMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putMyCandidateSkillTaxonomiesSkillTaxonomyIdSkills = (
  skillTaxonomyId: number,
  putMyCandidateSkillTaxonomiesSkillTaxonomyIdSkillsBody: PutMyCandidateSkillTaxonomiesSkillTaxonomyIdSkillsBody,
) => {
  return customHttpClient<PutMyCandidateSkillTaxonomiesSkillTaxonomyIdSkills200>({
    url: `/my/candidate/skill-taxonomies/${skillTaxonomyId}/skills`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: putMyCandidateSkillTaxonomiesSkillTaxonomyIdSkillsBody,
  });
};

export const getPutMyCandidateSkillTaxonomiesSkillTaxonomyIdSkillsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putMyCandidateSkillTaxonomiesSkillTaxonomyIdSkills>>,
    TError,
    { skillTaxonomyId: number; data: PutMyCandidateSkillTaxonomiesSkillTaxonomyIdSkillsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putMyCandidateSkillTaxonomiesSkillTaxonomyIdSkills>>,
  TError,
  { skillTaxonomyId: number; data: PutMyCandidateSkillTaxonomiesSkillTaxonomyIdSkillsBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putMyCandidateSkillTaxonomiesSkillTaxonomyIdSkills>>,
    { skillTaxonomyId: number; data: PutMyCandidateSkillTaxonomiesSkillTaxonomyIdSkillsBody }
  > = (props) => {
    const { skillTaxonomyId, data } = props ?? {};

    return putMyCandidateSkillTaxonomiesSkillTaxonomyIdSkills(skillTaxonomyId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutMyCandidateSkillTaxonomiesSkillTaxonomyIdSkillsMutationResult = NonNullable<
  Awaited<ReturnType<typeof putMyCandidateSkillTaxonomiesSkillTaxonomyIdSkills>>
>;
export type PutMyCandidateSkillTaxonomiesSkillTaxonomyIdSkillsMutationBody =
  PutMyCandidateSkillTaxonomiesSkillTaxonomyIdSkillsBody;
export type PutMyCandidateSkillTaxonomiesSkillTaxonomyIdSkillsMutationError = unknown;

export const usePutMyCandidateSkillTaxonomiesSkillTaxonomyIdSkills = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putMyCandidateSkillTaxonomiesSkillTaxonomyIdSkills>>,
    TError,
    { skillTaxonomyId: number; data: PutMyCandidateSkillTaxonomiesSkillTaxonomyIdSkillsBody },
    TContext
  >;
}) => {
  const mutationOptions = getPutMyCandidateSkillTaxonomiesSkillTaxonomyIdSkillsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getMyCandidateProfile = (signal?: AbortSignal) => {
  return customHttpClient<GetMyCandidateProfile200>({ url: `/my/candidate-profile`, method: 'GET', signal });
};

export const getGetMyCandidateProfileQueryKey = () => {
  return [`/my/candidate-profile`] as const;
};

export const getGetMyCandidateProfileQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyCandidateProfile>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMyCandidateProfile>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyCandidateProfileQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyCandidateProfile>>> = ({ signal }) =>
    getMyCandidateProfile(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyCandidateProfile>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMyCandidateProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getMyCandidateProfile>>>;
export type GetMyCandidateProfileQueryError = unknown;

export const useGetMyCandidateProfile = <
  TData = Awaited<ReturnType<typeof getMyCandidateProfile>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMyCandidateProfile>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetMyCandidateProfileQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const putMyCandidateProfile = (putMyCandidateProfileBody: PutMyCandidateProfileBody) => {
  return customHttpClient<PutMyCandidateProfile200>({
    url: `/my/candidate-profile`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: putMyCandidateProfileBody,
  });
};

export const getPutMyCandidateProfileMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putMyCandidateProfile>>,
    TError,
    { data: PutMyCandidateProfileBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putMyCandidateProfile>>,
  TError,
  { data: PutMyCandidateProfileBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putMyCandidateProfile>>,
    { data: PutMyCandidateProfileBody }
  > = (props) => {
    const { data } = props ?? {};

    return putMyCandidateProfile(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutMyCandidateProfileMutationResult = NonNullable<Awaited<ReturnType<typeof putMyCandidateProfile>>>;
export type PutMyCandidateProfileMutationBody = PutMyCandidateProfileBody;
export type PutMyCandidateProfileMutationError = unknown;

export const usePutMyCandidateProfile = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putMyCandidateProfile>>,
    TError,
    { data: PutMyCandidateProfileBody },
    TContext
  >;
}) => {
  const mutationOptions = getPutMyCandidateProfileMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getMyCandidateProfileEditOptions = (signal?: AbortSignal) => {
  return customHttpClient<GetMyCandidateProfileEditOptions200>({
    url: `/my/candidate-profile/edit-options`,
    method: 'GET',
    signal,
  });
};

export const getGetMyCandidateProfileEditOptionsQueryKey = () => {
  return [`/my/candidate-profile/edit-options`] as const;
};

export const getGetMyCandidateProfileEditOptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyCandidateProfileEditOptions>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMyCandidateProfileEditOptions>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyCandidateProfileEditOptionsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyCandidateProfileEditOptions>>> = ({ signal }) =>
    getMyCandidateProfileEditOptions(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyCandidateProfileEditOptions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMyCandidateProfileEditOptionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyCandidateProfileEditOptions>>
>;
export type GetMyCandidateProfileEditOptionsQueryError = unknown;

export const useGetMyCandidateProfileEditOptions = <
  TData = Awaited<ReturnType<typeof getMyCandidateProfileEditOptions>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMyCandidateProfileEditOptions>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetMyCandidateProfileEditOptionsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postMyCandidateProfileAvatar = (postMyCandidateProfileAvatarBody: PostMyCandidateProfileAvatarBody) => {
  return customHttpClient<PostMyCandidateProfileAvatar200>({
    url: `/my/candidate-profile/avatar`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postMyCandidateProfileAvatarBody,
  });
};

export const getPostMyCandidateProfileAvatarMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMyCandidateProfileAvatar>>,
    TError,
    { data: PostMyCandidateProfileAvatarBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMyCandidateProfileAvatar>>,
  TError,
  { data: PostMyCandidateProfileAvatarBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMyCandidateProfileAvatar>>,
    { data: PostMyCandidateProfileAvatarBody }
  > = (props) => {
    const { data } = props ?? {};

    return postMyCandidateProfileAvatar(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMyCandidateProfileAvatarMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMyCandidateProfileAvatar>>
>;
export type PostMyCandidateProfileAvatarMutationBody = PostMyCandidateProfileAvatarBody;
export type PostMyCandidateProfileAvatarMutationError = unknown;

export const usePostMyCandidateProfileAvatar = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMyCandidateProfileAvatar>>,
    TError,
    { data: PostMyCandidateProfileAvatarBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostMyCandidateProfileAvatarMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postMyCandidateProfileForget = (postMyCandidateProfileForgetBody: PostMyCandidateProfileForgetBody) => {
  return customHttpClient<PostMyCandidateProfileForget200>({
    url: `/my/candidate-profile/forget`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postMyCandidateProfileForgetBody,
  });
};

export const getPostMyCandidateProfileForgetMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMyCandidateProfileForget>>,
    TError,
    { data: PostMyCandidateProfileForgetBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMyCandidateProfileForget>>,
  TError,
  { data: PostMyCandidateProfileForgetBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMyCandidateProfileForget>>,
    { data: PostMyCandidateProfileForgetBody }
  > = (props) => {
    const { data } = props ?? {};

    return postMyCandidateProfileForget(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMyCandidateProfileForgetMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMyCandidateProfileForget>>
>;
export type PostMyCandidateProfileForgetMutationBody = PostMyCandidateProfileForgetBody;
export type PostMyCandidateProfileForgetMutationError = unknown;

export const usePostMyCandidateProfileForget = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMyCandidateProfileForget>>,
    TError,
    { data: PostMyCandidateProfileForgetBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostMyCandidateProfileForgetMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postMyCandidateProfileWorkHistory = (
  postMyCandidateProfileWorkHistoryBody: PostMyCandidateProfileWorkHistoryBody,
) => {
  return customHttpClient<PostMyCandidateProfileWorkHistory200>({
    url: `/my/candidate-profile/work-history`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postMyCandidateProfileWorkHistoryBody,
  });
};

export const getPostMyCandidateProfileWorkHistoryMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMyCandidateProfileWorkHistory>>,
    TError,
    { data: PostMyCandidateProfileWorkHistoryBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMyCandidateProfileWorkHistory>>,
  TError,
  { data: PostMyCandidateProfileWorkHistoryBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMyCandidateProfileWorkHistory>>,
    { data: PostMyCandidateProfileWorkHistoryBody }
  > = (props) => {
    const { data } = props ?? {};

    return postMyCandidateProfileWorkHistory(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMyCandidateProfileWorkHistoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMyCandidateProfileWorkHistory>>
>;
export type PostMyCandidateProfileWorkHistoryMutationBody = PostMyCandidateProfileWorkHistoryBody;
export type PostMyCandidateProfileWorkHistoryMutationError = unknown;

export const usePostMyCandidateProfileWorkHistory = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMyCandidateProfileWorkHistory>>,
    TError,
    { data: PostMyCandidateProfileWorkHistoryBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostMyCandidateProfileWorkHistoryMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putMyCandidateProfileWorkHistoryWorkHistoryId = (workHistoryId: number) => {
  return customHttpClient<PutMyCandidateProfileWorkHistoryWorkHistoryId200>({
    url: `/my/candidate-profile/work-history/${workHistoryId}`,
    method: 'PUT',
  });
};

export const getPutMyCandidateProfileWorkHistoryWorkHistoryIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putMyCandidateProfileWorkHistoryWorkHistoryId>>,
    TError,
    { workHistoryId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putMyCandidateProfileWorkHistoryWorkHistoryId>>,
  TError,
  { workHistoryId: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putMyCandidateProfileWorkHistoryWorkHistoryId>>,
    { workHistoryId: number }
  > = (props) => {
    const { workHistoryId } = props ?? {};

    return putMyCandidateProfileWorkHistoryWorkHistoryId(workHistoryId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutMyCandidateProfileWorkHistoryWorkHistoryIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putMyCandidateProfileWorkHistoryWorkHistoryId>>
>;

export type PutMyCandidateProfileWorkHistoryWorkHistoryIdMutationError = unknown;

export const usePutMyCandidateProfileWorkHistoryWorkHistoryId = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putMyCandidateProfileWorkHistoryWorkHistoryId>>,
    TError,
    { workHistoryId: number },
    TContext
  >;
}) => {
  const mutationOptions = getPutMyCandidateProfileWorkHistoryWorkHistoryIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteMyCandidateProfileWorkHistoryWorkHistoryId = (workHistoryId: number) => {
  return customHttpClient<DeleteMyCandidateProfileWorkHistoryWorkHistoryId200>({
    url: `/my/candidate-profile/work-history/${workHistoryId}`,
    method: 'DELETE',
  });
};

export const getDeleteMyCandidateProfileWorkHistoryWorkHistoryIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMyCandidateProfileWorkHistoryWorkHistoryId>>,
    TError,
    { workHistoryId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMyCandidateProfileWorkHistoryWorkHistoryId>>,
  TError,
  { workHistoryId: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMyCandidateProfileWorkHistoryWorkHistoryId>>,
    { workHistoryId: number }
  > = (props) => {
    const { workHistoryId } = props ?? {};

    return deleteMyCandidateProfileWorkHistoryWorkHistoryId(workHistoryId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMyCandidateProfileWorkHistoryWorkHistoryIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMyCandidateProfileWorkHistoryWorkHistoryId>>
>;

export type DeleteMyCandidateProfileWorkHistoryWorkHistoryIdMutationError = unknown;

export const useDeleteMyCandidateProfileWorkHistoryWorkHistoryId = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMyCandidateProfileWorkHistoryWorkHistoryId>>,
    TError,
    { workHistoryId: number },
    TContext
  >;
}) => {
  const mutationOptions = getDeleteMyCandidateProfileWorkHistoryWorkHistoryIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postMyCandidateProfileEducation = (
  postMyCandidateProfileEducationBody: PostMyCandidateProfileEducationBody,
) => {
  return customHttpClient<PostMyCandidateProfileEducation200>({
    url: `/my/candidate-profile/education`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postMyCandidateProfileEducationBody,
  });
};

export const getPostMyCandidateProfileEducationMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMyCandidateProfileEducation>>,
    TError,
    { data: PostMyCandidateProfileEducationBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMyCandidateProfileEducation>>,
  TError,
  { data: PostMyCandidateProfileEducationBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMyCandidateProfileEducation>>,
    { data: PostMyCandidateProfileEducationBody }
  > = (props) => {
    const { data } = props ?? {};

    return postMyCandidateProfileEducation(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMyCandidateProfileEducationMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMyCandidateProfileEducation>>
>;
export type PostMyCandidateProfileEducationMutationBody = PostMyCandidateProfileEducationBody;
export type PostMyCandidateProfileEducationMutationError = unknown;

export const usePostMyCandidateProfileEducation = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMyCandidateProfileEducation>>,
    TError,
    { data: PostMyCandidateProfileEducationBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostMyCandidateProfileEducationMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putMyCandidateProfileEducationEducationId = (educationId: number) => {
  return customHttpClient<PutMyCandidateProfileEducationEducationId200>({
    url: `/my/candidate-profile/education/${educationId}`,
    method: 'PUT',
  });
};

export const getPutMyCandidateProfileEducationEducationIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putMyCandidateProfileEducationEducationId>>,
    TError,
    { educationId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putMyCandidateProfileEducationEducationId>>,
  TError,
  { educationId: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putMyCandidateProfileEducationEducationId>>,
    { educationId: number }
  > = (props) => {
    const { educationId } = props ?? {};

    return putMyCandidateProfileEducationEducationId(educationId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutMyCandidateProfileEducationEducationIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putMyCandidateProfileEducationEducationId>>
>;

export type PutMyCandidateProfileEducationEducationIdMutationError = unknown;

export const usePutMyCandidateProfileEducationEducationId = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putMyCandidateProfileEducationEducationId>>,
    TError,
    { educationId: number },
    TContext
  >;
}) => {
  const mutationOptions = getPutMyCandidateProfileEducationEducationIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteMyCandidateProfileEducationEducationId = (educationId: number) => {
  return customHttpClient<DeleteMyCandidateProfileEducationEducationId200>({
    url: `/my/candidate-profile/education/${educationId}`,
    method: 'DELETE',
  });
};

export const getDeleteMyCandidateProfileEducationEducationIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMyCandidateProfileEducationEducationId>>,
    TError,
    { educationId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMyCandidateProfileEducationEducationId>>,
  TError,
  { educationId: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMyCandidateProfileEducationEducationId>>,
    { educationId: number }
  > = (props) => {
    const { educationId } = props ?? {};

    return deleteMyCandidateProfileEducationEducationId(educationId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMyCandidateProfileEducationEducationIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMyCandidateProfileEducationEducationId>>
>;

export type DeleteMyCandidateProfileEducationEducationIdMutationError = unknown;

export const useDeleteMyCandidateProfileEducationEducationId = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMyCandidateProfileEducationEducationId>>,
    TError,
    { educationId: number },
    TContext
  >;
}) => {
  const mutationOptions = getDeleteMyCandidateProfileEducationEducationIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postMyCandidateProfileAttachments = (
  postMyCandidateProfileAttachmentsBody: PostMyCandidateProfileAttachmentsBody,
) => {
  return customHttpClient<PostMyCandidateProfileAttachments200>({
    url: `/my/candidate-profile/attachments`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postMyCandidateProfileAttachmentsBody,
  });
};

export const getPostMyCandidateProfileAttachmentsMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMyCandidateProfileAttachments>>,
    TError,
    { data: PostMyCandidateProfileAttachmentsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMyCandidateProfileAttachments>>,
  TError,
  { data: PostMyCandidateProfileAttachmentsBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMyCandidateProfileAttachments>>,
    { data: PostMyCandidateProfileAttachmentsBody }
  > = (props) => {
    const { data } = props ?? {};

    return postMyCandidateProfileAttachments(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMyCandidateProfileAttachmentsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMyCandidateProfileAttachments>>
>;
export type PostMyCandidateProfileAttachmentsMutationBody = PostMyCandidateProfileAttachmentsBody;
export type PostMyCandidateProfileAttachmentsMutationError = unknown;

export const usePostMyCandidateProfileAttachments = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMyCandidateProfileAttachments>>,
    TError,
    { data: PostMyCandidateProfileAttachmentsBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostMyCandidateProfileAttachmentsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putMyCandidateProfileAttachmentsAttachmentId = (attachmentId: number) => {
  return customHttpClient<PutMyCandidateProfileAttachmentsAttachmentId200>({
    url: `/my/candidate-profile/attachments/${attachmentId}`,
    method: 'PUT',
  });
};

export const getPutMyCandidateProfileAttachmentsAttachmentIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putMyCandidateProfileAttachmentsAttachmentId>>,
    TError,
    { attachmentId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putMyCandidateProfileAttachmentsAttachmentId>>,
  TError,
  { attachmentId: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putMyCandidateProfileAttachmentsAttachmentId>>,
    { attachmentId: number }
  > = (props) => {
    const { attachmentId } = props ?? {};

    return putMyCandidateProfileAttachmentsAttachmentId(attachmentId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutMyCandidateProfileAttachmentsAttachmentIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putMyCandidateProfileAttachmentsAttachmentId>>
>;

export type PutMyCandidateProfileAttachmentsAttachmentIdMutationError = unknown;

export const usePutMyCandidateProfileAttachmentsAttachmentId = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putMyCandidateProfileAttachmentsAttachmentId>>,
    TError,
    { attachmentId: number },
    TContext
  >;
}) => {
  const mutationOptions = getPutMyCandidateProfileAttachmentsAttachmentIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteMyCandidateProfileAttachmentsAttachmentId = (attachmentId: number) => {
  return customHttpClient<DeleteMyCandidateProfileAttachmentsAttachmentId200>({
    url: `/my/candidate-profile/attachments/${attachmentId}`,
    method: 'DELETE',
  });
};

export const getDeleteMyCandidateProfileAttachmentsAttachmentIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMyCandidateProfileAttachmentsAttachmentId>>,
    TError,
    { attachmentId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMyCandidateProfileAttachmentsAttachmentId>>,
  TError,
  { attachmentId: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMyCandidateProfileAttachmentsAttachmentId>>,
    { attachmentId: number }
  > = (props) => {
    const { attachmentId } = props ?? {};

    return deleteMyCandidateProfileAttachmentsAttachmentId(attachmentId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMyCandidateProfileAttachmentsAttachmentIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMyCandidateProfileAttachmentsAttachmentId>>
>;

export type DeleteMyCandidateProfileAttachmentsAttachmentIdMutationError = unknown;

export const useDeleteMyCandidateProfileAttachmentsAttachmentId = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMyCandidateProfileAttachmentsAttachmentId>>,
    TError,
    { attachmentId: number },
    TContext
  >;
}) => {
  const mutationOptions = getDeleteMyCandidateProfileAttachmentsAttachmentIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postMyCandidateProfileResumes = (postMyCandidateProfileResumesBody: PostMyCandidateProfileResumesBody) => {
  return customHttpClient<PostMyCandidateProfileResumes200>({
    url: `/my/candidate-profile/resumes`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postMyCandidateProfileResumesBody,
  });
};

export const getPostMyCandidateProfileResumesMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMyCandidateProfileResumes>>,
    TError,
    { data: PostMyCandidateProfileResumesBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMyCandidateProfileResumes>>,
  TError,
  { data: PostMyCandidateProfileResumesBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMyCandidateProfileResumes>>,
    { data: PostMyCandidateProfileResumesBody }
  > = (props) => {
    const { data } = props ?? {};

    return postMyCandidateProfileResumes(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMyCandidateProfileResumesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMyCandidateProfileResumes>>
>;
export type PostMyCandidateProfileResumesMutationBody = PostMyCandidateProfileResumesBody;
export type PostMyCandidateProfileResumesMutationError = unknown;

export const usePostMyCandidateProfileResumes = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMyCandidateProfileResumes>>,
    TError,
    { data: PostMyCandidateProfileResumesBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostMyCandidateProfileResumesMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteMyCandidateProfileResumesResumeId = (resumeId: number) => {
  return customHttpClient<DeleteMyCandidateProfileResumesResumeId200>({
    url: `/my/candidate-profile/resumes/${resumeId}`,
    method: 'DELETE',
  });
};

export const getDeleteMyCandidateProfileResumesResumeIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMyCandidateProfileResumesResumeId>>,
    TError,
    { resumeId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMyCandidateProfileResumesResumeId>>,
  TError,
  { resumeId: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMyCandidateProfileResumesResumeId>>,
    { resumeId: number }
  > = (props) => {
    const { resumeId } = props ?? {};

    return deleteMyCandidateProfileResumesResumeId(resumeId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMyCandidateProfileResumesResumeIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMyCandidateProfileResumesResumeId>>
>;

export type DeleteMyCandidateProfileResumesResumeIdMutationError = unknown;

export const useDeleteMyCandidateProfileResumesResumeId = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMyCandidateProfileResumesResumeId>>,
    TError,
    { resumeId: number },
    TContext
  >;
}) => {
  const mutationOptions = getDeleteMyCandidateProfileResumesResumeIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postMyCandidateProfileLanguages = (
  postMyCandidateProfileLanguagesBody: PostMyCandidateProfileLanguagesBody,
) => {
  return customHttpClient<PostMyCandidateProfileLanguages200>({
    url: `/my/candidate-profile/languages`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postMyCandidateProfileLanguagesBody,
  });
};

export const getPostMyCandidateProfileLanguagesMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMyCandidateProfileLanguages>>,
    TError,
    { data: PostMyCandidateProfileLanguagesBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMyCandidateProfileLanguages>>,
  TError,
  { data: PostMyCandidateProfileLanguagesBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMyCandidateProfileLanguages>>,
    { data: PostMyCandidateProfileLanguagesBody }
  > = (props) => {
    const { data } = props ?? {};

    return postMyCandidateProfileLanguages(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMyCandidateProfileLanguagesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMyCandidateProfileLanguages>>
>;
export type PostMyCandidateProfileLanguagesMutationBody = PostMyCandidateProfileLanguagesBody;
export type PostMyCandidateProfileLanguagesMutationError = unknown;

export const usePostMyCandidateProfileLanguages = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMyCandidateProfileLanguages>>,
    TError,
    { data: PostMyCandidateProfileLanguagesBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostMyCandidateProfileLanguagesMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putMyCandidateProfileLanguagesCandidateLanguageId = (candidateLanguageId: number) => {
  return customHttpClient<PutMyCandidateProfileLanguagesCandidateLanguageId200>({
    url: `/my/candidate-profile/languages/${candidateLanguageId}`,
    method: 'PUT',
  });
};

export const getPutMyCandidateProfileLanguagesCandidateLanguageIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putMyCandidateProfileLanguagesCandidateLanguageId>>,
    TError,
    { candidateLanguageId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putMyCandidateProfileLanguagesCandidateLanguageId>>,
  TError,
  { candidateLanguageId: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putMyCandidateProfileLanguagesCandidateLanguageId>>,
    { candidateLanguageId: number }
  > = (props) => {
    const { candidateLanguageId } = props ?? {};

    return putMyCandidateProfileLanguagesCandidateLanguageId(candidateLanguageId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutMyCandidateProfileLanguagesCandidateLanguageIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putMyCandidateProfileLanguagesCandidateLanguageId>>
>;

export type PutMyCandidateProfileLanguagesCandidateLanguageIdMutationError = unknown;

export const usePutMyCandidateProfileLanguagesCandidateLanguageId = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putMyCandidateProfileLanguagesCandidateLanguageId>>,
    TError,
    { candidateLanguageId: number },
    TContext
  >;
}) => {
  const mutationOptions = getPutMyCandidateProfileLanguagesCandidateLanguageIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteMyCandidateProfileLanguagesCandidateLanguageId = (candidateLanguageId: number) => {
  return customHttpClient<DeleteMyCandidateProfileLanguagesCandidateLanguageId200>({
    url: `/my/candidate-profile/languages/${candidateLanguageId}`,
    method: 'DELETE',
  });
};

export const getDeleteMyCandidateProfileLanguagesCandidateLanguageIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMyCandidateProfileLanguagesCandidateLanguageId>>,
    TError,
    { candidateLanguageId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMyCandidateProfileLanguagesCandidateLanguageId>>,
  TError,
  { candidateLanguageId: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMyCandidateProfileLanguagesCandidateLanguageId>>,
    { candidateLanguageId: number }
  > = (props) => {
    const { candidateLanguageId } = props ?? {};

    return deleteMyCandidateProfileLanguagesCandidateLanguageId(candidateLanguageId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMyCandidateProfileLanguagesCandidateLanguageIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMyCandidateProfileLanguagesCandidateLanguageId>>
>;

export type DeleteMyCandidateProfileLanguagesCandidateLanguageIdMutationError = unknown;

export const useDeleteMyCandidateProfileLanguagesCandidateLanguageId = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMyCandidateProfileLanguagesCandidateLanguageId>>,
    TError,
    { candidateLanguageId: number },
    TContext
  >;
}) => {
  const mutationOptions = getDeleteMyCandidateProfileLanguagesCandidateLanguageIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getMyCandidateProfileResumesResumeIdParse = (resumeId: number, signal?: AbortSignal) => {
  return customHttpClient<GetMyCandidateProfileResumesResumeIdParse200>({
    url: `/my/candidate-profile/resumes/${resumeId}/parse`,
    method: 'GET',
    signal,
  });
};

export const getGetMyCandidateProfileResumesResumeIdParseQueryKey = (resumeId: number) => {
  return [`/my/candidate-profile/resumes/${resumeId}/parse`] as const;
};

export const getGetMyCandidateProfileResumesResumeIdParseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyCandidateProfileResumesResumeIdParse>>,
  TError = unknown,
>(
  resumeId: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getMyCandidateProfileResumesResumeIdParse>>, TError, TData>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyCandidateProfileResumesResumeIdParseQueryKey(resumeId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyCandidateProfileResumesResumeIdParse>>> = ({ signal }) =>
    getMyCandidateProfileResumesResumeIdParse(resumeId, signal);

  return { queryKey, queryFn, enabled: !!resumeId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyCandidateProfileResumesResumeIdParse>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMyCandidateProfileResumesResumeIdParseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyCandidateProfileResumesResumeIdParse>>
>;
export type GetMyCandidateProfileResumesResumeIdParseQueryError = unknown;

export const useGetMyCandidateProfileResumesResumeIdParse = <
  TData = Awaited<ReturnType<typeof getMyCandidateProfileResumesResumeIdParse>>,
  TError = unknown,
>(
  resumeId: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getMyCandidateProfileResumesResumeIdParse>>, TError, TData>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetMyCandidateProfileResumesResumeIdParseQueryOptions(resumeId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getMyCandidateProfileCustomFields = (signal?: AbortSignal) => {
  return customHttpClient<GetMyCandidateProfileCustomFields200>({
    url: `/my/candidate-profile/custom-fields`,
    method: 'GET',
    signal,
  });
};

export const getGetMyCandidateProfileCustomFieldsQueryKey = () => {
  return [`/my/candidate-profile/custom-fields`] as const;
};

export const getGetMyCandidateProfileCustomFieldsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyCandidateProfileCustomFields>>,
  TError = Status400 | Status401,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMyCandidateProfileCustomFields>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyCandidateProfileCustomFieldsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyCandidateProfileCustomFields>>> = ({ signal }) =>
    getMyCandidateProfileCustomFields(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyCandidateProfileCustomFields>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMyCandidateProfileCustomFieldsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyCandidateProfileCustomFields>>
>;
export type GetMyCandidateProfileCustomFieldsQueryError = Status400 | Status401;

export const useGetMyCandidateProfileCustomFields = <
  TData = Awaited<ReturnType<typeof getMyCandidateProfileCustomFields>>,
  TError = Status400 | Status401,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMyCandidateProfileCustomFields>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetMyCandidateProfileCustomFieldsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const putMyCandidateProfileCustomFields = (
  putMyCandidateProfileCustomFieldsBody: PutMyCandidateProfileCustomFieldsBody,
) => {
  return customHttpClient<PutMyCandidateProfileCustomFields200>({
    url: `/my/candidate-profile/custom-fields`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: putMyCandidateProfileCustomFieldsBody,
  });
};

export const getPutMyCandidateProfileCustomFieldsMutationOptions = <
  TError = Status400 | Status401,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putMyCandidateProfileCustomFields>>,
    TError,
    { data: PutMyCandidateProfileCustomFieldsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putMyCandidateProfileCustomFields>>,
  TError,
  { data: PutMyCandidateProfileCustomFieldsBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putMyCandidateProfileCustomFields>>,
    { data: PutMyCandidateProfileCustomFieldsBody }
  > = (props) => {
    const { data } = props ?? {};

    return putMyCandidateProfileCustomFields(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutMyCandidateProfileCustomFieldsMutationResult = NonNullable<
  Awaited<ReturnType<typeof putMyCandidateProfileCustomFields>>
>;
export type PutMyCandidateProfileCustomFieldsMutationBody = PutMyCandidateProfileCustomFieldsBody;
export type PutMyCandidateProfileCustomFieldsMutationError = Status400 | Status401;

export const usePutMyCandidateProfileCustomFields = <TError = Status400 | Status401, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putMyCandidateProfileCustomFields>>,
    TError,
    { data: PutMyCandidateProfileCustomFieldsBody },
    TContext
  >;
}) => {
  const mutationOptions = getPutMyCandidateProfileCustomFieldsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getMyCandidateProfileCustomFieldsModel = (signal?: AbortSignal) => {
  return customHttpClient<GetMyCandidateProfileCustomFieldsModel200>({
    url: `/my/candidate-profile/custom-fields/model`,
    method: 'GET',
    signal,
  });
};

export const getGetMyCandidateProfileCustomFieldsModelQueryKey = () => {
  return [`/my/candidate-profile/custom-fields/model`] as const;
};

export const getGetMyCandidateProfileCustomFieldsModelQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyCandidateProfileCustomFieldsModel>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMyCandidateProfileCustomFieldsModel>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyCandidateProfileCustomFieldsModelQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyCandidateProfileCustomFieldsModel>>> = ({ signal }) =>
    getMyCandidateProfileCustomFieldsModel(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyCandidateProfileCustomFieldsModel>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMyCandidateProfileCustomFieldsModelQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyCandidateProfileCustomFieldsModel>>
>;
export type GetMyCandidateProfileCustomFieldsModelQueryError = unknown;

export const useGetMyCandidateProfileCustomFieldsModel = <
  TData = Awaited<ReturnType<typeof getMyCandidateProfileCustomFieldsModel>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMyCandidateProfileCustomFieldsModel>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetMyCandidateProfileCustomFieldsModelQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const putMyCandidateProfileCustomFieldsExtend = (
  putMyCandidateProfileCustomFieldsExtendBody: PutMyCandidateProfileCustomFieldsExtendBody,
) => {
  return customHttpClient<PutMyCandidateProfileCustomFieldsExtend200>({
    url: `/my/candidate-profile/custom-fields/extend`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: putMyCandidateProfileCustomFieldsExtendBody,
  });
};

export const getPutMyCandidateProfileCustomFieldsExtendMutationOptions = <
  TError = Status400 | Status401,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putMyCandidateProfileCustomFieldsExtend>>,
    TError,
    { data: PutMyCandidateProfileCustomFieldsExtendBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putMyCandidateProfileCustomFieldsExtend>>,
  TError,
  { data: PutMyCandidateProfileCustomFieldsExtendBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putMyCandidateProfileCustomFieldsExtend>>,
    { data: PutMyCandidateProfileCustomFieldsExtendBody }
  > = (props) => {
    const { data } = props ?? {};

    return putMyCandidateProfileCustomFieldsExtend(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutMyCandidateProfileCustomFieldsExtendMutationResult = NonNullable<
  Awaited<ReturnType<typeof putMyCandidateProfileCustomFieldsExtend>>
>;
export type PutMyCandidateProfileCustomFieldsExtendMutationBody = PutMyCandidateProfileCustomFieldsExtendBody;
export type PutMyCandidateProfileCustomFieldsExtendMutationError = Status400 | Status401;

export const usePutMyCandidateProfileCustomFieldsExtend = <
  TError = Status400 | Status401,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putMyCandidateProfileCustomFieldsExtend>>,
    TError,
    { data: PutMyCandidateProfileCustomFieldsExtendBody },
    TContext
  >;
}) => {
  const mutationOptions = getPutMyCandidateProfileCustomFieldsExtendMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getMyContactProfile = (signal?: AbortSignal) => {
  return customHttpClient<GetMyContactProfile200>({ url: `/my/contact-profile`, method: 'GET', signal });
};

export const getGetMyContactProfileQueryKey = () => {
  return [`/my/contact-profile`] as const;
};

export const getGetMyContactProfileQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyContactProfile>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMyContactProfile>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyContactProfileQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyContactProfile>>> = ({ signal }) =>
    getMyContactProfile(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyContactProfile>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMyContactProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getMyContactProfile>>>;
export type GetMyContactProfileQueryError = unknown;

export const useGetMyContactProfile = <
  TData = Awaited<ReturnType<typeof getMyContactProfile>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMyContactProfile>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetMyContactProfileQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const putMyContactProfile = (putMyContactProfileBody: PutMyContactProfileBody) => {
  return customHttpClient<PutMyContactProfile200>({
    url: `/my/contact-profile`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: putMyContactProfileBody,
  });
};

export const getPutMyContactProfileMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putMyContactProfile>>,
    TError,
    { data: PutMyContactProfileBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putMyContactProfile>>,
  TError,
  { data: PutMyContactProfileBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putMyContactProfile>>,
    { data: PutMyContactProfileBody }
  > = (props) => {
    const { data } = props ?? {};

    return putMyContactProfile(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutMyContactProfileMutationResult = NonNullable<Awaited<ReturnType<typeof putMyContactProfile>>>;
export type PutMyContactProfileMutationBody = PutMyContactProfileBody;
export type PutMyContactProfileMutationError = unknown;

export const usePutMyContactProfile = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putMyContactProfile>>,
    TError,
    { data: PutMyContactProfileBody },
    TContext
  >;
}) => {
  const mutationOptions = getPutMyContactProfileMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteMyNylas = () => {
  return customHttpClient<DeleteMyNylas200>({ url: `/my/nylas`, method: 'DELETE' });
};

export const getDeleteMyNylasMutationOptions = <TError = Status400 | Status401, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof deleteMyNylas>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof deleteMyNylas>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteMyNylas>>, void> = () => {
    return deleteMyNylas();
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMyNylasMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMyNylas>>>;

export type DeleteMyNylasMutationError = Status400 | Status401;

export const useDeleteMyNylas = <TError = Status400 | Status401, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof deleteMyNylas>>, TError, void, TContext>;
}) => {
  const mutationOptions = getDeleteMyNylasMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getMyPipelines = (signal?: AbortSignal) => {
  return customHttpClient<GetMyPipelines200>({ url: `/my/pipelines`, method: 'GET', signal });
};

export const getGetMyPipelinesQueryKey = () => {
  return [`/my/pipelines`] as const;
};

export const getGetMyPipelinesQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyPipelines>>,
  TError = Status400 | Status401,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMyPipelines>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyPipelinesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyPipelines>>> = ({ signal }) => getMyPipelines(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyPipelines>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMyPipelinesQueryResult = NonNullable<Awaited<ReturnType<typeof getMyPipelines>>>;
export type GetMyPipelinesQueryError = Status400 | Status401;

export const useGetMyPipelines = <
  TData = Awaited<ReturnType<typeof getMyPipelines>>,
  TError = Status400 | Status401,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMyPipelines>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetMyPipelinesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getMyWebchats = (signal?: AbortSignal) => {
  return customHttpClient<GetMyWebchats200>({ url: `/my/webchats`, method: 'GET', signal });
};

export const getGetMyWebchatsQueryKey = () => {
  return [`/my/webchats`] as const;
};

export const getGetMyWebchatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyWebchats>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMyWebchats>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyWebchatsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyWebchats>>> = ({ signal }) => getMyWebchats(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyWebchats>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMyWebchatsQueryResult = NonNullable<Awaited<ReturnType<typeof getMyWebchats>>>;
export type GetMyWebchatsQueryError = unknown;

export const useGetMyWebchats = <TData = Awaited<ReturnType<typeof getMyWebchats>>, TError = unknown>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMyWebchats>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetMyWebchatsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getMyWebchatsMessages = (signal?: AbortSignal) => {
  return customHttpClient<GetMyWebchatsMessages200>({ url: `/my/webchats/messages`, method: 'GET', signal });
};

export const getGetMyWebchatsMessagesQueryKey = () => {
  return [`/my/webchats/messages`] as const;
};

export const getGetMyWebchatsMessagesQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyWebchatsMessages>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMyWebchatsMessages>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyWebchatsMessagesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyWebchatsMessages>>> = ({ signal }) =>
    getMyWebchatsMessages(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyWebchatsMessages>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMyWebchatsMessagesQueryResult = NonNullable<Awaited<ReturnType<typeof getMyWebchatsMessages>>>;
export type GetMyWebchatsMessagesQueryError = unknown;

export const useGetMyWebchatsMessages = <
  TData = Awaited<ReturnType<typeof getMyWebchatsMessages>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMyWebchatsMessages>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetMyWebchatsMessagesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postMyWebchatsRead = (postMyWebchatsReadBody: PostMyWebchatsReadBody) => {
  return customHttpClient<PostMyWebchatsRead200>({
    url: `/my/webchats/read`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postMyWebchatsReadBody,
  });
};

export const getPostMyWebchatsReadMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMyWebchatsRead>>,
    TError,
    { data: PostMyWebchatsReadBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMyWebchatsRead>>,
  TError,
  { data: PostMyWebchatsReadBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMyWebchatsRead>>,
    { data: PostMyWebchatsReadBody }
  > = (props) => {
    const { data } = props ?? {};

    return postMyWebchatsRead(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMyWebchatsReadMutationResult = NonNullable<Awaited<ReturnType<typeof postMyWebchatsRead>>>;
export type PostMyWebchatsReadMutationBody = PostMyWebchatsReadBody;
export type PostMyWebchatsReadMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostMyWebchatsRead = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMyWebchatsRead>>,
    TError,
    { data: PostMyWebchatsReadBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostMyWebchatsReadMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getMyWebchatsRead = (signal?: AbortSignal) => {
  return customHttpClient<GetMyWebchatsRead200>({ url: `/my/webchats/read`, method: 'GET', signal });
};

export const getGetMyWebchatsReadQueryKey = () => {
  return [`/my/webchats/read`] as const;
};

export const getGetMyWebchatsReadQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyWebchatsRead>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMyWebchatsRead>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyWebchatsReadQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyWebchatsRead>>> = ({ signal }) =>
    getMyWebchatsRead(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyWebchatsRead>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMyWebchatsReadQueryResult = NonNullable<Awaited<ReturnType<typeof getMyWebchatsRead>>>;
export type GetMyWebchatsReadQueryError = unknown;

export const useGetMyWebchatsRead = <
  TData = Awaited<ReturnType<typeof getMyWebchatsRead>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMyWebchatsRead>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetMyWebchatsReadQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getMyGdpr = (signal?: AbortSignal) => {
  return customHttpClient<GetMyGdpr200>({ url: `/my/gdpr`, method: 'GET', signal });
};

export const getGetMyGdprQueryKey = () => {
  return [`/my/gdpr`] as const;
};

export const getGetMyGdprQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyGdpr>>,
  TError = Status400 | Status401 | Status403,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMyGdpr>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyGdprQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyGdpr>>> = ({ signal }) => getMyGdpr(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyGdpr>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMyGdprQueryResult = NonNullable<Awaited<ReturnType<typeof getMyGdpr>>>;
export type GetMyGdprQueryError = Status400 | Status401 | Status403;

export const useGetMyGdpr = <
  TData = Awaited<ReturnType<typeof getMyGdpr>>,
  TError = Status400 | Status401 | Status403,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMyGdpr>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetMyGdprQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postMyGdpr = (postMyGdprBody: PostMyGdprBody) => {
  return customHttpClient<PostMyGdpr200>({
    url: `/my/gdpr`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postMyGdprBody,
  });
};

export const getPostMyGdprMutationOptions = <TError = Status400 | Status401 | Status403, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postMyGdpr>>, TError, { data: PostMyGdprBody }, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof postMyGdpr>>, TError, { data: PostMyGdprBody }, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMyGdpr>>, { data: PostMyGdprBody }> = (props) => {
    const { data } = props ?? {};

    return postMyGdpr(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMyGdprMutationResult = NonNullable<Awaited<ReturnType<typeof postMyGdpr>>>;
export type PostMyGdprMutationBody = PostMyGdprBody;
export type PostMyGdprMutationError = Status400 | Status401 | Status403;

export const usePostMyGdpr = <TError = Status400 | Status401 | Status403, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postMyGdpr>>, TError, { data: PostMyGdprBody }, TContext>;
}) => {
  const mutationOptions = getPostMyGdprMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postStopWords = (requestBodyStopWord: RequestBodyStopWord) => {
  return customHttpClient<StopWord>({
    url: `/stop-words`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: requestBodyStopWord,
  });
};

export const getPostStopWordsMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postStopWords>>,
    TError,
    { data: RequestBodyStopWord },
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<typeof postStopWords>>, TError, { data: RequestBodyStopWord }, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postStopWords>>, { data: RequestBodyStopWord }> = (
    props,
  ) => {
    const { data } = props ?? {};

    return postStopWords(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostStopWordsMutationResult = NonNullable<Awaited<ReturnType<typeof postStopWords>>>;
export type PostStopWordsMutationBody = RequestBodyStopWord;
export type PostStopWordsMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostStopWords = <TError = Status400 | Status401 | Status403 | Status404, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postStopWords>>,
    TError,
    { data: RequestBodyStopWord },
    TContext
  >;
}) => {
  const mutationOptions = getPostStopWordsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getStopWords = (signal?: AbortSignal) => {
  return customHttpClient<GetStopWords200>({ url: `/stop-words`, method: 'GET', signal });
};

export const getGetStopWordsQueryKey = () => {
  return [`/stop-words`] as const;
};

export const getGetStopWordsQueryOptions = <
  TData = Awaited<ReturnType<typeof getStopWords>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getStopWords>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetStopWordsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStopWords>>> = ({ signal }) => getStopWords(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStopWords>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetStopWordsQueryResult = NonNullable<Awaited<ReturnType<typeof getStopWords>>>;
export type GetStopWordsQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetStopWords = <
  TData = Awaited<ReturnType<typeof getStopWords>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getStopWords>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetStopWordsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getStopWordsStopWordId = (signal?: AbortSignal) => {
  return customHttpClient<GetStopWordsStopWordId200>({ url: `/stop-words/:stopWordId`, method: 'GET', signal });
};

export const getGetStopWordsStopWordIdQueryKey = () => {
  return [`/stop-words/:stopWordId`] as const;
};

export const getGetStopWordsStopWordIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getStopWordsStopWordId>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getStopWordsStopWordId>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetStopWordsStopWordIdQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStopWordsStopWordId>>> = ({ signal }) =>
    getStopWordsStopWordId(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStopWordsStopWordId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetStopWordsStopWordIdQueryResult = NonNullable<Awaited<ReturnType<typeof getStopWordsStopWordId>>>;
export type GetStopWordsStopWordIdQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetStopWordsStopWordId = <
  TData = Awaited<ReturnType<typeof getStopWordsStopWordId>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getStopWordsStopWordId>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetStopWordsStopWordIdQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const putStopWordsStopWordId = () => {
  return customHttpClient<PutStopWordsStopWordId200>({ url: `/stop-words/:stopWordId`, method: 'PUT' });
};

export const getPutStopWordsStopWordIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putStopWordsStopWordId>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof putStopWordsStopWordId>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof putStopWordsStopWordId>>, void> = () => {
    return putStopWordsStopWordId();
  };

  return { mutationFn, ...mutationOptions };
};

export type PutStopWordsStopWordIdMutationResult = NonNullable<Awaited<ReturnType<typeof putStopWordsStopWordId>>>;

export type PutStopWordsStopWordIdMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutStopWordsStopWordId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putStopWordsStopWordId>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPutStopWordsStopWordIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteStopWordsStopWordId = () => {
  return customHttpClient<DeleteStopWordsStopWordId200>({ url: `/stop-words/:stopWordId`, method: 'DELETE' });
};

export const getDeleteStopWordsStopWordIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof deleteStopWordsStopWordId>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof deleteStopWordsStopWordId>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteStopWordsStopWordId>>, void> = () => {
    return deleteStopWordsStopWordId();
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteStopWordsStopWordIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteStopWordsStopWordId>>
>;

export type DeleteStopWordsStopWordIdMutationError = Status400 | Status401 | Status403 | Status404;

export const useDeleteStopWordsStopWordId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof deleteStopWordsStopWordId>>, TError, void, TContext>;
}) => {
  const mutationOptions = getDeleteStopWordsStopWordIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getCandidatesEditOptions = (signal?: AbortSignal) => {
  return customHttpClient<GetCandidatesEditOptions200>({ url: `/candidates/edit-options`, method: 'GET', signal });
};

export const getGetCandidatesEditOptionsQueryKey = () => {
  return [`/candidates/edit-options`] as const;
};

export const getGetCandidatesEditOptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCandidatesEditOptions>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCandidatesEditOptions>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCandidatesEditOptionsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCandidatesEditOptions>>> = ({ signal }) =>
    getCandidatesEditOptions(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCandidatesEditOptions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCandidatesEditOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getCandidatesEditOptions>>>;
export type GetCandidatesEditOptionsQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetCandidatesEditOptions = <
  TData = Awaited<ReturnType<typeof getCandidatesEditOptions>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCandidatesEditOptions>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCandidatesEditOptionsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getCandidatesFilterOptions = (signal?: AbortSignal) => {
  return customHttpClient<GetCandidatesFilterOptions200>({ url: `/candidates/filter-options`, method: 'GET', signal });
};

export const getGetCandidatesFilterOptionsQueryKey = () => {
  return [`/candidates/filter-options`] as const;
};

export const getGetCandidatesFilterOptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCandidatesFilterOptions>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCandidatesFilterOptions>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCandidatesFilterOptionsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCandidatesFilterOptions>>> = ({ signal }) =>
    getCandidatesFilterOptions(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCandidatesFilterOptions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCandidatesFilterOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getCandidatesFilterOptions>>>;
export type GetCandidatesFilterOptionsQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetCandidatesFilterOptions = <
  TData = Awaited<ReturnType<typeof getCandidatesFilterOptions>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCandidatesFilterOptions>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCandidatesFilterOptionsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getCandidatesCandidateId = (candidateId: number, signal?: AbortSignal) => {
  return customHttpClient<GetCandidatesCandidateId200>({ url: `/candidates/${candidateId}`, method: 'GET', signal });
};

export const getGetCandidatesCandidateIdQueryKey = (candidateId: number) => {
  return [`/candidates/${candidateId}`] as const;
};

export const getGetCandidatesCandidateIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getCandidatesCandidateId>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  candidateId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getCandidatesCandidateId>>, TError, TData> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCandidatesCandidateIdQueryKey(candidateId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCandidatesCandidateId>>> = ({ signal }) =>
    getCandidatesCandidateId(candidateId, signal);

  return { queryKey, queryFn, enabled: !!candidateId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCandidatesCandidateId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCandidatesCandidateIdQueryResult = NonNullable<Awaited<ReturnType<typeof getCandidatesCandidateId>>>;
export type GetCandidatesCandidateIdQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetCandidatesCandidateId = <
  TData = Awaited<ReturnType<typeof getCandidatesCandidateId>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  candidateId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getCandidatesCandidateId>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCandidatesCandidateIdQueryOptions(candidateId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getCandidatesCandidateIdShareableProfile = (candidateId: number, signal?: AbortSignal) => {
  return customHttpClient<GetCandidatesCandidateIdShareableProfile200>({
    url: `/candidates/${candidateId}/shareable-profile`,
    method: 'GET',
    signal,
  });
};

export const getGetCandidatesCandidateIdShareableProfileQueryKey = (candidateId: number) => {
  return [`/candidates/${candidateId}/shareable-profile`] as const;
};

export const getGetCandidatesCandidateIdShareableProfileQueryOptions = <
  TData = Awaited<ReturnType<typeof getCandidatesCandidateIdShareableProfile>>,
  TError = unknown,
>(
  candidateId: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getCandidatesCandidateIdShareableProfile>>, TError, TData>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCandidatesCandidateIdShareableProfileQueryKey(candidateId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCandidatesCandidateIdShareableProfile>>> = ({ signal }) =>
    getCandidatesCandidateIdShareableProfile(candidateId, signal);

  return { queryKey, queryFn, enabled: !!candidateId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCandidatesCandidateIdShareableProfile>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCandidatesCandidateIdShareableProfileQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCandidatesCandidateIdShareableProfile>>
>;
export type GetCandidatesCandidateIdShareableProfileQueryError = unknown;

export const useGetCandidatesCandidateIdShareableProfile = <
  TData = Awaited<ReturnType<typeof getCandidatesCandidateIdShareableProfile>>,
  TError = unknown,
>(
  candidateId: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getCandidatesCandidateIdShareableProfile>>, TError, TData>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCandidatesCandidateIdShareableProfileQueryOptions(candidateId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postCandidatesPdfResume = (postCandidatesPdfResumeBody: PostCandidatesPdfResumeBody) => {
  return customHttpClient<PostCandidatesPdfResume200>({
    url: `/candidates/pdf-resume`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postCandidatesPdfResumeBody,
  });
};

export const getPostCandidatesPdfResumeMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCandidatesPdfResume>>,
    TError,
    { data: PostCandidatesPdfResumeBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCandidatesPdfResume>>,
  TError,
  { data: PostCandidatesPdfResumeBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCandidatesPdfResume>>,
    { data: PostCandidatesPdfResumeBody }
  > = (props) => {
    const { data } = props ?? {};

    return postCandidatesPdfResume(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCandidatesPdfResumeMutationResult = NonNullable<Awaited<ReturnType<typeof postCandidatesPdfResume>>>;
export type PostCandidatesPdfResumeMutationBody = PostCandidatesPdfResumeBody;
export type PostCandidatesPdfResumeMutationError = unknown;

export const usePostCandidatesPdfResume = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCandidatesPdfResume>>,
    TError,
    { data: PostCandidatesPdfResumeBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostCandidatesPdfResumeMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putCandidatesCandidateIdConfirm = (candidateId: number) => {
  return customHttpClient<PutCandidatesCandidateIdConfirm200>({
    url: `/candidates/${candidateId}/confirm`,
    method: 'PUT',
  });
};

export const getPutCandidatesCandidateIdConfirmMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putCandidatesCandidateIdConfirm>>,
    TError,
    { candidateId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putCandidatesCandidateIdConfirm>>,
  TError,
  { candidateId: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putCandidatesCandidateIdConfirm>>,
    { candidateId: number }
  > = (props) => {
    const { candidateId } = props ?? {};

    return putCandidatesCandidateIdConfirm(candidateId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutCandidatesCandidateIdConfirmMutationResult = NonNullable<
  Awaited<ReturnType<typeof putCandidatesCandidateIdConfirm>>
>;

export type PutCandidatesCandidateIdConfirmMutationError = unknown;

export const usePutCandidatesCandidateIdConfirm = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putCandidatesCandidateIdConfirm>>,
    TError,
    { candidateId: number },
    TContext
  >;
}) => {
  const mutationOptions = getPutCandidatesCandidateIdConfirmMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postCandidatesImportCv = (postCandidatesImportCvBody: PostCandidatesImportCvBody) => {
  return customHttpClient<PostCandidatesImportCv200>({
    url: `/candidates/import-cv`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postCandidatesImportCvBody,
  });
};

export const getPostCandidatesImportCvMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCandidatesImportCv>>,
    TError,
    { data: PostCandidatesImportCvBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCandidatesImportCv>>,
  TError,
  { data: PostCandidatesImportCvBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCandidatesImportCv>>,
    { data: PostCandidatesImportCvBody }
  > = (props) => {
    const { data } = props ?? {};

    return postCandidatesImportCv(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCandidatesImportCvMutationResult = NonNullable<Awaited<ReturnType<typeof postCandidatesImportCv>>>;
export type PostCandidatesImportCvMutationBody = PostCandidatesImportCvBody;
export type PostCandidatesImportCvMutationError = unknown;

export const usePostCandidatesImportCv = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCandidatesImportCv>>,
    TError,
    { data: PostCandidatesImportCvBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostCandidatesImportCvMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postCandidates = (postCandidatesBody: PostCandidatesBody) => {
  return customHttpClient<PostCandidates200>({
    url: `/candidates`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postCandidatesBody,
  });
};

export const getPostCandidatesMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCandidates>>,
    TError,
    { data: PostCandidatesBody },
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<typeof postCandidates>>, TError, { data: PostCandidatesBody }, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCandidates>>, { data: PostCandidatesBody }> = (
    props,
  ) => {
    const { data } = props ?? {};

    return postCandidates(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCandidatesMutationResult = NonNullable<Awaited<ReturnType<typeof postCandidates>>>;
export type PostCandidatesMutationBody = PostCandidatesBody;
export type PostCandidatesMutationError = unknown;

export const usePostCandidates = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCandidates>>,
    TError,
    { data: PostCandidatesBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostCandidatesMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getCandidatesSearchAddToJob = (params: GetCandidatesSearchAddToJobParams, signal?: AbortSignal) => {
  return customHttpClient<GetCandidatesSearchAddToJob200>({
    url: `/candidates/search/add-to-job`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetCandidatesSearchAddToJobQueryKey = (params: GetCandidatesSearchAddToJobParams) => {
  return [`/candidates/search/add-to-job`, ...(params ? [params] : [])] as const;
};

export const getGetCandidatesSearchAddToJobQueryOptions = <
  TData = Awaited<ReturnType<typeof getCandidatesSearchAddToJob>>,
  TError = unknown,
>(
  params: GetCandidatesSearchAddToJobParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getCandidatesSearchAddToJob>>, TError, TData> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCandidatesSearchAddToJobQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCandidatesSearchAddToJob>>> = ({ signal }) =>
    getCandidatesSearchAddToJob(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCandidatesSearchAddToJob>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCandidatesSearchAddToJobQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCandidatesSearchAddToJob>>
>;
export type GetCandidatesSearchAddToJobQueryError = unknown;

export const useGetCandidatesSearchAddToJob = <
  TData = Awaited<ReturnType<typeof getCandidatesSearchAddToJob>>,
  TError = unknown,
>(
  params: GetCandidatesSearchAddToJobParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getCandidatesSearchAddToJob>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCandidatesSearchAddToJobQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postCandidatesSearch = (postCandidatesSearchBody: PostCandidatesSearchBody) => {
  return customHttpClient<PostCandidatesSearch200>({
    url: `/candidates/search`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postCandidatesSearchBody,
  });
};

export const getPostCandidatesSearchMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCandidatesSearch>>,
    TError,
    { data: PostCandidatesSearchBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCandidatesSearch>>,
  TError,
  { data: PostCandidatesSearchBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCandidatesSearch>>,
    { data: PostCandidatesSearchBody }
  > = (props) => {
    const { data } = props ?? {};

    return postCandidatesSearch(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCandidatesSearchMutationResult = NonNullable<Awaited<ReturnType<typeof postCandidatesSearch>>>;
export type PostCandidatesSearchMutationBody = PostCandidatesSearchBody;
export type PostCandidatesSearchMutationError = unknown;

export const usePostCandidatesSearch = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCandidatesSearch>>,
    TError,
    { data: PostCandidatesSearchBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostCandidatesSearchMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postCandidatesShareJobs = (postCandidatesShareJobsBody: PostCandidatesShareJobsBody) => {
  return customHttpClient<PostCandidatesShareJobs200>({
    url: `/candidates/share-jobs`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postCandidatesShareJobsBody,
  });
};

export const getPostCandidatesShareJobsMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCandidatesShareJobs>>,
    TError,
    { data: PostCandidatesShareJobsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCandidatesShareJobs>>,
  TError,
  { data: PostCandidatesShareJobsBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCandidatesShareJobs>>,
    { data: PostCandidatesShareJobsBody }
  > = (props) => {
    const { data } = props ?? {};

    return postCandidatesShareJobs(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCandidatesShareJobsMutationResult = NonNullable<Awaited<ReturnType<typeof postCandidatesShareJobs>>>;
export type PostCandidatesShareJobsMutationBody = PostCandidatesShareJobsBody;
export type PostCandidatesShareJobsMutationError = unknown;

export const usePostCandidatesShareJobs = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCandidatesShareJobs>>,
    TError,
    { data: PostCandidatesShareJobsBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostCandidatesShareJobsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getUtilsClearAuthInformationUserId = (userId: number, signal?: AbortSignal) => {
  return customHttpClient<GetUtilsClearAuthInformationUserId200>({
    url: `/utils/clear-auth-information/${userId}`,
    method: 'GET',
    signal,
  });
};

export const getGetUtilsClearAuthInformationUserIdQueryKey = (userId: number) => {
  return [`/utils/clear-auth-information/${userId}`] as const;
};

export const getGetUtilsClearAuthInformationUserIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getUtilsClearAuthInformationUserId>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  userId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getUtilsClearAuthInformationUserId>>, TError, TData> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUtilsClearAuthInformationUserIdQueryKey(userId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUtilsClearAuthInformationUserId>>> = ({ signal }) =>
    getUtilsClearAuthInformationUserId(userId, signal);

  return { queryKey, queryFn, enabled: !!userId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUtilsClearAuthInformationUserId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetUtilsClearAuthInformationUserIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUtilsClearAuthInformationUserId>>
>;
export type GetUtilsClearAuthInformationUserIdQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetUtilsClearAuthInformationUserId = <
  TData = Awaited<ReturnType<typeof getUtilsClearAuthInformationUserId>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  userId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getUtilsClearAuthInformationUserId>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetUtilsClearAuthInformationUserIdQueryOptions(userId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * search in match filters (elastic search) /agent/match
 */
export const postJobsJobIdMatchCandidatesSearch = (
  jobId: number,
  postJobsJobIdMatchCandidatesSearchBody: PostJobsJobIdMatchCandidatesSearchBody,
) => {
  return customHttpClient<PostJobsJobIdMatchCandidatesSearch200>({
    url: `/jobs/${jobId}/match/candidates/search`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postJobsJobIdMatchCandidatesSearchBody,
  });
};

export const getPostJobsJobIdMatchCandidatesSearchMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesSearch>>,
    TError,
    { jobId: number; data: PostJobsJobIdMatchCandidatesSearchBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesSearch>>,
  TError,
  { jobId: number; data: PostJobsJobIdMatchCandidatesSearchBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesSearch>>,
    { jobId: number; data: PostJobsJobIdMatchCandidatesSearchBody }
  > = (props) => {
    const { jobId, data } = props ?? {};

    return postJobsJobIdMatchCandidatesSearch(jobId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostJobsJobIdMatchCandidatesSearchMutationResult = NonNullable<
  Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesSearch>>
>;
export type PostJobsJobIdMatchCandidatesSearchMutationBody = PostJobsJobIdMatchCandidatesSearchBody;
export type PostJobsJobIdMatchCandidatesSearchMutationError = unknown;

export const usePostJobsJobIdMatchCandidatesSearch = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesSearch>>,
    TError,
    { jobId: number; data: PostJobsJobIdMatchCandidatesSearchBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostJobsJobIdMatchCandidatesSearchMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * use for exaplanation search
 */
export const postJobsJobIdMatchCandidatesSearchExplain = (
  jobId: number,
  postJobsJobIdMatchCandidatesSearchExplainBody: PostJobsJobIdMatchCandidatesSearchExplainBody,
) => {
  return customHttpClient<PostJobsJobIdMatchCandidatesSearchExplain200>({
    url: `/jobs/${jobId}/match/candidates/search/explain`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postJobsJobIdMatchCandidatesSearchExplainBody,
  });
};

export const getPostJobsJobIdMatchCandidatesSearchExplainMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesSearchExplain>>,
    TError,
    { jobId: number; data: PostJobsJobIdMatchCandidatesSearchExplainBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesSearchExplain>>,
  TError,
  { jobId: number; data: PostJobsJobIdMatchCandidatesSearchExplainBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesSearchExplain>>,
    { jobId: number; data: PostJobsJobIdMatchCandidatesSearchExplainBody }
  > = (props) => {
    const { jobId, data } = props ?? {};

    return postJobsJobIdMatchCandidatesSearchExplain(jobId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostJobsJobIdMatchCandidatesSearchExplainMutationResult = NonNullable<
  Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesSearchExplain>>
>;
export type PostJobsJobIdMatchCandidatesSearchExplainMutationBody = PostJobsJobIdMatchCandidatesSearchExplainBody;
export type PostJobsJobIdMatchCandidatesSearchExplainMutationError = unknown;

export const usePostJobsJobIdMatchCandidatesSearchExplain = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesSearchExplain>>,
    TError,
    { jobId: number; data: PostJobsJobIdMatchCandidatesSearchExplainBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostJobsJobIdMatchCandidatesSearchExplainMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * get filters for match
 */
export const getJobsJobIdMatchCandidatesDefaultFilter = (jobId: number, signal?: AbortSignal) => {
  return customHttpClient<GetJobsJobIdMatchCandidatesDefaultFilter200>({
    url: `/jobs/${jobId}/match/candidates/default-filter`,
    method: 'GET',
    signal,
  });
};

export const getGetJobsJobIdMatchCandidatesDefaultFilterQueryKey = (jobId: number) => {
  return [`/jobs/${jobId}/match/candidates/default-filter`] as const;
};

export const getGetJobsJobIdMatchCandidatesDefaultFilterQueryOptions = <
  TData = Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesDefaultFilter>>,
  TError = Status400 | Status401 | Status404,
>(
  jobId: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesDefaultFilter>>, TError, TData>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetJobsJobIdMatchCandidatesDefaultFilterQueryKey(jobId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesDefaultFilter>>> = ({ signal }) =>
    getJobsJobIdMatchCandidatesDefaultFilter(jobId, signal);

  return { queryKey, queryFn, enabled: !!jobId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesDefaultFilter>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetJobsJobIdMatchCandidatesDefaultFilterQueryResult = NonNullable<
  Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesDefaultFilter>>
>;
export type GetJobsJobIdMatchCandidatesDefaultFilterQueryError = Status400 | Status401 | Status404;

export const useGetJobsJobIdMatchCandidatesDefaultFilter = <
  TData = Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesDefaultFilter>>,
  TError = Status400 | Status401 | Status404,
>(
  jobId: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesDefaultFilter>>, TError, TData>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetJobsJobIdMatchCandidatesDefaultFilterQueryOptions(jobId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postJobsJobIdMatchCandidatesMatchGptSearchAsync = (
  jobId: number,
  postJobsJobIdMatchCandidatesMatchGptSearchAsyncBody: PostJobsJobIdMatchCandidatesMatchGptSearchAsyncBody,
) => {
  return customHttpClient<PostJobsJobIdMatchCandidatesMatchGptSearchAsync200>({
    url: `/jobs/${jobId}/match/candidates/match-gpt/search/async`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postJobsJobIdMatchCandidatesMatchGptSearchAsyncBody,
  });
};

export const getPostJobsJobIdMatchCandidatesMatchGptSearchAsyncMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesMatchGptSearchAsync>>,
    TError,
    { jobId: number; data: PostJobsJobIdMatchCandidatesMatchGptSearchAsyncBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesMatchGptSearchAsync>>,
  TError,
  { jobId: number; data: PostJobsJobIdMatchCandidatesMatchGptSearchAsyncBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesMatchGptSearchAsync>>,
    { jobId: number; data: PostJobsJobIdMatchCandidatesMatchGptSearchAsyncBody }
  > = (props) => {
    const { jobId, data } = props ?? {};

    return postJobsJobIdMatchCandidatesMatchGptSearchAsync(jobId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostJobsJobIdMatchCandidatesMatchGptSearchAsyncMutationResult = NonNullable<
  Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesMatchGptSearchAsync>>
>;
export type PostJobsJobIdMatchCandidatesMatchGptSearchAsyncMutationBody =
  PostJobsJobIdMatchCandidatesMatchGptSearchAsyncBody;
export type PostJobsJobIdMatchCandidatesMatchGptSearchAsyncMutationError = unknown;

export const usePostJobsJobIdMatchCandidatesMatchGptSearchAsync = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesMatchGptSearchAsync>>,
    TError,
    { jobId: number; data: PostJobsJobIdMatchCandidatesMatchGptSearchAsyncBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostJobsJobIdMatchCandidatesMatchGptSearchAsyncMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postJobsJobIdMatchCandidatesApplicationsMatchGptSearchAsync = (
  jobId: number,
  postJobsJobIdMatchCandidatesApplicationsMatchGptSearchAsyncBody: PostJobsJobIdMatchCandidatesApplicationsMatchGptSearchAsyncBody,
) => {
  return customHttpClient<PostJobsJobIdMatchCandidatesApplicationsMatchGptSearchAsync200>({
    url: `/jobs/${jobId}/match/candidates/applications-match-gpt/search/async`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postJobsJobIdMatchCandidatesApplicationsMatchGptSearchAsyncBody,
  });
};

export const getPostJobsJobIdMatchCandidatesApplicationsMatchGptSearchAsyncMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesApplicationsMatchGptSearchAsync>>,
    TError,
    { jobId: number; data: PostJobsJobIdMatchCandidatesApplicationsMatchGptSearchAsyncBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesApplicationsMatchGptSearchAsync>>,
  TError,
  { jobId: number; data: PostJobsJobIdMatchCandidatesApplicationsMatchGptSearchAsyncBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesApplicationsMatchGptSearchAsync>>,
    { jobId: number; data: PostJobsJobIdMatchCandidatesApplicationsMatchGptSearchAsyncBody }
  > = (props) => {
    const { jobId, data } = props ?? {};

    return postJobsJobIdMatchCandidatesApplicationsMatchGptSearchAsync(jobId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostJobsJobIdMatchCandidatesApplicationsMatchGptSearchAsyncMutationResult = NonNullable<
  Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesApplicationsMatchGptSearchAsync>>
>;
export type PostJobsJobIdMatchCandidatesApplicationsMatchGptSearchAsyncMutationBody =
  PostJobsJobIdMatchCandidatesApplicationsMatchGptSearchAsyncBody;
export type PostJobsJobIdMatchCandidatesApplicationsMatchGptSearchAsyncMutationError = unknown;

export const usePostJobsJobIdMatchCandidatesApplicationsMatchGptSearchAsync = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesApplicationsMatchGptSearchAsync>>,
    TError,
    { jobId: number; data: PostJobsJobIdMatchCandidatesApplicationsMatchGptSearchAsyncBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostJobsJobIdMatchCandidatesApplicationsMatchGptSearchAsyncMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * only agent
used in match buttons

 */
export const getJobsJobIdMatchPipelinesEditOptions = (jobId: number, signal?: AbortSignal) => {
  return customHttpClient<GetJobsJobIdMatchPipelinesEditOptions200>({
    url: `/jobs/${jobId}/match/pipelines/edit-options`,
    method: 'GET',
    signal,
  });
};

export const getGetJobsJobIdMatchPipelinesEditOptionsQueryKey = (jobId: number) => {
  return [`/jobs/${jobId}/match/pipelines/edit-options`] as const;
};

export const getGetJobsJobIdMatchPipelinesEditOptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getJobsJobIdMatchPipelinesEditOptions>>,
  TError = Status400 | Status401 | Status404,
>(
  jobId: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getJobsJobIdMatchPipelinesEditOptions>>, TError, TData>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetJobsJobIdMatchPipelinesEditOptionsQueryKey(jobId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobsJobIdMatchPipelinesEditOptions>>> = ({ signal }) =>
    getJobsJobIdMatchPipelinesEditOptions(jobId, signal);

  return { queryKey, queryFn, enabled: !!jobId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getJobsJobIdMatchPipelinesEditOptions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetJobsJobIdMatchPipelinesEditOptionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getJobsJobIdMatchPipelinesEditOptions>>
>;
export type GetJobsJobIdMatchPipelinesEditOptionsQueryError = Status400 | Status401 | Status404;

export const useGetJobsJobIdMatchPipelinesEditOptions = <
  TData = Awaited<ReturnType<typeof getJobsJobIdMatchPipelinesEditOptions>>,
  TError = Status400 | Status401 | Status404,
>(
  jobId: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getJobsJobIdMatchPipelinesEditOptions>>, TError, TData>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetJobsJobIdMatchPipelinesEditOptionsQueryOptions(jobId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * filter crud in match
 */
export const postJobsJobIdMatchFilters = (
  jobId: number,
  postJobsJobIdMatchFiltersBody: PostJobsJobIdMatchFiltersBody,
) => {
  return customHttpClient<PostJobsJobIdMatchFilters200>({
    url: `/jobs/${jobId}/match/filters`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postJobsJobIdMatchFiltersBody,
  });
};

export const getPostJobsJobIdMatchFiltersMutationOptions = <
  TError = Status400 | Status401 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdMatchFilters>>,
    TError,
    { jobId: number; data: PostJobsJobIdMatchFiltersBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postJobsJobIdMatchFilters>>,
  TError,
  { jobId: number; data: PostJobsJobIdMatchFiltersBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postJobsJobIdMatchFilters>>,
    { jobId: number; data: PostJobsJobIdMatchFiltersBody }
  > = (props) => {
    const { jobId, data } = props ?? {};

    return postJobsJobIdMatchFilters(jobId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostJobsJobIdMatchFiltersMutationResult = NonNullable<
  Awaited<ReturnType<typeof postJobsJobIdMatchFilters>>
>;
export type PostJobsJobIdMatchFiltersMutationBody = PostJobsJobIdMatchFiltersBody;
export type PostJobsJobIdMatchFiltersMutationError = Status400 | Status401 | Status404;

export const usePostJobsJobIdMatchFilters = <TError = Status400 | Status401 | Status404, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdMatchFilters>>,
    TError,
    { jobId: number; data: PostJobsJobIdMatchFiltersBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostJobsJobIdMatchFiltersMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * filter crud in match
 */
export const putJobsJobIdMatchFiltersJobFilterId = (
  jobId: number,
  jobFilterId: number,
  putJobsJobIdMatchFiltersJobFilterIdBody: PutJobsJobIdMatchFiltersJobFilterIdBody,
) => {
  return customHttpClient<PutJobsJobIdMatchFiltersJobFilterId200>({
    url: `/jobs/${jobId}/match/filters/${jobFilterId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: putJobsJobIdMatchFiltersJobFilterIdBody,
  });
};

export const getPutJobsJobIdMatchFiltersJobFilterIdMutationOptions = <
  TError = Status400 | Status401 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putJobsJobIdMatchFiltersJobFilterId>>,
    TError,
    { jobId: number; jobFilterId: number; data: PutJobsJobIdMatchFiltersJobFilterIdBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putJobsJobIdMatchFiltersJobFilterId>>,
  TError,
  { jobId: number; jobFilterId: number; data: PutJobsJobIdMatchFiltersJobFilterIdBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putJobsJobIdMatchFiltersJobFilterId>>,
    { jobId: number; jobFilterId: number; data: PutJobsJobIdMatchFiltersJobFilterIdBody }
  > = (props) => {
    const { jobId, jobFilterId, data } = props ?? {};

    return putJobsJobIdMatchFiltersJobFilterId(jobId, jobFilterId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutJobsJobIdMatchFiltersJobFilterIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putJobsJobIdMatchFiltersJobFilterId>>
>;
export type PutJobsJobIdMatchFiltersJobFilterIdMutationBody = PutJobsJobIdMatchFiltersJobFilterIdBody;
export type PutJobsJobIdMatchFiltersJobFilterIdMutationError = Status400 | Status401 | Status404;

export const usePutJobsJobIdMatchFiltersJobFilterId = <
  TError = Status400 | Status401 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putJobsJobIdMatchFiltersJobFilterId>>,
    TError,
    { jobId: number; jobFilterId: number; data: PutJobsJobIdMatchFiltersJobFilterIdBody },
    TContext
  >;
}) => {
  const mutationOptions = getPutJobsJobIdMatchFiltersJobFilterIdMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * filter crud in match
 */
export const deleteJobsJobIdMatchFiltersJobFilterId = (jobId: number, jobFilterId: number) => {
  return customHttpClient<DeleteJobsJobIdMatchFiltersJobFilterId200>({
    url: `/jobs/${jobId}/match/filters/${jobFilterId}`,
    method: 'DELETE',
  });
};

export const getDeleteJobsJobIdMatchFiltersJobFilterIdMutationOptions = <
  TError = Status400 | Status401 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteJobsJobIdMatchFiltersJobFilterId>>,
    TError,
    { jobId: number; jobFilterId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteJobsJobIdMatchFiltersJobFilterId>>,
  TError,
  { jobId: number; jobFilterId: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteJobsJobIdMatchFiltersJobFilterId>>,
    { jobId: number; jobFilterId: number }
  > = (props) => {
    const { jobId, jobFilterId } = props ?? {};

    return deleteJobsJobIdMatchFiltersJobFilterId(jobId, jobFilterId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteJobsJobIdMatchFiltersJobFilterIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteJobsJobIdMatchFiltersJobFilterId>>
>;

export type DeleteJobsJobIdMatchFiltersJobFilterIdMutationError = Status400 | Status401 | Status404;

export const useDeleteJobsJobIdMatchFiltersJobFilterId = <
  TError = Status400 | Status401 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteJobsJobIdMatchFiltersJobFilterId>>,
    TError,
    { jobId: number; jobFilterId: number },
    TContext
  >;
}) => {
  const mutationOptions = getDeleteJobsJobIdMatchFiltersJobFilterIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postJobsMatchPipelinesMove = (postJobsMatchPipelinesMoveBody: PostJobsMatchPipelinesMoveBody) => {
  return customHttpClient<PostJobsMatchPipelinesMove200>({
    url: `/jobs/match/pipelines/move`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postJobsMatchPipelinesMoveBody,
  });
};

export const getPostJobsMatchPipelinesMoveMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsMatchPipelinesMove>>,
    TError,
    { data: PostJobsMatchPipelinesMoveBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postJobsMatchPipelinesMove>>,
  TError,
  { data: PostJobsMatchPipelinesMoveBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postJobsMatchPipelinesMove>>,
    { data: PostJobsMatchPipelinesMoveBody }
  > = (props) => {
    const { data } = props ?? {};

    return postJobsMatchPipelinesMove(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostJobsMatchPipelinesMoveMutationResult = NonNullable<
  Awaited<ReturnType<typeof postJobsMatchPipelinesMove>>
>;
export type PostJobsMatchPipelinesMoveMutationBody = PostJobsMatchPipelinesMoveBody;
export type PostJobsMatchPipelinesMoveMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostJobsMatchPipelinesMove = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsMatchPipelinesMove>>,
    TError,
    { data: PostJobsMatchPipelinesMoveBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostJobsMatchPipelinesMoveMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postJobsMatchPipelinesMoveEntryPoint = (
  postJobsMatchPipelinesMoveEntryPointBody: PostJobsMatchPipelinesMoveEntryPointBody,
) => {
  return customHttpClient<PostJobsMatchPipelinesMoveEntryPoint200>({
    url: `/jobs/match/pipelines/move/entry-point`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postJobsMatchPipelinesMoveEntryPointBody,
  });
};

export const getPostJobsMatchPipelinesMoveEntryPointMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsMatchPipelinesMoveEntryPoint>>,
    TError,
    { data: PostJobsMatchPipelinesMoveEntryPointBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postJobsMatchPipelinesMoveEntryPoint>>,
  TError,
  { data: PostJobsMatchPipelinesMoveEntryPointBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postJobsMatchPipelinesMoveEntryPoint>>,
    { data: PostJobsMatchPipelinesMoveEntryPointBody }
  > = (props) => {
    const { data } = props ?? {};

    return postJobsMatchPipelinesMoveEntryPoint(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostJobsMatchPipelinesMoveEntryPointMutationResult = NonNullable<
  Awaited<ReturnType<typeof postJobsMatchPipelinesMoveEntryPoint>>
>;
export type PostJobsMatchPipelinesMoveEntryPointMutationBody = PostJobsMatchPipelinesMoveEntryPointBody;
export type PostJobsMatchPipelinesMoveEntryPointMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostJobsMatchPipelinesMoveEntryPoint = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsMatchPipelinesMoveEntryPoint>>,
    TError,
    { data: PostJobsMatchPipelinesMoveEntryPointBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostJobsMatchPipelinesMoveEntryPointMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getJobs = (params?: GetJobsParams, signal?: AbortSignal) => {
  return customHttpClient<GetJobs200>({ url: `/jobs`, method: 'GET', params, signal });
};

export const getGetJobsQueryKey = (params?: GetJobsParams) => {
  return [`/jobs`, ...(params ? [params] : [])] as const;
};

export const getGetJobsQueryOptions = <
  TData = Awaited<ReturnType<typeof getJobs>>,
  TError = Status400 | Status401 | Status404,
>(
  params?: GetJobsParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getJobs>>, TError, TData> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetJobsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobs>>> = ({ signal }) => getJobs(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getJobs>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetJobsQueryResult = NonNullable<Awaited<ReturnType<typeof getJobs>>>;
export type GetJobsQueryError = Status400 | Status401 | Status404;

export const useGetJobs = <TData = Awaited<ReturnType<typeof getJobs>>, TError = Status400 | Status401 | Status404>(
  params?: GetJobsParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getJobs>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetJobsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postJobs = (postJobsBody: PostJobsBody) => {
  return customHttpClient<PostJobs200>({
    url: `/jobs`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postJobsBody,
  });
};

export const getPostJobsMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postJobs>>, TError, { data: PostJobsBody }, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof postJobs>>, TError, { data: PostJobsBody }, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postJobs>>, { data: PostJobsBody }> = (props) => {
    const { data } = props ?? {};

    return postJobs(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostJobsMutationResult = NonNullable<Awaited<ReturnType<typeof postJobs>>>;
export type PostJobsMutationBody = PostJobsBody;
export type PostJobsMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostJobs = <TError = Status400 | Status401 | Status403 | Status404, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postJobs>>, TError, { data: PostJobsBody }, TContext>;
}) => {
  const mutationOptions = getPostJobsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getJobsJobId = (jobId: number, signal?: AbortSignal) => {
  return customHttpClient<GetJobsJobId200>({ url: `/jobs/${jobId}`, method: 'GET', signal });
};

export const getGetJobsJobIdQueryKey = (jobId: number) => {
  return [`/jobs/${jobId}`] as const;
};

export const getGetJobsJobIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getJobsJobId>>,
  TError = Status400 | Status401 | Status404,
>(
  jobId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getJobsJobId>>, TError, TData> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetJobsJobIdQueryKey(jobId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobsJobId>>> = ({ signal }) => getJobsJobId(jobId, signal);

  return { queryKey, queryFn, enabled: !!jobId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getJobsJobId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetJobsJobIdQueryResult = NonNullable<Awaited<ReturnType<typeof getJobsJobId>>>;
export type GetJobsJobIdQueryError = Status400 | Status401 | Status404;

export const useGetJobsJobId = <
  TData = Awaited<ReturnType<typeof getJobsJobId>>,
  TError = Status400 | Status401 | Status404,
>(
  jobId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getJobsJobId>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetJobsJobIdQueryOptions(jobId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const putJobsJobId = (jobId: number, putJobsJobIdBody: PutJobsJobIdBody) => {
  return customHttpClient<PutJobsJobId200>({
    url: `/jobs/${jobId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: putJobsJobIdBody,
  });
};

export const getPutJobsJobIdMutationOptions = <
  TError = Status400 | Status401 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putJobsJobId>>,
    TError,
    { jobId: number; data: PutJobsJobIdBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putJobsJobId>>,
  TError,
  { jobId: number; data: PutJobsJobIdBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putJobsJobId>>,
    { jobId: number; data: PutJobsJobIdBody }
  > = (props) => {
    const { jobId, data } = props ?? {};

    return putJobsJobId(jobId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutJobsJobIdMutationResult = NonNullable<Awaited<ReturnType<typeof putJobsJobId>>>;
export type PutJobsJobIdMutationBody = PutJobsJobIdBody;
export type PutJobsJobIdMutationError = Status400 | Status401 | Status404;

export const usePutJobsJobId = <TError = Status400 | Status401 | Status404, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putJobsJobId>>,
    TError,
    { jobId: number; data: PutJobsJobIdBody },
    TContext
  >;
}) => {
  const mutationOptions = getPutJobsJobIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteJobsJobId = (jobId: number) => {
  return customHttpClient<DeleteJobsJobId200>({ url: `/jobs/${jobId}`, method: 'DELETE' });
};

export const getDeleteJobsJobIdMutationOptions = <
  TError = Status400 | Status401 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof deleteJobsJobId>>, TError, { jobId: number }, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof deleteJobsJobId>>, TError, { jobId: number }, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteJobsJobId>>, { jobId: number }> = (props) => {
    const { jobId } = props ?? {};

    return deleteJobsJobId(jobId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteJobsJobIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteJobsJobId>>>;

export type DeleteJobsJobIdMutationError = Status400 | Status401 | Status404;

export const useDeleteJobsJobId = <TError = Status400 | Status401 | Status404, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof deleteJobsJobId>>, TError, { jobId: number }, TContext>;
}) => {
  const mutationOptions = getDeleteJobsJobIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postJobsJobIdClone = (jobId: number, postJobsJobIdCloneBody: PostJobsJobIdCloneBody) => {
  return customHttpClient<PostJobsJobIdClone200>({
    url: `/jobs/${jobId}/clone`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postJobsJobIdCloneBody,
  });
};

export const getPostJobsJobIdCloneMutationOptions = <
  TError = Status400 | Status401 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdClone>>,
    TError,
    { jobId: number; data: PostJobsJobIdCloneBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postJobsJobIdClone>>,
  TError,
  { jobId: number; data: PostJobsJobIdCloneBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postJobsJobIdClone>>,
    { jobId: number; data: PostJobsJobIdCloneBody }
  > = (props) => {
    const { jobId, data } = props ?? {};

    return postJobsJobIdClone(jobId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostJobsJobIdCloneMutationResult = NonNullable<Awaited<ReturnType<typeof postJobsJobIdClone>>>;
export type PostJobsJobIdCloneMutationBody = PostJobsJobIdCloneBody;
export type PostJobsJobIdCloneMutationError = Status400 | Status401 | Status404;

export const usePostJobsJobIdClone = <TError = Status400 | Status401 | Status404, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdClone>>,
    TError,
    { jobId: number; data: PostJobsJobIdCloneBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostJobsJobIdCloneMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getJobsFilterOptions = (signal?: AbortSignal) => {
  return customHttpClient<GetJobsFilterOptions200>({ url: `/jobs/filter-options`, method: 'GET', signal });
};

export const getGetJobsFilterOptionsQueryKey = () => {
  return [`/jobs/filter-options`] as const;
};

export const getGetJobsFilterOptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getJobsFilterOptions>>,
  TError = Status400 | Status401 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getJobsFilterOptions>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetJobsFilterOptionsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobsFilterOptions>>> = ({ signal }) =>
    getJobsFilterOptions(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getJobsFilterOptions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetJobsFilterOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getJobsFilterOptions>>>;
export type GetJobsFilterOptionsQueryError = Status400 | Status401 | Status404;

export const useGetJobsFilterOptions = <
  TData = Awaited<ReturnType<typeof getJobsFilterOptions>>,
  TError = Status400 | Status401 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getJobsFilterOptions>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetJobsFilterOptionsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getJobsEditOptions = (signal?: AbortSignal) => {
  return customHttpClient<GetJobsEditOptions200>({ url: `/jobs/edit-options`, method: 'GET', signal });
};

export const getGetJobsEditOptionsQueryKey = () => {
  return [`/jobs/edit-options`] as const;
};

export const getGetJobsEditOptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getJobsEditOptions>>,
  TError = Status400 | Status401 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getJobsEditOptions>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetJobsEditOptionsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobsEditOptions>>> = ({ signal }) =>
    getJobsEditOptions(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getJobsEditOptions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetJobsEditOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getJobsEditOptions>>>;
export type GetJobsEditOptionsQueryError = Status400 | Status401 | Status404;

export const useGetJobsEditOptions = <
  TData = Awaited<ReturnType<typeof getJobsEditOptions>>,
  TError = Status400 | Status401 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getJobsEditOptions>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetJobsEditOptionsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postJobsSearch = (postJobsSearchBody: PostJobsSearchBody) => {
  return customHttpClient<PostJobsSearch200>({
    url: `/jobs/search`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postJobsSearchBody,
  });
};

export const getPostJobsSearchMutationOptions = <
  TError = Status400 | Status401 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsSearch>>,
    TError,
    { data: PostJobsSearchBody },
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<typeof postJobsSearch>>, TError, { data: PostJobsSearchBody }, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postJobsSearch>>, { data: PostJobsSearchBody }> = (
    props,
  ) => {
    const { data } = props ?? {};

    return postJobsSearch(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostJobsSearchMutationResult = NonNullable<Awaited<ReturnType<typeof postJobsSearch>>>;
export type PostJobsSearchMutationBody = PostJobsSearchBody;
export type PostJobsSearchMutationError = Status400 | Status401 | Status404;

export const usePostJobsSearch = <TError = Status400 | Status401 | Status404, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsSearch>>,
    TError,
    { data: PostJobsSearchBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostJobsSearchMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postJobsRecommendedMy = (requestBodyMyRecommendedJobs: RequestBodyMyRecommendedJobs) => {
  return customHttpClient<PostJobsRecommendedMy200>({
    url: `/jobs/recommended/my`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: requestBodyMyRecommendedJobs,
  });
};

export const getPostJobsRecommendedMyMutationOptions = <
  TError = Status400 | Status401 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsRecommendedMy>>,
    TError,
    { data: RequestBodyMyRecommendedJobs },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postJobsRecommendedMy>>,
  TError,
  { data: RequestBodyMyRecommendedJobs },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postJobsRecommendedMy>>,
    { data: RequestBodyMyRecommendedJobs }
  > = (props) => {
    const { data } = props ?? {};

    return postJobsRecommendedMy(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostJobsRecommendedMyMutationResult = NonNullable<Awaited<ReturnType<typeof postJobsRecommendedMy>>>;
export type PostJobsRecommendedMyMutationBody = RequestBodyMyRecommendedJobs;
export type PostJobsRecommendedMyMutationError = Status400 | Status401 | Status404;

export const usePostJobsRecommendedMy = <TError = Status400 | Status401 | Status404, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsRecommendedMy>>,
    TError,
    { data: RequestBodyMyRecommendedJobs },
    TContext
  >;
}) => {
  const mutationOptions = getPostJobsRecommendedMyMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postJobsRecommendedCandidateId = (
  candidateId: number,
  requestBodyMyRecommendedJobs: RequestBodyMyRecommendedJobs,
) => {
  return customHttpClient<PostJobsRecommendedCandidateId200>({
    url: `/jobs/recommended/${candidateId}`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: requestBodyMyRecommendedJobs,
  });
};

export const getPostJobsRecommendedCandidateIdMutationOptions = <
  TError = Status400 | Status401 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsRecommendedCandidateId>>,
    TError,
    { candidateId: number; data: RequestBodyMyRecommendedJobs },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postJobsRecommendedCandidateId>>,
  TError,
  { candidateId: number; data: RequestBodyMyRecommendedJobs },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postJobsRecommendedCandidateId>>,
    { candidateId: number; data: RequestBodyMyRecommendedJobs }
  > = (props) => {
    const { candidateId, data } = props ?? {};

    return postJobsRecommendedCandidateId(candidateId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostJobsRecommendedCandidateIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof postJobsRecommendedCandidateId>>
>;
export type PostJobsRecommendedCandidateIdMutationBody = RequestBodyMyRecommendedJobs;
export type PostJobsRecommendedCandidateIdMutationError = Status400 | Status401 | Status404;

export const usePostJobsRecommendedCandidateId = <
  TError = Status400 | Status401 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsRecommendedCandidateId>>,
    TError,
    { candidateId: number; data: RequestBodyMyRecommendedJobs },
    TContext
  >;
}) => {
  const mutationOptions = getPostJobsRecommendedCandidateIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postJobsJobIdAvatar = (jobId: number, postJobsJobIdAvatarBody: PostJobsJobIdAvatarBody) => {
  return customHttpClient<PostJobsJobIdAvatar200>({
    url: `/jobs/${jobId}/avatar`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postJobsJobIdAvatarBody,
  });
};

export const getPostJobsJobIdAvatarMutationOptions = <
  TError = Status400 | Status401 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdAvatar>>,
    TError,
    { jobId: number; data: PostJobsJobIdAvatarBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postJobsJobIdAvatar>>,
  TError,
  { jobId: number; data: PostJobsJobIdAvatarBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postJobsJobIdAvatar>>,
    { jobId: number; data: PostJobsJobIdAvatarBody }
  > = (props) => {
    const { jobId, data } = props ?? {};

    return postJobsJobIdAvatar(jobId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostJobsJobIdAvatarMutationResult = NonNullable<Awaited<ReturnType<typeof postJobsJobIdAvatar>>>;
export type PostJobsJobIdAvatarMutationBody = PostJobsJobIdAvatarBody;
export type PostJobsJobIdAvatarMutationError = Status400 | Status401 | Status404;

export const usePostJobsJobIdAvatar = <TError = Status400 | Status401 | Status404, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdAvatar>>,
    TError,
    { jobId: number; data: PostJobsJobIdAvatarBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostJobsJobIdAvatarMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getSettings = (signal?: AbortSignal) => {
  return customHttpClient<GetSettings200>({ url: `/settings`, method: 'GET', signal });
};

export const getGetSettingsQueryKey = () => {
  return [`/settings`] as const;
};

export const getGetSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSettings>>,
  TError = Status400 | Status401 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getSettings>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSettingsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettings>>> = ({ signal }) => getSettings(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSettings>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getSettings>>>;
export type GetSettingsQueryError = Status400 | Status401 | Status404;

export const useGetSettings = <
  TData = Awaited<ReturnType<typeof getSettings>>,
  TError = Status400 | Status401 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getSettings>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetSettingsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const putSettingsUpdateConstants = (putSettingsUpdateConstantsBody: PutSettingsUpdateConstantsBody) => {
  return customHttpClient<PutSettingsUpdateConstants200>({
    url: `/settings/update-constants`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: putSettingsUpdateConstantsBody,
  });
};

export const getPutSettingsUpdateConstantsMutationOptions = <
  TError = Status400 | Status401 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putSettingsUpdateConstants>>,
    TError,
    { data: PutSettingsUpdateConstantsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putSettingsUpdateConstants>>,
  TError,
  { data: PutSettingsUpdateConstantsBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putSettingsUpdateConstants>>,
    { data: PutSettingsUpdateConstantsBody }
  > = (props) => {
    const { data } = props ?? {};

    return putSettingsUpdateConstants(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutSettingsUpdateConstantsMutationResult = NonNullable<
  Awaited<ReturnType<typeof putSettingsUpdateConstants>>
>;
export type PutSettingsUpdateConstantsMutationBody = PutSettingsUpdateConstantsBody;
export type PutSettingsUpdateConstantsMutationError = Status400 | Status401 | Status404;

export const usePutSettingsUpdateConstants = <
  TError = Status400 | Status401 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putSettingsUpdateConstants>>,
    TError,
    { data: PutSettingsUpdateConstantsBody },
    TContext
  >;
}) => {
  const mutationOptions = getPutSettingsUpdateConstantsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postAgents = (postAgentsBody: PostAgentsBody) => {
  return customHttpClient<AgentItem>({
    url: `/agents`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postAgentsBody,
  });
};

export const getPostAgentsMutationOptions = <TError = Status400 | Status401 | Status404, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postAgents>>, TError, { data: PostAgentsBody }, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof postAgents>>, TError, { data: PostAgentsBody }, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAgents>>, { data: PostAgentsBody }> = (props) => {
    const { data } = props ?? {};

    return postAgents(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAgentsMutationResult = NonNullable<Awaited<ReturnType<typeof postAgents>>>;
export type PostAgentsMutationBody = PostAgentsBody;
export type PostAgentsMutationError = Status400 | Status401 | Status404;

export const usePostAgents = <TError = Status400 | Status401 | Status404, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postAgents>>, TError, { data: PostAgentsBody }, TContext>;
}) => {
  const mutationOptions = getPostAgentsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getAgents = (params?: GetAgentsParams, signal?: AbortSignal) => {
  return customHttpClient<GetAgents200>({ url: `/agents`, method: 'GET', params, signal });
};

export const getGetAgentsQueryKey = (params?: GetAgentsParams) => {
  return [`/agents`, ...(params ? [params] : [])] as const;
};

export const getGetAgentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAgents>>,
  TError = Status400 | Status401 | Status404,
>(
  params?: GetAgentsParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getAgents>>, TError, TData> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAgentsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgents>>> = ({ signal }) => getAgents(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAgents>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAgentsQueryResult = NonNullable<Awaited<ReturnType<typeof getAgents>>>;
export type GetAgentsQueryError = Status400 | Status401 | Status404;

export const useGetAgents = <TData = Awaited<ReturnType<typeof getAgents>>, TError = Status400 | Status401 | Status404>(
  params?: GetAgentsParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getAgents>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetAgentsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postAgentsSearch = (postAgentsSearchBody: PostAgentsSearchBody) => {
  return customHttpClient<AgentItem>({
    url: `/agents/search`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postAgentsSearchBody,
  });
};

export const getPostAgentsSearchMutationOptions = <
  TError = Status400 | Status401 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAgentsSearch>>,
    TError,
    { data: PostAgentsSearchBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAgentsSearch>>,
  TError,
  { data: PostAgentsSearchBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAgentsSearch>>, { data: PostAgentsSearchBody }> = (
    props,
  ) => {
    const { data } = props ?? {};

    return postAgentsSearch(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAgentsSearchMutationResult = NonNullable<Awaited<ReturnType<typeof postAgentsSearch>>>;
export type PostAgentsSearchMutationBody = PostAgentsSearchBody;
export type PostAgentsSearchMutationError = Status400 | Status401 | Status404;

export const usePostAgentsSearch = <TError = Status400 | Status401 | Status404, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAgentsSearch>>,
    TError,
    { data: PostAgentsSearchBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostAgentsSearchMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getAgentsSearch = (params?: GetAgentsSearchParams, signal?: AbortSignal) => {
  return customHttpClient<GetAgentsSearch200>({ url: `/agents/search`, method: 'GET', params, signal });
};

export const getGetAgentsSearchQueryKey = (params?: GetAgentsSearchParams) => {
  return [`/agents/search`, ...(params ? [params] : [])] as const;
};

export const getGetAgentsSearchQueryOptions = <
  TData = Awaited<ReturnType<typeof getAgentsSearch>>,
  TError = Status400 | Status401 | Status404,
>(
  params?: GetAgentsSearchParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getAgentsSearch>>, TError, TData> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAgentsSearchQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgentsSearch>>> = ({ signal }) =>
    getAgentsSearch(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAgentsSearch>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAgentsSearchQueryResult = NonNullable<Awaited<ReturnType<typeof getAgentsSearch>>>;
export type GetAgentsSearchQueryError = Status400 | Status401 | Status404;

export const useGetAgentsSearch = <
  TData = Awaited<ReturnType<typeof getAgentsSearch>>,
  TError = Status400 | Status401 | Status404,
>(
  params?: GetAgentsSearchParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getAgentsSearch>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetAgentsSearchQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getAgentsUserId = (userId: number, signal?: AbortSignal) => {
  return customHttpClient<AgentItem>({ url: `/agents/${userId}`, method: 'GET', signal });
};

export const getGetAgentsUserIdQueryKey = (userId: number) => {
  return [`/agents/${userId}`] as const;
};

export const getGetAgentsUserIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getAgentsUserId>>,
  TError = Status400 | Status401 | Status404,
>(
  userId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getAgentsUserId>>, TError, TData> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAgentsUserIdQueryKey(userId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgentsUserId>>> = ({ signal }) =>
    getAgentsUserId(userId, signal);

  return { queryKey, queryFn, enabled: !!userId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAgentsUserId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAgentsUserIdQueryResult = NonNullable<Awaited<ReturnType<typeof getAgentsUserId>>>;
export type GetAgentsUserIdQueryError = Status400 | Status401 | Status404;

export const useGetAgentsUserId = <
  TData = Awaited<ReturnType<typeof getAgentsUserId>>,
  TError = Status400 | Status401 | Status404,
>(
  userId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getAgentsUserId>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetAgentsUserIdQueryOptions(userId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const putAgentsUserId = (userId: number) => {
  return customHttpClient<AgentItem>({ url: `/agents/${userId}`, method: 'PUT' });
};

export const getPutAgentsUserIdMutationOptions = <
  TError = Status400 | Status401 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putAgentsUserId>>, TError, { userId: number }, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof putAgentsUserId>>, TError, { userId: number }, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAgentsUserId>>, { userId: number }> = (props) => {
    const { userId } = props ?? {};

    return putAgentsUserId(userId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutAgentsUserIdMutationResult = NonNullable<Awaited<ReturnType<typeof putAgentsUserId>>>;

export type PutAgentsUserIdMutationError = Status400 | Status401 | Status404;

export const usePutAgentsUserId = <TError = Status400 | Status401 | Status404, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putAgentsUserId>>, TError, { userId: number }, TContext>;
}) => {
  const mutationOptions = getPutAgentsUserIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteAgentsUserId = (userId: number) => {
  return customHttpClient<DeleteAgentsUserId200>({ url: `/agents/${userId}`, method: 'DELETE' });
};

export const getDeleteAgentsUserIdMutationOptions = <
  TError = Status400 | Status401 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof deleteAgentsUserId>>, TError, { userId: number }, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof deleteAgentsUserId>>, TError, { userId: number }, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAgentsUserId>>, { userId: number }> = (props) => {
    const { userId } = props ?? {};

    return deleteAgentsUserId(userId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAgentsUserIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAgentsUserId>>>;

export type DeleteAgentsUserIdMutationError = Status400 | Status401 | Status404;

export const useDeleteAgentsUserId = <TError = Status400 | Status401 | Status404, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof deleteAgentsUserId>>, TError, { userId: number }, TContext>;
}) => {
  const mutationOptions = getDeleteAgentsUserIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postNotifications = (postNotificationsBody: PostNotificationsBody) => {
  return customHttpClient<Notification>({
    url: `/notifications`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postNotificationsBody,
  });
};

export const getPostNotificationsMutationOptions = <TError = Status400 | Status401, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postNotifications>>,
    TError,
    { data: PostNotificationsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postNotifications>>,
  TError,
  { data: PostNotificationsBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postNotifications>>, { data: PostNotificationsBody }> = (
    props,
  ) => {
    const { data } = props ?? {};

    return postNotifications(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostNotificationsMutationResult = NonNullable<Awaited<ReturnType<typeof postNotifications>>>;
export type PostNotificationsMutationBody = PostNotificationsBody;
export type PostNotificationsMutationError = Status400 | Status401;

export const usePostNotifications = <TError = Status400 | Status401, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postNotifications>>,
    TError,
    { data: PostNotificationsBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostNotificationsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getNotifications = (signal?: AbortSignal) => {
  return customHttpClient<GetNotifications200>({ url: `/notifications`, method: 'GET', signal });
};

export const getGetNotificationsQueryKey = () => {
  return [`/notifications`] as const;
};

export const getGetNotificationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getNotifications>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getNotifications>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetNotificationsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotifications>>> = ({ signal }) => getNotifications(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNotifications>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetNotificationsQueryResult = NonNullable<Awaited<ReturnType<typeof getNotifications>>>;
export type GetNotificationsQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetNotifications = <
  TData = Awaited<ReturnType<typeof getNotifications>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getNotifications>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetNotificationsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getTags = (params?: GetTagsParams, signal?: AbortSignal) => {
  return customHttpClient<GetTags200>({ url: `/tags`, method: 'GET', params, signal });
};

export const getGetTagsQueryKey = (params?: GetTagsParams) => {
  return [`/tags`, ...(params ? [params] : [])] as const;
};

export const getGetTagsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTags>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  params?: GetTagsParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getTags>>, TError, TData> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTagsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTags>>> = ({ signal }) => getTags(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTags>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTagsQueryResult = NonNullable<Awaited<ReturnType<typeof getTags>>>;
export type GetTagsQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetTags = <
  TData = Awaited<ReturnType<typeof getTags>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  params?: GetTagsParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getTags>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTagsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postTags = (postTagsBody: PostTagsBody) => {
  return customHttpClient<PostTags200>({
    url: `/tags`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postTagsBody,
  });
};

export const getPostTagsMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postTags>>, TError, { data: PostTagsBody }, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof postTags>>, TError, { data: PostTagsBody }, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTags>>, { data: PostTagsBody }> = (props) => {
    const { data } = props ?? {};

    return postTags(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostTagsMutationResult = NonNullable<Awaited<ReturnType<typeof postTags>>>;
export type PostTagsMutationBody = PostTagsBody;
export type PostTagsMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostTags = <TError = Status400 | Status401 | Status403 | Status404, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postTags>>, TError, { data: PostTagsBody }, TContext>;
}) => {
  const mutationOptions = getPostTagsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putTagsTagId = (tagId: string, putTagsTagIdBody: PutTagsTagIdBody) => {
  return customHttpClient<PutTagsTagId200>({
    url: `/tags/${tagId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: putTagsTagIdBody,
  });
};

export const getPutTagsTagIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putTagsTagId>>,
    TError,
    { tagId: string; data: PutTagsTagIdBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putTagsTagId>>,
  TError,
  { tagId: string; data: PutTagsTagIdBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putTagsTagId>>,
    { tagId: string; data: PutTagsTagIdBody }
  > = (props) => {
    const { tagId, data } = props ?? {};

    return putTagsTagId(tagId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutTagsTagIdMutationResult = NonNullable<Awaited<ReturnType<typeof putTagsTagId>>>;
export type PutTagsTagIdMutationBody = PutTagsTagIdBody;
export type PutTagsTagIdMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutTagsTagId = <TError = Status400 | Status401 | Status403 | Status404, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putTagsTagId>>,
    TError,
    { tagId: string; data: PutTagsTagIdBody },
    TContext
  >;
}) => {
  const mutationOptions = getPutTagsTagIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteTagsTagId = (tagId: string) => {
  return customHttpClient<DeleteTagsTagId200>({ url: `/tags/${tagId}`, method: 'DELETE' });
};

export const getDeleteTagsTagIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof deleteTagsTagId>>, TError, { tagId: string }, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof deleteTagsTagId>>, TError, { tagId: string }, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTagsTagId>>, { tagId: string }> = (props) => {
    const { tagId } = props ?? {};

    return deleteTagsTagId(tagId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTagsTagIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTagsTagId>>>;

export type DeleteTagsTagIdMutationError = Status400 | Status401 | Status403 | Status404;

export const useDeleteTagsTagId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof deleteTagsTagId>>, TError, { tagId: string }, TContext>;
}) => {
  const mutationOptions = getDeleteTagsTagIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getAgentsUserIdTags = (userId: number, signal?: AbortSignal) => {
  return customHttpClient<GetAgentsUserIdTags200>({ url: `/agents/${userId}/tags`, method: 'GET', signal });
};

export const getGetAgentsUserIdTagsQueryKey = (userId: number) => {
  return [`/agents/${userId}/tags`] as const;
};

export const getGetAgentsUserIdTagsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAgentsUserIdTags>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  userId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getAgentsUserIdTags>>, TError, TData> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAgentsUserIdTagsQueryKey(userId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgentsUserIdTags>>> = ({ signal }) =>
    getAgentsUserIdTags(userId, signal);

  return { queryKey, queryFn, enabled: !!userId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAgentsUserIdTags>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAgentsUserIdTagsQueryResult = NonNullable<Awaited<ReturnType<typeof getAgentsUserIdTags>>>;
export type GetAgentsUserIdTagsQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetAgentsUserIdTags = <
  TData = Awaited<ReturnType<typeof getAgentsUserIdTags>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  userId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getAgentsUserIdTags>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetAgentsUserIdTagsQueryOptions(userId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getCandidatesUserIdTags = (userId: number, signal?: AbortSignal) => {
  return customHttpClient<GetCandidatesUserIdTags200>({ url: `/candidates/${userId}/tags`, method: 'GET', signal });
};

export const getGetCandidatesUserIdTagsQueryKey = (userId: number) => {
  return [`/candidates/${userId}/tags`] as const;
};

export const getGetCandidatesUserIdTagsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCandidatesUserIdTags>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  userId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getCandidatesUserIdTags>>, TError, TData> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCandidatesUserIdTagsQueryKey(userId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCandidatesUserIdTags>>> = ({ signal }) =>
    getCandidatesUserIdTags(userId, signal);

  return { queryKey, queryFn, enabled: !!userId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCandidatesUserIdTags>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCandidatesUserIdTagsQueryResult = NonNullable<Awaited<ReturnType<typeof getCandidatesUserIdTags>>>;
export type GetCandidatesUserIdTagsQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetCandidatesUserIdTags = <
  TData = Awaited<ReturnType<typeof getCandidatesUserIdTags>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  userId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getCandidatesUserIdTags>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCandidatesUserIdTagsQueryOptions(userId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getContactsUserIdTags = (userId: number, signal?: AbortSignal) => {
  return customHttpClient<GetContactsUserIdTags200>({ url: `/contacts/${userId}/tags`, method: 'GET', signal });
};

export const getGetContactsUserIdTagsQueryKey = (userId: number) => {
  return [`/contacts/${userId}/tags`] as const;
};

export const getGetContactsUserIdTagsQueryOptions = <
  TData = Awaited<ReturnType<typeof getContactsUserIdTags>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  userId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getContactsUserIdTags>>, TError, TData> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetContactsUserIdTagsQueryKey(userId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getContactsUserIdTags>>> = ({ signal }) =>
    getContactsUserIdTags(userId, signal);

  return { queryKey, queryFn, enabled: !!userId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getContactsUserIdTags>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetContactsUserIdTagsQueryResult = NonNullable<Awaited<ReturnType<typeof getContactsUserIdTags>>>;
export type GetContactsUserIdTagsQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetContactsUserIdTags = <
  TData = Awaited<ReturnType<typeof getContactsUserIdTags>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  userId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getContactsUserIdTags>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetContactsUserIdTagsQueryOptions(userId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getJobsJobIdTags = (jobId: number, signal?: AbortSignal) => {
  return customHttpClient<GetJobsJobIdTags200>({ url: `/jobs/${jobId}/tags`, method: 'GET', signal });
};

export const getGetJobsJobIdTagsQueryKey = (jobId: number) => {
  return [`/jobs/${jobId}/tags`] as const;
};

export const getGetJobsJobIdTagsQueryOptions = <
  TData = Awaited<ReturnType<typeof getJobsJobIdTags>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  jobId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getJobsJobIdTags>>, TError, TData> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetJobsJobIdTagsQueryKey(jobId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobsJobIdTags>>> = ({ signal }) =>
    getJobsJobIdTags(jobId, signal);

  return { queryKey, queryFn, enabled: !!jobId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getJobsJobIdTags>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetJobsJobIdTagsQueryResult = NonNullable<Awaited<ReturnType<typeof getJobsJobIdTags>>>;
export type GetJobsJobIdTagsQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetJobsJobIdTags = <
  TData = Awaited<ReturnType<typeof getJobsJobIdTags>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  jobId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getJobsJobIdTags>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetJobsJobIdTagsQueryOptions(jobId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postPipelines = (postPipelinesBody: PostPipelinesBody) => {
  return customHttpClient<PostPipelines200>({
    url: `/pipelines`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postPipelinesBody,
  });
};

export const getPostPipelinesMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPipelines>>,
    TError,
    { data: PostPipelinesBody },
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<typeof postPipelines>>, TError, { data: PostPipelinesBody }, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPipelines>>, { data: PostPipelinesBody }> = (
    props,
  ) => {
    const { data } = props ?? {};

    return postPipelines(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostPipelinesMutationResult = NonNullable<Awaited<ReturnType<typeof postPipelines>>>;
export type PostPipelinesMutationBody = PostPipelinesBody;
export type PostPipelinesMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostPipelines = <TError = Status400 | Status401 | Status403 | Status404, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPipelines>>,
    TError,
    { data: PostPipelinesBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostPipelinesMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getPipelinesSettingsMy = (signal?: AbortSignal) => {
  return customHttpClient<GetPipelinesSettingsMy200>({ url: `/pipelines/settings/my`, method: 'GET', signal });
};

export const getGetPipelinesSettingsMyQueryKey = () => {
  return [`/pipelines/settings/my`] as const;
};

export const getGetPipelinesSettingsMyQueryOptions = <
  TData = Awaited<ReturnType<typeof getPipelinesSettingsMy>>,
  TError = Status400 | Status401,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getPipelinesSettingsMy>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPipelinesSettingsMyQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPipelinesSettingsMy>>> = ({ signal }) =>
    getPipelinesSettingsMy(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPipelinesSettingsMy>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPipelinesSettingsMyQueryResult = NonNullable<Awaited<ReturnType<typeof getPipelinesSettingsMy>>>;
export type GetPipelinesSettingsMyQueryError = Status400 | Status401;

export const useGetPipelinesSettingsMy = <
  TData = Awaited<ReturnType<typeof getPipelinesSettingsMy>>,
  TError = Status400 | Status401,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getPipelinesSettingsMy>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetPipelinesSettingsMyQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getPipelinesPipelineId = (pipelineId: number, signal?: AbortSignal) => {
  return customHttpClient<Pipeline>({ url: `/pipelines/${pipelineId}`, method: 'GET', signal });
};

export const getGetPipelinesPipelineIdQueryKey = (pipelineId: number) => {
  return [`/pipelines/${pipelineId}`] as const;
};

export const getGetPipelinesPipelineIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getPipelinesPipelineId>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  pipelineId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getPipelinesPipelineId>>, TError, TData> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPipelinesPipelineIdQueryKey(pipelineId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPipelinesPipelineId>>> = ({ signal }) =>
    getPipelinesPipelineId(pipelineId, signal);

  return { queryKey, queryFn, enabled: !!pipelineId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPipelinesPipelineId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPipelinesPipelineIdQueryResult = NonNullable<Awaited<ReturnType<typeof getPipelinesPipelineId>>>;
export type GetPipelinesPipelineIdQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetPipelinesPipelineId = <
  TData = Awaited<ReturnType<typeof getPipelinesPipelineId>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  pipelineId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getPipelinesPipelineId>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetPipelinesPipelineIdQueryOptions(pipelineId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const deletePipelinesPipelineId = (pipelineId: number) => {
  return customHttpClient<DeletePipelinesPipelineId200>({ url: `/pipelines/${pipelineId}`, method: 'DELETE' });
};

export const getDeletePipelinesPipelineIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePipelinesPipelineId>>,
    TError,
    { pipelineId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deletePipelinesPipelineId>>,
  TError,
  { pipelineId: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePipelinesPipelineId>>, { pipelineId: number }> = (
    props,
  ) => {
    const { pipelineId } = props ?? {};

    return deletePipelinesPipelineId(pipelineId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeletePipelinesPipelineIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deletePipelinesPipelineId>>
>;

export type DeletePipelinesPipelineIdMutationError = Status400 | Status401 | Status403 | Status404;

export const useDeletePipelinesPipelineId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePipelinesPipelineId>>,
    TError,
    { pipelineId: number },
    TContext
  >;
}) => {
  const mutationOptions = getDeletePipelinesPipelineIdMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Move a candidate to another pipeline
 */
export const putPipelinesPipelineIdCandidateCandidateIdMove = (pipelineId: number, candidateId: number) => {
  return customHttpClient<PutPipelinesPipelineIdCandidateCandidateIdMove200>({
    url: `/pipelines/${pipelineId}/candidate/${candidateId}/move`,
    method: 'PUT',
  });
};

export const getPutPipelinesPipelineIdCandidateCandidateIdMoveMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putPipelinesPipelineIdCandidateCandidateIdMove>>,
    TError,
    { pipelineId: number; candidateId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putPipelinesPipelineIdCandidateCandidateIdMove>>,
  TError,
  { pipelineId: number; candidateId: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putPipelinesPipelineIdCandidateCandidateIdMove>>,
    { pipelineId: number; candidateId: number }
  > = (props) => {
    const { pipelineId, candidateId } = props ?? {};

    return putPipelinesPipelineIdCandidateCandidateIdMove(pipelineId, candidateId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutPipelinesPipelineIdCandidateCandidateIdMoveMutationResult = NonNullable<
  Awaited<ReturnType<typeof putPipelinesPipelineIdCandidateCandidateIdMove>>
>;

export type PutPipelinesPipelineIdCandidateCandidateIdMoveMutationError = Status400 | Status401 | Status403 | Status404;

/**
 * @summary Move a candidate to another pipeline
 */
export const usePutPipelinesPipelineIdCandidateCandidateIdMove = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putPipelinesPipelineIdCandidateCandidateIdMove>>,
    TError,
    { pipelineId: number; candidateId: number },
    TContext
  >;
}) => {
  const mutationOptions = getPutPipelinesPipelineIdCandidateCandidateIdMoveMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Move a job to another pipeline
 */
export const putPipelinesPipelineIdJobJobIdMove = (pipelineId: number, jobId: number) => {
  return customHttpClient<PutPipelinesPipelineIdJobJobIdMove200>({
    url: `/pipelines/${pipelineId}/job/${jobId}/move`,
    method: 'PUT',
  });
};

export const getPutPipelinesPipelineIdJobJobIdMoveMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putPipelinesPipelineIdJobJobIdMove>>,
    TError,
    { pipelineId: number; jobId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putPipelinesPipelineIdJobJobIdMove>>,
  TError,
  { pipelineId: number; jobId: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putPipelinesPipelineIdJobJobIdMove>>,
    { pipelineId: number; jobId: number }
  > = (props) => {
    const { pipelineId, jobId } = props ?? {};

    return putPipelinesPipelineIdJobJobIdMove(pipelineId, jobId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutPipelinesPipelineIdJobJobIdMoveMutationResult = NonNullable<
  Awaited<ReturnType<typeof putPipelinesPipelineIdJobJobIdMove>>
>;

export type PutPipelinesPipelineIdJobJobIdMoveMutationError = Status400 | Status401 | Status403 | Status404;

/**
 * @summary Move a job to another pipeline
 */
export const usePutPipelinesPipelineIdJobJobIdMove = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putPipelinesPipelineIdJobJobIdMove>>,
    TError,
    { pipelineId: number; jobId: number },
    TContext
  >;
}) => {
  const mutationOptions = getPutPipelinesPipelineIdJobJobIdMoveMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postPipelinesSearch = (postPipelinesSearchBody: PostPipelinesSearchBody) => {
  return customHttpClient<PostPipelinesSearch200>({
    url: `/pipelines/search`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postPipelinesSearchBody,
  });
};

export const getPostPipelinesSearchMutationOptions = <TError = Status400 | Status401, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPipelinesSearch>>,
    TError,
    { data: PostPipelinesSearchBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postPipelinesSearch>>,
  TError,
  { data: PostPipelinesSearchBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postPipelinesSearch>>,
    { data: PostPipelinesSearchBody }
  > = (props) => {
    const { data } = props ?? {};

    return postPipelinesSearch(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostPipelinesSearchMutationResult = NonNullable<Awaited<ReturnType<typeof postPipelinesSearch>>>;
export type PostPipelinesSearchMutationBody = PostPipelinesSearchBody;
export type PostPipelinesSearchMutationError = Status400 | Status401;

export const usePostPipelinesSearch = <TError = Status400 | Status401, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPipelinesSearch>>,
    TError,
    { data: PostPipelinesSearchBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostPipelinesSearchMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * update counter in jobs on candidate side
 */
export const postPipelinesMarkRead = (postPipelinesMarkReadBody: PostPipelinesMarkReadBody) => {
  return customHttpClient<PostPipelinesMarkRead200>({
    url: `/pipelines/mark-read`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postPipelinesMarkReadBody,
  });
};

export const getPostPipelinesMarkReadMutationOptions = <TError = Status400 | Status401, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPipelinesMarkRead>>,
    TError,
    { data: PostPipelinesMarkReadBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postPipelinesMarkRead>>,
  TError,
  { data: PostPipelinesMarkReadBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postPipelinesMarkRead>>,
    { data: PostPipelinesMarkReadBody }
  > = (props) => {
    const { data } = props ?? {};

    return postPipelinesMarkRead(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostPipelinesMarkReadMutationResult = NonNullable<Awaited<ReturnType<typeof postPipelinesMarkRead>>>;
export type PostPipelinesMarkReadMutationBody = PostPipelinesMarkReadBody;
export type PostPipelinesMarkReadMutationError = Status400 | Status401;

export const usePostPipelinesMarkRead = <TError = Status400 | Status401, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPipelinesMarkRead>>,
    TError,
    { data: PostPipelinesMarkReadBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostPipelinesMarkReadMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putPipelinesMarkRead = () => {
  return customHttpClient<PutPipelinesMarkRead200>({ url: `/pipelines/mark-read`, method: 'PUT' });
};

export const getPutPipelinesMarkReadMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putPipelinesMarkRead>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof putPipelinesMarkRead>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof putPipelinesMarkRead>>, void> = () => {
    return putPipelinesMarkRead();
  };

  return { mutationFn, ...mutationOptions };
};

export type PutPipelinesMarkReadMutationResult = NonNullable<Awaited<ReturnType<typeof putPipelinesMarkRead>>>;

export type PutPipelinesMarkReadMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutPipelinesMarkRead = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putPipelinesMarkRead>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPutPipelinesMarkReadMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getPlacementsPlacementId = (placementId: number, signal?: AbortSignal) => {
  return customHttpClient<Placement>({ url: `/placements/${placementId}`, method: 'GET', signal });
};

export const getGetPlacementsPlacementIdQueryKey = (placementId: number) => {
  return [`/placements/${placementId}`] as const;
};

export const getGetPlacementsPlacementIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getPlacementsPlacementId>>,
  TError = Status400 | Status401,
>(
  placementId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getPlacementsPlacementId>>, TError, TData> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPlacementsPlacementIdQueryKey(placementId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlacementsPlacementId>>> = ({ signal }) =>
    getPlacementsPlacementId(placementId, signal);

  return { queryKey, queryFn, enabled: !!placementId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPlacementsPlacementId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPlacementsPlacementIdQueryResult = NonNullable<Awaited<ReturnType<typeof getPlacementsPlacementId>>>;
export type GetPlacementsPlacementIdQueryError = Status400 | Status401;

export const useGetPlacementsPlacementId = <
  TData = Awaited<ReturnType<typeof getPlacementsPlacementId>>,
  TError = Status400 | Status401,
>(
  placementId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getPlacementsPlacementId>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetPlacementsPlacementIdQueryOptions(placementId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postEmailsSendAutomaticEmail = (postEmailsSendAutomaticEmailBody: PostEmailsSendAutomaticEmailBody) => {
  return customHttpClient<Success>({
    url: `/emails/send-automatic-email`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postEmailsSendAutomaticEmailBody,
  });
};

export const getPostEmailsSendAutomaticEmailMutationOptions = <
  TError = Status400 | Status401,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postEmailsSendAutomaticEmail>>,
    TError,
    { data: PostEmailsSendAutomaticEmailBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postEmailsSendAutomaticEmail>>,
  TError,
  { data: PostEmailsSendAutomaticEmailBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postEmailsSendAutomaticEmail>>,
    { data: PostEmailsSendAutomaticEmailBody }
  > = (props) => {
    const { data } = props ?? {};

    return postEmailsSendAutomaticEmail(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostEmailsSendAutomaticEmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof postEmailsSendAutomaticEmail>>
>;
export type PostEmailsSendAutomaticEmailMutationBody = PostEmailsSendAutomaticEmailBody;
export type PostEmailsSendAutomaticEmailMutationError = Status400 | Status401;

export const usePostEmailsSendAutomaticEmail = <TError = Status400 | Status401, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postEmailsSendAutomaticEmail>>,
    TError,
    { data: PostEmailsSendAutomaticEmailBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostEmailsSendAutomaticEmailMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postEmailsSendEmailToHrAgent = (postEmailsSendEmailToHrAgentBody: PostEmailsSendEmailToHrAgentBody) => {
  return customHttpClient<PostEmailsSendEmailToHrAgent200>({
    url: `/emails/send-email-to-hr-agent`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postEmailsSendEmailToHrAgentBody,
  });
};

export const getPostEmailsSendEmailToHrAgentMutationOptions = <
  TError = Status400 | Status401,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postEmailsSendEmailToHrAgent>>,
    TError,
    { data: PostEmailsSendEmailToHrAgentBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postEmailsSendEmailToHrAgent>>,
  TError,
  { data: PostEmailsSendEmailToHrAgentBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postEmailsSendEmailToHrAgent>>,
    { data: PostEmailsSendEmailToHrAgentBody }
  > = (props) => {
    const { data } = props ?? {};

    return postEmailsSendEmailToHrAgent(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostEmailsSendEmailToHrAgentMutationResult = NonNullable<
  Awaited<ReturnType<typeof postEmailsSendEmailToHrAgent>>
>;
export type PostEmailsSendEmailToHrAgentMutationBody = PostEmailsSendEmailToHrAgentBody;
export type PostEmailsSendEmailToHrAgentMutationError = Status400 | Status401;

export const usePostEmailsSendEmailToHrAgent = <TError = Status400 | Status401, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postEmailsSendEmailToHrAgent>>,
    TError,
    { data: PostEmailsSendEmailToHrAgentBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostEmailsSendEmailToHrAgentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postEmailsSendToCandidate = (postEmailsSendToCandidateBody: PostEmailsSendToCandidateBody) => {
  return customHttpClient<PostEmailsSendToCandidate200>({
    url: `/emails/send-to-candidate`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postEmailsSendToCandidateBody,
  });
};

export const getPostEmailsSendToCandidateMutationOptions = <
  TError = Status400 | Status401,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postEmailsSendToCandidate>>,
    TError,
    { data: PostEmailsSendToCandidateBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postEmailsSendToCandidate>>,
  TError,
  { data: PostEmailsSendToCandidateBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postEmailsSendToCandidate>>,
    { data: PostEmailsSendToCandidateBody }
  > = (props) => {
    const { data } = props ?? {};

    return postEmailsSendToCandidate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostEmailsSendToCandidateMutationResult = NonNullable<
  Awaited<ReturnType<typeof postEmailsSendToCandidate>>
>;
export type PostEmailsSendToCandidateMutationBody = PostEmailsSendToCandidateBody;
export type PostEmailsSendToCandidateMutationError = Status400 | Status401;

export const usePostEmailsSendToCandidate = <TError = Status400 | Status401, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postEmailsSendToCandidate>>,
    TError,
    { data: PostEmailsSendToCandidateBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostEmailsSendToCandidateMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postEmailsSendToContact = (postEmailsSendToContactBody: PostEmailsSendToContactBody) => {
  return customHttpClient<PostEmailsSendToContact200>({
    url: `/emails/send-to-contact`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postEmailsSendToContactBody,
  });
};

export const getPostEmailsSendToContactMutationOptions = <
  TError = Status400 | Status401,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postEmailsSendToContact>>,
    TError,
    { data: PostEmailsSendToContactBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postEmailsSendToContact>>,
  TError,
  { data: PostEmailsSendToContactBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postEmailsSendToContact>>,
    { data: PostEmailsSendToContactBody }
  > = (props) => {
    const { data } = props ?? {};

    return postEmailsSendToContact(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostEmailsSendToContactMutationResult = NonNullable<Awaited<ReturnType<typeof postEmailsSendToContact>>>;
export type PostEmailsSendToContactMutationBody = PostEmailsSendToContactBody;
export type PostEmailsSendToContactMutationError = Status400 | Status401;

export const usePostEmailsSendToContact = <TError = Status400 | Status401, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postEmailsSendToContact>>,
    TError,
    { data: PostEmailsSendToContactBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostEmailsSendToContactMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postEmailsSearch = (postEmailsSearchBody: PostEmailsSearchBody) => {
  return customHttpClient<PostEmailsSearch200>({
    url: `/emails/search`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postEmailsSearchBody,
  });
};

export const getPostEmailsSearchMutationOptions = <TError = Status400 | Status401, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postEmailsSearch>>,
    TError,
    { data: PostEmailsSearchBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postEmailsSearch>>,
  TError,
  { data: PostEmailsSearchBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEmailsSearch>>, { data: PostEmailsSearchBody }> = (
    props,
  ) => {
    const { data } = props ?? {};

    return postEmailsSearch(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostEmailsSearchMutationResult = NonNullable<Awaited<ReturnType<typeof postEmailsSearch>>>;
export type PostEmailsSearchMutationBody = PostEmailsSearchBody;
export type PostEmailsSearchMutationError = Status400 | Status401;

export const usePostEmailsSearch = <TError = Status400 | Status401, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postEmailsSearch>>,
    TError,
    { data: PostEmailsSearchBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostEmailsSearchMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getEmailsTags = (signal?: AbortSignal) => {
  return customHttpClient<GetEmailsTags200>({ url: `/emails/tags`, method: 'GET', signal });
};

export const getGetEmailsTagsQueryKey = () => {
  return [`/emails/tags`] as const;
};

export const getGetEmailsTagsQueryOptions = <
  TData = Awaited<ReturnType<typeof getEmailsTags>>,
  TError = Status400 | Status401,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getEmailsTags>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEmailsTagsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmailsTags>>> = ({ signal }) => getEmailsTags(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEmailsTags>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEmailsTagsQueryResult = NonNullable<Awaited<ReturnType<typeof getEmailsTags>>>;
export type GetEmailsTagsQueryError = Status400 | Status401;

export const useGetEmailsTags = <
  TData = Awaited<ReturnType<typeof getEmailsTags>>,
  TError = Status400 | Status401,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getEmailsTags>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetEmailsTagsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postEmailsPreview = (postEmailsPreviewBody: PostEmailsPreviewBody) => {
  return customHttpClient<PostEmailsPreview200>({
    url: `/emails/preview`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postEmailsPreviewBody,
  });
};

export const getPostEmailsPreviewMutationOptions = <TError = Status400 | Status401, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postEmailsPreview>>,
    TError,
    { data: PostEmailsPreviewBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postEmailsPreview>>,
  TError,
  { data: PostEmailsPreviewBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEmailsPreview>>, { data: PostEmailsPreviewBody }> = (
    props,
  ) => {
    const { data } = props ?? {};

    return postEmailsPreview(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostEmailsPreviewMutationResult = NonNullable<Awaited<ReturnType<typeof postEmailsPreview>>>;
export type PostEmailsPreviewMutationBody = PostEmailsPreviewBody;
export type PostEmailsPreviewMutationError = Status400 | Status401;

export const usePostEmailsPreview = <TError = Status400 | Status401, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postEmailsPreview>>,
    TError,
    { data: PostEmailsPreviewBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostEmailsPreviewMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postEmailsPreviewEdited = (postEmailsPreviewEditedBody: PostEmailsPreviewEditedBody) => {
  return customHttpClient<PostEmailsPreviewEdited200>({
    url: `/emails/preview-edited`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postEmailsPreviewEditedBody,
  });
};

export const getPostEmailsPreviewEditedMutationOptions = <
  TError = Status400 | Status401,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postEmailsPreviewEdited>>,
    TError,
    { data: PostEmailsPreviewEditedBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postEmailsPreviewEdited>>,
  TError,
  { data: PostEmailsPreviewEditedBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postEmailsPreviewEdited>>,
    { data: PostEmailsPreviewEditedBody }
  > = (props) => {
    const { data } = props ?? {};

    return postEmailsPreviewEdited(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostEmailsPreviewEditedMutationResult = NonNullable<Awaited<ReturnType<typeof postEmailsPreviewEdited>>>;
export type PostEmailsPreviewEditedMutationBody = PostEmailsPreviewEditedBody;
export type PostEmailsPreviewEditedMutationError = Status400 | Status401;

export const usePostEmailsPreviewEdited = <TError = Status400 | Status401, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postEmailsPreviewEdited>>,
    TError,
    { data: PostEmailsPreviewEditedBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostEmailsPreviewEditedMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postEmailsSend = (postEmailsSendBody: PostEmailsSendBody) => {
  return customHttpClient<PostEmailsSend200>({
    url: `/emails/send`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postEmailsSendBody,
  });
};

export const getPostEmailsSendMutationOptions = <TError = Status400 | Status401, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postEmailsSend>>,
    TError,
    { data: PostEmailsSendBody },
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<typeof postEmailsSend>>, TError, { data: PostEmailsSendBody }, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEmailsSend>>, { data: PostEmailsSendBody }> = (
    props,
  ) => {
    const { data } = props ?? {};

    return postEmailsSend(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostEmailsSendMutationResult = NonNullable<Awaited<ReturnType<typeof postEmailsSend>>>;
export type PostEmailsSendMutationBody = PostEmailsSendBody;
export type PostEmailsSendMutationError = Status400 | Status401;

export const usePostEmailsSend = <TError = Status400 | Status401, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postEmailsSend>>,
    TError,
    { data: PostEmailsSendBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostEmailsSendMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postEmailsSendResume = (postEmailsSendResumeBody: PostEmailsSendResumeBody) => {
  return customHttpClient<PostEmailsSendResume200>({
    url: `/emails/send-resume`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postEmailsSendResumeBody,
  });
};

export const getPostEmailsSendResumeMutationOptions = <TError = Status400 | Status401, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postEmailsSendResume>>,
    TError,
    { data: PostEmailsSendResumeBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postEmailsSendResume>>,
  TError,
  { data: PostEmailsSendResumeBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postEmailsSendResume>>,
    { data: PostEmailsSendResumeBody }
  > = (props) => {
    const { data } = props ?? {};

    return postEmailsSendResume(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostEmailsSendResumeMutationResult = NonNullable<Awaited<ReturnType<typeof postEmailsSendResume>>>;
export type PostEmailsSendResumeMutationBody = PostEmailsSendResumeBody;
export type PostEmailsSendResumeMutationError = Status400 | Status401;

export const usePostEmailsSendResume = <TError = Status400 | Status401, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postEmailsSendResume>>,
    TError,
    { data: PostEmailsSendResumeBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostEmailsSendResumeMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getEmailsSentSentEmailIdAttachmentsAttachmentId = (
  sentEmailId: number,
  attachmentId: number,
  signal?: AbortSignal,
) => {
  return customHttpClient<GetEmailsSentSentEmailIdAttachmentsAttachmentId200>({
    url: `/emails/sent/${sentEmailId}/attachments/${attachmentId}`,
    method: 'GET',
    signal,
  });
};

export const getGetEmailsSentSentEmailIdAttachmentsAttachmentIdQueryKey = (
  sentEmailId: number,
  attachmentId: number,
) => {
  return [`/emails/sent/${sentEmailId}/attachments/${attachmentId}`] as const;
};

export const getGetEmailsSentSentEmailIdAttachmentsAttachmentIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getEmailsSentSentEmailIdAttachmentsAttachmentId>>,
  TError = Status400 | Status401,
>(
  sentEmailId: number,
  attachmentId: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getEmailsSentSentEmailIdAttachmentsAttachmentId>>, TError, TData>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetEmailsSentSentEmailIdAttachmentsAttachmentIdQueryKey(sentEmailId, attachmentId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmailsSentSentEmailIdAttachmentsAttachmentId>>> = ({
    signal,
  }) => getEmailsSentSentEmailIdAttachmentsAttachmentId(sentEmailId, attachmentId, signal);

  return { queryKey, queryFn, enabled: !!(sentEmailId && attachmentId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEmailsSentSentEmailIdAttachmentsAttachmentId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEmailsSentSentEmailIdAttachmentsAttachmentIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEmailsSentSentEmailIdAttachmentsAttachmentId>>
>;
export type GetEmailsSentSentEmailIdAttachmentsAttachmentIdQueryError = Status400 | Status401;

export const useGetEmailsSentSentEmailIdAttachmentsAttachmentId = <
  TData = Awaited<ReturnType<typeof getEmailsSentSentEmailIdAttachmentsAttachmentId>>,
  TError = Status400 | Status401,
>(
  sentEmailId: number,
  attachmentId: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getEmailsSentSentEmailIdAttachmentsAttachmentId>>, TError, TData>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetEmailsSentSentEmailIdAttachmentsAttachmentIdQueryOptions(
    sentEmailId,
    attachmentId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getEmailsReceivedReceivedEmailIdAttachmentsAttachmentId = (
  receivedEmailId: number,
  attachmentId: number,
  signal?: AbortSignal,
) => {
  return customHttpClient<GetEmailsReceivedReceivedEmailIdAttachmentsAttachmentId200>({
    url: `/emails/received/${receivedEmailId}/attachments/${attachmentId}`,
    method: 'GET',
    signal,
  });
};

export const getGetEmailsReceivedReceivedEmailIdAttachmentsAttachmentIdQueryKey = (
  receivedEmailId: number,
  attachmentId: number,
) => {
  return [`/emails/received/${receivedEmailId}/attachments/${attachmentId}`] as const;
};

export const getGetEmailsReceivedReceivedEmailIdAttachmentsAttachmentIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getEmailsReceivedReceivedEmailIdAttachmentsAttachmentId>>,
  TError = Status400 | Status401,
>(
  receivedEmailId: number,
  attachmentId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getEmailsReceivedReceivedEmailIdAttachmentsAttachmentId>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetEmailsReceivedReceivedEmailIdAttachmentsAttachmentIdQueryKey(receivedEmailId, attachmentId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmailsReceivedReceivedEmailIdAttachmentsAttachmentId>>> = ({
    signal,
  }) => getEmailsReceivedReceivedEmailIdAttachmentsAttachmentId(receivedEmailId, attachmentId, signal);

  return { queryKey, queryFn, enabled: !!(receivedEmailId && attachmentId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEmailsReceivedReceivedEmailIdAttachmentsAttachmentId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEmailsReceivedReceivedEmailIdAttachmentsAttachmentIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEmailsReceivedReceivedEmailIdAttachmentsAttachmentId>>
>;
export type GetEmailsReceivedReceivedEmailIdAttachmentsAttachmentIdQueryError = Status400 | Status401;

export const useGetEmailsReceivedReceivedEmailIdAttachmentsAttachmentId = <
  TData = Awaited<ReturnType<typeof getEmailsReceivedReceivedEmailIdAttachmentsAttachmentId>>,
  TError = Status400 | Status401,
>(
  receivedEmailId: number,
  attachmentId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getEmailsReceivedReceivedEmailIdAttachmentsAttachmentId>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetEmailsReceivedReceivedEmailIdAttachmentsAttachmentIdQueryOptions(
    receivedEmailId,
    attachmentId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getEmailsSentSentEmailId = (signal?: AbortSignal) => {
  return customHttpClient<GetEmailsSentSentEmailId200>({ url: `/emails/sent/:sentEmailId`, method: 'GET', signal });
};

export const getGetEmailsSentSentEmailIdQueryKey = () => {
  return [`/emails/sent/:sentEmailId`] as const;
};

export const getGetEmailsSentSentEmailIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getEmailsSentSentEmailId>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getEmailsSentSentEmailId>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEmailsSentSentEmailIdQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmailsSentSentEmailId>>> = ({ signal }) =>
    getEmailsSentSentEmailId(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEmailsSentSentEmailId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEmailsSentSentEmailIdQueryResult = NonNullable<Awaited<ReturnType<typeof getEmailsSentSentEmailId>>>;
export type GetEmailsSentSentEmailIdQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetEmailsSentSentEmailId = <
  TData = Awaited<ReturnType<typeof getEmailsSentSentEmailId>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getEmailsSentSentEmailId>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetEmailsSentSentEmailIdQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getEmailsReceivedReceivedEmailId = (signal?: AbortSignal) => {
  return customHttpClient<GetEmailsReceivedReceivedEmailId200>({
    url: `/emails/received/:receivedEmailId`,
    method: 'GET',
    signal,
  });
};

export const getGetEmailsReceivedReceivedEmailIdQueryKey = () => {
  return [`/emails/received/:receivedEmailId`] as const;
};

export const getGetEmailsReceivedReceivedEmailIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getEmailsReceivedReceivedEmailId>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getEmailsReceivedReceivedEmailId>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEmailsReceivedReceivedEmailIdQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmailsReceivedReceivedEmailId>>> = ({ signal }) =>
    getEmailsReceivedReceivedEmailId(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEmailsReceivedReceivedEmailId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEmailsReceivedReceivedEmailIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEmailsReceivedReceivedEmailId>>
>;
export type GetEmailsReceivedReceivedEmailIdQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetEmailsReceivedReceivedEmailId = <
  TData = Awaited<ReturnType<typeof getEmailsReceivedReceivedEmailId>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getEmailsReceivedReceivedEmailId>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetEmailsReceivedReceivedEmailIdQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getEvaBotCampaignsEditOptions = (signal?: AbortSignal) => {
  return customHttpClient<GetEvaBotCampaignsEditOptions200>({
    url: `/eva-bot-campaigns/edit-options`,
    method: 'GET',
    signal,
  });
};

export const getGetEvaBotCampaignsEditOptionsQueryKey = () => {
  return [`/eva-bot-campaigns/edit-options`] as const;
};

export const getGetEvaBotCampaignsEditOptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getEvaBotCampaignsEditOptions>>,
  TError = Status401,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getEvaBotCampaignsEditOptions>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEvaBotCampaignsEditOptionsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEvaBotCampaignsEditOptions>>> = ({ signal }) =>
    getEvaBotCampaignsEditOptions(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEvaBotCampaignsEditOptions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEvaBotCampaignsEditOptionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEvaBotCampaignsEditOptions>>
>;
export type GetEvaBotCampaignsEditOptionsQueryError = Status401;

export const useGetEvaBotCampaignsEditOptions = <
  TData = Awaited<ReturnType<typeof getEvaBotCampaignsEditOptions>>,
  TError = Status401,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getEvaBotCampaignsEditOptions>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetEvaBotCampaignsEditOptionsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getEvaBotCampaignsEvaBotCampaignIdVisualisations = (evaBotCampaignId: number, signal?: AbortSignal) => {
  return customHttpClient<GetEvaBotCampaignsEvaBotCampaignIdVisualisations200>({
    url: `/eva-bot-campaigns/${evaBotCampaignId}/visualisations`,
    method: 'GET',
    signal,
  });
};

export const getGetEvaBotCampaignsEvaBotCampaignIdVisualisationsQueryKey = (evaBotCampaignId: number) => {
  return [`/eva-bot-campaigns/${evaBotCampaignId}/visualisations`] as const;
};

export const getGetEvaBotCampaignsEvaBotCampaignIdVisualisationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getEvaBotCampaignsEvaBotCampaignIdVisualisations>>,
  TError = Status401 | Status404,
>(
  evaBotCampaignId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getEvaBotCampaignsEvaBotCampaignIdVisualisations>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetEvaBotCampaignsEvaBotCampaignIdVisualisationsQueryKey(evaBotCampaignId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEvaBotCampaignsEvaBotCampaignIdVisualisations>>> = ({
    signal,
  }) => getEvaBotCampaignsEvaBotCampaignIdVisualisations(evaBotCampaignId, signal);

  return { queryKey, queryFn, enabled: !!evaBotCampaignId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEvaBotCampaignsEvaBotCampaignIdVisualisations>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEvaBotCampaignsEvaBotCampaignIdVisualisationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEvaBotCampaignsEvaBotCampaignIdVisualisations>>
>;
export type GetEvaBotCampaignsEvaBotCampaignIdVisualisationsQueryError = Status401 | Status404;

export const useGetEvaBotCampaignsEvaBotCampaignIdVisualisations = <
  TData = Awaited<ReturnType<typeof getEvaBotCampaignsEvaBotCampaignIdVisualisations>>,
  TError = Status401 | Status404,
>(
  evaBotCampaignId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getEvaBotCampaignsEvaBotCampaignIdVisualisations>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetEvaBotCampaignsEvaBotCampaignIdVisualisationsQueryOptions(evaBotCampaignId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getEvaBotCampaignsEvaBotCampaignIdListCandidates = (
  evaBotCampaignId: number,
  params?: GetEvaBotCampaignsEvaBotCampaignIdListCandidatesParams,
  signal?: AbortSignal,
) => {
  return customHttpClient<GetEvaBotCampaignsEvaBotCampaignIdListCandidates200>({
    url: `/eva-bot-campaigns/${evaBotCampaignId}/list-candidates`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetEvaBotCampaignsEvaBotCampaignIdListCandidatesQueryKey = (
  evaBotCampaignId: number,
  params?: GetEvaBotCampaignsEvaBotCampaignIdListCandidatesParams,
) => {
  return [`/eva-bot-campaigns/${evaBotCampaignId}/list-candidates`, ...(params ? [params] : [])] as const;
};

export const getGetEvaBotCampaignsEvaBotCampaignIdListCandidatesQueryOptions = <
  TData = Awaited<ReturnType<typeof getEvaBotCampaignsEvaBotCampaignIdListCandidates>>,
  TError = Status401 | Status404,
>(
  evaBotCampaignId: number,
  params?: GetEvaBotCampaignsEvaBotCampaignIdListCandidatesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getEvaBotCampaignsEvaBotCampaignIdListCandidates>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetEvaBotCampaignsEvaBotCampaignIdListCandidatesQueryKey(evaBotCampaignId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEvaBotCampaignsEvaBotCampaignIdListCandidates>>> = ({
    signal,
  }) => getEvaBotCampaignsEvaBotCampaignIdListCandidates(evaBotCampaignId, params, signal);

  return { queryKey, queryFn, enabled: !!evaBotCampaignId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEvaBotCampaignsEvaBotCampaignIdListCandidates>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEvaBotCampaignsEvaBotCampaignIdListCandidatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEvaBotCampaignsEvaBotCampaignIdListCandidates>>
>;
export type GetEvaBotCampaignsEvaBotCampaignIdListCandidatesQueryError = Status401 | Status404;

export const useGetEvaBotCampaignsEvaBotCampaignIdListCandidates = <
  TData = Awaited<ReturnType<typeof getEvaBotCampaignsEvaBotCampaignIdListCandidates>>,
  TError = Status401 | Status404,
>(
  evaBotCampaignId: number,
  params?: GetEvaBotCampaignsEvaBotCampaignIdListCandidatesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getEvaBotCampaignsEvaBotCampaignIdListCandidates>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetEvaBotCampaignsEvaBotCampaignIdListCandidatesQueryOptions(
    evaBotCampaignId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const putEvaBotCampaignsEvaBotCampaignId = () => {
  return customHttpClient<PutEvaBotCampaignsEvaBotCampaignId200>({
    url: `/eva-bot-campaigns/:evaBotCampaignId`,
    method: 'PUT',
  });
};

export const getPutEvaBotCampaignsEvaBotCampaignIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putEvaBotCampaignsEvaBotCampaignId>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof putEvaBotCampaignsEvaBotCampaignId>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof putEvaBotCampaignsEvaBotCampaignId>>, void> = () => {
    return putEvaBotCampaignsEvaBotCampaignId();
  };

  return { mutationFn, ...mutationOptions };
};

export type PutEvaBotCampaignsEvaBotCampaignIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putEvaBotCampaignsEvaBotCampaignId>>
>;

export type PutEvaBotCampaignsEvaBotCampaignIdMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutEvaBotCampaignsEvaBotCampaignId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putEvaBotCampaignsEvaBotCampaignId>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPutEvaBotCampaignsEvaBotCampaignIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteEvaBotCampaignsEvaBotCampaignId = () => {
  return customHttpClient<DeleteEvaBotCampaignsEvaBotCampaignId200>({
    url: `/eva-bot-campaigns/:evaBotCampaignId`,
    method: 'DELETE',
  });
};

export const getDeleteEvaBotCampaignsEvaBotCampaignIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteEvaBotCampaignsEvaBotCampaignId>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<typeof deleteEvaBotCampaignsEvaBotCampaignId>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEvaBotCampaignsEvaBotCampaignId>>, void> = () => {
    return deleteEvaBotCampaignsEvaBotCampaignId();
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteEvaBotCampaignsEvaBotCampaignIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteEvaBotCampaignsEvaBotCampaignId>>
>;

export type DeleteEvaBotCampaignsEvaBotCampaignIdMutationError = Status400 | Status401 | Status403 | Status404;

export const useDeleteEvaBotCampaignsEvaBotCampaignId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteEvaBotCampaignsEvaBotCampaignId>>,
    TError,
    void,
    TContext
  >;
}) => {
  const mutationOptions = getDeleteEvaBotCampaignsEvaBotCampaignIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postEvaBotCampaigns = (postEvaBotCampaignsBody: PostEvaBotCampaignsBody) => {
  return customHttpClient<EvaBotCampaign>({
    url: `/eva-bot-campaigns`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postEvaBotCampaignsBody,
  });
};

export const getPostEvaBotCampaignsMutationOptions = <TError = Status400 | Status401, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postEvaBotCampaigns>>,
    TError,
    { data: PostEvaBotCampaignsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postEvaBotCampaigns>>,
  TError,
  { data: PostEvaBotCampaignsBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postEvaBotCampaigns>>,
    { data: PostEvaBotCampaignsBody }
  > = (props) => {
    const { data } = props ?? {};

    return postEvaBotCampaigns(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostEvaBotCampaignsMutationResult = NonNullable<Awaited<ReturnType<typeof postEvaBotCampaigns>>>;
export type PostEvaBotCampaignsMutationBody = PostEvaBotCampaignsBody;
export type PostEvaBotCampaignsMutationError = Status400 | Status401;

export const usePostEvaBotCampaigns = <TError = Status400 | Status401, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postEvaBotCampaigns>>,
    TError,
    { data: PostEvaBotCampaignsBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostEvaBotCampaignsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getEvaBotCampaigns = (params?: GetEvaBotCampaignsParams, signal?: AbortSignal) => {
  return customHttpClient<GetEvaBotCampaigns200>({ url: `/eva-bot-campaigns`, method: 'GET', params, signal });
};

export const getGetEvaBotCampaignsQueryKey = (params?: GetEvaBotCampaignsParams) => {
  return [`/eva-bot-campaigns`, ...(params ? [params] : [])] as const;
};

export const getGetEvaBotCampaignsQueryOptions = <
  TData = Awaited<ReturnType<typeof getEvaBotCampaigns>>,
  TError = Status401,
>(
  params?: GetEvaBotCampaignsParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getEvaBotCampaigns>>, TError, TData> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEvaBotCampaignsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEvaBotCampaigns>>> = ({ signal }) =>
    getEvaBotCampaigns(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEvaBotCampaigns>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEvaBotCampaignsQueryResult = NonNullable<Awaited<ReturnType<typeof getEvaBotCampaigns>>>;
export type GetEvaBotCampaignsQueryError = Status401;

export const useGetEvaBotCampaigns = <TData = Awaited<ReturnType<typeof getEvaBotCampaigns>>, TError = Status401>(
  params?: GetEvaBotCampaignsParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getEvaBotCampaigns>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetEvaBotCampaignsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postNylasOauth = (postNylasOauthBody: PostNylasOauthBody) => {
  return customHttpClient<PostNylasOauth200>({
    url: `/nylas/oauth`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postNylasOauthBody,
  });
};

export const getPostNylasOauthMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postNylasOauth>>,
    TError,
    { data: PostNylasOauthBody },
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<typeof postNylasOauth>>, TError, { data: PostNylasOauthBody }, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postNylasOauth>>, { data: PostNylasOauthBody }> = (
    props,
  ) => {
    const { data } = props ?? {};

    return postNylasOauth(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostNylasOauthMutationResult = NonNullable<Awaited<ReturnType<typeof postNylasOauth>>>;
export type PostNylasOauthMutationBody = PostNylasOauthBody;
export type PostNylasOauthMutationError = unknown;

export const usePostNylasOauth = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postNylasOauth>>,
    TError,
    { data: PostNylasOauthBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostNylasOauthMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getNylasOauth = (signal?: AbortSignal) => {
  return customHttpClient<GetNylasOauth200>({ url: `/nylas/oauth`, method: 'GET', signal });
};

export const getGetNylasOauthQueryKey = () => {
  return [`/nylas/oauth`] as const;
};

export const getGetNylasOauthQueryOptions = <
  TData = Awaited<ReturnType<typeof getNylasOauth>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getNylasOauth>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetNylasOauthQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNylasOauth>>> = ({ signal }) => getNylasOauth(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNylasOauth>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetNylasOauthQueryResult = NonNullable<Awaited<ReturnType<typeof getNylasOauth>>>;
export type GetNylasOauthQueryError = unknown;

export const useGetNylasOauth = <TData = Awaited<ReturnType<typeof getNylasOauth>>, TError = unknown>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getNylasOauth>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetNylasOauthQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getNylasOauthCallback = (signal?: AbortSignal) => {
  return customHttpClient<GetNylasOauthCallback200>({ url: `/nylas/oauth/callback`, method: 'GET', signal });
};

export const getGetNylasOauthCallbackQueryKey = () => {
  return [`/nylas/oauth/callback`] as const;
};

export const getGetNylasOauthCallbackQueryOptions = <
  TData = Awaited<ReturnType<typeof getNylasOauthCallback>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getNylasOauthCallback>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetNylasOauthCallbackQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNylasOauthCallback>>> = ({ signal }) =>
    getNylasOauthCallback(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNylasOauthCallback>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetNylasOauthCallbackQueryResult = NonNullable<Awaited<ReturnType<typeof getNylasOauthCallback>>>;
export type GetNylasOauthCallbackQueryError = unknown;

export const useGetNylasOauthCallback = <
  TData = Awaited<ReturnType<typeof getNylasOauthCallback>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getNylasOauthCallback>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetNylasOauthCallbackQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postNylasWebhookMessageCreated = (
  postNylasWebhookMessageCreatedBody: PostNylasWebhookMessageCreatedBody,
) => {
  return customHttpClient<PostNylasWebhookMessageCreated200>({
    url: `/nylas/webhook/message-created`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postNylasWebhookMessageCreatedBody,
  });
};

export const getPostNylasWebhookMessageCreatedMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postNylasWebhookMessageCreated>>,
    TError,
    { data: PostNylasWebhookMessageCreatedBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postNylasWebhookMessageCreated>>,
  TError,
  { data: PostNylasWebhookMessageCreatedBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postNylasWebhookMessageCreated>>,
    { data: PostNylasWebhookMessageCreatedBody }
  > = (props) => {
    const { data } = props ?? {};

    return postNylasWebhookMessageCreated(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostNylasWebhookMessageCreatedMutationResult = NonNullable<
  Awaited<ReturnType<typeof postNylasWebhookMessageCreated>>
>;
export type PostNylasWebhookMessageCreatedMutationBody = PostNylasWebhookMessageCreatedBody;
export type PostNylasWebhookMessageCreatedMutationError = unknown;

export const usePostNylasWebhookMessageCreated = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postNylasWebhookMessageCreated>>,
    TError,
    { data: PostNylasWebhookMessageCreatedBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostNylasWebhookMessageCreatedMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getNylasWebhookMessageCreated = (signal?: AbortSignal) => {
  return customHttpClient<GetNylasWebhookMessageCreated200>({
    url: `/nylas/webhook/message-created`,
    method: 'GET',
    signal,
  });
};

export const getGetNylasWebhookMessageCreatedQueryKey = () => {
  return [`/nylas/webhook/message-created`] as const;
};

export const getGetNylasWebhookMessageCreatedQueryOptions = <
  TData = Awaited<ReturnType<typeof getNylasWebhookMessageCreated>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getNylasWebhookMessageCreated>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetNylasWebhookMessageCreatedQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNylasWebhookMessageCreated>>> = ({ signal }) =>
    getNylasWebhookMessageCreated(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNylasWebhookMessageCreated>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetNylasWebhookMessageCreatedQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNylasWebhookMessageCreated>>
>;
export type GetNylasWebhookMessageCreatedQueryError = unknown;

export const useGetNylasWebhookMessageCreated = <
  TData = Awaited<ReturnType<typeof getNylasWebhookMessageCreated>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getNylasWebhookMessageCreated>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetNylasWebhookMessageCreatedQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postNylasWebhookAccountExpire = (postNylasWebhookAccountExpireBody: PostNylasWebhookAccountExpireBody) => {
  return customHttpClient<PostNylasWebhookAccountExpire200>({
    url: `/nylas/webhook/account-expire`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postNylasWebhookAccountExpireBody,
  });
};

export const getPostNylasWebhookAccountExpireMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postNylasWebhookAccountExpire>>,
    TError,
    { data: PostNylasWebhookAccountExpireBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postNylasWebhookAccountExpire>>,
  TError,
  { data: PostNylasWebhookAccountExpireBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postNylasWebhookAccountExpire>>,
    { data: PostNylasWebhookAccountExpireBody }
  > = (props) => {
    const { data } = props ?? {};

    return postNylasWebhookAccountExpire(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostNylasWebhookAccountExpireMutationResult = NonNullable<
  Awaited<ReturnType<typeof postNylasWebhookAccountExpire>>
>;
export type PostNylasWebhookAccountExpireMutationBody = PostNylasWebhookAccountExpireBody;
export type PostNylasWebhookAccountExpireMutationError = unknown;

export const usePostNylasWebhookAccountExpire = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postNylasWebhookAccountExpire>>,
    TError,
    { data: PostNylasWebhookAccountExpireBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostNylasWebhookAccountExpireMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getNylasWebhookAccountExpire = (signal?: AbortSignal) => {
  return customHttpClient<GetNylasWebhookAccountExpire200>({
    url: `/nylas/webhook/account-expire`,
    method: 'GET',
    signal,
  });
};

export const getGetNylasWebhookAccountExpireQueryKey = () => {
  return [`/nylas/webhook/account-expire`] as const;
};

export const getGetNylasWebhookAccountExpireQueryOptions = <
  TData = Awaited<ReturnType<typeof getNylasWebhookAccountExpire>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getNylasWebhookAccountExpire>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetNylasWebhookAccountExpireQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNylasWebhookAccountExpire>>> = ({ signal }) =>
    getNylasWebhookAccountExpire(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNylasWebhookAccountExpire>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetNylasWebhookAccountExpireQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNylasWebhookAccountExpire>>
>;
export type GetNylasWebhookAccountExpireQueryError = unknown;

export const useGetNylasWebhookAccountExpire = <
  TData = Awaited<ReturnType<typeof getNylasWebhookAccountExpire>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getNylasWebhookAccountExpire>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetNylasWebhookAccountExpireQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postV2NylasOauth = (postV2NylasOauthBody: PostV2NylasOauthBody) => {
  return customHttpClient<PostV2NylasOauth200>({
    url: `/v2/nylas/oauth`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postV2NylasOauthBody,
  });
};

export const getPostV2NylasOauthMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV2NylasOauth>>,
    TError,
    { data: PostV2NylasOauthBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV2NylasOauth>>,
  TError,
  { data: PostV2NylasOauthBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postV2NylasOauth>>, { data: PostV2NylasOauthBody }> = (
    props,
  ) => {
    const { data } = props ?? {};

    return postV2NylasOauth(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV2NylasOauthMutationResult = NonNullable<Awaited<ReturnType<typeof postV2NylasOauth>>>;
export type PostV2NylasOauthMutationBody = PostV2NylasOauthBody;
export type PostV2NylasOauthMutationError = unknown;

export const usePostV2NylasOauth = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV2NylasOauth>>,
    TError,
    { data: PostV2NylasOauthBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostV2NylasOauthMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getV2NylasOauth = (signal?: AbortSignal) => {
  return customHttpClient<GetV2NylasOauth200>({ url: `/v2/nylas/oauth`, method: 'GET', signal });
};

export const getGetV2NylasOauthQueryKey = () => {
  return [`/v2/nylas/oauth`] as const;
};

export const getGetV2NylasOauthQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2NylasOauth>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getV2NylasOauth>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetV2NylasOauthQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV2NylasOauth>>> = ({ signal }) => getV2NylasOauth(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2NylasOauth>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetV2NylasOauthQueryResult = NonNullable<Awaited<ReturnType<typeof getV2NylasOauth>>>;
export type GetV2NylasOauthQueryError = unknown;

export const useGetV2NylasOauth = <TData = Awaited<ReturnType<typeof getV2NylasOauth>>, TError = unknown>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getV2NylasOauth>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetV2NylasOauthQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getV2NylasOauthExchange = (signal?: AbortSignal) => {
  return customHttpClient<GetV2NylasOauthExchange200>({ url: `/v2/nylas/oauth/exchange`, method: 'GET', signal });
};

export const getGetV2NylasOauthExchangeQueryKey = () => {
  return [`/v2/nylas/oauth/exchange`] as const;
};

export const getGetV2NylasOauthExchangeQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2NylasOauthExchange>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getV2NylasOauthExchange>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetV2NylasOauthExchangeQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV2NylasOauthExchange>>> = ({ signal }) =>
    getV2NylasOauthExchange(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2NylasOauthExchange>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetV2NylasOauthExchangeQueryResult = NonNullable<Awaited<ReturnType<typeof getV2NylasOauthExchange>>>;
export type GetV2NylasOauthExchangeQueryError = unknown;

export const useGetV2NylasOauthExchange = <
  TData = Awaited<ReturnType<typeof getV2NylasOauthExchange>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getV2NylasOauthExchange>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetV2NylasOauthExchangeQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postV2NylasWebhookMessageWebhook = (
  postV2NylasWebhookMessageWebhookBody: PostV2NylasWebhookMessageWebhookBody,
) => {
  return customHttpClient<PostV2NylasWebhookMessageWebhook200>({
    url: `/v2/nylas/webhook/message-webhook`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postV2NylasWebhookMessageWebhookBody,
  });
};

export const getPostV2NylasWebhookMessageWebhookMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV2NylasWebhookMessageWebhook>>,
    TError,
    { data: PostV2NylasWebhookMessageWebhookBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV2NylasWebhookMessageWebhook>>,
  TError,
  { data: PostV2NylasWebhookMessageWebhookBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV2NylasWebhookMessageWebhook>>,
    { data: PostV2NylasWebhookMessageWebhookBody }
  > = (props) => {
    const { data } = props ?? {};

    return postV2NylasWebhookMessageWebhook(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV2NylasWebhookMessageWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV2NylasWebhookMessageWebhook>>
>;
export type PostV2NylasWebhookMessageWebhookMutationBody = PostV2NylasWebhookMessageWebhookBody;
export type PostV2NylasWebhookMessageWebhookMutationError = unknown;

export const usePostV2NylasWebhookMessageWebhook = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV2NylasWebhookMessageWebhook>>,
    TError,
    { data: PostV2NylasWebhookMessageWebhookBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostV2NylasWebhookMessageWebhookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getV2NylasWebhookMessageWebhook = (signal?: AbortSignal) => {
  return customHttpClient<GetV2NylasWebhookMessageWebhook200>({
    url: `/v2/nylas/webhook/message-webhook`,
    method: 'GET',
    signal,
  });
};

export const getGetV2NylasWebhookMessageWebhookQueryKey = () => {
  return [`/v2/nylas/webhook/message-webhook`] as const;
};

export const getGetV2NylasWebhookMessageWebhookQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2NylasWebhookMessageWebhook>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getV2NylasWebhookMessageWebhook>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetV2NylasWebhookMessageWebhookQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV2NylasWebhookMessageWebhook>>> = ({ signal }) =>
    getV2NylasWebhookMessageWebhook(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2NylasWebhookMessageWebhook>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetV2NylasWebhookMessageWebhookQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2NylasWebhookMessageWebhook>>
>;
export type GetV2NylasWebhookMessageWebhookQueryError = unknown;

export const useGetV2NylasWebhookMessageWebhook = <
  TData = Awaited<ReturnType<typeof getV2NylasWebhookMessageWebhook>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getV2NylasWebhookMessageWebhook>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetV2NylasWebhookMessageWebhookQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postV2NylasWebhookMessageTrackingWebhook = (
  postV2NylasWebhookMessageTrackingWebhookBody: PostV2NylasWebhookMessageTrackingWebhookBody,
) => {
  return customHttpClient<PostV2NylasWebhookMessageTrackingWebhook200>({
    url: `/v2/nylas/webhook/message-tracking-webhook`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postV2NylasWebhookMessageTrackingWebhookBody,
  });
};

export const getPostV2NylasWebhookMessageTrackingWebhookMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV2NylasWebhookMessageTrackingWebhook>>,
    TError,
    { data: PostV2NylasWebhookMessageTrackingWebhookBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV2NylasWebhookMessageTrackingWebhook>>,
  TError,
  { data: PostV2NylasWebhookMessageTrackingWebhookBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV2NylasWebhookMessageTrackingWebhook>>,
    { data: PostV2NylasWebhookMessageTrackingWebhookBody }
  > = (props) => {
    const { data } = props ?? {};

    return postV2NylasWebhookMessageTrackingWebhook(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV2NylasWebhookMessageTrackingWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV2NylasWebhookMessageTrackingWebhook>>
>;
export type PostV2NylasWebhookMessageTrackingWebhookMutationBody = PostV2NylasWebhookMessageTrackingWebhookBody;
export type PostV2NylasWebhookMessageTrackingWebhookMutationError = unknown;

export const usePostV2NylasWebhookMessageTrackingWebhook = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV2NylasWebhookMessageTrackingWebhook>>,
    TError,
    { data: PostV2NylasWebhookMessageTrackingWebhookBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostV2NylasWebhookMessageTrackingWebhookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getV2NylasWebhookMessageTrackingWebhook = (signal?: AbortSignal) => {
  return customHttpClient<GetV2NylasWebhookMessageTrackingWebhook200>({
    url: `/v2/nylas/webhook/message-tracking-webhook`,
    method: 'GET',
    signal,
  });
};

export const getGetV2NylasWebhookMessageTrackingWebhookQueryKey = () => {
  return [`/v2/nylas/webhook/message-tracking-webhook`] as const;
};

export const getGetV2NylasWebhookMessageTrackingWebhookQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2NylasWebhookMessageTrackingWebhook>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getV2NylasWebhookMessageTrackingWebhook>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetV2NylasWebhookMessageTrackingWebhookQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV2NylasWebhookMessageTrackingWebhook>>> = ({ signal }) =>
    getV2NylasWebhookMessageTrackingWebhook(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2NylasWebhookMessageTrackingWebhook>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetV2NylasWebhookMessageTrackingWebhookQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2NylasWebhookMessageTrackingWebhook>>
>;
export type GetV2NylasWebhookMessageTrackingWebhookQueryError = unknown;

export const useGetV2NylasWebhookMessageTrackingWebhook = <
  TData = Awaited<ReturnType<typeof getV2NylasWebhookMessageTrackingWebhook>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getV2NylasWebhookMessageTrackingWebhook>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetV2NylasWebhookMessageTrackingWebhookQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postV2NylasWebhookGrantWebhook = (
  postV2NylasWebhookGrantWebhookBody: PostV2NylasWebhookGrantWebhookBody,
) => {
  return customHttpClient<PostV2NylasWebhookGrantWebhook200>({
    url: `/v2/nylas/webhook/grant-webhook`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postV2NylasWebhookGrantWebhookBody,
  });
};

export const getPostV2NylasWebhookGrantWebhookMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV2NylasWebhookGrantWebhook>>,
    TError,
    { data: PostV2NylasWebhookGrantWebhookBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV2NylasWebhookGrantWebhook>>,
  TError,
  { data: PostV2NylasWebhookGrantWebhookBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV2NylasWebhookGrantWebhook>>,
    { data: PostV2NylasWebhookGrantWebhookBody }
  > = (props) => {
    const { data } = props ?? {};

    return postV2NylasWebhookGrantWebhook(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV2NylasWebhookGrantWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV2NylasWebhookGrantWebhook>>
>;
export type PostV2NylasWebhookGrantWebhookMutationBody = PostV2NylasWebhookGrantWebhookBody;
export type PostV2NylasWebhookGrantWebhookMutationError = unknown;

export const usePostV2NylasWebhookGrantWebhook = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV2NylasWebhookGrantWebhook>>,
    TError,
    { data: PostV2NylasWebhookGrantWebhookBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostV2NylasWebhookGrantWebhookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getV2NylasWebhookGrantWebhook = (signal?: AbortSignal) => {
  return customHttpClient<GetV2NylasWebhookGrantWebhook200>({
    url: `/v2/nylas/webhook/grant-webhook`,
    method: 'GET',
    signal,
  });
};

export const getGetV2NylasWebhookGrantWebhookQueryKey = () => {
  return [`/v2/nylas/webhook/grant-webhook`] as const;
};

export const getGetV2NylasWebhookGrantWebhookQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2NylasWebhookGrantWebhook>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getV2NylasWebhookGrantWebhook>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetV2NylasWebhookGrantWebhookQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV2NylasWebhookGrantWebhook>>> = ({ signal }) =>
    getV2NylasWebhookGrantWebhook(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2NylasWebhookGrantWebhook>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetV2NylasWebhookGrantWebhookQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2NylasWebhookGrantWebhook>>
>;
export type GetV2NylasWebhookGrantWebhookQueryError = unknown;

export const useGetV2NylasWebhookGrantWebhook = <
  TData = Awaited<ReturnType<typeof getV2NylasWebhookGrantWebhook>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getV2NylasWebhookGrantWebhook>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetV2NylasWebhookGrantWebhookQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postActivityLogActivityTypeId = (postActivityLogActivityTypeIdBody: PostActivityLogActivityTypeIdBody) => {
  return customHttpClient<PostActivityLogActivityTypeId200>({
    url: `/activity-log/:activityTypeId`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postActivityLogActivityTypeIdBody,
  });
};

export const getPostActivityLogActivityTypeIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postActivityLogActivityTypeId>>,
    TError,
    { data: PostActivityLogActivityTypeIdBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postActivityLogActivityTypeId>>,
  TError,
  { data: PostActivityLogActivityTypeIdBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postActivityLogActivityTypeId>>,
    { data: PostActivityLogActivityTypeIdBody }
  > = (props) => {
    const { data } = props ?? {};

    return postActivityLogActivityTypeId(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostActivityLogActivityTypeIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof postActivityLogActivityTypeId>>
>;
export type PostActivityLogActivityTypeIdMutationBody = PostActivityLogActivityTypeIdBody;
export type PostActivityLogActivityTypeIdMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostActivityLogActivityTypeId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postActivityLogActivityTypeId>>,
    TError,
    { data: PostActivityLogActivityTypeIdBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostActivityLogActivityTypeIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postActivityNotesNotes = (postActivityNotesNotesBody: PostActivityNotesNotesBody) => {
  return customHttpClient<PostActivityNotesNotes200>({
    url: `/activity-notes/notes`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postActivityNotesNotesBody,
  });
};

export const getPostActivityNotesNotesMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postActivityNotesNotes>>,
    TError,
    { data: PostActivityNotesNotesBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postActivityNotesNotes>>,
  TError,
  { data: PostActivityNotesNotesBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postActivityNotesNotes>>,
    { data: PostActivityNotesNotesBody }
  > = (props) => {
    const { data } = props ?? {};

    return postActivityNotesNotes(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostActivityNotesNotesMutationResult = NonNullable<Awaited<ReturnType<typeof postActivityNotesNotes>>>;
export type PostActivityNotesNotesMutationBody = PostActivityNotesNotesBody;
export type PostActivityNotesNotesMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostActivityNotesNotes = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postActivityNotesNotes>>,
    TError,
    { data: PostActivityNotesNotesBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostActivityNotesNotesMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postActivityNotesNotesSearch = (postActivityNotesNotesSearchBody: PostActivityNotesNotesSearchBody) => {
  return customHttpClient<PostActivityNotesNotesSearch200>({
    url: `/activity-notes/notes/search`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postActivityNotesNotesSearchBody,
  });
};

export const getPostActivityNotesNotesSearchMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postActivityNotesNotesSearch>>,
    TError,
    { data: PostActivityNotesNotesSearchBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postActivityNotesNotesSearch>>,
  TError,
  { data: PostActivityNotesNotesSearchBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postActivityNotesNotesSearch>>,
    { data: PostActivityNotesNotesSearchBody }
  > = (props) => {
    const { data } = props ?? {};

    return postActivityNotesNotesSearch(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostActivityNotesNotesSearchMutationResult = NonNullable<
  Awaited<ReturnType<typeof postActivityNotesNotesSearch>>
>;
export type PostActivityNotesNotesSearchMutationBody = PostActivityNotesNotesSearchBody;
export type PostActivityNotesNotesSearchMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostActivityNotesNotesSearch = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postActivityNotesNotesSearch>>,
    TError,
    { data: PostActivityNotesNotesSearchBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostActivityNotesNotesSearchMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postActivityNotesOmnichatOmnichatId = (
  postActivityNotesOmnichatOmnichatIdBody: PostActivityNotesOmnichatOmnichatIdBody,
) => {
  return customHttpClient<PostActivityNotesOmnichatOmnichatId200>({
    url: `/activity-notes/omnichat/:omnichatId`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postActivityNotesOmnichatOmnichatIdBody,
  });
};

export const getPostActivityNotesOmnichatOmnichatIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postActivityNotesOmnichatOmnichatId>>,
    TError,
    { data: PostActivityNotesOmnichatOmnichatIdBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postActivityNotesOmnichatOmnichatId>>,
  TError,
  { data: PostActivityNotesOmnichatOmnichatIdBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postActivityNotesOmnichatOmnichatId>>,
    { data: PostActivityNotesOmnichatOmnichatIdBody }
  > = (props) => {
    const { data } = props ?? {};

    return postActivityNotesOmnichatOmnichatId(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostActivityNotesOmnichatOmnichatIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof postActivityNotesOmnichatOmnichatId>>
>;
export type PostActivityNotesOmnichatOmnichatIdMutationBody = PostActivityNotesOmnichatOmnichatIdBody;
export type PostActivityNotesOmnichatOmnichatIdMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostActivityNotesOmnichatOmnichatId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postActivityNotesOmnichatOmnichatId>>,
    TError,
    { data: PostActivityNotesOmnichatOmnichatIdBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostActivityNotesOmnichatOmnichatIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putActivityNotesNotesActivityNoteId = () => {
  return customHttpClient<PutActivityNotesNotesActivityNoteId200>({
    url: `/activity-notes/notes/:activityNoteId`,
    method: 'PUT',
  });
};

export const getPutActivityNotesNotesActivityNoteIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putActivityNotesNotesActivityNoteId>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<typeof putActivityNotesNotesActivityNoteId>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof putActivityNotesNotesActivityNoteId>>, void> = () => {
    return putActivityNotesNotesActivityNoteId();
  };

  return { mutationFn, ...mutationOptions };
};

export type PutActivityNotesNotesActivityNoteIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putActivityNotesNotesActivityNoteId>>
>;

export type PutActivityNotesNotesActivityNoteIdMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutActivityNotesNotesActivityNoteId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putActivityNotesNotesActivityNoteId>>,
    TError,
    void,
    TContext
  >;
}) => {
  const mutationOptions = getPutActivityNotesNotesActivityNoteIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteActivityNotesNotesActivityNoteId = () => {
  return customHttpClient<DeleteActivityNotesNotesActivityNoteId200>({
    url: `/activity-notes/notes/:activityNoteId`,
    method: 'DELETE',
  });
};

export const getDeleteActivityNotesNotesActivityNoteIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteActivityNotesNotesActivityNoteId>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<typeof deleteActivityNotesNotesActivityNoteId>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteActivityNotesNotesActivityNoteId>>, void> = () => {
    return deleteActivityNotesNotesActivityNoteId();
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteActivityNotesNotesActivityNoteIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteActivityNotesNotesActivityNoteId>>
>;

export type DeleteActivityNotesNotesActivityNoteIdMutationError = Status400 | Status401 | Status403 | Status404;

export const useDeleteActivityNotesNotesActivityNoteId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteActivityNotesNotesActivityNoteId>>,
    TError,
    void,
    TContext
  >;
}) => {
  const mutationOptions = getDeleteActivityNotesNotesActivityNoteIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getAgentsCustomFieldsModel = (signal?: AbortSignal) => {
  return customHttpClient<GetAgentsCustomFieldsModel200>({ url: `/agents/custom-fields/model`, method: 'GET', signal });
};

export const getGetAgentsCustomFieldsModelQueryKey = () => {
  return [`/agents/custom-fields/model`] as const;
};

export const getGetAgentsCustomFieldsModelQueryOptions = <
  TData = Awaited<ReturnType<typeof getAgentsCustomFieldsModel>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getAgentsCustomFieldsModel>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAgentsCustomFieldsModelQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgentsCustomFieldsModel>>> = ({ signal }) =>
    getAgentsCustomFieldsModel(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAgentsCustomFieldsModel>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAgentsCustomFieldsModelQueryResult = NonNullable<Awaited<ReturnType<typeof getAgentsCustomFieldsModel>>>;
export type GetAgentsCustomFieldsModelQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetAgentsCustomFieldsModel = <
  TData = Awaited<ReturnType<typeof getAgentsCustomFieldsModel>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getAgentsCustomFieldsModel>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetAgentsCustomFieldsModelQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const putAgentsCustomFieldsModel = () => {
  return customHttpClient<PutAgentsCustomFieldsModel200>({ url: `/agents/custom-fields/model`, method: 'PUT' });
};

export const getPutAgentsCustomFieldsModelMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putAgentsCustomFieldsModel>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof putAgentsCustomFieldsModel>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAgentsCustomFieldsModel>>, void> = () => {
    return putAgentsCustomFieldsModel();
  };

  return { mutationFn, ...mutationOptions };
};

export type PutAgentsCustomFieldsModelMutationResult = NonNullable<
  Awaited<ReturnType<typeof putAgentsCustomFieldsModel>>
>;

export type PutAgentsCustomFieldsModelMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutAgentsCustomFieldsModel = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putAgentsCustomFieldsModel>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPutAgentsCustomFieldsModelMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postAgentsCustomFieldsValidate = (
  postAgentsCustomFieldsValidateBody: PostAgentsCustomFieldsValidateBody,
) => {
  return customHttpClient<PostAgentsCustomFieldsValidate200>({
    url: `/agents/custom-fields/validate`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postAgentsCustomFieldsValidateBody,
  });
};

export const getPostAgentsCustomFieldsValidateMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAgentsCustomFieldsValidate>>,
    TError,
    { data: PostAgentsCustomFieldsValidateBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAgentsCustomFieldsValidate>>,
  TError,
  { data: PostAgentsCustomFieldsValidateBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAgentsCustomFieldsValidate>>,
    { data: PostAgentsCustomFieldsValidateBody }
  > = (props) => {
    const { data } = props ?? {};

    return postAgentsCustomFieldsValidate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAgentsCustomFieldsValidateMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAgentsCustomFieldsValidate>>
>;
export type PostAgentsCustomFieldsValidateMutationBody = PostAgentsCustomFieldsValidateBody;
export type PostAgentsCustomFieldsValidateMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostAgentsCustomFieldsValidate = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAgentsCustomFieldsValidate>>,
    TError,
    { data: PostAgentsCustomFieldsValidateBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostAgentsCustomFieldsValidateMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getAgentsEntityIdCustomFields = (entityId: string, signal?: AbortSignal) => {
  return customHttpClient<GetAgentsEntityIdCustomFields200>({
    url: `/agents/${entityId}/custom-fields`,
    method: 'GET',
    signal,
  });
};

export const getGetAgentsEntityIdCustomFieldsQueryKey = (entityId: string) => {
  return [`/agents/${entityId}/custom-fields`] as const;
};

export const getGetAgentsEntityIdCustomFieldsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAgentsEntityIdCustomFields>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  entityId: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getAgentsEntityIdCustomFields>>, TError, TData> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAgentsEntityIdCustomFieldsQueryKey(entityId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgentsEntityIdCustomFields>>> = ({ signal }) =>
    getAgentsEntityIdCustomFields(entityId, signal);

  return { queryKey, queryFn, enabled: !!entityId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAgentsEntityIdCustomFields>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAgentsEntityIdCustomFieldsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAgentsEntityIdCustomFields>>
>;
export type GetAgentsEntityIdCustomFieldsQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetAgentsEntityIdCustomFields = <
  TData = Awaited<ReturnType<typeof getAgentsEntityIdCustomFields>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  entityId: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getAgentsEntityIdCustomFields>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetAgentsEntityIdCustomFieldsQueryOptions(entityId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const putAgentsEntityIdCustomFields = (entityId: string) => {
  return customHttpClient<PutAgentsEntityIdCustomFields200>({
    url: `/agents/${entityId}/custom-fields`,
    method: 'PUT',
  });
};

export const getPutAgentsEntityIdCustomFieldsMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putAgentsEntityIdCustomFields>>,
    TError,
    { entityId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putAgentsEntityIdCustomFields>>,
  TError,
  { entityId: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putAgentsEntityIdCustomFields>>,
    { entityId: string }
  > = (props) => {
    const { entityId } = props ?? {};

    return putAgentsEntityIdCustomFields(entityId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutAgentsEntityIdCustomFieldsMutationResult = NonNullable<
  Awaited<ReturnType<typeof putAgentsEntityIdCustomFields>>
>;

export type PutAgentsEntityIdCustomFieldsMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutAgentsEntityIdCustomFields = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putAgentsEntityIdCustomFields>>,
    TError,
    { entityId: string },
    TContext
  >;
}) => {
  const mutationOptions = getPutAgentsEntityIdCustomFieldsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putAgentsEntityIdCustomFieldsExtend = (
  entityId: string,
  putAgentsEntityIdCustomFieldsExtendBody: PutAgentsEntityIdCustomFieldsExtendBody,
) => {
  return customHttpClient<PutAgentsEntityIdCustomFieldsExtend200>({
    url: `/agents/${entityId}/custom-fields/extend`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: putAgentsEntityIdCustomFieldsExtendBody,
  });
};

export const getPutAgentsEntityIdCustomFieldsExtendMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putAgentsEntityIdCustomFieldsExtend>>,
    TError,
    { entityId: string; data: PutAgentsEntityIdCustomFieldsExtendBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putAgentsEntityIdCustomFieldsExtend>>,
  TError,
  { entityId: string; data: PutAgentsEntityIdCustomFieldsExtendBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putAgentsEntityIdCustomFieldsExtend>>,
    { entityId: string; data: PutAgentsEntityIdCustomFieldsExtendBody }
  > = (props) => {
    const { entityId, data } = props ?? {};

    return putAgentsEntityIdCustomFieldsExtend(entityId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutAgentsEntityIdCustomFieldsExtendMutationResult = NonNullable<
  Awaited<ReturnType<typeof putAgentsEntityIdCustomFieldsExtend>>
>;
export type PutAgentsEntityIdCustomFieldsExtendMutationBody = PutAgentsEntityIdCustomFieldsExtendBody;
export type PutAgentsEntityIdCustomFieldsExtendMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutAgentsEntityIdCustomFieldsExtend = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putAgentsEntityIdCustomFieldsExtend>>,
    TError,
    { entityId: string; data: PutAgentsEntityIdCustomFieldsExtendBody },
    TContext
  >;
}) => {
  const mutationOptions = getPutAgentsEntityIdCustomFieldsExtendMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putAgentsEntityIdNotesPanel = (entityId: string) => {
  return customHttpClient<PutAgentsEntityIdNotesPanel200>({ url: `/agents/${entityId}/notes/panel`, method: 'PUT' });
};

export const getPutAgentsEntityIdNotesPanelMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putAgentsEntityIdNotesPanel>>,
    TError,
    { entityId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putAgentsEntityIdNotesPanel>>,
  TError,
  { entityId: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAgentsEntityIdNotesPanel>>, { entityId: string }> = (
    props,
  ) => {
    const { entityId } = props ?? {};

    return putAgentsEntityIdNotesPanel(entityId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutAgentsEntityIdNotesPanelMutationResult = NonNullable<
  Awaited<ReturnType<typeof putAgentsEntityIdNotesPanel>>
>;

export type PutAgentsEntityIdNotesPanelMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutAgentsEntityIdNotesPanel = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putAgentsEntityIdNotesPanel>>,
    TError,
    { entityId: string },
    TContext
  >;
}) => {
  const mutationOptions = getPutAgentsEntityIdNotesPanelMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteAgentsEntityIdNotesPanel = (entityId: string) => {
  return customHttpClient<DeleteAgentsEntityIdNotesPanel200>({
    url: `/agents/${entityId}/notes/panel`,
    method: 'DELETE',
  });
};

export const getDeleteAgentsEntityIdNotesPanelMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAgentsEntityIdNotesPanel>>,
    TError,
    { entityId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAgentsEntityIdNotesPanel>>,
  TError,
  { entityId: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAgentsEntityIdNotesPanel>>,
    { entityId: string }
  > = (props) => {
    const { entityId } = props ?? {};

    return deleteAgentsEntityIdNotesPanel(entityId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAgentsEntityIdNotesPanelMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAgentsEntityIdNotesPanel>>
>;

export type DeleteAgentsEntityIdNotesPanelMutationError = Status400 | Status401 | Status403 | Status404;

export const useDeleteAgentsEntityIdNotesPanel = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAgentsEntityIdNotesPanel>>,
    TError,
    { entityId: string },
    TContext
  >;
}) => {
  const mutationOptions = getDeleteAgentsEntityIdNotesPanelMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postAgentsUserIdResendInvite = (postAgentsUserIdResendInviteBody: PostAgentsUserIdResendInviteBody) => {
  return customHttpClient<PostAgentsUserIdResendInvite200>({
    url: `/agents/:userId/resend-invite`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postAgentsUserIdResendInviteBody,
  });
};

export const getPostAgentsUserIdResendInviteMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAgentsUserIdResendInvite>>,
    TError,
    { data: PostAgentsUserIdResendInviteBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAgentsUserIdResendInvite>>,
  TError,
  { data: PostAgentsUserIdResendInviteBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAgentsUserIdResendInvite>>,
    { data: PostAgentsUserIdResendInviteBody }
  > = (props) => {
    const { data } = props ?? {};

    return postAgentsUserIdResendInvite(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAgentsUserIdResendInviteMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAgentsUserIdResendInvite>>
>;
export type PostAgentsUserIdResendInviteMutationBody = PostAgentsUserIdResendInviteBody;
export type PostAgentsUserIdResendInviteMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostAgentsUserIdResendInvite = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAgentsUserIdResendInvite>>,
    TError,
    { data: PostAgentsUserIdResendInviteBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostAgentsUserIdResendInviteMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getAgentsEditOptions = (signal?: AbortSignal) => {
  return customHttpClient<GetAgentsEditOptions200>({ url: `/agents/edit-options`, method: 'GET', signal });
};

export const getGetAgentsEditOptionsQueryKey = () => {
  return [`/agents/edit-options`] as const;
};

export const getGetAgentsEditOptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAgentsEditOptions>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getAgentsEditOptions>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAgentsEditOptionsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgentsEditOptions>>> = ({ signal }) =>
    getAgentsEditOptions(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAgentsEditOptions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAgentsEditOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getAgentsEditOptions>>>;
export type GetAgentsEditOptionsQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetAgentsEditOptions = <
  TData = Awaited<ReturnType<typeof getAgentsEditOptions>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getAgentsEditOptions>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetAgentsEditOptionsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postAgentsUserIdResetPassword = (postAgentsUserIdResetPasswordBody: PostAgentsUserIdResetPasswordBody) => {
  return customHttpClient<PostAgentsUserIdResetPassword200>({
    url: `/agents/:userId/reset-password`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postAgentsUserIdResetPasswordBody,
  });
};

export const getPostAgentsUserIdResetPasswordMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAgentsUserIdResetPassword>>,
    TError,
    { data: PostAgentsUserIdResetPasswordBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAgentsUserIdResetPassword>>,
  TError,
  { data: PostAgentsUserIdResetPasswordBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAgentsUserIdResetPassword>>,
    { data: PostAgentsUserIdResetPasswordBody }
  > = (props) => {
    const { data } = props ?? {};

    return postAgentsUserIdResetPassword(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAgentsUserIdResetPasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAgentsUserIdResetPassword>>
>;
export type PostAgentsUserIdResetPasswordMutationBody = PostAgentsUserIdResetPasswordBody;
export type PostAgentsUserIdResetPasswordMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostAgentsUserIdResetPassword = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAgentsUserIdResetPassword>>,
    TError,
    { data: PostAgentsUserIdResetPasswordBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostAgentsUserIdResetPasswordMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postAgentsUserIdChangeVisibility = (
  postAgentsUserIdChangeVisibilityBody: PostAgentsUserIdChangeVisibilityBody,
) => {
  return customHttpClient<PostAgentsUserIdChangeVisibility200>({
    url: `/agents/:userId/change-visibility`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postAgentsUserIdChangeVisibilityBody,
  });
};

export const getPostAgentsUserIdChangeVisibilityMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAgentsUserIdChangeVisibility>>,
    TError,
    { data: PostAgentsUserIdChangeVisibilityBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAgentsUserIdChangeVisibility>>,
  TError,
  { data: PostAgentsUserIdChangeVisibilityBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAgentsUserIdChangeVisibility>>,
    { data: PostAgentsUserIdChangeVisibilityBody }
  > = (props) => {
    const { data } = props ?? {};

    return postAgentsUserIdChangeVisibility(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAgentsUserIdChangeVisibilityMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAgentsUserIdChangeVisibility>>
>;
export type PostAgentsUserIdChangeVisibilityMutationBody = PostAgentsUserIdChangeVisibilityBody;
export type PostAgentsUserIdChangeVisibilityMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostAgentsUserIdChangeVisibility = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAgentsUserIdChangeVisibility>>,
    TError,
    { data: PostAgentsUserIdChangeVisibilityBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostAgentsUserIdChangeVisibilityMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postAgentsUserIdDeactivate = (postAgentsUserIdDeactivateBody: PostAgentsUserIdDeactivateBody) => {
  return customHttpClient<PostAgentsUserIdDeactivate200>({
    url: `/agents/:userId/deactivate`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postAgentsUserIdDeactivateBody,
  });
};

export const getPostAgentsUserIdDeactivateMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAgentsUserIdDeactivate>>,
    TError,
    { data: PostAgentsUserIdDeactivateBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAgentsUserIdDeactivate>>,
  TError,
  { data: PostAgentsUserIdDeactivateBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAgentsUserIdDeactivate>>,
    { data: PostAgentsUserIdDeactivateBody }
  > = (props) => {
    const { data } = props ?? {};

    return postAgentsUserIdDeactivate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAgentsUserIdDeactivateMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAgentsUserIdDeactivate>>
>;
export type PostAgentsUserIdDeactivateMutationBody = PostAgentsUserIdDeactivateBody;
export type PostAgentsUserIdDeactivateMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostAgentsUserIdDeactivate = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAgentsUserIdDeactivate>>,
    TError,
    { data: PostAgentsUserIdDeactivateBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostAgentsUserIdDeactivateMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postAgentsUserIdReactivate = (postAgentsUserIdReactivateBody: PostAgentsUserIdReactivateBody) => {
  return customHttpClient<PostAgentsUserIdReactivate200>({
    url: `/agents/:userId/reactivate`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postAgentsUserIdReactivateBody,
  });
};

export const getPostAgentsUserIdReactivateMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAgentsUserIdReactivate>>,
    TError,
    { data: PostAgentsUserIdReactivateBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAgentsUserIdReactivate>>,
  TError,
  { data: PostAgentsUserIdReactivateBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAgentsUserIdReactivate>>,
    { data: PostAgentsUserIdReactivateBody }
  > = (props) => {
    const { data } = props ?? {};

    return postAgentsUserIdReactivate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAgentsUserIdReactivateMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAgentsUserIdReactivate>>
>;
export type PostAgentsUserIdReactivateMutationBody = PostAgentsUserIdReactivateBody;
export type PostAgentsUserIdReactivateMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostAgentsUserIdReactivate = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAgentsUserIdReactivate>>,
    TError,
    { data: PostAgentsUserIdReactivateBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostAgentsUserIdReactivateMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putAgentsUserIdNotifications = () => {
  return customHttpClient<PutAgentsUserIdNotifications200>({ url: `/agents/:userId/notifications`, method: 'PUT' });
};

export const getPutAgentsUserIdNotificationsMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putAgentsUserIdNotifications>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof putAgentsUserIdNotifications>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAgentsUserIdNotifications>>, void> = () => {
    return putAgentsUserIdNotifications();
  };

  return { mutationFn, ...mutationOptions };
};

export type PutAgentsUserIdNotificationsMutationResult = NonNullable<
  Awaited<ReturnType<typeof putAgentsUserIdNotifications>>
>;

export type PutAgentsUserIdNotificationsMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutAgentsUserIdNotifications = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putAgentsUserIdNotifications>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPutAgentsUserIdNotificationsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postAgentsUserIdExternalCredentialsExternalSystemCode = (
  postAgentsUserIdExternalCredentialsExternalSystemCodeBody: PostAgentsUserIdExternalCredentialsExternalSystemCodeBody,
) => {
  return customHttpClient<PostAgentsUserIdExternalCredentialsExternalSystemCode200>({
    url: `/agents/:userId/external-credentials/:externalSystemCode`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postAgentsUserIdExternalCredentialsExternalSystemCodeBody,
  });
};

export const getPostAgentsUserIdExternalCredentialsExternalSystemCodeMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAgentsUserIdExternalCredentialsExternalSystemCode>>,
    TError,
    { data: PostAgentsUserIdExternalCredentialsExternalSystemCodeBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAgentsUserIdExternalCredentialsExternalSystemCode>>,
  TError,
  { data: PostAgentsUserIdExternalCredentialsExternalSystemCodeBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAgentsUserIdExternalCredentialsExternalSystemCode>>,
    { data: PostAgentsUserIdExternalCredentialsExternalSystemCodeBody }
  > = (props) => {
    const { data } = props ?? {};

    return postAgentsUserIdExternalCredentialsExternalSystemCode(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAgentsUserIdExternalCredentialsExternalSystemCodeMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAgentsUserIdExternalCredentialsExternalSystemCode>>
>;
export type PostAgentsUserIdExternalCredentialsExternalSystemCodeMutationBody =
  PostAgentsUserIdExternalCredentialsExternalSystemCodeBody;
export type PostAgentsUserIdExternalCredentialsExternalSystemCodeMutationError =
  | Status400
  | Status401
  | Status403
  | Status404;

export const usePostAgentsUserIdExternalCredentialsExternalSystemCode = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAgentsUserIdExternalCredentialsExternalSystemCode>>,
    TError,
    { data: PostAgentsUserIdExternalCredentialsExternalSystemCodeBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostAgentsUserIdExternalCredentialsExternalSystemCodeMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteAgentsUserIdExternalCredentialsExternalSystemCode = () => {
  return customHttpClient<DeleteAgentsUserIdExternalCredentialsExternalSystemCode200>({
    url: `/agents/:userId/external-credentials/:externalSystemCode`,
    method: 'DELETE',
  });
};

export const getDeleteAgentsUserIdExternalCredentialsExternalSystemCodeMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAgentsUserIdExternalCredentialsExternalSystemCode>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAgentsUserIdExternalCredentialsExternalSystemCode>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAgentsUserIdExternalCredentialsExternalSystemCode>>,
    void
  > = () => {
    return deleteAgentsUserIdExternalCredentialsExternalSystemCode();
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAgentsUserIdExternalCredentialsExternalSystemCodeMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAgentsUserIdExternalCredentialsExternalSystemCode>>
>;

export type DeleteAgentsUserIdExternalCredentialsExternalSystemCodeMutationError =
  | Status400
  | Status401
  | Status403
  | Status404;

export const useDeleteAgentsUserIdExternalCredentialsExternalSystemCode = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAgentsUserIdExternalCredentialsExternalSystemCode>>,
    TError,
    void,
    TContext
  >;
}) => {
  const mutationOptions = getDeleteAgentsUserIdExternalCredentialsExternalSystemCodeMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postAttachmentTypes = (postAttachmentTypesBody: PostAttachmentTypesBody) => {
  return customHttpClient<PostAttachmentTypes200>({
    url: `/attachment-types`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postAttachmentTypesBody,
  });
};

export const getPostAttachmentTypesMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAttachmentTypes>>,
    TError,
    { data: PostAttachmentTypesBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAttachmentTypes>>,
  TError,
  { data: PostAttachmentTypesBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAttachmentTypes>>,
    { data: PostAttachmentTypesBody }
  > = (props) => {
    const { data } = props ?? {};

    return postAttachmentTypes(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAttachmentTypesMutationResult = NonNullable<Awaited<ReturnType<typeof postAttachmentTypes>>>;
export type PostAttachmentTypesMutationBody = PostAttachmentTypesBody;
export type PostAttachmentTypesMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostAttachmentTypes = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAttachmentTypes>>,
    TError,
    { data: PostAttachmentTypesBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostAttachmentTypesMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getAttachmentTypes = (signal?: AbortSignal) => {
  return customHttpClient<GetAttachmentTypes200>({ url: `/attachment-types`, method: 'GET', signal });
};

export const getGetAttachmentTypesQueryKey = () => {
  return [`/attachment-types`] as const;
};

export const getGetAttachmentTypesQueryOptions = <
  TData = Awaited<ReturnType<typeof getAttachmentTypes>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getAttachmentTypes>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAttachmentTypesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAttachmentTypes>>> = ({ signal }) =>
    getAttachmentTypes(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAttachmentTypes>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAttachmentTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getAttachmentTypes>>>;
export type GetAttachmentTypesQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetAttachmentTypes = <
  TData = Awaited<ReturnType<typeof getAttachmentTypes>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getAttachmentTypes>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetAttachmentTypesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const putAttachmentTypesAttachmentTypeId = () => {
  return customHttpClient<PutAttachmentTypesAttachmentTypeId200>({
    url: `/attachment-types/:attachmentTypeId`,
    method: 'PUT',
  });
};

export const getPutAttachmentTypesAttachmentTypeIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putAttachmentTypesAttachmentTypeId>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof putAttachmentTypesAttachmentTypeId>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAttachmentTypesAttachmentTypeId>>, void> = () => {
    return putAttachmentTypesAttachmentTypeId();
  };

  return { mutationFn, ...mutationOptions };
};

export type PutAttachmentTypesAttachmentTypeIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putAttachmentTypesAttachmentTypeId>>
>;

export type PutAttachmentTypesAttachmentTypeIdMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutAttachmentTypesAttachmentTypeId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putAttachmentTypesAttachmentTypeId>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPutAttachmentTypesAttachmentTypeIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteAttachmentTypesAttachmentTypeId = () => {
  return customHttpClient<DeleteAttachmentTypesAttachmentTypeId200>({
    url: `/attachment-types/:attachmentTypeId`,
    method: 'DELETE',
  });
};

export const getDeleteAttachmentTypesAttachmentTypeIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAttachmentTypesAttachmentTypeId>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<typeof deleteAttachmentTypesAttachmentTypeId>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAttachmentTypesAttachmentTypeId>>, void> = () => {
    return deleteAttachmentTypesAttachmentTypeId();
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAttachmentTypesAttachmentTypeIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAttachmentTypesAttachmentTypeId>>
>;

export type DeleteAttachmentTypesAttachmentTypeIdMutationError = Status400 | Status401 | Status403 | Status404;

export const useDeleteAttachmentTypesAttachmentTypeId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAttachmentTypesAttachmentTypeId>>,
    TError,
    void,
    TContext
  >;
}) => {
  const mutationOptions = getDeleteAttachmentTypesAttachmentTypeIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postAttachmentTypesAttachmentTypeIdEnable = (
  postAttachmentTypesAttachmentTypeIdEnableBody: PostAttachmentTypesAttachmentTypeIdEnableBody,
) => {
  return customHttpClient<PostAttachmentTypesAttachmentTypeIdEnable200>({
    url: `/attachment-types/:attachmentTypeId/enable`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postAttachmentTypesAttachmentTypeIdEnableBody,
  });
};

export const getPostAttachmentTypesAttachmentTypeIdEnableMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAttachmentTypesAttachmentTypeIdEnable>>,
    TError,
    { data: PostAttachmentTypesAttachmentTypeIdEnableBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAttachmentTypesAttachmentTypeIdEnable>>,
  TError,
  { data: PostAttachmentTypesAttachmentTypeIdEnableBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAttachmentTypesAttachmentTypeIdEnable>>,
    { data: PostAttachmentTypesAttachmentTypeIdEnableBody }
  > = (props) => {
    const { data } = props ?? {};

    return postAttachmentTypesAttachmentTypeIdEnable(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAttachmentTypesAttachmentTypeIdEnableMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAttachmentTypesAttachmentTypeIdEnable>>
>;
export type PostAttachmentTypesAttachmentTypeIdEnableMutationBody = PostAttachmentTypesAttachmentTypeIdEnableBody;
export type PostAttachmentTypesAttachmentTypeIdEnableMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostAttachmentTypesAttachmentTypeIdEnable = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAttachmentTypesAttachmentTypeIdEnable>>,
    TError,
    { data: PostAttachmentTypesAttachmentTypeIdEnableBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostAttachmentTypesAttachmentTypeIdEnableMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postAttachmentTypesAttachmentTypeIdDisable = (
  postAttachmentTypesAttachmentTypeIdDisableBody: PostAttachmentTypesAttachmentTypeIdDisableBody,
) => {
  return customHttpClient<PostAttachmentTypesAttachmentTypeIdDisable200>({
    url: `/attachment-types/:attachmentTypeId/disable`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postAttachmentTypesAttachmentTypeIdDisableBody,
  });
};

export const getPostAttachmentTypesAttachmentTypeIdDisableMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAttachmentTypesAttachmentTypeIdDisable>>,
    TError,
    { data: PostAttachmentTypesAttachmentTypeIdDisableBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAttachmentTypesAttachmentTypeIdDisable>>,
  TError,
  { data: PostAttachmentTypesAttachmentTypeIdDisableBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAttachmentTypesAttachmentTypeIdDisable>>,
    { data: PostAttachmentTypesAttachmentTypeIdDisableBody }
  > = (props) => {
    const { data } = props ?? {};

    return postAttachmentTypesAttachmentTypeIdDisable(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAttachmentTypesAttachmentTypeIdDisableMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAttachmentTypesAttachmentTypeIdDisable>>
>;
export type PostAttachmentTypesAttachmentTypeIdDisableMutationBody = PostAttachmentTypesAttachmentTypeIdDisableBody;
export type PostAttachmentTypesAttachmentTypeIdDisableMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostAttachmentTypesAttachmentTypeIdDisable = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAttachmentTypesAttachmentTypeIdDisable>>,
    TError,
    { data: PostAttachmentTypesAttachmentTypeIdDisableBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostAttachmentTypesAttachmentTypeIdDisableMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postAttachmentTypesAttachmentTypeIdUserGroups = (
  postAttachmentTypesAttachmentTypeIdUserGroupsBody: PostAttachmentTypesAttachmentTypeIdUserGroupsBody,
) => {
  return customHttpClient<PostAttachmentTypesAttachmentTypeIdUserGroups200>({
    url: `/attachment-types/:attachmentTypeId/user-groups`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postAttachmentTypesAttachmentTypeIdUserGroupsBody,
  });
};

export const getPostAttachmentTypesAttachmentTypeIdUserGroupsMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAttachmentTypesAttachmentTypeIdUserGroups>>,
    TError,
    { data: PostAttachmentTypesAttachmentTypeIdUserGroupsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAttachmentTypesAttachmentTypeIdUserGroups>>,
  TError,
  { data: PostAttachmentTypesAttachmentTypeIdUserGroupsBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAttachmentTypesAttachmentTypeIdUserGroups>>,
    { data: PostAttachmentTypesAttachmentTypeIdUserGroupsBody }
  > = (props) => {
    const { data } = props ?? {};

    return postAttachmentTypesAttachmentTypeIdUserGroups(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAttachmentTypesAttachmentTypeIdUserGroupsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAttachmentTypesAttachmentTypeIdUserGroups>>
>;
export type PostAttachmentTypesAttachmentTypeIdUserGroupsMutationBody =
  PostAttachmentTypesAttachmentTypeIdUserGroupsBody;
export type PostAttachmentTypesAttachmentTypeIdUserGroupsMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostAttachmentTypesAttachmentTypeIdUserGroups = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAttachmentTypesAttachmentTypeIdUserGroups>>,
    TError,
    { data: PostAttachmentTypesAttachmentTypeIdUserGroupsBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostAttachmentTypesAttachmentTypeIdUserGroupsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postCallsLookup = (postCallsLookupBody: PostCallsLookupBody) => {
  return customHttpClient<PostCallsLookup200>({
    url: `/calls/lookup`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postCallsLookupBody,
  });
};

export const getPostCallsLookupMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCallsLookup>>,
    TError,
    { data: PostCallsLookupBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCallsLookup>>,
  TError,
  { data: PostCallsLookupBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCallsLookup>>, { data: PostCallsLookupBody }> = (
    props,
  ) => {
    const { data } = props ?? {};

    return postCallsLookup(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCallsLookupMutationResult = NonNullable<Awaited<ReturnType<typeof postCallsLookup>>>;
export type PostCallsLookupMutationBody = PostCallsLookupBody;
export type PostCallsLookupMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostCallsLookup = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCallsLookup>>,
    TError,
    { data: PostCallsLookupBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostCallsLookupMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postCalls = (postCallsBody: PostCallsBody) => {
  return customHttpClient<PostCalls200>({
    url: `/calls`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postCallsBody,
  });
};

export const getPostCallsMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postCalls>>, TError, { data: PostCallsBody }, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof postCalls>>, TError, { data: PostCallsBody }, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCalls>>, { data: PostCallsBody }> = (props) => {
    const { data } = props ?? {};

    return postCalls(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCallsMutationResult = NonNullable<Awaited<ReturnType<typeof postCalls>>>;
export type PostCallsMutationBody = PostCallsBody;
export type PostCallsMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostCalls = <TError = Status400 | Status401 | Status403 | Status404, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postCalls>>, TError, { data: PostCallsBody }, TContext>;
}) => {
  const mutationOptions = getPostCallsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postCallsCallIdLink = (postCallsCallIdLinkBody: PostCallsCallIdLinkBody) => {
  return customHttpClient<PostCallsCallIdLink200>({
    url: `/calls/:callId/link`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postCallsCallIdLinkBody,
  });
};

export const getPostCallsCallIdLinkMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCallsCallIdLink>>,
    TError,
    { data: PostCallsCallIdLinkBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCallsCallIdLink>>,
  TError,
  { data: PostCallsCallIdLinkBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCallsCallIdLink>>,
    { data: PostCallsCallIdLinkBody }
  > = (props) => {
    const { data } = props ?? {};

    return postCallsCallIdLink(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCallsCallIdLinkMutationResult = NonNullable<Awaited<ReturnType<typeof postCallsCallIdLink>>>;
export type PostCallsCallIdLinkMutationBody = PostCallsCallIdLinkBody;
export type PostCallsCallIdLinkMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostCallsCallIdLink = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCallsCallIdLink>>,
    TError,
    { data: PostCallsCallIdLinkBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostCallsCallIdLinkMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putCallsCallId = () => {
  return customHttpClient<PutCallsCallId200>({ url: `/calls/:callId`, method: 'PUT' });
};

export const getPutCallsCallIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putCallsCallId>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof putCallsCallId>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof putCallsCallId>>, void> = () => {
    return putCallsCallId();
  };

  return { mutationFn, ...mutationOptions };
};

export type PutCallsCallIdMutationResult = NonNullable<Awaited<ReturnType<typeof putCallsCallId>>>;

export type PutCallsCallIdMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutCallsCallId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putCallsCallId>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPutCallsCallIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteCallsCallId = () => {
  return customHttpClient<DeleteCallsCallId200>({ url: `/calls/:callId`, method: 'DELETE' });
};

export const getDeleteCallsCallIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof deleteCallsCallId>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof deleteCallsCallId>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCallsCallId>>, void> = () => {
    return deleteCallsCallId();
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCallsCallIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCallsCallId>>>;

export type DeleteCallsCallIdMutationError = Status400 | Status401 | Status403 | Status404;

export const useDeleteCallsCallId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof deleteCallsCallId>>, TError, void, TContext>;
}) => {
  const mutationOptions = getDeleteCallsCallIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postCallsCallTypes = (postCallsCallTypesBody: PostCallsCallTypesBody) => {
  return customHttpClient<PostCallsCallTypes200>({
    url: `/calls/call-types`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postCallsCallTypesBody,
  });
};

export const getPostCallsCallTypesMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCallsCallTypes>>,
    TError,
    { data: PostCallsCallTypesBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCallsCallTypes>>,
  TError,
  { data: PostCallsCallTypesBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCallsCallTypes>>,
    { data: PostCallsCallTypesBody }
  > = (props) => {
    const { data } = props ?? {};

    return postCallsCallTypes(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCallsCallTypesMutationResult = NonNullable<Awaited<ReturnType<typeof postCallsCallTypes>>>;
export type PostCallsCallTypesMutationBody = PostCallsCallTypesBody;
export type PostCallsCallTypesMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostCallsCallTypes = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCallsCallTypes>>,
    TError,
    { data: PostCallsCallTypesBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostCallsCallTypesMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getCallsCallTypes = (signal?: AbortSignal) => {
  return customHttpClient<GetCallsCallTypes200>({ url: `/calls/call-types`, method: 'GET', signal });
};

export const getGetCallsCallTypesQueryKey = () => {
  return [`/calls/call-types`] as const;
};

export const getGetCallsCallTypesQueryOptions = <
  TData = Awaited<ReturnType<typeof getCallsCallTypes>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCallsCallTypes>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCallsCallTypesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCallsCallTypes>>> = ({ signal }) =>
    getCallsCallTypes(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCallsCallTypes>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCallsCallTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getCallsCallTypes>>>;
export type GetCallsCallTypesQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetCallsCallTypes = <
  TData = Awaited<ReturnType<typeof getCallsCallTypes>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCallsCallTypes>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCallsCallTypesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const putCallsCallTypesCallTypeId = () => {
  return customHttpClient<PutCallsCallTypesCallTypeId200>({ url: `/calls/call-types/:callTypeId`, method: 'PUT' });
};

export const getPutCallsCallTypesCallTypeIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putCallsCallTypesCallTypeId>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof putCallsCallTypesCallTypeId>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof putCallsCallTypesCallTypeId>>, void> = () => {
    return putCallsCallTypesCallTypeId();
  };

  return { mutationFn, ...mutationOptions };
};

export type PutCallsCallTypesCallTypeIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putCallsCallTypesCallTypeId>>
>;

export type PutCallsCallTypesCallTypeIdMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutCallsCallTypesCallTypeId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putCallsCallTypesCallTypeId>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPutCallsCallTypesCallTypeIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteCallsCallTypesCallTypeId = () => {
  return customHttpClient<DeleteCallsCallTypesCallTypeId200>({
    url: `/calls/call-types/:callTypeId`,
    method: 'DELETE',
  });
};

export const getDeleteCallsCallTypesCallTypeIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof deleteCallsCallTypesCallTypeId>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof deleteCallsCallTypesCallTypeId>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCallsCallTypesCallTypeId>>, void> = () => {
    return deleteCallsCallTypesCallTypeId();
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCallsCallTypesCallTypeIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCallsCallTypesCallTypeId>>
>;

export type DeleteCallsCallTypesCallTypeIdMutationError = Status400 | Status401 | Status403 | Status404;

export const useDeleteCallsCallTypesCallTypeId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof deleteCallsCallTypesCallTypeId>>, TError, void, TContext>;
}) => {
  const mutationOptions = getDeleteCallsCallTypesCallTypeIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postCallsCallOutcomes = (postCallsCallOutcomesBody: PostCallsCallOutcomesBody) => {
  return customHttpClient<PostCallsCallOutcomes200>({
    url: `/calls/call-outcomes`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postCallsCallOutcomesBody,
  });
};

export const getPostCallsCallOutcomesMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCallsCallOutcomes>>,
    TError,
    { data: PostCallsCallOutcomesBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCallsCallOutcomes>>,
  TError,
  { data: PostCallsCallOutcomesBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCallsCallOutcomes>>,
    { data: PostCallsCallOutcomesBody }
  > = (props) => {
    const { data } = props ?? {};

    return postCallsCallOutcomes(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCallsCallOutcomesMutationResult = NonNullable<Awaited<ReturnType<typeof postCallsCallOutcomes>>>;
export type PostCallsCallOutcomesMutationBody = PostCallsCallOutcomesBody;
export type PostCallsCallOutcomesMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostCallsCallOutcomes = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCallsCallOutcomes>>,
    TError,
    { data: PostCallsCallOutcomesBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostCallsCallOutcomesMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getCallsCallOutcomes = (signal?: AbortSignal) => {
  return customHttpClient<GetCallsCallOutcomes200>({ url: `/calls/call-outcomes`, method: 'GET', signal });
};

export const getGetCallsCallOutcomesQueryKey = () => {
  return [`/calls/call-outcomes`] as const;
};

export const getGetCallsCallOutcomesQueryOptions = <
  TData = Awaited<ReturnType<typeof getCallsCallOutcomes>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCallsCallOutcomes>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCallsCallOutcomesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCallsCallOutcomes>>> = ({ signal }) =>
    getCallsCallOutcomes(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCallsCallOutcomes>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCallsCallOutcomesQueryResult = NonNullable<Awaited<ReturnType<typeof getCallsCallOutcomes>>>;
export type GetCallsCallOutcomesQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetCallsCallOutcomes = <
  TData = Awaited<ReturnType<typeof getCallsCallOutcomes>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCallsCallOutcomes>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCallsCallOutcomesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const putCallsCallOutcomesCallOutcomeId = () => {
  return customHttpClient<PutCallsCallOutcomesCallOutcomeId200>({
    url: `/calls/call-outcomes/:callOutcomeId`,
    method: 'PUT',
  });
};

export const getPutCallsCallOutcomesCallOutcomeIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putCallsCallOutcomesCallOutcomeId>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof putCallsCallOutcomesCallOutcomeId>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof putCallsCallOutcomesCallOutcomeId>>, void> = () => {
    return putCallsCallOutcomesCallOutcomeId();
  };

  return { mutationFn, ...mutationOptions };
};

export type PutCallsCallOutcomesCallOutcomeIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putCallsCallOutcomesCallOutcomeId>>
>;

export type PutCallsCallOutcomesCallOutcomeIdMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutCallsCallOutcomesCallOutcomeId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putCallsCallOutcomesCallOutcomeId>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPutCallsCallOutcomesCallOutcomeIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteCallsCallOutcomesCallOutcomeId = () => {
  return customHttpClient<DeleteCallsCallOutcomesCallOutcomeId200>({
    url: `/calls/call-outcomes/:callOutcomeId`,
    method: 'DELETE',
  });
};

export const getDeleteCallsCallOutcomesCallOutcomeIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCallsCallOutcomesCallOutcomeId>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<typeof deleteCallsCallOutcomesCallOutcomeId>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCallsCallOutcomesCallOutcomeId>>, void> = () => {
    return deleteCallsCallOutcomesCallOutcomeId();
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCallsCallOutcomesCallOutcomeIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCallsCallOutcomesCallOutcomeId>>
>;

export type DeleteCallsCallOutcomesCallOutcomeIdMutationError = Status400 | Status401 | Status403 | Status404;

export const useDeleteCallsCallOutcomesCallOutcomeId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCallsCallOutcomesCallOutcomeId>>,
    TError,
    void,
    TContext
  >;
}) => {
  const mutationOptions = getDeleteCallsCallOutcomesCallOutcomeIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getCallsAgentCalls = (signal?: AbortSignal) => {
  return customHttpClient<GetCallsAgentCalls200>({ url: `/calls/agent-calls`, method: 'GET', signal });
};

export const getGetCallsAgentCallsQueryKey = () => {
  return [`/calls/agent-calls`] as const;
};

export const getGetCallsAgentCallsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCallsAgentCalls>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCallsAgentCalls>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCallsAgentCallsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCallsAgentCalls>>> = ({ signal }) =>
    getCallsAgentCalls(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCallsAgentCalls>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCallsAgentCallsQueryResult = NonNullable<Awaited<ReturnType<typeof getCallsAgentCalls>>>;
export type GetCallsAgentCallsQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetCallsAgentCalls = <
  TData = Awaited<ReturnType<typeof getCallsAgentCalls>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCallsAgentCalls>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCallsAgentCallsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getCallsAgentsOnline = (signal?: AbortSignal) => {
  return customHttpClient<GetCallsAgentsOnline200>({ url: `/calls/agents-online`, method: 'GET', signal });
};

export const getGetCallsAgentsOnlineQueryKey = () => {
  return [`/calls/agents-online`] as const;
};

export const getGetCallsAgentsOnlineQueryOptions = <
  TData = Awaited<ReturnType<typeof getCallsAgentsOnline>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCallsAgentsOnline>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCallsAgentsOnlineQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCallsAgentsOnline>>> = ({ signal }) =>
    getCallsAgentsOnline(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCallsAgentsOnline>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCallsAgentsOnlineQueryResult = NonNullable<Awaited<ReturnType<typeof getCallsAgentsOnline>>>;
export type GetCallsAgentsOnlineQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetCallsAgentsOnline = <
  TData = Awaited<ReturnType<typeof getCallsAgentsOnline>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCallsAgentsOnline>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCallsAgentsOnlineQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getCandidatesCustomFieldsModel = (signal?: AbortSignal) => {
  return customHttpClient<GetCandidatesCustomFieldsModel200>({
    url: `/candidates/custom-fields/model`,
    method: 'GET',
    signal,
  });
};

export const getGetCandidatesCustomFieldsModelQueryKey = () => {
  return [`/candidates/custom-fields/model`] as const;
};

export const getGetCandidatesCustomFieldsModelQueryOptions = <
  TData = Awaited<ReturnType<typeof getCandidatesCustomFieldsModel>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCandidatesCustomFieldsModel>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCandidatesCustomFieldsModelQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCandidatesCustomFieldsModel>>> = ({ signal }) =>
    getCandidatesCustomFieldsModel(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCandidatesCustomFieldsModel>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCandidatesCustomFieldsModelQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCandidatesCustomFieldsModel>>
>;
export type GetCandidatesCustomFieldsModelQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetCandidatesCustomFieldsModel = <
  TData = Awaited<ReturnType<typeof getCandidatesCustomFieldsModel>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCandidatesCustomFieldsModel>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCandidatesCustomFieldsModelQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const putCandidatesCustomFieldsModel = () => {
  return customHttpClient<PutCandidatesCustomFieldsModel200>({ url: `/candidates/custom-fields/model`, method: 'PUT' });
};

export const getPutCandidatesCustomFieldsModelMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putCandidatesCustomFieldsModel>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof putCandidatesCustomFieldsModel>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof putCandidatesCustomFieldsModel>>, void> = () => {
    return putCandidatesCustomFieldsModel();
  };

  return { mutationFn, ...mutationOptions };
};

export type PutCandidatesCustomFieldsModelMutationResult = NonNullable<
  Awaited<ReturnType<typeof putCandidatesCustomFieldsModel>>
>;

export type PutCandidatesCustomFieldsModelMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutCandidatesCustomFieldsModel = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putCandidatesCustomFieldsModel>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPutCandidatesCustomFieldsModelMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postCandidatesCustomFieldsValidate = (
  postCandidatesCustomFieldsValidateBody: PostCandidatesCustomFieldsValidateBody,
) => {
  return customHttpClient<PostCandidatesCustomFieldsValidate200>({
    url: `/candidates/custom-fields/validate`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postCandidatesCustomFieldsValidateBody,
  });
};

export const getPostCandidatesCustomFieldsValidateMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCandidatesCustomFieldsValidate>>,
    TError,
    { data: PostCandidatesCustomFieldsValidateBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCandidatesCustomFieldsValidate>>,
  TError,
  { data: PostCandidatesCustomFieldsValidateBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCandidatesCustomFieldsValidate>>,
    { data: PostCandidatesCustomFieldsValidateBody }
  > = (props) => {
    const { data } = props ?? {};

    return postCandidatesCustomFieldsValidate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCandidatesCustomFieldsValidateMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCandidatesCustomFieldsValidate>>
>;
export type PostCandidatesCustomFieldsValidateMutationBody = PostCandidatesCustomFieldsValidateBody;
export type PostCandidatesCustomFieldsValidateMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostCandidatesCustomFieldsValidate = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCandidatesCustomFieldsValidate>>,
    TError,
    { data: PostCandidatesCustomFieldsValidateBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostCandidatesCustomFieldsValidateMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getCandidatesEntityIdCustomFields = (entityId: string, signal?: AbortSignal) => {
  return customHttpClient<GetCandidatesEntityIdCustomFields200>({
    url: `/candidates/${entityId}/custom-fields`,
    method: 'GET',
    signal,
  });
};

export const getGetCandidatesEntityIdCustomFieldsQueryKey = (entityId: string) => {
  return [`/candidates/${entityId}/custom-fields`] as const;
};

export const getGetCandidatesEntityIdCustomFieldsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCandidatesEntityIdCustomFields>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  entityId: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getCandidatesEntityIdCustomFields>>, TError, TData> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCandidatesEntityIdCustomFieldsQueryKey(entityId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCandidatesEntityIdCustomFields>>> = ({ signal }) =>
    getCandidatesEntityIdCustomFields(entityId, signal);

  return { queryKey, queryFn, enabled: !!entityId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCandidatesEntityIdCustomFields>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCandidatesEntityIdCustomFieldsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCandidatesEntityIdCustomFields>>
>;
export type GetCandidatesEntityIdCustomFieldsQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetCandidatesEntityIdCustomFields = <
  TData = Awaited<ReturnType<typeof getCandidatesEntityIdCustomFields>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  entityId: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getCandidatesEntityIdCustomFields>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCandidatesEntityIdCustomFieldsQueryOptions(entityId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * full update custom fields
 */
export const putCandidatesEntityIdCustomFields = (
  entityId: string,
  putCandidatesEntityIdCustomFieldsBody: PutCandidatesEntityIdCustomFieldsBody,
) => {
  return customHttpClient<PutCandidatesEntityIdCustomFields200>({
    url: `/candidates/${entityId}/custom-fields`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: putCandidatesEntityIdCustomFieldsBody,
  });
};

export const getPutCandidatesEntityIdCustomFieldsMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putCandidatesEntityIdCustomFields>>,
    TError,
    { entityId: string; data: PutCandidatesEntityIdCustomFieldsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putCandidatesEntityIdCustomFields>>,
  TError,
  { entityId: string; data: PutCandidatesEntityIdCustomFieldsBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putCandidatesEntityIdCustomFields>>,
    { entityId: string; data: PutCandidatesEntityIdCustomFieldsBody }
  > = (props) => {
    const { entityId, data } = props ?? {};

    return putCandidatesEntityIdCustomFields(entityId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutCandidatesEntityIdCustomFieldsMutationResult = NonNullable<
  Awaited<ReturnType<typeof putCandidatesEntityIdCustomFields>>
>;
export type PutCandidatesEntityIdCustomFieldsMutationBody = PutCandidatesEntityIdCustomFieldsBody;
export type PutCandidatesEntityIdCustomFieldsMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutCandidatesEntityIdCustomFields = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putCandidatesEntityIdCustomFields>>,
    TError,
    { entityId: string; data: PutCandidatesEntityIdCustomFieldsBody },
    TContext
  >;
}) => {
  const mutationOptions = getPutCandidatesEntityIdCustomFieldsMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * partial update custom fields
 */
export const putCandidatesEntityIdCustomFieldsExtend = (
  entityId: string,
  putCandidatesEntityIdCustomFieldsExtendBody: PutCandidatesEntityIdCustomFieldsExtendBody,
) => {
  return customHttpClient<PutCandidatesEntityIdCustomFieldsExtend200>({
    url: `/candidates/${entityId}/custom-fields/extend`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: putCandidatesEntityIdCustomFieldsExtendBody,
  });
};

export const getPutCandidatesEntityIdCustomFieldsExtendMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putCandidatesEntityIdCustomFieldsExtend>>,
    TError,
    { entityId: string; data: PutCandidatesEntityIdCustomFieldsExtendBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putCandidatesEntityIdCustomFieldsExtend>>,
  TError,
  { entityId: string; data: PutCandidatesEntityIdCustomFieldsExtendBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putCandidatesEntityIdCustomFieldsExtend>>,
    { entityId: string; data: PutCandidatesEntityIdCustomFieldsExtendBody }
  > = (props) => {
    const { entityId, data } = props ?? {};

    return putCandidatesEntityIdCustomFieldsExtend(entityId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutCandidatesEntityIdCustomFieldsExtendMutationResult = NonNullable<
  Awaited<ReturnType<typeof putCandidatesEntityIdCustomFieldsExtend>>
>;
export type PutCandidatesEntityIdCustomFieldsExtendMutationBody = PutCandidatesEntityIdCustomFieldsExtendBody;
export type PutCandidatesEntityIdCustomFieldsExtendMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutCandidatesEntityIdCustomFieldsExtend = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putCandidatesEntityIdCustomFieldsExtend>>,
    TError,
    { entityId: string; data: PutCandidatesEntityIdCustomFieldsExtendBody },
    TContext
  >;
}) => {
  const mutationOptions = getPutCandidatesEntityIdCustomFieldsExtendMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postCandidatesLists = (postCandidatesListsBody: PostCandidatesListsBody) => {
  return customHttpClient<PostCandidatesLists200>({
    url: `/candidates/lists`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postCandidatesListsBody,
  });
};

export const getPostCandidatesListsMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCandidatesLists>>,
    TError,
    { data: PostCandidatesListsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCandidatesLists>>,
  TError,
  { data: PostCandidatesListsBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCandidatesLists>>,
    { data: PostCandidatesListsBody }
  > = (props) => {
    const { data } = props ?? {};

    return postCandidatesLists(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCandidatesListsMutationResult = NonNullable<Awaited<ReturnType<typeof postCandidatesLists>>>;
export type PostCandidatesListsMutationBody = PostCandidatesListsBody;
export type PostCandidatesListsMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostCandidatesLists = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCandidatesLists>>,
    TError,
    { data: PostCandidatesListsBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostCandidatesListsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getCandidatesLists = (signal?: AbortSignal) => {
  return customHttpClient<GetCandidatesLists200>({ url: `/candidates/lists`, method: 'GET', signal });
};

export const getGetCandidatesListsQueryKey = () => {
  return [`/candidates/lists`] as const;
};

export const getGetCandidatesListsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCandidatesLists>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCandidatesLists>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCandidatesListsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCandidatesLists>>> = ({ signal }) =>
    getCandidatesLists(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCandidatesLists>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCandidatesListsQueryResult = NonNullable<Awaited<ReturnType<typeof getCandidatesLists>>>;
export type GetCandidatesListsQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetCandidatesLists = <
  TData = Awaited<ReturnType<typeof getCandidatesLists>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCandidatesLists>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCandidatesListsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postCandidatesListsEntityListIdCreateNewEntity = (
  postCandidatesListsEntityListIdCreateNewEntityBody: PostCandidatesListsEntityListIdCreateNewEntityBody,
) => {
  return customHttpClient<PostCandidatesListsEntityListIdCreateNewEntity200>({
    url: `/candidates/lists/:entityListId/create-new-entity`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postCandidatesListsEntityListIdCreateNewEntityBody,
  });
};

export const getPostCandidatesListsEntityListIdCreateNewEntityMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCandidatesListsEntityListIdCreateNewEntity>>,
    TError,
    { data: PostCandidatesListsEntityListIdCreateNewEntityBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCandidatesListsEntityListIdCreateNewEntity>>,
  TError,
  { data: PostCandidatesListsEntityListIdCreateNewEntityBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCandidatesListsEntityListIdCreateNewEntity>>,
    { data: PostCandidatesListsEntityListIdCreateNewEntityBody }
  > = (props) => {
    const { data } = props ?? {};

    return postCandidatesListsEntityListIdCreateNewEntity(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCandidatesListsEntityListIdCreateNewEntityMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCandidatesListsEntityListIdCreateNewEntity>>
>;
export type PostCandidatesListsEntityListIdCreateNewEntityMutationBody =
  PostCandidatesListsEntityListIdCreateNewEntityBody;
export type PostCandidatesListsEntityListIdCreateNewEntityMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostCandidatesListsEntityListIdCreateNewEntity = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCandidatesListsEntityListIdCreateNewEntity>>,
    TError,
    { data: PostCandidatesListsEntityListIdCreateNewEntityBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostCandidatesListsEntityListIdCreateNewEntityMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getCandidatesListsEntityListIdCandidates = (signal?: AbortSignal) => {
  return customHttpClient<GetCandidatesListsEntityListIdCandidates200>({
    url: `/candidates/lists/:entityListId/candidates`,
    method: 'GET',
    signal,
  });
};

export const getGetCandidatesListsEntityListIdCandidatesQueryKey = () => {
  return [`/candidates/lists/:entityListId/candidates`] as const;
};

export const getGetCandidatesListsEntityListIdCandidatesQueryOptions = <
  TData = Awaited<ReturnType<typeof getCandidatesListsEntityListIdCandidates>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCandidatesListsEntityListIdCandidates>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCandidatesListsEntityListIdCandidatesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCandidatesListsEntityListIdCandidates>>> = ({ signal }) =>
    getCandidatesListsEntityListIdCandidates(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCandidatesListsEntityListIdCandidates>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCandidatesListsEntityListIdCandidatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCandidatesListsEntityListIdCandidates>>
>;
export type GetCandidatesListsEntityListIdCandidatesQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetCandidatesListsEntityListIdCandidates = <
  TData = Awaited<ReturnType<typeof getCandidatesListsEntityListIdCandidates>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCandidatesListsEntityListIdCandidates>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCandidatesListsEntityListIdCandidatesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postCandidatesListsEntityListIdAdd = (
  postCandidatesListsEntityListIdAddBody: PostCandidatesListsEntityListIdAddBody,
) => {
  return customHttpClient<PostCandidatesListsEntityListIdAdd200>({
    url: `/candidates/lists/:entityListId/add`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postCandidatesListsEntityListIdAddBody,
  });
};

export const getPostCandidatesListsEntityListIdAddMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCandidatesListsEntityListIdAdd>>,
    TError,
    { data: PostCandidatesListsEntityListIdAddBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCandidatesListsEntityListIdAdd>>,
  TError,
  { data: PostCandidatesListsEntityListIdAddBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCandidatesListsEntityListIdAdd>>,
    { data: PostCandidatesListsEntityListIdAddBody }
  > = (props) => {
    const { data } = props ?? {};

    return postCandidatesListsEntityListIdAdd(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCandidatesListsEntityListIdAddMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCandidatesListsEntityListIdAdd>>
>;
export type PostCandidatesListsEntityListIdAddMutationBody = PostCandidatesListsEntityListIdAddBody;
export type PostCandidatesListsEntityListIdAddMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostCandidatesListsEntityListIdAdd = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCandidatesListsEntityListIdAdd>>,
    TError,
    { data: PostCandidatesListsEntityListIdAddBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostCandidatesListsEntityListIdAddMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postCandidatesListsEntityListIdRemove = (
  postCandidatesListsEntityListIdRemoveBody: PostCandidatesListsEntityListIdRemoveBody,
) => {
  return customHttpClient<PostCandidatesListsEntityListIdRemove200>({
    url: `/candidates/lists/:entityListId/remove`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postCandidatesListsEntityListIdRemoveBody,
  });
};

export const getPostCandidatesListsEntityListIdRemoveMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCandidatesListsEntityListIdRemove>>,
    TError,
    { data: PostCandidatesListsEntityListIdRemoveBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCandidatesListsEntityListIdRemove>>,
  TError,
  { data: PostCandidatesListsEntityListIdRemoveBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCandidatesListsEntityListIdRemove>>,
    { data: PostCandidatesListsEntityListIdRemoveBody }
  > = (props) => {
    const { data } = props ?? {};

    return postCandidatesListsEntityListIdRemove(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCandidatesListsEntityListIdRemoveMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCandidatesListsEntityListIdRemove>>
>;
export type PostCandidatesListsEntityListIdRemoveMutationBody = PostCandidatesListsEntityListIdRemoveBody;
export type PostCandidatesListsEntityListIdRemoveMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostCandidatesListsEntityListIdRemove = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCandidatesListsEntityListIdRemove>>,
    TError,
    { data: PostCandidatesListsEntityListIdRemoveBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostCandidatesListsEntityListIdRemoveMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postCandidatesListsEntityListIdReorder = (
  postCandidatesListsEntityListIdReorderBody: PostCandidatesListsEntityListIdReorderBody,
) => {
  return customHttpClient<PostCandidatesListsEntityListIdReorder200>({
    url: `/candidates/lists/:entityListId/reorder`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postCandidatesListsEntityListIdReorderBody,
  });
};

export const getPostCandidatesListsEntityListIdReorderMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCandidatesListsEntityListIdReorder>>,
    TError,
    { data: PostCandidatesListsEntityListIdReorderBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCandidatesListsEntityListIdReorder>>,
  TError,
  { data: PostCandidatesListsEntityListIdReorderBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCandidatesListsEntityListIdReorder>>,
    { data: PostCandidatesListsEntityListIdReorderBody }
  > = (props) => {
    const { data } = props ?? {};

    return postCandidatesListsEntityListIdReorder(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCandidatesListsEntityListIdReorderMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCandidatesListsEntityListIdReorder>>
>;
export type PostCandidatesListsEntityListIdReorderMutationBody = PostCandidatesListsEntityListIdReorderBody;
export type PostCandidatesListsEntityListIdReorderMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostCandidatesListsEntityListIdReorder = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCandidatesListsEntityListIdReorder>>,
    TError,
    { data: PostCandidatesListsEntityListIdReorderBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostCandidatesListsEntityListIdReorderMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postCandidatesListsEntityListIdUserGroups = (
  postCandidatesListsEntityListIdUserGroupsBody: PostCandidatesListsEntityListIdUserGroupsBody,
) => {
  return customHttpClient<PostCandidatesListsEntityListIdUserGroups200>({
    url: `/candidates/lists/:entityListId/user-groups`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postCandidatesListsEntityListIdUserGroupsBody,
  });
};

export const getPostCandidatesListsEntityListIdUserGroupsMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCandidatesListsEntityListIdUserGroups>>,
    TError,
    { data: PostCandidatesListsEntityListIdUserGroupsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCandidatesListsEntityListIdUserGroups>>,
  TError,
  { data: PostCandidatesListsEntityListIdUserGroupsBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCandidatesListsEntityListIdUserGroups>>,
    { data: PostCandidatesListsEntityListIdUserGroupsBody }
  > = (props) => {
    const { data } = props ?? {};

    return postCandidatesListsEntityListIdUserGroups(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCandidatesListsEntityListIdUserGroupsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCandidatesListsEntityListIdUserGroups>>
>;
export type PostCandidatesListsEntityListIdUserGroupsMutationBody = PostCandidatesListsEntityListIdUserGroupsBody;
export type PostCandidatesListsEntityListIdUserGroupsMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostCandidatesListsEntityListIdUserGroups = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCandidatesListsEntityListIdUserGroups>>,
    TError,
    { data: PostCandidatesListsEntityListIdUserGroupsBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostCandidatesListsEntityListIdUserGroupsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postCandidatesEntityIdLists = (
  entityId: string,
  postCandidatesEntityIdListsBody: PostCandidatesEntityIdListsBody,
) => {
  return customHttpClient<PostCandidatesEntityIdLists200>({
    url: `/candidates/${entityId}/lists`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postCandidatesEntityIdListsBody,
  });
};

export const getPostCandidatesEntityIdListsMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCandidatesEntityIdLists>>,
    TError,
    { entityId: string; data: PostCandidatesEntityIdListsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCandidatesEntityIdLists>>,
  TError,
  { entityId: string; data: PostCandidatesEntityIdListsBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCandidatesEntityIdLists>>,
    { entityId: string; data: PostCandidatesEntityIdListsBody }
  > = (props) => {
    const { entityId, data } = props ?? {};

    return postCandidatesEntityIdLists(entityId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCandidatesEntityIdListsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCandidatesEntityIdLists>>
>;
export type PostCandidatesEntityIdListsMutationBody = PostCandidatesEntityIdListsBody;
export type PostCandidatesEntityIdListsMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostCandidatesEntityIdLists = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCandidatesEntityIdLists>>,
    TError,
    { entityId: string; data: PostCandidatesEntityIdListsBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostCandidatesEntityIdListsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putCandidatesEntityIdNotesPanel = (entityId: string) => {
  return customHttpClient<PutCandidatesEntityIdNotesPanel200>({
    url: `/candidates/${entityId}/notes/panel`,
    method: 'PUT',
  });
};

export const getPutCandidatesEntityIdNotesPanelMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putCandidatesEntityIdNotesPanel>>,
    TError,
    { entityId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putCandidatesEntityIdNotesPanel>>,
  TError,
  { entityId: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putCandidatesEntityIdNotesPanel>>,
    { entityId: string }
  > = (props) => {
    const { entityId } = props ?? {};

    return putCandidatesEntityIdNotesPanel(entityId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutCandidatesEntityIdNotesPanelMutationResult = NonNullable<
  Awaited<ReturnType<typeof putCandidatesEntityIdNotesPanel>>
>;

export type PutCandidatesEntityIdNotesPanelMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutCandidatesEntityIdNotesPanel = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putCandidatesEntityIdNotesPanel>>,
    TError,
    { entityId: string },
    TContext
  >;
}) => {
  const mutationOptions = getPutCandidatesEntityIdNotesPanelMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteCandidatesEntityIdNotesPanel = (entityId: string) => {
  return customHttpClient<DeleteCandidatesEntityIdNotesPanel200>({
    url: `/candidates/${entityId}/notes/panel`,
    method: 'DELETE',
  });
};

export const getDeleteCandidatesEntityIdNotesPanelMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCandidatesEntityIdNotesPanel>>,
    TError,
    { entityId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCandidatesEntityIdNotesPanel>>,
  TError,
  { entityId: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCandidatesEntityIdNotesPanel>>,
    { entityId: string }
  > = (props) => {
    const { entityId } = props ?? {};

    return deleteCandidatesEntityIdNotesPanel(entityId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCandidatesEntityIdNotesPanelMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCandidatesEntityIdNotesPanel>>
>;

export type DeleteCandidatesEntityIdNotesPanelMutationError = Status400 | Status401 | Status403 | Status404;

export const useDeleteCandidatesEntityIdNotesPanel = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCandidatesEntityIdNotesPanel>>,
    TError,
    { entityId: string },
    TContext
  >;
}) => {
  const mutationOptions = getDeleteCandidatesEntityIdNotesPanelMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putCandidatesEntityIdNotesPdf = (entityId: string) => {
  return customHttpClient<PutCandidatesEntityIdNotesPdf200>({
    url: `/candidates/${entityId}/notes/pdf`,
    method: 'PUT',
  });
};

export const getPutCandidatesEntityIdNotesPdfMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putCandidatesEntityIdNotesPdf>>,
    TError,
    { entityId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putCandidatesEntityIdNotesPdf>>,
  TError,
  { entityId: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putCandidatesEntityIdNotesPdf>>,
    { entityId: string }
  > = (props) => {
    const { entityId } = props ?? {};

    return putCandidatesEntityIdNotesPdf(entityId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutCandidatesEntityIdNotesPdfMutationResult = NonNullable<
  Awaited<ReturnType<typeof putCandidatesEntityIdNotesPdf>>
>;

export type PutCandidatesEntityIdNotesPdfMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutCandidatesEntityIdNotesPdf = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putCandidatesEntityIdNotesPdf>>,
    TError,
    { entityId: string },
    TContext
  >;
}) => {
  const mutationOptions = getPutCandidatesEntityIdNotesPdfMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteCandidatesEntityIdNotesPdf = (entityId: string) => {
  return customHttpClient<DeleteCandidatesEntityIdNotesPdf200>({
    url: `/candidates/${entityId}/notes/pdf`,
    method: 'DELETE',
  });
};

export const getDeleteCandidatesEntityIdNotesPdfMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCandidatesEntityIdNotesPdf>>,
    TError,
    { entityId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCandidatesEntityIdNotesPdf>>,
  TError,
  { entityId: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCandidatesEntityIdNotesPdf>>,
    { entityId: string }
  > = (props) => {
    const { entityId } = props ?? {};

    return deleteCandidatesEntityIdNotesPdf(entityId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCandidatesEntityIdNotesPdfMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCandidatesEntityIdNotesPdf>>
>;

export type DeleteCandidatesEntityIdNotesPdfMutationError = Status400 | Status401 | Status403 | Status404;

export const useDeleteCandidatesEntityIdNotesPdf = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCandidatesEntityIdNotesPdf>>,
    TError,
    { entityId: string },
    TContext
  >;
}) => {
  const mutationOptions = getDeleteCandidatesEntityIdNotesPdfMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postCandidatesTotaljobsGroupIdImport = (
  postCandidatesTotaljobsGroupIdImportBody: PostCandidatesTotaljobsGroupIdImportBody,
) => {
  return customHttpClient<PostCandidatesTotaljobsGroupIdImport200>({
    url: `/candidates/totaljobs-group/:id/import`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postCandidatesTotaljobsGroupIdImportBody,
  });
};

export const getPostCandidatesTotaljobsGroupIdImportMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCandidatesTotaljobsGroupIdImport>>,
    TError,
    { data: PostCandidatesTotaljobsGroupIdImportBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCandidatesTotaljobsGroupIdImport>>,
  TError,
  { data: PostCandidatesTotaljobsGroupIdImportBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCandidatesTotaljobsGroupIdImport>>,
    { data: PostCandidatesTotaljobsGroupIdImportBody }
  > = (props) => {
    const { data } = props ?? {};

    return postCandidatesTotaljobsGroupIdImport(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCandidatesTotaljobsGroupIdImportMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCandidatesTotaljobsGroupIdImport>>
>;
export type PostCandidatesTotaljobsGroupIdImportMutationBody = PostCandidatesTotaljobsGroupIdImportBody;
export type PostCandidatesTotaljobsGroupIdImportMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostCandidatesTotaljobsGroupIdImport = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCandidatesTotaljobsGroupIdImport>>,
    TError,
    { data: PostCandidatesTotaljobsGroupIdImportBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostCandidatesTotaljobsGroupIdImportMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postCandidatesCatererIdImport = (postCandidatesCatererIdImportBody: PostCandidatesCatererIdImportBody) => {
  return customHttpClient<PostCandidatesCatererIdImport200>({
    url: `/candidates/caterer/:id/import`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postCandidatesCatererIdImportBody,
  });
};

export const getPostCandidatesCatererIdImportMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCandidatesCatererIdImport>>,
    TError,
    { data: PostCandidatesCatererIdImportBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCandidatesCatererIdImport>>,
  TError,
  { data: PostCandidatesCatererIdImportBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCandidatesCatererIdImport>>,
    { data: PostCandidatesCatererIdImportBody }
  > = (props) => {
    const { data } = props ?? {};

    return postCandidatesCatererIdImport(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCandidatesCatererIdImportMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCandidatesCatererIdImport>>
>;
export type PostCandidatesCatererIdImportMutationBody = PostCandidatesCatererIdImportBody;
export type PostCandidatesCatererIdImportMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostCandidatesCatererIdImport = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCandidatesCatererIdImport>>,
    TError,
    { data: PostCandidatesCatererIdImportBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostCandidatesCatererIdImportMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postCandidatesJobsiteIdImport = (postCandidatesJobsiteIdImportBody: PostCandidatesJobsiteIdImportBody) => {
  return customHttpClient<PostCandidatesJobsiteIdImport200>({
    url: `/candidates/jobsite/:id/import`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postCandidatesJobsiteIdImportBody,
  });
};

export const getPostCandidatesJobsiteIdImportMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCandidatesJobsiteIdImport>>,
    TError,
    { data: PostCandidatesJobsiteIdImportBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCandidatesJobsiteIdImport>>,
  TError,
  { data: PostCandidatesJobsiteIdImportBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCandidatesJobsiteIdImport>>,
    { data: PostCandidatesJobsiteIdImportBody }
  > = (props) => {
    const { data } = props ?? {};

    return postCandidatesJobsiteIdImport(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCandidatesJobsiteIdImportMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCandidatesJobsiteIdImport>>
>;
export type PostCandidatesJobsiteIdImportMutationBody = PostCandidatesJobsiteIdImportBody;
export type PostCandidatesJobsiteIdImportMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostCandidatesJobsiteIdImport = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCandidatesJobsiteIdImport>>,
    TError,
    { data: PostCandidatesJobsiteIdImportBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostCandidatesJobsiteIdImportMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postCandidatesEMedCareersIdImport = () => {
  return customHttpClient<PostCandidatesEMedCareersIdImport200>({
    url: `/candidates/e-med-careers/:id/import`,
    method: 'POST',
  });
};

export const getPostCandidatesEMedCareersIdImportMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postCandidatesEMedCareersIdImport>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof postCandidatesEMedCareersIdImport>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCandidatesEMedCareersIdImport>>, void> = () => {
    return postCandidatesEMedCareersIdImport();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCandidatesEMedCareersIdImportMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCandidatesEMedCareersIdImport>>
>;

export type PostCandidatesEMedCareersIdImportMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostCandidatesEMedCareersIdImport = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postCandidatesEMedCareersIdImport>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPostCandidatesEMedCareersIdImportMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postCandidatesReedIdImport = () => {
  return customHttpClient<PostCandidatesReedIdImport200>({ url: `/candidates/reed/:id/import`, method: 'POST' });
};

export const getPostCandidatesReedIdImportMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postCandidatesReedIdImport>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof postCandidatesReedIdImport>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCandidatesReedIdImport>>, void> = () => {
    return postCandidatesReedIdImport();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCandidatesReedIdImportMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCandidatesReedIdImport>>
>;

export type PostCandidatesReedIdImportMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostCandidatesReedIdImport = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postCandidatesReedIdImport>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPostCandidatesReedIdImportMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postCandidatesTotaljobsIdImport = () => {
  return customHttpClient<PostCandidatesTotaljobsIdImport200>({
    url: `/candidates/totaljobs/:id/import`,
    method: 'POST',
  });
};

export const getPostCandidatesTotaljobsIdImportMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postCandidatesTotaljobsIdImport>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof postCandidatesTotaljobsIdImport>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCandidatesTotaljobsIdImport>>, void> = () => {
    return postCandidatesTotaljobsIdImport();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCandidatesTotaljobsIdImportMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCandidatesTotaljobsIdImport>>
>;

export type PostCandidatesTotaljobsIdImportMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostCandidatesTotaljobsIdImport = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postCandidatesTotaljobsIdImport>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPostCandidatesTotaljobsIdImportMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postCandidatesCvLibraryIdImport = () => {
  return customHttpClient<PostCandidatesCvLibraryIdImport200>({
    url: `/candidates/cv-library/:id/import`,
    method: 'POST',
  });
};

export const getPostCandidatesCvLibraryIdImportMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postCandidatesCvLibraryIdImport>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof postCandidatesCvLibraryIdImport>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCandidatesCvLibraryIdImport>>, void> = () => {
    return postCandidatesCvLibraryIdImport();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCandidatesCvLibraryIdImportMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCandidatesCvLibraryIdImport>>
>;

export type PostCandidatesCvLibraryIdImportMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostCandidatesCvLibraryIdImport = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postCandidatesCvLibraryIdImport>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPostCandidatesCvLibraryIdImportMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getCandidatesCatererId = (signal?: AbortSignal) => {
  return customHttpClient<GetCandidatesCatererId200>({ url: `/candidates/caterer/:id`, method: 'GET', signal });
};

export const getGetCandidatesCatererIdQueryKey = () => {
  return [`/candidates/caterer/:id`] as const;
};

export const getGetCandidatesCatererIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getCandidatesCatererId>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCandidatesCatererId>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCandidatesCatererIdQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCandidatesCatererId>>> = ({ signal }) =>
    getCandidatesCatererId(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCandidatesCatererId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCandidatesCatererIdQueryResult = NonNullable<Awaited<ReturnType<typeof getCandidatesCatererId>>>;
export type GetCandidatesCatererIdQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetCandidatesCatererId = <
  TData = Awaited<ReturnType<typeof getCandidatesCatererId>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCandidatesCatererId>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCandidatesCatererIdQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getCandidatesJobsiteId = (signal?: AbortSignal) => {
  return customHttpClient<GetCandidatesJobsiteId200>({ url: `/candidates/jobsite/:id`, method: 'GET', signal });
};

export const getGetCandidatesJobsiteIdQueryKey = () => {
  return [`/candidates/jobsite/:id`] as const;
};

export const getGetCandidatesJobsiteIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getCandidatesJobsiteId>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCandidatesJobsiteId>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCandidatesJobsiteIdQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCandidatesJobsiteId>>> = ({ signal }) =>
    getCandidatesJobsiteId(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCandidatesJobsiteId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCandidatesJobsiteIdQueryResult = NonNullable<Awaited<ReturnType<typeof getCandidatesJobsiteId>>>;
export type GetCandidatesJobsiteIdQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetCandidatesJobsiteId = <
  TData = Awaited<ReturnType<typeof getCandidatesJobsiteId>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCandidatesJobsiteId>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCandidatesJobsiteIdQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getCandidatesEMedCareersId = (signal?: AbortSignal) => {
  return customHttpClient<GetCandidatesEMedCareersId200>({
    url: `/candidates/e-med-careers/:id`,
    method: 'GET',
    signal,
  });
};

export const getGetCandidatesEMedCareersIdQueryKey = () => {
  return [`/candidates/e-med-careers/:id`] as const;
};

export const getGetCandidatesEMedCareersIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getCandidatesEMedCareersId>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCandidatesEMedCareersId>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCandidatesEMedCareersIdQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCandidatesEMedCareersId>>> = ({ signal }) =>
    getCandidatesEMedCareersId(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCandidatesEMedCareersId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCandidatesEMedCareersIdQueryResult = NonNullable<Awaited<ReturnType<typeof getCandidatesEMedCareersId>>>;
export type GetCandidatesEMedCareersIdQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetCandidatesEMedCareersId = <
  TData = Awaited<ReturnType<typeof getCandidatesEMedCareersId>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCandidatesEMedCareersId>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCandidatesEMedCareersIdQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getCandidatesReedId = (signal?: AbortSignal) => {
  return customHttpClient<GetCandidatesReedId200>({ url: `/candidates/reed/:id`, method: 'GET', signal });
};

export const getGetCandidatesReedIdQueryKey = () => {
  return [`/candidates/reed/:id`] as const;
};

export const getGetCandidatesReedIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getCandidatesReedId>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCandidatesReedId>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCandidatesReedIdQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCandidatesReedId>>> = ({ signal }) =>
    getCandidatesReedId(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCandidatesReedId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCandidatesReedIdQueryResult = NonNullable<Awaited<ReturnType<typeof getCandidatesReedId>>>;
export type GetCandidatesReedIdQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetCandidatesReedId = <
  TData = Awaited<ReturnType<typeof getCandidatesReedId>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCandidatesReedId>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCandidatesReedIdQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getCandidatesTotaljobsId = (signal?: AbortSignal) => {
  return customHttpClient<GetCandidatesTotaljobsId200>({ url: `/candidates/totaljobs/:id`, method: 'GET', signal });
};

export const getGetCandidatesTotaljobsIdQueryKey = () => {
  return [`/candidates/totaljobs/:id`] as const;
};

export const getGetCandidatesTotaljobsIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getCandidatesTotaljobsId>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCandidatesTotaljobsId>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCandidatesTotaljobsIdQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCandidatesTotaljobsId>>> = ({ signal }) =>
    getCandidatesTotaljobsId(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCandidatesTotaljobsId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCandidatesTotaljobsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getCandidatesTotaljobsId>>>;
export type GetCandidatesTotaljobsIdQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetCandidatesTotaljobsId = <
  TData = Awaited<ReturnType<typeof getCandidatesTotaljobsId>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCandidatesTotaljobsId>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCandidatesTotaljobsIdQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getCandidatesCvLibraryId = (signal?: AbortSignal) => {
  return customHttpClient<GetCandidatesCvLibraryId200>({ url: `/candidates/cv-library/:id`, method: 'GET', signal });
};

export const getGetCandidatesCvLibraryIdQueryKey = () => {
  return [`/candidates/cv-library/:id`] as const;
};

export const getGetCandidatesCvLibraryIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getCandidatesCvLibraryId>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCandidatesCvLibraryId>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCandidatesCvLibraryIdQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCandidatesCvLibraryId>>> = ({ signal }) =>
    getCandidatesCvLibraryId(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCandidatesCvLibraryId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCandidatesCvLibraryIdQueryResult = NonNullable<Awaited<ReturnType<typeof getCandidatesCvLibraryId>>>;
export type GetCandidatesCvLibraryIdQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetCandidatesCvLibraryId = <
  TData = Awaited<ReturnType<typeof getCandidatesCvLibraryId>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCandidatesCvLibraryId>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCandidatesCvLibraryIdQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getCandidatesTotaljobsGroupId = (signal?: AbortSignal) => {
  return customHttpClient<GetCandidatesTotaljobsGroupId200>({
    url: `/candidates/totaljobs-group/:id`,
    method: 'GET',
    signal,
  });
};

export const getGetCandidatesTotaljobsGroupIdQueryKey = () => {
  return [`/candidates/totaljobs-group/:id`] as const;
};

export const getGetCandidatesTotaljobsGroupIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getCandidatesTotaljobsGroupId>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCandidatesTotaljobsGroupId>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCandidatesTotaljobsGroupIdQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCandidatesTotaljobsGroupId>>> = ({ signal }) =>
    getCandidatesTotaljobsGroupId(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCandidatesTotaljobsGroupId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCandidatesTotaljobsGroupIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCandidatesTotaljobsGroupId>>
>;
export type GetCandidatesTotaljobsGroupIdQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetCandidatesTotaljobsGroupId = <
  TData = Awaited<ReturnType<typeof getCandidatesTotaljobsGroupId>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCandidatesTotaljobsGroupId>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCandidatesTotaljobsGroupIdQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getCandidatesId = (signal?: AbortSignal) => {
  return customHttpClient<GetCandidatesId200>({ url: `/candidates/:id`, method: 'GET', signal });
};

export const getGetCandidatesIdQueryKey = () => {
  return [`/candidates/:id`] as const;
};

export const getGetCandidatesIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getCandidatesId>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCandidatesId>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCandidatesIdQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCandidatesId>>> = ({ signal }) => getCandidatesId(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCandidatesId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCandidatesIdQueryResult = NonNullable<Awaited<ReturnType<typeof getCandidatesId>>>;
export type GetCandidatesIdQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetCandidatesId = <
  TData = Awaited<ReturnType<typeof getCandidatesId>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCandidatesId>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCandidatesIdQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const putCandidatesId = () => {
  return customHttpClient<PutCandidatesId200>({ url: `/candidates/:id`, method: 'PUT' });
};

export const getPutCandidatesIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putCandidatesId>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof putCandidatesId>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof putCandidatesId>>, void> = () => {
    return putCandidatesId();
  };

  return { mutationFn, ...mutationOptions };
};

export type PutCandidatesIdMutationResult = NonNullable<Awaited<ReturnType<typeof putCandidatesId>>>;

export type PutCandidatesIdMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutCandidatesId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putCandidatesId>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPutCandidatesIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteCandidatesId = () => {
  return customHttpClient<DeleteCandidatesId200>({ url: `/candidates/:id`, method: 'DELETE' });
};

export const getDeleteCandidatesIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof deleteCandidatesId>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof deleteCandidatesId>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCandidatesId>>, void> = () => {
    return deleteCandidatesId();
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCandidatesIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCandidatesId>>>;

export type DeleteCandidatesIdMutationError = Status400 | Status401 | Status403 | Status404;

export const useDeleteCandidatesId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof deleteCandidatesId>>, TError, void, TContext>;
}) => {
  const mutationOptions = getDeleteCandidatesIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getCandidatesIdShareableProfile = (signal?: AbortSignal) => {
  return customHttpClient<GetCandidatesIdShareableProfile200>({
    url: `/candidates/:id/shareable-profile`,
    method: 'GET',
    signal,
  });
};

export const getGetCandidatesIdShareableProfileQueryKey = () => {
  return [`/candidates/:id/shareable-profile`] as const;
};

export const getGetCandidatesIdShareableProfileQueryOptions = <
  TData = Awaited<ReturnType<typeof getCandidatesIdShareableProfile>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCandidatesIdShareableProfile>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCandidatesIdShareableProfileQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCandidatesIdShareableProfile>>> = ({ signal }) =>
    getCandidatesIdShareableProfile(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCandidatesIdShareableProfile>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCandidatesIdShareableProfileQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCandidatesIdShareableProfile>>
>;
export type GetCandidatesIdShareableProfileQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetCandidatesIdShareableProfile = <
  TData = Awaited<ReturnType<typeof getCandidatesIdShareableProfile>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCandidatesIdShareableProfile>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCandidatesIdShareableProfileQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const putCandidatesIdConfirm = () => {
  return customHttpClient<PutCandidatesIdConfirm200>({ url: `/candidates/:id/confirm`, method: 'PUT' });
};

export const getPutCandidatesIdConfirmMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putCandidatesIdConfirm>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof putCandidatesIdConfirm>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof putCandidatesIdConfirm>>, void> = () => {
    return putCandidatesIdConfirm();
  };

  return { mutationFn, ...mutationOptions };
};

export type PutCandidatesIdConfirmMutationResult = NonNullable<Awaited<ReturnType<typeof putCandidatesIdConfirm>>>;

export type PutCandidatesIdConfirmMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutCandidatesIdConfirm = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putCandidatesIdConfirm>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPutCandidatesIdConfirmMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postCandidatesIdStar = () => {
  return customHttpClient<PostCandidatesIdStar200>({ url: `/candidates/:id/star`, method: 'POST' });
};

export const getPostCandidatesIdStarMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postCandidatesIdStar>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof postCandidatesIdStar>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCandidatesIdStar>>, void> = () => {
    return postCandidatesIdStar();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCandidatesIdStarMutationResult = NonNullable<Awaited<ReturnType<typeof postCandidatesIdStar>>>;

export type PostCandidatesIdStarMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostCandidatesIdStar = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postCandidatesIdStar>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPostCandidatesIdStarMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postCandidatesIdUnstar = () => {
  return customHttpClient<PostCandidatesIdUnstar200>({ url: `/candidates/:id/unstar`, method: 'POST' });
};

export const getPostCandidatesIdUnstarMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postCandidatesIdUnstar>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof postCandidatesIdUnstar>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCandidatesIdUnstar>>, void> = () => {
    return postCandidatesIdUnstar();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCandidatesIdUnstarMutationResult = NonNullable<Awaited<ReturnType<typeof postCandidatesIdUnstar>>>;

export type PostCandidatesIdUnstarMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostCandidatesIdUnstar = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postCandidatesIdUnstar>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPostCandidatesIdUnstarMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteCandidatesCandidateIdAttachmentsAttachmentId = (candidateId: number, attachmentId: number) => {
  return customHttpClient<DeleteCandidatesCandidateIdAttachmentsAttachmentId200>({
    url: `/candidates/${candidateId}/attachments/${attachmentId}`,
    method: 'DELETE',
  });
};

export const getDeleteCandidatesCandidateIdAttachmentsAttachmentIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCandidatesCandidateIdAttachmentsAttachmentId>>,
    TError,
    { candidateId: number; attachmentId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCandidatesCandidateIdAttachmentsAttachmentId>>,
  TError,
  { candidateId: number; attachmentId: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCandidatesCandidateIdAttachmentsAttachmentId>>,
    { candidateId: number; attachmentId: number }
  > = (props) => {
    const { candidateId, attachmentId } = props ?? {};

    return deleteCandidatesCandidateIdAttachmentsAttachmentId(candidateId, attachmentId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCandidatesCandidateIdAttachmentsAttachmentIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCandidatesCandidateIdAttachmentsAttachmentId>>
>;

export type DeleteCandidatesCandidateIdAttachmentsAttachmentIdMutationError =
  | Status400
  | Status401
  | Status403
  | Status404;

export const useDeleteCandidatesCandidateIdAttachmentsAttachmentId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCandidatesCandidateIdAttachmentsAttachmentId>>,
    TError,
    { candidateId: number; attachmentId: number },
    TContext
  >;
}) => {
  const mutationOptions = getDeleteCandidatesCandidateIdAttachmentsAttachmentIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postCandidatesCandidateIdAttachmentsAttachmentIdSign = (candidateId: number, attachmentId: number) => {
  return customHttpClient<PostCandidatesCandidateIdAttachmentsAttachmentIdSign200>({
    url: `/candidates/${candidateId}/attachments/${attachmentId}/sign`,
    method: 'POST',
  });
};

export const getPostCandidatesCandidateIdAttachmentsAttachmentIdSignMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCandidatesCandidateIdAttachmentsAttachmentIdSign>>,
    TError,
    { candidateId: number; attachmentId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCandidatesCandidateIdAttachmentsAttachmentIdSign>>,
  TError,
  { candidateId: number; attachmentId: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCandidatesCandidateIdAttachmentsAttachmentIdSign>>,
    { candidateId: number; attachmentId: number }
  > = (props) => {
    const { candidateId, attachmentId } = props ?? {};

    return postCandidatesCandidateIdAttachmentsAttachmentIdSign(candidateId, attachmentId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCandidatesCandidateIdAttachmentsAttachmentIdSignMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCandidatesCandidateIdAttachmentsAttachmentIdSign>>
>;

export type PostCandidatesCandidateIdAttachmentsAttachmentIdSignMutationError =
  | Status400
  | Status401
  | Status403
  | Status404;

export const usePostCandidatesCandidateIdAttachmentsAttachmentIdSign = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCandidatesCandidateIdAttachmentsAttachmentIdSign>>,
    TError,
    { candidateId: number; attachmentId: number },
    TContext
  >;
}) => {
  const mutationOptions = getPostCandidatesCandidateIdAttachmentsAttachmentIdSignMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postCandidatesCandidateIdAttachments = (candidateId: number) => {
  return customHttpClient<PostCandidatesCandidateIdAttachments200>({
    url: `/candidates/${candidateId}/attachments`,
    method: 'POST',
  });
};

export const getPostCandidatesCandidateIdAttachmentsMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCandidatesCandidateIdAttachments>>,
    TError,
    { candidateId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCandidatesCandidateIdAttachments>>,
  TError,
  { candidateId: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCandidatesCandidateIdAttachments>>,
    { candidateId: number }
  > = (props) => {
    const { candidateId } = props ?? {};

    return postCandidatesCandidateIdAttachments(candidateId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCandidatesCandidateIdAttachmentsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCandidatesCandidateIdAttachments>>
>;

export type PostCandidatesCandidateIdAttachmentsMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostCandidatesCandidateIdAttachments = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCandidatesCandidateIdAttachments>>,
    TError,
    { candidateId: number },
    TContext
  >;
}) => {
  const mutationOptions = getPostCandidatesCandidateIdAttachmentsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putCandidatesAttachmentsAttachmentId = (attachmentId: number) => {
  return customHttpClient<PutCandidatesAttachmentsAttachmentId200>({
    url: `/candidates/attachments/${attachmentId}`,
    method: 'PUT',
  });
};

export const getPutCandidatesAttachmentsAttachmentIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putCandidatesAttachmentsAttachmentId>>,
    TError,
    { attachmentId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putCandidatesAttachmentsAttachmentId>>,
  TError,
  { attachmentId: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putCandidatesAttachmentsAttachmentId>>,
    { attachmentId: number }
  > = (props) => {
    const { attachmentId } = props ?? {};

    return putCandidatesAttachmentsAttachmentId(attachmentId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutCandidatesAttachmentsAttachmentIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putCandidatesAttachmentsAttachmentId>>
>;

export type PutCandidatesAttachmentsAttachmentIdMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutCandidatesAttachmentsAttachmentId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putCandidatesAttachmentsAttachmentId>>,
    TError,
    { attachmentId: number },
    TContext
  >;
}) => {
  const mutationOptions = getPutCandidatesAttachmentsAttachmentIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteCandidatesCandidateIdResumesResumeId = (candidateId: number, resumeId: number) => {
  return customHttpClient<DeleteCandidatesCandidateIdResumesResumeId200>({
    url: `/candidates/${candidateId}/resumes/${resumeId}`,
    method: 'DELETE',
  });
};

export const getDeleteCandidatesCandidateIdResumesResumeIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCandidatesCandidateIdResumesResumeId>>,
    TError,
    { candidateId: number; resumeId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCandidatesCandidateIdResumesResumeId>>,
  TError,
  { candidateId: number; resumeId: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCandidatesCandidateIdResumesResumeId>>,
    { candidateId: number; resumeId: number }
  > = (props) => {
    const { candidateId, resumeId } = props ?? {};

    return deleteCandidatesCandidateIdResumesResumeId(candidateId, resumeId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCandidatesCandidateIdResumesResumeIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCandidatesCandidateIdResumesResumeId>>
>;

export type DeleteCandidatesCandidateIdResumesResumeIdMutationError = Status400 | Status401 | Status403 | Status404;

export const useDeleteCandidatesCandidateIdResumesResumeId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCandidatesCandidateIdResumesResumeId>>,
    TError,
    { candidateId: number; resumeId: number },
    TContext
  >;
}) => {
  const mutationOptions = getDeleteCandidatesCandidateIdResumesResumeIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postCandidatesCandidateIdResumesResumeIdSign = (candidateId: number, resumeId: number) => {
  return customHttpClient<PostCandidatesCandidateIdResumesResumeIdSign200>({
    url: `/candidates/${candidateId}/resumes/${resumeId}/sign`,
    method: 'POST',
  });
};

export const getPostCandidatesCandidateIdResumesResumeIdSignMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCandidatesCandidateIdResumesResumeIdSign>>,
    TError,
    { candidateId: number; resumeId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCandidatesCandidateIdResumesResumeIdSign>>,
  TError,
  { candidateId: number; resumeId: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCandidatesCandidateIdResumesResumeIdSign>>,
    { candidateId: number; resumeId: number }
  > = (props) => {
    const { candidateId, resumeId } = props ?? {};

    return postCandidatesCandidateIdResumesResumeIdSign(candidateId, resumeId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCandidatesCandidateIdResumesResumeIdSignMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCandidatesCandidateIdResumesResumeIdSign>>
>;

export type PostCandidatesCandidateIdResumesResumeIdSignMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostCandidatesCandidateIdResumesResumeIdSign = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCandidatesCandidateIdResumesResumeIdSign>>,
    TError,
    { candidateId: number; resumeId: number },
    TContext
  >;
}) => {
  const mutationOptions = getPostCandidatesCandidateIdResumesResumeIdSignMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postCandidatesCandidateIdResumes = (candidateId: number) => {
  return customHttpClient<PostCandidatesCandidateIdResumes200>({
    url: `/candidates/${candidateId}/resumes`,
    method: 'POST',
  });
};

export const getPostCandidatesCandidateIdResumesMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCandidatesCandidateIdResumes>>,
    TError,
    { candidateId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCandidatesCandidateIdResumes>>,
  TError,
  { candidateId: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCandidatesCandidateIdResumes>>,
    { candidateId: number }
  > = (props) => {
    const { candidateId } = props ?? {};

    return postCandidatesCandidateIdResumes(candidateId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCandidatesCandidateIdResumesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCandidatesCandidateIdResumes>>
>;

export type PostCandidatesCandidateIdResumesMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostCandidatesCandidateIdResumes = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCandidatesCandidateIdResumes>>,
    TError,
    { candidateId: number },
    TContext
  >;
}) => {
  const mutationOptions = getPostCandidatesCandidateIdResumesMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getCandidatesCandidateIdResumesResumeIdParse = (
  candidateId: number,
  resumeId: number,
  signal?: AbortSignal,
) => {
  return customHttpClient<GetCandidatesCandidateIdResumesResumeIdParse200>({
    url: `/candidates/${candidateId}/resumes/${resumeId}/parse`,
    method: 'GET',
    signal,
  });
};

export const getGetCandidatesCandidateIdResumesResumeIdParseQueryKey = (candidateId: number, resumeId: number) => {
  return [`/candidates/${candidateId}/resumes/${resumeId}/parse`] as const;
};

export const getGetCandidatesCandidateIdResumesResumeIdParseQueryOptions = <
  TData = Awaited<ReturnType<typeof getCandidatesCandidateIdResumesResumeIdParse>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  candidateId: number,
  resumeId: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getCandidatesCandidateIdResumesResumeIdParse>>, TError, TData>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCandidatesCandidateIdResumesResumeIdParseQueryKey(candidateId, resumeId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCandidatesCandidateIdResumesResumeIdParse>>> = ({
    signal,
  }) => getCandidatesCandidateIdResumesResumeIdParse(candidateId, resumeId, signal);

  return { queryKey, queryFn, enabled: !!(candidateId && resumeId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCandidatesCandidateIdResumesResumeIdParse>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCandidatesCandidateIdResumesResumeIdParseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCandidatesCandidateIdResumesResumeIdParse>>
>;
export type GetCandidatesCandidateIdResumesResumeIdParseQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetCandidatesCandidateIdResumesResumeIdParse = <
  TData = Awaited<ReturnType<typeof getCandidatesCandidateIdResumesResumeIdParse>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  candidateId: number,
  resumeId: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getCandidatesCandidateIdResumesResumeIdParse>>, TError, TData>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCandidatesCandidateIdResumesResumeIdParseQueryOptions(candidateId, resumeId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postCandidatesCandidateIdAvatar = (candidateId: number) => {
  return customHttpClient<PostCandidatesCandidateIdAvatar200>({
    url: `/candidates/${candidateId}/avatar/`,
    method: 'POST',
  });
};

export const getPostCandidatesCandidateIdAvatarMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCandidatesCandidateIdAvatar>>,
    TError,
    { candidateId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCandidatesCandidateIdAvatar>>,
  TError,
  { candidateId: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCandidatesCandidateIdAvatar>>,
    { candidateId: number }
  > = (props) => {
    const { candidateId } = props ?? {};

    return postCandidatesCandidateIdAvatar(candidateId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCandidatesCandidateIdAvatarMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCandidatesCandidateIdAvatar>>
>;

export type PostCandidatesCandidateIdAvatarMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostCandidatesCandidateIdAvatar = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCandidatesCandidateIdAvatar>>,
    TError,
    { candidateId: number },
    TContext
  >;
}) => {
  const mutationOptions = getPostCandidatesCandidateIdAvatarMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postCandidatesIdForget = () => {
  return customHttpClient<PostCandidatesIdForget200>({ url: `/candidates/:id/forget`, method: 'POST' });
};

export const getPostCandidatesIdForgetMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postCandidatesIdForget>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof postCandidatesIdForget>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCandidatesIdForget>>, void> = () => {
    return postCandidatesIdForget();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCandidatesIdForgetMutationResult = NonNullable<Awaited<ReturnType<typeof postCandidatesIdForget>>>;

export type PostCandidatesIdForgetMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostCandidatesIdForget = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postCandidatesIdForget>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPostCandidatesIdForgetMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postCandidatesIdForgetReactivate = () => {
  return customHttpClient<PostCandidatesIdForgetReactivate200>({
    url: `/candidates/:id/forget-reactivate`,
    method: 'POST',
  });
};

export const getPostCandidatesIdForgetReactivateMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postCandidatesIdForgetReactivate>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof postCandidatesIdForgetReactivate>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCandidatesIdForgetReactivate>>, void> = () => {
    return postCandidatesIdForgetReactivate();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCandidatesIdForgetReactivateMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCandidatesIdForgetReactivate>>
>;

export type PostCandidatesIdForgetReactivateMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostCandidatesIdForgetReactivate = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postCandidatesIdForgetReactivate>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPostCandidatesIdForgetReactivateMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postCandidatesIdInterimAvailability = () => {
  return customHttpClient<PostCandidatesIdInterimAvailability200>({
    url: `/candidates/:id/interim-availability`,
    method: 'POST',
  });
};

export const getPostCandidatesIdInterimAvailabilityMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCandidatesIdInterimAvailability>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<typeof postCandidatesIdInterimAvailability>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCandidatesIdInterimAvailability>>, void> = () => {
    return postCandidatesIdInterimAvailability();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCandidatesIdInterimAvailabilityMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCandidatesIdInterimAvailability>>
>;

export type PostCandidatesIdInterimAvailabilityMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostCandidatesIdInterimAvailability = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCandidatesIdInterimAvailability>>,
    TError,
    void,
    TContext
  >;
}) => {
  const mutationOptions = getPostCandidatesIdInterimAvailabilityMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getCandidatesIdGdprArchive = (signal?: AbortSignal) => {
  return customHttpClient<GetCandidatesIdGdprArchive200>({
    url: `/candidates/:id/gdpr-archive`,
    method: 'GET',
    signal,
  });
};

export const getGetCandidatesIdGdprArchiveQueryKey = () => {
  return [`/candidates/:id/gdpr-archive`] as const;
};

export const getGetCandidatesIdGdprArchiveQueryOptions = <
  TData = Awaited<ReturnType<typeof getCandidatesIdGdprArchive>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCandidatesIdGdprArchive>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCandidatesIdGdprArchiveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCandidatesIdGdprArchive>>> = ({ signal }) =>
    getCandidatesIdGdprArchive(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCandidatesIdGdprArchive>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCandidatesIdGdprArchiveQueryResult = NonNullable<Awaited<ReturnType<typeof getCandidatesIdGdprArchive>>>;
export type GetCandidatesIdGdprArchiveQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetCandidatesIdGdprArchive = <
  TData = Awaited<ReturnType<typeof getCandidatesIdGdprArchive>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCandidatesIdGdprArchive>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCandidatesIdGdprArchiveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postCandidatesCandidateIdInterimWorkHistory = () => {
  return customHttpClient<PostCandidatesCandidateIdInterimWorkHistory200>({
    url: `/candidates/:candidateId/interim-work-history`,
    method: 'POST',
  });
};

export const getPostCandidatesCandidateIdInterimWorkHistoryMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCandidatesCandidateIdInterimWorkHistory>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCandidatesCandidateIdInterimWorkHistory>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCandidatesCandidateIdInterimWorkHistory>>,
    void
  > = () => {
    return postCandidatesCandidateIdInterimWorkHistory();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCandidatesCandidateIdInterimWorkHistoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCandidatesCandidateIdInterimWorkHistory>>
>;

export type PostCandidatesCandidateIdInterimWorkHistoryMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostCandidatesCandidateIdInterimWorkHistory = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCandidatesCandidateIdInterimWorkHistory>>,
    TError,
    void,
    TContext
  >;
}) => {
  const mutationOptions = getPostCandidatesCandidateIdInterimWorkHistoryMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putCandidatesCandidateIdInterimWorkHistoryInterimWorkHistoryId = () => {
  return customHttpClient<PutCandidatesCandidateIdInterimWorkHistoryInterimWorkHistoryId200>({
    url: `/candidates/:candidateId/interim-work-history/:interimWorkHistoryId`,
    method: 'PUT',
  });
};

export const getPutCandidatesCandidateIdInterimWorkHistoryInterimWorkHistoryIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putCandidatesCandidateIdInterimWorkHistoryInterimWorkHistoryId>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putCandidatesCandidateIdInterimWorkHistoryInterimWorkHistoryId>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putCandidatesCandidateIdInterimWorkHistoryInterimWorkHistoryId>>,
    void
  > = () => {
    return putCandidatesCandidateIdInterimWorkHistoryInterimWorkHistoryId();
  };

  return { mutationFn, ...mutationOptions };
};

export type PutCandidatesCandidateIdInterimWorkHistoryInterimWorkHistoryIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putCandidatesCandidateIdInterimWorkHistoryInterimWorkHistoryId>>
>;

export type PutCandidatesCandidateIdInterimWorkHistoryInterimWorkHistoryIdMutationError =
  | Status400
  | Status401
  | Status403
  | Status404;

export const usePutCandidatesCandidateIdInterimWorkHistoryInterimWorkHistoryId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putCandidatesCandidateIdInterimWorkHistoryInterimWorkHistoryId>>,
    TError,
    void,
    TContext
  >;
}) => {
  const mutationOptions = getPutCandidatesCandidateIdInterimWorkHistoryInterimWorkHistoryIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteCandidatesCandidateIdInterimWorkHistoryInterimWorkHistoryId = () => {
  return customHttpClient<DeleteCandidatesCandidateIdInterimWorkHistoryInterimWorkHistoryId200>({
    url: `/candidates/:candidateId/interim-work-history/:interimWorkHistoryId`,
    method: 'DELETE',
  });
};

export const getDeleteCandidatesCandidateIdInterimWorkHistoryInterimWorkHistoryIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCandidatesCandidateIdInterimWorkHistoryInterimWorkHistoryId>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCandidatesCandidateIdInterimWorkHistoryInterimWorkHistoryId>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCandidatesCandidateIdInterimWorkHistoryInterimWorkHistoryId>>,
    void
  > = () => {
    return deleteCandidatesCandidateIdInterimWorkHistoryInterimWorkHistoryId();
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCandidatesCandidateIdInterimWorkHistoryInterimWorkHistoryIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCandidatesCandidateIdInterimWorkHistoryInterimWorkHistoryId>>
>;

export type DeleteCandidatesCandidateIdInterimWorkHistoryInterimWorkHistoryIdMutationError =
  | Status400
  | Status401
  | Status403
  | Status404;

export const useDeleteCandidatesCandidateIdInterimWorkHistoryInterimWorkHistoryId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCandidatesCandidateIdInterimWorkHistoryInterimWorkHistoryId>>,
    TError,
    void,
    TContext
  >;
}) => {
  const mutationOptions = getDeleteCandidatesCandidateIdInterimWorkHistoryInterimWorkHistoryIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postCandidatesCandidateIdWorkHistory = () => {
  return customHttpClient<PostCandidatesCandidateIdWorkHistory200>({
    url: `/candidates/:candidateId/work-history`,
    method: 'POST',
  });
};

export const getPostCandidatesCandidateIdWorkHistoryMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCandidatesCandidateIdWorkHistory>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<typeof postCandidatesCandidateIdWorkHistory>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCandidatesCandidateIdWorkHistory>>, void> = () => {
    return postCandidatesCandidateIdWorkHistory();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCandidatesCandidateIdWorkHistoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCandidatesCandidateIdWorkHistory>>
>;

export type PostCandidatesCandidateIdWorkHistoryMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostCandidatesCandidateIdWorkHistory = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCandidatesCandidateIdWorkHistory>>,
    TError,
    void,
    TContext
  >;
}) => {
  const mutationOptions = getPostCandidatesCandidateIdWorkHistoryMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putCandidatesCandidateIdWorkHistoryWorkHistoryId = () => {
  return customHttpClient<PutCandidatesCandidateIdWorkHistoryWorkHistoryId200>({
    url: `/candidates/:candidateId/work-history/:workHistoryId`,
    method: 'PUT',
  });
};

export const getPutCandidatesCandidateIdWorkHistoryWorkHistoryIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putCandidatesCandidateIdWorkHistoryWorkHistoryId>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putCandidatesCandidateIdWorkHistoryWorkHistoryId>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putCandidatesCandidateIdWorkHistoryWorkHistoryId>>,
    void
  > = () => {
    return putCandidatesCandidateIdWorkHistoryWorkHistoryId();
  };

  return { mutationFn, ...mutationOptions };
};

export type PutCandidatesCandidateIdWorkHistoryWorkHistoryIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putCandidatesCandidateIdWorkHistoryWorkHistoryId>>
>;

export type PutCandidatesCandidateIdWorkHistoryWorkHistoryIdMutationError =
  | Status400
  | Status401
  | Status403
  | Status404;

export const usePutCandidatesCandidateIdWorkHistoryWorkHistoryId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putCandidatesCandidateIdWorkHistoryWorkHistoryId>>,
    TError,
    void,
    TContext
  >;
}) => {
  const mutationOptions = getPutCandidatesCandidateIdWorkHistoryWorkHistoryIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteCandidatesCandidateIdWorkHistoryWorkHistoryId = () => {
  return customHttpClient<DeleteCandidatesCandidateIdWorkHistoryWorkHistoryId200>({
    url: `/candidates/:candidateId/work-history/:workHistoryId`,
    method: 'DELETE',
  });
};

export const getDeleteCandidatesCandidateIdWorkHistoryWorkHistoryIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCandidatesCandidateIdWorkHistoryWorkHistoryId>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCandidatesCandidateIdWorkHistoryWorkHistoryId>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCandidatesCandidateIdWorkHistoryWorkHistoryId>>,
    void
  > = () => {
    return deleteCandidatesCandidateIdWorkHistoryWorkHistoryId();
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCandidatesCandidateIdWorkHistoryWorkHistoryIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCandidatesCandidateIdWorkHistoryWorkHistoryId>>
>;

export type DeleteCandidatesCandidateIdWorkHistoryWorkHistoryIdMutationError =
  | Status400
  | Status401
  | Status403
  | Status404;

export const useDeleteCandidatesCandidateIdWorkHistoryWorkHistoryId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCandidatesCandidateIdWorkHistoryWorkHistoryId>>,
    TError,
    void,
    TContext
  >;
}) => {
  const mutationOptions = getDeleteCandidatesCandidateIdWorkHistoryWorkHistoryIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postCandidatesCandidateIdEducation = () => {
  return customHttpClient<PostCandidatesCandidateIdEducation200>({
    url: `/candidates/:candidateId/education`,
    method: 'POST',
  });
};

export const getPostCandidatesCandidateIdEducationMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postCandidatesCandidateIdEducation>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof postCandidatesCandidateIdEducation>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCandidatesCandidateIdEducation>>, void> = () => {
    return postCandidatesCandidateIdEducation();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCandidatesCandidateIdEducationMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCandidatesCandidateIdEducation>>
>;

export type PostCandidatesCandidateIdEducationMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostCandidatesCandidateIdEducation = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postCandidatesCandidateIdEducation>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPostCandidatesCandidateIdEducationMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putCandidatesCandidateIdEducationEducationId = () => {
  return customHttpClient<PutCandidatesCandidateIdEducationEducationId200>({
    url: `/candidates/:candidateId/education/:educationId`,
    method: 'PUT',
  });
};

export const getPutCandidatesCandidateIdEducationEducationIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putCandidatesCandidateIdEducationEducationId>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putCandidatesCandidateIdEducationEducationId>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putCandidatesCandidateIdEducationEducationId>>,
    void
  > = () => {
    return putCandidatesCandidateIdEducationEducationId();
  };

  return { mutationFn, ...mutationOptions };
};

export type PutCandidatesCandidateIdEducationEducationIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putCandidatesCandidateIdEducationEducationId>>
>;

export type PutCandidatesCandidateIdEducationEducationIdMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutCandidatesCandidateIdEducationEducationId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putCandidatesCandidateIdEducationEducationId>>,
    TError,
    void,
    TContext
  >;
}) => {
  const mutationOptions = getPutCandidatesCandidateIdEducationEducationIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteCandidatesCandidateIdEducationEducationId = () => {
  return customHttpClient<DeleteCandidatesCandidateIdEducationEducationId200>({
    url: `/candidates/:candidateId/education/:educationId`,
    method: 'DELETE',
  });
};

export const getDeleteCandidatesCandidateIdEducationEducationIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCandidatesCandidateIdEducationEducationId>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCandidatesCandidateIdEducationEducationId>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCandidatesCandidateIdEducationEducationId>>,
    void
  > = () => {
    return deleteCandidatesCandidateIdEducationEducationId();
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCandidatesCandidateIdEducationEducationIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCandidatesCandidateIdEducationEducationId>>
>;

export type DeleteCandidatesCandidateIdEducationEducationIdMutationError =
  | Status400
  | Status401
  | Status403
  | Status404;

export const useDeleteCandidatesCandidateIdEducationEducationId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCandidatesCandidateIdEducationEducationId>>,
    TError,
    void,
    TContext
  >;
}) => {
  const mutationOptions = getDeleteCandidatesCandidateIdEducationEducationIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postCandidatesCandidateIdChatbotPause = () => {
  return customHttpClient<PostCandidatesCandidateIdChatbotPause200>({
    url: `/candidates/:candidateId/chatbot/pause`,
    method: 'POST',
  });
};

export const getPostCandidatesCandidateIdChatbotPauseMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCandidatesCandidateIdChatbotPause>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<typeof postCandidatesCandidateIdChatbotPause>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCandidatesCandidateIdChatbotPause>>, void> = () => {
    return postCandidatesCandidateIdChatbotPause();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCandidatesCandidateIdChatbotPauseMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCandidatesCandidateIdChatbotPause>>
>;

export type PostCandidatesCandidateIdChatbotPauseMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostCandidatesCandidateIdChatbotPause = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCandidatesCandidateIdChatbotPause>>,
    TError,
    void,
    TContext
  >;
}) => {
  const mutationOptions = getPostCandidatesCandidateIdChatbotPauseMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postCandidatesCandidateIdChatbotResume = () => {
  return customHttpClient<PostCandidatesCandidateIdChatbotResume200>({
    url: `/candidates/:candidateId/chatbot/resume`,
    method: 'POST',
  });
};

export const getPostCandidatesCandidateIdChatbotResumeMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCandidatesCandidateIdChatbotResume>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<typeof postCandidatesCandidateIdChatbotResume>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCandidatesCandidateIdChatbotResume>>, void> = () => {
    return postCandidatesCandidateIdChatbotResume();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCandidatesCandidateIdChatbotResumeMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCandidatesCandidateIdChatbotResume>>
>;

export type PostCandidatesCandidateIdChatbotResumeMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostCandidatesCandidateIdChatbotResume = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCandidatesCandidateIdChatbotResume>>,
    TError,
    void,
    TContext
  >;
}) => {
  const mutationOptions = getPostCandidatesCandidateIdChatbotResumeMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postCandidatesCandidateIdLanguages = () => {
  return customHttpClient<PostCandidatesCandidateIdLanguages200>({
    url: `/candidates/:candidateId/languages`,
    method: 'POST',
  });
};

export const getPostCandidatesCandidateIdLanguagesMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postCandidatesCandidateIdLanguages>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof postCandidatesCandidateIdLanguages>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCandidatesCandidateIdLanguages>>, void> = () => {
    return postCandidatesCandidateIdLanguages();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCandidatesCandidateIdLanguagesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCandidatesCandidateIdLanguages>>
>;

export type PostCandidatesCandidateIdLanguagesMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostCandidatesCandidateIdLanguages = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postCandidatesCandidateIdLanguages>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPostCandidatesCandidateIdLanguagesMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putCandidatesCandidateIdLanguagesCandidateLanguageId = () => {
  return customHttpClient<PutCandidatesCandidateIdLanguagesCandidateLanguageId200>({
    url: `/candidates/:candidateId/languages/:candidateLanguageId`,
    method: 'PUT',
  });
};

export const getPutCandidatesCandidateIdLanguagesCandidateLanguageIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putCandidatesCandidateIdLanguagesCandidateLanguageId>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putCandidatesCandidateIdLanguagesCandidateLanguageId>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putCandidatesCandidateIdLanguagesCandidateLanguageId>>,
    void
  > = () => {
    return putCandidatesCandidateIdLanguagesCandidateLanguageId();
  };

  return { mutationFn, ...mutationOptions };
};

export type PutCandidatesCandidateIdLanguagesCandidateLanguageIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putCandidatesCandidateIdLanguagesCandidateLanguageId>>
>;

export type PutCandidatesCandidateIdLanguagesCandidateLanguageIdMutationError =
  | Status400
  | Status401
  | Status403
  | Status404;

export const usePutCandidatesCandidateIdLanguagesCandidateLanguageId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putCandidatesCandidateIdLanguagesCandidateLanguageId>>,
    TError,
    void,
    TContext
  >;
}) => {
  const mutationOptions = getPutCandidatesCandidateIdLanguagesCandidateLanguageIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteCandidatesCandidateIdLanguagesCandidateLanguageId = () => {
  return customHttpClient<DeleteCandidatesCandidateIdLanguagesCandidateLanguageId200>({
    url: `/candidates/:candidateId/languages/:candidateLanguageId`,
    method: 'DELETE',
  });
};

export const getDeleteCandidatesCandidateIdLanguagesCandidateLanguageIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCandidatesCandidateIdLanguagesCandidateLanguageId>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCandidatesCandidateIdLanguagesCandidateLanguageId>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCandidatesCandidateIdLanguagesCandidateLanguageId>>,
    void
  > = () => {
    return deleteCandidatesCandidateIdLanguagesCandidateLanguageId();
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCandidatesCandidateIdLanguagesCandidateLanguageIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCandidatesCandidateIdLanguagesCandidateLanguageId>>
>;

export type DeleteCandidatesCandidateIdLanguagesCandidateLanguageIdMutationError =
  | Status400
  | Status401
  | Status403
  | Status404;

export const useDeleteCandidatesCandidateIdLanguagesCandidateLanguageId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCandidatesCandidateIdLanguagesCandidateLanguageId>>,
    TError,
    void,
    TContext
  >;
}) => {
  const mutationOptions = getDeleteCandidatesCandidateIdLanguagesCandidateLanguageIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postCandidatesCandidateIdValidate = () => {
  return customHttpClient<PostCandidatesCandidateIdValidate200>({
    url: `/candidates/:candidateId/validate`,
    method: 'POST',
  });
};

export const getPostCandidatesCandidateIdValidateMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postCandidatesCandidateIdValidate>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof postCandidatesCandidateIdValidate>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCandidatesCandidateIdValidate>>, void> = () => {
    return postCandidatesCandidateIdValidate();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCandidatesCandidateIdValidateMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCandidatesCandidateIdValidate>>
>;

export type PostCandidatesCandidateIdValidateMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostCandidatesCandidateIdValidate = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postCandidatesCandidateIdValidate>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPostCandidatesCandidateIdValidateMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postChatsSendSms = () => {
  return customHttpClient<PostChatsSendSms200>({ url: `/chats/send-sms`, method: 'POST' });
};

export const getPostChatsSendSmsMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postChatsSendSms>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof postChatsSendSms>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postChatsSendSms>>, void> = () => {
    return postChatsSendSms();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostChatsSendSmsMutationResult = NonNullable<Awaited<ReturnType<typeof postChatsSendSms>>>;

export type PostChatsSendSmsMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostChatsSendSms = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postChatsSendSms>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPostChatsSendSmsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postChatsSendFbMessage = () => {
  return customHttpClient<PostChatsSendFbMessage200>({ url: `/chats/send-fb-message`, method: 'POST' });
};

export const getPostChatsSendFbMessageMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postChatsSendFbMessage>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof postChatsSendFbMessage>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postChatsSendFbMessage>>, void> = () => {
    return postChatsSendFbMessage();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostChatsSendFbMessageMutationResult = NonNullable<Awaited<ReturnType<typeof postChatsSendFbMessage>>>;

export type PostChatsSendFbMessageMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostChatsSendFbMessage = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postChatsSendFbMessage>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPostChatsSendFbMessageMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postChatsSendLlMessage = () => {
  return customHttpClient<PostChatsSendLlMessage200>({ url: `/chats/send-ll-message`, method: 'POST' });
};

export const getPostChatsSendLlMessageMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postChatsSendLlMessage>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof postChatsSendLlMessage>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postChatsSendLlMessage>>, void> = () => {
    return postChatsSendLlMessage();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostChatsSendLlMessageMutationResult = NonNullable<Awaited<ReturnType<typeof postChatsSendLlMessage>>>;

export type PostChatsSendLlMessageMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostChatsSendLlMessage = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postChatsSendLlMessage>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPostChatsSendLlMessageMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getChatsFilterOptions = (signal?: AbortSignal) => {
  return customHttpClient<GetChatsFilterOptions200>({ url: `/chats/filter-options`, method: 'GET', signal });
};

export const getGetChatsFilterOptionsQueryKey = () => {
  return [`/chats/filter-options`] as const;
};

export const getGetChatsFilterOptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getChatsFilterOptions>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getChatsFilterOptions>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetChatsFilterOptionsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getChatsFilterOptions>>> = ({ signal }) =>
    getChatsFilterOptions(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getChatsFilterOptions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetChatsFilterOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getChatsFilterOptions>>>;
export type GetChatsFilterOptionsQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetChatsFilterOptions = <
  TData = Awaited<ReturnType<typeof getChatsFilterOptions>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getChatsFilterOptions>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetChatsFilterOptionsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getChatsSearch = (signal?: AbortSignal) => {
  return customHttpClient<GetChatsSearch200>({ url: `/chats/search`, method: 'GET', signal });
};

export const getGetChatsSearchQueryKey = () => {
  return [`/chats/search`] as const;
};

export const getGetChatsSearchQueryOptions = <
  TData = Awaited<ReturnType<typeof getChatsSearch>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getChatsSearch>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetChatsSearchQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getChatsSearch>>> = ({ signal }) => getChatsSearch(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getChatsSearch>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetChatsSearchQueryResult = NonNullable<Awaited<ReturnType<typeof getChatsSearch>>>;
export type GetChatsSearchQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetChatsSearch = <
  TData = Awaited<ReturnType<typeof getChatsSearch>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getChatsSearch>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetChatsSearchQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getChatsUnreadCounters = (signal?: AbortSignal) => {
  return customHttpClient<GetChatsUnreadCounters200>({ url: `/chats/unread-counters`, method: 'GET', signal });
};

export const getGetChatsUnreadCountersQueryKey = () => {
  return [`/chats/unread-counters`] as const;
};

export const getGetChatsUnreadCountersQueryOptions = <
  TData = Awaited<ReturnType<typeof getChatsUnreadCounters>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getChatsUnreadCounters>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetChatsUnreadCountersQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getChatsUnreadCounters>>> = ({ signal }) =>
    getChatsUnreadCounters(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getChatsUnreadCounters>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetChatsUnreadCountersQueryResult = NonNullable<Awaited<ReturnType<typeof getChatsUnreadCounters>>>;
export type GetChatsUnreadCountersQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetChatsUnreadCounters = <
  TData = Awaited<ReturnType<typeof getChatsUnreadCounters>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getChatsUnreadCounters>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetChatsUnreadCountersQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getChatsId = (signal?: AbortSignal) => {
  return customHttpClient<GetChatsId200>({ url: `/chats/:id`, method: 'GET', signal });
};

export const getGetChatsIdQueryKey = () => {
  return [`/chats/:id`] as const;
};

export const getGetChatsIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getChatsId>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getChatsId>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetChatsIdQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getChatsId>>> = ({ signal }) => getChatsId(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getChatsId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetChatsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getChatsId>>>;
export type GetChatsIdQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetChatsId = <
  TData = Awaited<ReturnType<typeof getChatsId>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getChatsId>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetChatsIdQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getChatsIdMessages = (signal?: AbortSignal) => {
  return customHttpClient<GetChatsIdMessages200>({ url: `/chats/:id/messages`, method: 'GET', signal });
};

export const getGetChatsIdMessagesQueryKey = () => {
  return [`/chats/:id/messages`] as const;
};

export const getGetChatsIdMessagesQueryOptions = <
  TData = Awaited<ReturnType<typeof getChatsIdMessages>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getChatsIdMessages>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetChatsIdMessagesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getChatsIdMessages>>> = ({ signal }) =>
    getChatsIdMessages(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getChatsIdMessages>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetChatsIdMessagesQueryResult = NonNullable<Awaited<ReturnType<typeof getChatsIdMessages>>>;
export type GetChatsIdMessagesQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetChatsIdMessages = <
  TData = Awaited<ReturnType<typeof getChatsIdMessages>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getChatsIdMessages>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetChatsIdMessagesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getCompaniesCustomFieldsModel = (signal?: AbortSignal) => {
  return customHttpClient<GetCompaniesCustomFieldsModel200>({
    url: `/companies/custom-fields/model`,
    method: 'GET',
    signal,
  });
};

export const getGetCompaniesCustomFieldsModelQueryKey = () => {
  return [`/companies/custom-fields/model`] as const;
};

export const getGetCompaniesCustomFieldsModelQueryOptions = <
  TData = Awaited<ReturnType<typeof getCompaniesCustomFieldsModel>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCompaniesCustomFieldsModel>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCompaniesCustomFieldsModelQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompaniesCustomFieldsModel>>> = ({ signal }) =>
    getCompaniesCustomFieldsModel(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCompaniesCustomFieldsModel>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCompaniesCustomFieldsModelQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCompaniesCustomFieldsModel>>
>;
export type GetCompaniesCustomFieldsModelQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetCompaniesCustomFieldsModel = <
  TData = Awaited<ReturnType<typeof getCompaniesCustomFieldsModel>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCompaniesCustomFieldsModel>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCompaniesCustomFieldsModelQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const putCompaniesCustomFieldsModel = () => {
  return customHttpClient<PutCompaniesCustomFieldsModel200>({ url: `/companies/custom-fields/model`, method: 'PUT' });
};

export const getPutCompaniesCustomFieldsModelMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putCompaniesCustomFieldsModel>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof putCompaniesCustomFieldsModel>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof putCompaniesCustomFieldsModel>>, void> = () => {
    return putCompaniesCustomFieldsModel();
  };

  return { mutationFn, ...mutationOptions };
};

export type PutCompaniesCustomFieldsModelMutationResult = NonNullable<
  Awaited<ReturnType<typeof putCompaniesCustomFieldsModel>>
>;

export type PutCompaniesCustomFieldsModelMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutCompaniesCustomFieldsModel = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putCompaniesCustomFieldsModel>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPutCompaniesCustomFieldsModelMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postCompaniesCustomFieldsValidate = () => {
  return customHttpClient<PostCompaniesCustomFieldsValidate200>({
    url: `/companies/custom-fields/validate`,
    method: 'POST',
  });
};

export const getPostCompaniesCustomFieldsValidateMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postCompaniesCustomFieldsValidate>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof postCompaniesCustomFieldsValidate>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCompaniesCustomFieldsValidate>>, void> = () => {
    return postCompaniesCustomFieldsValidate();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCompaniesCustomFieldsValidateMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCompaniesCustomFieldsValidate>>
>;

export type PostCompaniesCustomFieldsValidateMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostCompaniesCustomFieldsValidate = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postCompaniesCustomFieldsValidate>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPostCompaniesCustomFieldsValidateMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getCompaniesEntityIdCustomFields = (entityId: string, signal?: AbortSignal) => {
  return customHttpClient<GetCompaniesEntityIdCustomFields200>({
    url: `/companies/${entityId}/custom-fields`,
    method: 'GET',
    signal,
  });
};

export const getGetCompaniesEntityIdCustomFieldsQueryKey = (entityId: string) => {
  return [`/companies/${entityId}/custom-fields`] as const;
};

export const getGetCompaniesEntityIdCustomFieldsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCompaniesEntityIdCustomFields>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  entityId: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getCompaniesEntityIdCustomFields>>, TError, TData> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCompaniesEntityIdCustomFieldsQueryKey(entityId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompaniesEntityIdCustomFields>>> = ({ signal }) =>
    getCompaniesEntityIdCustomFields(entityId, signal);

  return { queryKey, queryFn, enabled: !!entityId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCompaniesEntityIdCustomFields>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCompaniesEntityIdCustomFieldsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCompaniesEntityIdCustomFields>>
>;
export type GetCompaniesEntityIdCustomFieldsQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetCompaniesEntityIdCustomFields = <
  TData = Awaited<ReturnType<typeof getCompaniesEntityIdCustomFields>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  entityId: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getCompaniesEntityIdCustomFields>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCompaniesEntityIdCustomFieldsQueryOptions(entityId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const putCompaniesEntityIdCustomFields = (entityId: string) => {
  return customHttpClient<PutCompaniesEntityIdCustomFields200>({
    url: `/companies/${entityId}/custom-fields`,
    method: 'PUT',
  });
};

export const getPutCompaniesEntityIdCustomFieldsMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putCompaniesEntityIdCustomFields>>,
    TError,
    { entityId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putCompaniesEntityIdCustomFields>>,
  TError,
  { entityId: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putCompaniesEntityIdCustomFields>>,
    { entityId: string }
  > = (props) => {
    const { entityId } = props ?? {};

    return putCompaniesEntityIdCustomFields(entityId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutCompaniesEntityIdCustomFieldsMutationResult = NonNullable<
  Awaited<ReturnType<typeof putCompaniesEntityIdCustomFields>>
>;

export type PutCompaniesEntityIdCustomFieldsMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutCompaniesEntityIdCustomFields = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putCompaniesEntityIdCustomFields>>,
    TError,
    { entityId: string },
    TContext
  >;
}) => {
  const mutationOptions = getPutCompaniesEntityIdCustomFieldsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putCompaniesEntityIdCustomFieldsExtend = (
  entityId: string,
  putCompaniesEntityIdCustomFieldsExtendBody: PutCompaniesEntityIdCustomFieldsExtendBody,
) => {
  return customHttpClient<PutCompaniesEntityIdCustomFieldsExtend200>({
    url: `/companies/${entityId}/custom-fields/extend`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: putCompaniesEntityIdCustomFieldsExtendBody,
  });
};

export const getPutCompaniesEntityIdCustomFieldsExtendMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putCompaniesEntityIdCustomFieldsExtend>>,
    TError,
    { entityId: string; data: PutCompaniesEntityIdCustomFieldsExtendBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putCompaniesEntityIdCustomFieldsExtend>>,
  TError,
  { entityId: string; data: PutCompaniesEntityIdCustomFieldsExtendBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putCompaniesEntityIdCustomFieldsExtend>>,
    { entityId: string; data: PutCompaniesEntityIdCustomFieldsExtendBody }
  > = (props) => {
    const { entityId, data } = props ?? {};

    return putCompaniesEntityIdCustomFieldsExtend(entityId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutCompaniesEntityIdCustomFieldsExtendMutationResult = NonNullable<
  Awaited<ReturnType<typeof putCompaniesEntityIdCustomFieldsExtend>>
>;
export type PutCompaniesEntityIdCustomFieldsExtendMutationBody = PutCompaniesEntityIdCustomFieldsExtendBody;
export type PutCompaniesEntityIdCustomFieldsExtendMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutCompaniesEntityIdCustomFieldsExtend = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putCompaniesEntityIdCustomFieldsExtend>>,
    TError,
    { entityId: string; data: PutCompaniesEntityIdCustomFieldsExtendBody },
    TContext
  >;
}) => {
  const mutationOptions = getPutCompaniesEntityIdCustomFieldsExtendMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postCompaniesLists = () => {
  return customHttpClient<PostCompaniesLists200>({ url: `/companies/lists`, method: 'POST' });
};

export const getPostCompaniesListsMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postCompaniesLists>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof postCompaniesLists>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCompaniesLists>>, void> = () => {
    return postCompaniesLists();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCompaniesListsMutationResult = NonNullable<Awaited<ReturnType<typeof postCompaniesLists>>>;

export type PostCompaniesListsMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostCompaniesLists = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postCompaniesLists>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPostCompaniesListsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getCompaniesLists = (signal?: AbortSignal) => {
  return customHttpClient<GetCompaniesLists200>({ url: `/companies/lists`, method: 'GET', signal });
};

export const getGetCompaniesListsQueryKey = () => {
  return [`/companies/lists`] as const;
};

export const getGetCompaniesListsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCompaniesLists>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCompaniesLists>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCompaniesListsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompaniesLists>>> = ({ signal }) =>
    getCompaniesLists(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCompaniesLists>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCompaniesListsQueryResult = NonNullable<Awaited<ReturnType<typeof getCompaniesLists>>>;
export type GetCompaniesListsQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetCompaniesLists = <
  TData = Awaited<ReturnType<typeof getCompaniesLists>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCompaniesLists>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCompaniesListsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postCompaniesListsEntityListIdCreateNewEntity = () => {
  return customHttpClient<PostCompaniesListsEntityListIdCreateNewEntity200>({
    url: `/companies/lists/:entityListId/create-new-entity`,
    method: 'POST',
  });
};

export const getPostCompaniesListsEntityListIdCreateNewEntityMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCompaniesListsEntityListIdCreateNewEntity>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCompaniesListsEntityListIdCreateNewEntity>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCompaniesListsEntityListIdCreateNewEntity>>,
    void
  > = () => {
    return postCompaniesListsEntityListIdCreateNewEntity();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCompaniesListsEntityListIdCreateNewEntityMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCompaniesListsEntityListIdCreateNewEntity>>
>;

export type PostCompaniesListsEntityListIdCreateNewEntityMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostCompaniesListsEntityListIdCreateNewEntity = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCompaniesListsEntityListIdCreateNewEntity>>,
    TError,
    void,
    TContext
  >;
}) => {
  const mutationOptions = getPostCompaniesListsEntityListIdCreateNewEntityMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getCompaniesListsEntityListId = (signal?: AbortSignal) => {
  return customHttpClient<GetCompaniesListsEntityListId200>({
    url: `/companies/lists/:entityListId`,
    method: 'GET',
    signal,
  });
};

export const getGetCompaniesListsEntityListIdQueryKey = () => {
  return [`/companies/lists/:entityListId`] as const;
};

export const getGetCompaniesListsEntityListIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getCompaniesListsEntityListId>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCompaniesListsEntityListId>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCompaniesListsEntityListIdQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompaniesListsEntityListId>>> = ({ signal }) =>
    getCompaniesListsEntityListId(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCompaniesListsEntityListId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCompaniesListsEntityListIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCompaniesListsEntityListId>>
>;
export type GetCompaniesListsEntityListIdQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetCompaniesListsEntityListId = <
  TData = Awaited<ReturnType<typeof getCompaniesListsEntityListId>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCompaniesListsEntityListId>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCompaniesListsEntityListIdQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const putCompaniesListsEntityListId = () => {
  return customHttpClient<PutCompaniesListsEntityListId200>({ url: `/companies/lists/:entityListId`, method: 'PUT' });
};

export const getPutCompaniesListsEntityListIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putCompaniesListsEntityListId>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof putCompaniesListsEntityListId>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof putCompaniesListsEntityListId>>, void> = () => {
    return putCompaniesListsEntityListId();
  };

  return { mutationFn, ...mutationOptions };
};

export type PutCompaniesListsEntityListIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putCompaniesListsEntityListId>>
>;

export type PutCompaniesListsEntityListIdMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutCompaniesListsEntityListId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putCompaniesListsEntityListId>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPutCompaniesListsEntityListIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteCompaniesListsEntityListId = () => {
  return customHttpClient<DeleteCompaniesListsEntityListId200>({
    url: `/companies/lists/:entityListId`,
    method: 'DELETE',
  });
};

export const getDeleteCompaniesListsEntityListIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof deleteCompaniesListsEntityListId>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof deleteCompaniesListsEntityListId>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCompaniesListsEntityListId>>, void> = () => {
    return deleteCompaniesListsEntityListId();
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCompaniesListsEntityListIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCompaniesListsEntityListId>>
>;

export type DeleteCompaniesListsEntityListIdMutationError = Status400 | Status401 | Status403 | Status404;

export const useDeleteCompaniesListsEntityListId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof deleteCompaniesListsEntityListId>>, TError, void, TContext>;
}) => {
  const mutationOptions = getDeleteCompaniesListsEntityListIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getCompaniesListsEntityListIdCompanies = (signal?: AbortSignal) => {
  return customHttpClient<GetCompaniesListsEntityListIdCompanies200>({
    url: `/companies/lists/:entityListId/companies`,
    method: 'GET',
    signal,
  });
};

export const getGetCompaniesListsEntityListIdCompaniesQueryKey = () => {
  return [`/companies/lists/:entityListId/companies`] as const;
};

export const getGetCompaniesListsEntityListIdCompaniesQueryOptions = <
  TData = Awaited<ReturnType<typeof getCompaniesListsEntityListIdCompanies>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCompaniesListsEntityListIdCompanies>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCompaniesListsEntityListIdCompaniesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompaniesListsEntityListIdCompanies>>> = ({ signal }) =>
    getCompaniesListsEntityListIdCompanies(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCompaniesListsEntityListIdCompanies>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCompaniesListsEntityListIdCompaniesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCompaniesListsEntityListIdCompanies>>
>;
export type GetCompaniesListsEntityListIdCompaniesQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetCompaniesListsEntityListIdCompanies = <
  TData = Awaited<ReturnType<typeof getCompaniesListsEntityListIdCompanies>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCompaniesListsEntityListIdCompanies>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCompaniesListsEntityListIdCompaniesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postCompaniesListsEntityListIdAdd = () => {
  return customHttpClient<PostCompaniesListsEntityListIdAdd200>({
    url: `/companies/lists/:entityListId/add`,
    method: 'POST',
  });
};

export const getPostCompaniesListsEntityListIdAddMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postCompaniesListsEntityListIdAdd>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof postCompaniesListsEntityListIdAdd>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCompaniesListsEntityListIdAdd>>, void> = () => {
    return postCompaniesListsEntityListIdAdd();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCompaniesListsEntityListIdAddMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCompaniesListsEntityListIdAdd>>
>;

export type PostCompaniesListsEntityListIdAddMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostCompaniesListsEntityListIdAdd = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postCompaniesListsEntityListIdAdd>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPostCompaniesListsEntityListIdAddMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postCompaniesListsEntityListIdRemove = () => {
  return customHttpClient<PostCompaniesListsEntityListIdRemove200>({
    url: `/companies/lists/:entityListId/remove`,
    method: 'POST',
  });
};

export const getPostCompaniesListsEntityListIdRemoveMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCompaniesListsEntityListIdRemove>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<typeof postCompaniesListsEntityListIdRemove>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCompaniesListsEntityListIdRemove>>, void> = () => {
    return postCompaniesListsEntityListIdRemove();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCompaniesListsEntityListIdRemoveMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCompaniesListsEntityListIdRemove>>
>;

export type PostCompaniesListsEntityListIdRemoveMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostCompaniesListsEntityListIdRemove = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCompaniesListsEntityListIdRemove>>,
    TError,
    void,
    TContext
  >;
}) => {
  const mutationOptions = getPostCompaniesListsEntityListIdRemoveMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postCompaniesListsEntityListIdReorder = () => {
  return customHttpClient<PostCompaniesListsEntityListIdReorder200>({
    url: `/companies/lists/:entityListId/reorder`,
    method: 'POST',
  });
};

export const getPostCompaniesListsEntityListIdReorderMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCompaniesListsEntityListIdReorder>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<typeof postCompaniesListsEntityListIdReorder>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCompaniesListsEntityListIdReorder>>, void> = () => {
    return postCompaniesListsEntityListIdReorder();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCompaniesListsEntityListIdReorderMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCompaniesListsEntityListIdReorder>>
>;

export type PostCompaniesListsEntityListIdReorderMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostCompaniesListsEntityListIdReorder = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCompaniesListsEntityListIdReorder>>,
    TError,
    void,
    TContext
  >;
}) => {
  const mutationOptions = getPostCompaniesListsEntityListIdReorderMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postCompaniesListsEntityListIdUserGroups = () => {
  return customHttpClient<PostCompaniesListsEntityListIdUserGroups200>({
    url: `/companies/lists/:entityListId/user-groups`,
    method: 'POST',
  });
};

export const getPostCompaniesListsEntityListIdUserGroupsMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCompaniesListsEntityListIdUserGroups>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCompaniesListsEntityListIdUserGroups>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCompaniesListsEntityListIdUserGroups>>,
    void
  > = () => {
    return postCompaniesListsEntityListIdUserGroups();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCompaniesListsEntityListIdUserGroupsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCompaniesListsEntityListIdUserGroups>>
>;

export type PostCompaniesListsEntityListIdUserGroupsMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostCompaniesListsEntityListIdUserGroups = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCompaniesListsEntityListIdUserGroups>>,
    TError,
    void,
    TContext
  >;
}) => {
  const mutationOptions = getPostCompaniesListsEntityListIdUserGroupsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postCompaniesEntityIdLists = (entityId: string) => {
  return customHttpClient<PostCompaniesEntityIdLists200>({ url: `/companies/${entityId}/lists`, method: 'POST' });
};

export const getPostCompaniesEntityIdListsMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCompaniesEntityIdLists>>,
    TError,
    { entityId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCompaniesEntityIdLists>>,
  TError,
  { entityId: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCompaniesEntityIdLists>>, { entityId: string }> = (
    props,
  ) => {
    const { entityId } = props ?? {};

    return postCompaniesEntityIdLists(entityId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCompaniesEntityIdListsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCompaniesEntityIdLists>>
>;

export type PostCompaniesEntityIdListsMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostCompaniesEntityIdLists = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCompaniesEntityIdLists>>,
    TError,
    { entityId: string },
    TContext
  >;
}) => {
  const mutationOptions = getPostCompaniesEntityIdListsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putCompaniesEntityIdNotesPanel = (entityId: string) => {
  return customHttpClient<PutCompaniesEntityIdNotesPanel200>({
    url: `/companies/${entityId}/notes/panel`,
    method: 'PUT',
  });
};

export const getPutCompaniesEntityIdNotesPanelMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putCompaniesEntityIdNotesPanel>>,
    TError,
    { entityId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putCompaniesEntityIdNotesPanel>>,
  TError,
  { entityId: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putCompaniesEntityIdNotesPanel>>,
    { entityId: string }
  > = (props) => {
    const { entityId } = props ?? {};

    return putCompaniesEntityIdNotesPanel(entityId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutCompaniesEntityIdNotesPanelMutationResult = NonNullable<
  Awaited<ReturnType<typeof putCompaniesEntityIdNotesPanel>>
>;

export type PutCompaniesEntityIdNotesPanelMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutCompaniesEntityIdNotesPanel = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putCompaniesEntityIdNotesPanel>>,
    TError,
    { entityId: string },
    TContext
  >;
}) => {
  const mutationOptions = getPutCompaniesEntityIdNotesPanelMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteCompaniesEntityIdNotesPanel = (entityId: string) => {
  return customHttpClient<DeleteCompaniesEntityIdNotesPanel200>({
    url: `/companies/${entityId}/notes/panel`,
    method: 'DELETE',
  });
};

export const getDeleteCompaniesEntityIdNotesPanelMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCompaniesEntityIdNotesPanel>>,
    TError,
    { entityId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCompaniesEntityIdNotesPanel>>,
  TError,
  { entityId: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCompaniesEntityIdNotesPanel>>,
    { entityId: string }
  > = (props) => {
    const { entityId } = props ?? {};

    return deleteCompaniesEntityIdNotesPanel(entityId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCompaniesEntityIdNotesPanelMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCompaniesEntityIdNotesPanel>>
>;

export type DeleteCompaniesEntityIdNotesPanelMutationError = Status400 | Status401 | Status403 | Status404;

export const useDeleteCompaniesEntityIdNotesPanel = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCompaniesEntityIdNotesPanel>>,
    TError,
    { entityId: string },
    TContext
  >;
}) => {
  const mutationOptions = getDeleteCompaniesEntityIdNotesPanelMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postCompanies = () => {
  return customHttpClient<PostCompanies200>({ url: `/companies`, method: 'POST' });
};

export const getPostCompaniesMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postCompanies>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof postCompanies>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCompanies>>, void> = () => {
    return postCompanies();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCompaniesMutationResult = NonNullable<Awaited<ReturnType<typeof postCompanies>>>;

export type PostCompaniesMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostCompanies = <TError = Status400 | Status401 | Status403 | Status404, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postCompanies>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPostCompaniesMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getCompanies = (signal?: AbortSignal) => {
  return customHttpClient<GetCompanies200>({ url: `/companies`, method: 'GET', signal });
};

export const getGetCompaniesQueryKey = () => {
  return [`/companies`] as const;
};

export const getGetCompaniesQueryOptions = <
  TData = Awaited<ReturnType<typeof getCompanies>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCompanies>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCompaniesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanies>>> = ({ signal }) => getCompanies(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCompanies>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCompaniesQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanies>>>;
export type GetCompaniesQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetCompanies = <
  TData = Awaited<ReturnType<typeof getCompanies>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCompanies>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCompaniesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postCompaniesSearch = () => {
  return customHttpClient<PostCompaniesSearch200>({ url: `/companies/search`, method: 'POST' });
};

export const getPostCompaniesSearchMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postCompaniesSearch>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof postCompaniesSearch>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCompaniesSearch>>, void> = () => {
    return postCompaniesSearch();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCompaniesSearchMutationResult = NonNullable<Awaited<ReturnType<typeof postCompaniesSearch>>>;

export type PostCompaniesSearchMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostCompaniesSearch = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postCompaniesSearch>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPostCompaniesSearchMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getCompaniesFilterOptions = (signal?: AbortSignal) => {
  return customHttpClient<GetCompaniesFilterOptions200>({ url: `/companies/filter-options`, method: 'GET', signal });
};

export const getGetCompaniesFilterOptionsQueryKey = () => {
  return [`/companies/filter-options`] as const;
};

export const getGetCompaniesFilterOptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCompaniesFilterOptions>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCompaniesFilterOptions>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCompaniesFilterOptionsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompaniesFilterOptions>>> = ({ signal }) =>
    getCompaniesFilterOptions(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCompaniesFilterOptions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCompaniesFilterOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getCompaniesFilterOptions>>>;
export type GetCompaniesFilterOptionsQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetCompaniesFilterOptions = <
  TData = Awaited<ReturnType<typeof getCompaniesFilterOptions>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCompaniesFilterOptions>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCompaniesFilterOptionsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getCompaniesEditOptions = (signal?: AbortSignal) => {
  return customHttpClient<GetCompaniesEditOptions200>({ url: `/companies/edit-options`, method: 'GET', signal });
};

export const getGetCompaniesEditOptionsQueryKey = () => {
  return [`/companies/edit-options`] as const;
};

export const getGetCompaniesEditOptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCompaniesEditOptions>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCompaniesEditOptions>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCompaniesEditOptionsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompaniesEditOptions>>> = ({ signal }) =>
    getCompaniesEditOptions(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCompaniesEditOptions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCompaniesEditOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getCompaniesEditOptions>>>;
export type GetCompaniesEditOptionsQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetCompaniesEditOptions = <
  TData = Awaited<ReturnType<typeof getCompaniesEditOptions>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCompaniesEditOptions>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCompaniesEditOptionsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postCompaniesCompanyIdAvatar = () => {
  return customHttpClient<PostCompaniesCompanyIdAvatar200>({ url: `/companies/:companyId/avatar`, method: 'POST' });
};

export const getPostCompaniesCompanyIdAvatarMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postCompaniesCompanyIdAvatar>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof postCompaniesCompanyIdAvatar>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCompaniesCompanyIdAvatar>>, void> = () => {
    return postCompaniesCompanyIdAvatar();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCompaniesCompanyIdAvatarMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCompaniesCompanyIdAvatar>>
>;

export type PostCompaniesCompanyIdAvatarMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostCompaniesCompanyIdAvatar = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postCompaniesCompanyIdAvatar>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPostCompaniesCompanyIdAvatarMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getCompaniesCompanyId = (signal?: AbortSignal) => {
  return customHttpClient<GetCompaniesCompanyId200>({ url: `/companies/:companyId`, method: 'GET', signal });
};

export const getGetCompaniesCompanyIdQueryKey = () => {
  return [`/companies/:companyId`] as const;
};

export const getGetCompaniesCompanyIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getCompaniesCompanyId>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCompaniesCompanyId>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCompaniesCompanyIdQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompaniesCompanyId>>> = ({ signal }) =>
    getCompaniesCompanyId(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCompaniesCompanyId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCompaniesCompanyIdQueryResult = NonNullable<Awaited<ReturnType<typeof getCompaniesCompanyId>>>;
export type GetCompaniesCompanyIdQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetCompaniesCompanyId = <
  TData = Awaited<ReturnType<typeof getCompaniesCompanyId>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCompaniesCompanyId>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCompaniesCompanyIdQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const putCompaniesCompanyId = () => {
  return customHttpClient<PutCompaniesCompanyId200>({ url: `/companies/:companyId`, method: 'PUT' });
};

export const getPutCompaniesCompanyIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putCompaniesCompanyId>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof putCompaniesCompanyId>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof putCompaniesCompanyId>>, void> = () => {
    return putCompaniesCompanyId();
  };

  return { mutationFn, ...mutationOptions };
};

export type PutCompaniesCompanyIdMutationResult = NonNullable<Awaited<ReturnType<typeof putCompaniesCompanyId>>>;

export type PutCompaniesCompanyIdMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutCompaniesCompanyId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putCompaniesCompanyId>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPutCompaniesCompanyIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteCompaniesCompanyId = () => {
  return customHttpClient<DeleteCompaniesCompanyId200>({ url: `/companies/:companyId`, method: 'DELETE' });
};

export const getDeleteCompaniesCompanyIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof deleteCompaniesCompanyId>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof deleteCompaniesCompanyId>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCompaniesCompanyId>>, void> = () => {
    return deleteCompaniesCompanyId();
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCompaniesCompanyIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCompaniesCompanyId>>>;

export type DeleteCompaniesCompanyIdMutationError = Status400 | Status401 | Status403 | Status404;

export const useDeleteCompaniesCompanyId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof deleteCompaniesCompanyId>>, TError, void, TContext>;
}) => {
  const mutationOptions = getDeleteCompaniesCompanyIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getContactsCustomFieldsModel = (signal?: AbortSignal) => {
  return customHttpClient<GetContactsCustomFieldsModel200>({
    url: `/contacts/custom-fields/model`,
    method: 'GET',
    signal,
  });
};

export const getGetContactsCustomFieldsModelQueryKey = () => {
  return [`/contacts/custom-fields/model`] as const;
};

export const getGetContactsCustomFieldsModelQueryOptions = <
  TData = Awaited<ReturnType<typeof getContactsCustomFieldsModel>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getContactsCustomFieldsModel>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetContactsCustomFieldsModelQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getContactsCustomFieldsModel>>> = ({ signal }) =>
    getContactsCustomFieldsModel(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getContactsCustomFieldsModel>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetContactsCustomFieldsModelQueryResult = NonNullable<
  Awaited<ReturnType<typeof getContactsCustomFieldsModel>>
>;
export type GetContactsCustomFieldsModelQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetContactsCustomFieldsModel = <
  TData = Awaited<ReturnType<typeof getContactsCustomFieldsModel>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getContactsCustomFieldsModel>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetContactsCustomFieldsModelQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const putContactsCustomFieldsModel = () => {
  return customHttpClient<PutContactsCustomFieldsModel200>({ url: `/contacts/custom-fields/model`, method: 'PUT' });
};

export const getPutContactsCustomFieldsModelMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putContactsCustomFieldsModel>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof putContactsCustomFieldsModel>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof putContactsCustomFieldsModel>>, void> = () => {
    return putContactsCustomFieldsModel();
  };

  return { mutationFn, ...mutationOptions };
};

export type PutContactsCustomFieldsModelMutationResult = NonNullable<
  Awaited<ReturnType<typeof putContactsCustomFieldsModel>>
>;

export type PutContactsCustomFieldsModelMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutContactsCustomFieldsModel = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putContactsCustomFieldsModel>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPutContactsCustomFieldsModelMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postContactsCustomFieldsValidate = () => {
  return customHttpClient<PostContactsCustomFieldsValidate200>({
    url: `/contacts/custom-fields/validate`,
    method: 'POST',
  });
};

export const getPostContactsCustomFieldsValidateMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postContactsCustomFieldsValidate>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof postContactsCustomFieldsValidate>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postContactsCustomFieldsValidate>>, void> = () => {
    return postContactsCustomFieldsValidate();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostContactsCustomFieldsValidateMutationResult = NonNullable<
  Awaited<ReturnType<typeof postContactsCustomFieldsValidate>>
>;

export type PostContactsCustomFieldsValidateMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostContactsCustomFieldsValidate = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postContactsCustomFieldsValidate>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPostContactsCustomFieldsValidateMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getContactsEntityIdCustomFields = (entityId: string, signal?: AbortSignal) => {
  return customHttpClient<GetContactsEntityIdCustomFields200>({
    url: `/contacts/${entityId}/custom-fields`,
    method: 'GET',
    signal,
  });
};

export const getGetContactsEntityIdCustomFieldsQueryKey = (entityId: string) => {
  return [`/contacts/${entityId}/custom-fields`] as const;
};

export const getGetContactsEntityIdCustomFieldsQueryOptions = <
  TData = Awaited<ReturnType<typeof getContactsEntityIdCustomFields>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  entityId: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getContactsEntityIdCustomFields>>, TError, TData> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetContactsEntityIdCustomFieldsQueryKey(entityId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getContactsEntityIdCustomFields>>> = ({ signal }) =>
    getContactsEntityIdCustomFields(entityId, signal);

  return { queryKey, queryFn, enabled: !!entityId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getContactsEntityIdCustomFields>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetContactsEntityIdCustomFieldsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getContactsEntityIdCustomFields>>
>;
export type GetContactsEntityIdCustomFieldsQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetContactsEntityIdCustomFields = <
  TData = Awaited<ReturnType<typeof getContactsEntityIdCustomFields>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  entityId: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getContactsEntityIdCustomFields>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetContactsEntityIdCustomFieldsQueryOptions(entityId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const putContactsEntityIdCustomFields = (entityId: string) => {
  return customHttpClient<PutContactsEntityIdCustomFields200>({
    url: `/contacts/${entityId}/custom-fields`,
    method: 'PUT',
  });
};

export const getPutContactsEntityIdCustomFieldsMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putContactsEntityIdCustomFields>>,
    TError,
    { entityId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putContactsEntityIdCustomFields>>,
  TError,
  { entityId: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putContactsEntityIdCustomFields>>,
    { entityId: string }
  > = (props) => {
    const { entityId } = props ?? {};

    return putContactsEntityIdCustomFields(entityId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutContactsEntityIdCustomFieldsMutationResult = NonNullable<
  Awaited<ReturnType<typeof putContactsEntityIdCustomFields>>
>;

export type PutContactsEntityIdCustomFieldsMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutContactsEntityIdCustomFields = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putContactsEntityIdCustomFields>>,
    TError,
    { entityId: string },
    TContext
  >;
}) => {
  const mutationOptions = getPutContactsEntityIdCustomFieldsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putContactsEntityIdCustomFieldsExtend = (
  entityId: string,
  putContactsEntityIdCustomFieldsExtendBody: PutContactsEntityIdCustomFieldsExtendBody,
) => {
  return customHttpClient<PutContactsEntityIdCustomFieldsExtend200>({
    url: `/contacts/${entityId}/custom-fields/extend`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: putContactsEntityIdCustomFieldsExtendBody,
  });
};

export const getPutContactsEntityIdCustomFieldsExtendMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putContactsEntityIdCustomFieldsExtend>>,
    TError,
    { entityId: string; data: PutContactsEntityIdCustomFieldsExtendBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putContactsEntityIdCustomFieldsExtend>>,
  TError,
  { entityId: string; data: PutContactsEntityIdCustomFieldsExtendBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putContactsEntityIdCustomFieldsExtend>>,
    { entityId: string; data: PutContactsEntityIdCustomFieldsExtendBody }
  > = (props) => {
    const { entityId, data } = props ?? {};

    return putContactsEntityIdCustomFieldsExtend(entityId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutContactsEntityIdCustomFieldsExtendMutationResult = NonNullable<
  Awaited<ReturnType<typeof putContactsEntityIdCustomFieldsExtend>>
>;
export type PutContactsEntityIdCustomFieldsExtendMutationBody = PutContactsEntityIdCustomFieldsExtendBody;
export type PutContactsEntityIdCustomFieldsExtendMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutContactsEntityIdCustomFieldsExtend = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putContactsEntityIdCustomFieldsExtend>>,
    TError,
    { entityId: string; data: PutContactsEntityIdCustomFieldsExtendBody },
    TContext
  >;
}) => {
  const mutationOptions = getPutContactsEntityIdCustomFieldsExtendMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postContactsLists = () => {
  return customHttpClient<PostContactsLists200>({ url: `/contacts/lists`, method: 'POST' });
};

export const getPostContactsListsMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postContactsLists>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof postContactsLists>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postContactsLists>>, void> = () => {
    return postContactsLists();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostContactsListsMutationResult = NonNullable<Awaited<ReturnType<typeof postContactsLists>>>;

export type PostContactsListsMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostContactsLists = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postContactsLists>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPostContactsListsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getContactsLists = (signal?: AbortSignal) => {
  return customHttpClient<GetContactsLists200>({ url: `/contacts/lists`, method: 'GET', signal });
};

export const getGetContactsListsQueryKey = () => {
  return [`/contacts/lists`] as const;
};

export const getGetContactsListsQueryOptions = <
  TData = Awaited<ReturnType<typeof getContactsLists>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getContactsLists>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetContactsListsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getContactsLists>>> = ({ signal }) => getContactsLists(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getContactsLists>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetContactsListsQueryResult = NonNullable<Awaited<ReturnType<typeof getContactsLists>>>;
export type GetContactsListsQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetContactsLists = <
  TData = Awaited<ReturnType<typeof getContactsLists>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getContactsLists>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetContactsListsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postContactsListsEntityListIdCreateNewEntity = () => {
  return customHttpClient<PostContactsListsEntityListIdCreateNewEntity200>({
    url: `/contacts/lists/:entityListId/create-new-entity`,
    method: 'POST',
  });
};

export const getPostContactsListsEntityListIdCreateNewEntityMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postContactsListsEntityListIdCreateNewEntity>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postContactsListsEntityListIdCreateNewEntity>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postContactsListsEntityListIdCreateNewEntity>>,
    void
  > = () => {
    return postContactsListsEntityListIdCreateNewEntity();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostContactsListsEntityListIdCreateNewEntityMutationResult = NonNullable<
  Awaited<ReturnType<typeof postContactsListsEntityListIdCreateNewEntity>>
>;

export type PostContactsListsEntityListIdCreateNewEntityMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostContactsListsEntityListIdCreateNewEntity = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postContactsListsEntityListIdCreateNewEntity>>,
    TError,
    void,
    TContext
  >;
}) => {
  const mutationOptions = getPostContactsListsEntityListIdCreateNewEntityMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getContactsListsEntityListId = (signal?: AbortSignal) => {
  return customHttpClient<GetContactsListsEntityListId200>({
    url: `/contacts/lists/:entityListId`,
    method: 'GET',
    signal,
  });
};

export const getGetContactsListsEntityListIdQueryKey = () => {
  return [`/contacts/lists/:entityListId`] as const;
};

export const getGetContactsListsEntityListIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getContactsListsEntityListId>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getContactsListsEntityListId>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetContactsListsEntityListIdQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getContactsListsEntityListId>>> = ({ signal }) =>
    getContactsListsEntityListId(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getContactsListsEntityListId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetContactsListsEntityListIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getContactsListsEntityListId>>
>;
export type GetContactsListsEntityListIdQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetContactsListsEntityListId = <
  TData = Awaited<ReturnType<typeof getContactsListsEntityListId>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getContactsListsEntityListId>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetContactsListsEntityListIdQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const putContactsListsEntityListId = () => {
  return customHttpClient<PutContactsListsEntityListId200>({ url: `/contacts/lists/:entityListId`, method: 'PUT' });
};

export const getPutContactsListsEntityListIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putContactsListsEntityListId>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof putContactsListsEntityListId>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof putContactsListsEntityListId>>, void> = () => {
    return putContactsListsEntityListId();
  };

  return { mutationFn, ...mutationOptions };
};

export type PutContactsListsEntityListIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putContactsListsEntityListId>>
>;

export type PutContactsListsEntityListIdMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutContactsListsEntityListId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putContactsListsEntityListId>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPutContactsListsEntityListIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteContactsListsEntityListId = () => {
  return customHttpClient<DeleteContactsListsEntityListId200>({
    url: `/contacts/lists/:entityListId`,
    method: 'DELETE',
  });
};

export const getDeleteContactsListsEntityListIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof deleteContactsListsEntityListId>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof deleteContactsListsEntityListId>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteContactsListsEntityListId>>, void> = () => {
    return deleteContactsListsEntityListId();
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteContactsListsEntityListIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteContactsListsEntityListId>>
>;

export type DeleteContactsListsEntityListIdMutationError = Status400 | Status401 | Status403 | Status404;

export const useDeleteContactsListsEntityListId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof deleteContactsListsEntityListId>>, TError, void, TContext>;
}) => {
  const mutationOptions = getDeleteContactsListsEntityListIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getContactsListsEntityListIdContacts = (signal?: AbortSignal) => {
  return customHttpClient<GetContactsListsEntityListIdContacts200>({
    url: `/contacts/lists/:entityListId/contacts`,
    method: 'GET',
    signal,
  });
};

export const getGetContactsListsEntityListIdContactsQueryKey = () => {
  return [`/contacts/lists/:entityListId/contacts`] as const;
};

export const getGetContactsListsEntityListIdContactsQueryOptions = <
  TData = Awaited<ReturnType<typeof getContactsListsEntityListIdContacts>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getContactsListsEntityListIdContacts>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetContactsListsEntityListIdContactsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getContactsListsEntityListIdContacts>>> = ({ signal }) =>
    getContactsListsEntityListIdContacts(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getContactsListsEntityListIdContacts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetContactsListsEntityListIdContactsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getContactsListsEntityListIdContacts>>
>;
export type GetContactsListsEntityListIdContactsQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetContactsListsEntityListIdContacts = <
  TData = Awaited<ReturnType<typeof getContactsListsEntityListIdContacts>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getContactsListsEntityListIdContacts>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetContactsListsEntityListIdContactsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postContactsListsEntityListIdAdd = () => {
  return customHttpClient<PostContactsListsEntityListIdAdd200>({
    url: `/contacts/lists/:entityListId/add`,
    method: 'POST',
  });
};

export const getPostContactsListsEntityListIdAddMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postContactsListsEntityListIdAdd>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof postContactsListsEntityListIdAdd>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postContactsListsEntityListIdAdd>>, void> = () => {
    return postContactsListsEntityListIdAdd();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostContactsListsEntityListIdAddMutationResult = NonNullable<
  Awaited<ReturnType<typeof postContactsListsEntityListIdAdd>>
>;

export type PostContactsListsEntityListIdAddMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostContactsListsEntityListIdAdd = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postContactsListsEntityListIdAdd>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPostContactsListsEntityListIdAddMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postContactsListsEntityListIdRemove = () => {
  return customHttpClient<PostContactsListsEntityListIdRemove200>({
    url: `/contacts/lists/:entityListId/remove`,
    method: 'POST',
  });
};

export const getPostContactsListsEntityListIdRemoveMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postContactsListsEntityListIdRemove>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<typeof postContactsListsEntityListIdRemove>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postContactsListsEntityListIdRemove>>, void> = () => {
    return postContactsListsEntityListIdRemove();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostContactsListsEntityListIdRemoveMutationResult = NonNullable<
  Awaited<ReturnType<typeof postContactsListsEntityListIdRemove>>
>;

export type PostContactsListsEntityListIdRemoveMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostContactsListsEntityListIdRemove = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postContactsListsEntityListIdRemove>>,
    TError,
    void,
    TContext
  >;
}) => {
  const mutationOptions = getPostContactsListsEntityListIdRemoveMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postContactsListsEntityListIdReorder = () => {
  return customHttpClient<PostContactsListsEntityListIdReorder200>({
    url: `/contacts/lists/:entityListId/reorder`,
    method: 'POST',
  });
};

export const getPostContactsListsEntityListIdReorderMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postContactsListsEntityListIdReorder>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<typeof postContactsListsEntityListIdReorder>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postContactsListsEntityListIdReorder>>, void> = () => {
    return postContactsListsEntityListIdReorder();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostContactsListsEntityListIdReorderMutationResult = NonNullable<
  Awaited<ReturnType<typeof postContactsListsEntityListIdReorder>>
>;

export type PostContactsListsEntityListIdReorderMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostContactsListsEntityListIdReorder = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postContactsListsEntityListIdReorder>>,
    TError,
    void,
    TContext
  >;
}) => {
  const mutationOptions = getPostContactsListsEntityListIdReorderMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postContactsListsEntityListIdUserGroups = () => {
  return customHttpClient<PostContactsListsEntityListIdUserGroups200>({
    url: `/contacts/lists/:entityListId/user-groups`,
    method: 'POST',
  });
};

export const getPostContactsListsEntityListIdUserGroupsMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postContactsListsEntityListIdUserGroups>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<typeof postContactsListsEntityListIdUserGroups>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postContactsListsEntityListIdUserGroups>>,
    void
  > = () => {
    return postContactsListsEntityListIdUserGroups();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostContactsListsEntityListIdUserGroupsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postContactsListsEntityListIdUserGroups>>
>;

export type PostContactsListsEntityListIdUserGroupsMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostContactsListsEntityListIdUserGroups = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postContactsListsEntityListIdUserGroups>>,
    TError,
    void,
    TContext
  >;
}) => {
  const mutationOptions = getPostContactsListsEntityListIdUserGroupsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postContactsEntityIdLists = (entityId: string) => {
  return customHttpClient<PostContactsEntityIdLists200>({ url: `/contacts/${entityId}/lists`, method: 'POST' });
};

export const getPostContactsEntityIdListsMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postContactsEntityIdLists>>,
    TError,
    { entityId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postContactsEntityIdLists>>,
  TError,
  { entityId: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postContactsEntityIdLists>>, { entityId: string }> = (
    props,
  ) => {
    const { entityId } = props ?? {};

    return postContactsEntityIdLists(entityId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostContactsEntityIdListsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postContactsEntityIdLists>>
>;

export type PostContactsEntityIdListsMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostContactsEntityIdLists = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postContactsEntityIdLists>>,
    TError,
    { entityId: string },
    TContext
  >;
}) => {
  const mutationOptions = getPostContactsEntityIdListsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putContactsEntityIdNotesPanel = (entityId: string) => {
  return customHttpClient<PutContactsEntityIdNotesPanel200>({
    url: `/contacts/${entityId}/notes/panel`,
    method: 'PUT',
  });
};

export const getPutContactsEntityIdNotesPanelMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putContactsEntityIdNotesPanel>>,
    TError,
    { entityId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putContactsEntityIdNotesPanel>>,
  TError,
  { entityId: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putContactsEntityIdNotesPanel>>,
    { entityId: string }
  > = (props) => {
    const { entityId } = props ?? {};

    return putContactsEntityIdNotesPanel(entityId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutContactsEntityIdNotesPanelMutationResult = NonNullable<
  Awaited<ReturnType<typeof putContactsEntityIdNotesPanel>>
>;

export type PutContactsEntityIdNotesPanelMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutContactsEntityIdNotesPanel = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putContactsEntityIdNotesPanel>>,
    TError,
    { entityId: string },
    TContext
  >;
}) => {
  const mutationOptions = getPutContactsEntityIdNotesPanelMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteContactsEntityIdNotesPanel = (entityId: string) => {
  return customHttpClient<DeleteContactsEntityIdNotesPanel200>({
    url: `/contacts/${entityId}/notes/panel`,
    method: 'DELETE',
  });
};

export const getDeleteContactsEntityIdNotesPanelMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteContactsEntityIdNotesPanel>>,
    TError,
    { entityId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteContactsEntityIdNotesPanel>>,
  TError,
  { entityId: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteContactsEntityIdNotesPanel>>,
    { entityId: string }
  > = (props) => {
    const { entityId } = props ?? {};

    return deleteContactsEntityIdNotesPanel(entityId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteContactsEntityIdNotesPanelMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteContactsEntityIdNotesPanel>>
>;

export type DeleteContactsEntityIdNotesPanelMutationError = Status400 | Status401 | Status403 | Status404;

export const useDeleteContactsEntityIdNotesPanel = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteContactsEntityIdNotesPanel>>,
    TError,
    { entityId: string },
    TContext
  >;
}) => {
  const mutationOptions = getDeleteContactsEntityIdNotesPanelMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getContactsId = (signal?: AbortSignal) => {
  return customHttpClient<GetContactsId200>({ url: `/contacts/:id`, method: 'GET', signal });
};

export const getGetContactsIdQueryKey = () => {
  return [`/contacts/:id`] as const;
};

export const getGetContactsIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getContactsId>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getContactsId>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetContactsIdQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getContactsId>>> = ({ signal }) => getContactsId(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getContactsId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetContactsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getContactsId>>>;
export type GetContactsIdQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetContactsId = <
  TData = Awaited<ReturnType<typeof getContactsId>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getContactsId>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetContactsIdQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const putContactsId = () => {
  return customHttpClient<PutContactsId200>({ url: `/contacts/:id`, method: 'PUT' });
};

export const getPutContactsIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putContactsId>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof putContactsId>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof putContactsId>>, void> = () => {
    return putContactsId();
  };

  return { mutationFn, ...mutationOptions };
};

export type PutContactsIdMutationResult = NonNullable<Awaited<ReturnType<typeof putContactsId>>>;

export type PutContactsIdMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutContactsId = <TError = Status400 | Status401 | Status403 | Status404, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putContactsId>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPutContactsIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteContactsId = () => {
  return customHttpClient<DeleteContactsId200>({ url: `/contacts/:id`, method: 'DELETE' });
};

export const getDeleteContactsIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof deleteContactsId>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof deleteContactsId>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteContactsId>>, void> = () => {
    return deleteContactsId();
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteContactsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteContactsId>>>;

export type DeleteContactsIdMutationError = Status400 | Status401 | Status403 | Status404;

export const useDeleteContactsId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof deleteContactsId>>, TError, void, TContext>;
}) => {
  const mutationOptions = getDeleteContactsIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getContactsEditOptions = (signal?: AbortSignal) => {
  return customHttpClient<GetContactsEditOptions200>({ url: `/contacts/edit-options`, method: 'GET', signal });
};

export const getGetContactsEditOptionsQueryKey = () => {
  return [`/contacts/edit-options`] as const;
};

export const getGetContactsEditOptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getContactsEditOptions>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getContactsEditOptions>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetContactsEditOptionsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getContactsEditOptions>>> = ({ signal }) =>
    getContactsEditOptions(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getContactsEditOptions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetContactsEditOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getContactsEditOptions>>>;
export type GetContactsEditOptionsQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetContactsEditOptions = <
  TData = Awaited<ReturnType<typeof getContactsEditOptions>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getContactsEditOptions>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetContactsEditOptionsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getContactsFilterOptions = (signal?: AbortSignal) => {
  return customHttpClient<GetContactsFilterOptions200>({ url: `/contacts/filter-options`, method: 'GET', signal });
};

export const getGetContactsFilterOptionsQueryKey = () => {
  return [`/contacts/filter-options`] as const;
};

export const getGetContactsFilterOptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getContactsFilterOptions>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getContactsFilterOptions>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetContactsFilterOptionsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getContactsFilterOptions>>> = ({ signal }) =>
    getContactsFilterOptions(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getContactsFilterOptions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetContactsFilterOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getContactsFilterOptions>>>;
export type GetContactsFilterOptionsQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetContactsFilterOptions = <
  TData = Awaited<ReturnType<typeof getContactsFilterOptions>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getContactsFilterOptions>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetContactsFilterOptionsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postContacts = () => {
  return customHttpClient<PostContacts200>({ url: `/contacts`, method: 'POST' });
};

export const getPostContactsMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postContacts>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof postContacts>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postContacts>>, void> = () => {
    return postContacts();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostContactsMutationResult = NonNullable<Awaited<ReturnType<typeof postContacts>>>;

export type PostContactsMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostContacts = <TError = Status400 | Status401 | Status403 | Status404, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postContacts>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPostContactsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getContacts = (signal?: AbortSignal) => {
  return customHttpClient<GetContacts200>({ url: `/contacts`, method: 'GET', signal });
};

export const getGetContactsQueryKey = () => {
  return [`/contacts`] as const;
};

export const getGetContactsQueryOptions = <
  TData = Awaited<ReturnType<typeof getContacts>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getContacts>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetContactsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getContacts>>> = ({ signal }) => getContacts(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getContacts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetContactsQueryResult = NonNullable<Awaited<ReturnType<typeof getContacts>>>;
export type GetContactsQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetContacts = <
  TData = Awaited<ReturnType<typeof getContacts>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getContacts>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetContactsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postContactsSearch = () => {
  return customHttpClient<PostContactsSearch200>({ url: `/contacts/search`, method: 'POST' });
};

export const getPostContactsSearchMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postContactsSearch>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof postContactsSearch>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postContactsSearch>>, void> = () => {
    return postContactsSearch();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostContactsSearchMutationResult = NonNullable<Awaited<ReturnType<typeof postContactsSearch>>>;

export type PostContactsSearchMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostContactsSearch = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postContactsSearch>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPostContactsSearchMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postContactsIdForget = () => {
  return customHttpClient<PostContactsIdForget200>({ url: `/contacts/:id/forget`, method: 'POST' });
};

export const getPostContactsIdForgetMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postContactsIdForget>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof postContactsIdForget>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postContactsIdForget>>, void> = () => {
    return postContactsIdForget();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostContactsIdForgetMutationResult = NonNullable<Awaited<ReturnType<typeof postContactsIdForget>>>;

export type PostContactsIdForgetMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostContactsIdForget = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postContactsIdForget>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPostContactsIdForgetMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postContactsIdForgetReactivate = () => {
  return customHttpClient<PostContactsIdForgetReactivate200>({
    url: `/contacts/:id/forget-reactivate`,
    method: 'POST',
  });
};

export const getPostContactsIdForgetReactivateMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postContactsIdForgetReactivate>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof postContactsIdForgetReactivate>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postContactsIdForgetReactivate>>, void> = () => {
    return postContactsIdForgetReactivate();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostContactsIdForgetReactivateMutationResult = NonNullable<
  Awaited<ReturnType<typeof postContactsIdForgetReactivate>>
>;

export type PostContactsIdForgetReactivateMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostContactsIdForgetReactivate = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postContactsIdForgetReactivate>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPostContactsIdForgetReactivateMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postContactsIdInterimAvailability = () => {
  return customHttpClient<PostContactsIdInterimAvailability200>({
    url: `/contacts/:id/interim-availability`,
    method: 'POST',
  });
};

export const getPostContactsIdInterimAvailabilityMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postContactsIdInterimAvailability>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof postContactsIdInterimAvailability>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postContactsIdInterimAvailability>>, void> = () => {
    return postContactsIdInterimAvailability();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostContactsIdInterimAvailabilityMutationResult = NonNullable<
  Awaited<ReturnType<typeof postContactsIdInterimAvailability>>
>;

export type PostContactsIdInterimAvailabilityMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostContactsIdInterimAvailability = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postContactsIdInterimAvailability>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPostContactsIdInterimAvailabilityMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postContactsUserIdDeactivate = () => {
  return customHttpClient<PostContactsUserIdDeactivate200>({ url: `/contacts/:userId/deactivate`, method: 'POST' });
};

export const getPostContactsUserIdDeactivateMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postContactsUserIdDeactivate>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof postContactsUserIdDeactivate>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postContactsUserIdDeactivate>>, void> = () => {
    return postContactsUserIdDeactivate();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostContactsUserIdDeactivateMutationResult = NonNullable<
  Awaited<ReturnType<typeof postContactsUserIdDeactivate>>
>;

export type PostContactsUserIdDeactivateMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostContactsUserIdDeactivate = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postContactsUserIdDeactivate>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPostContactsUserIdDeactivateMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postContactsUserIdReactivate = () => {
  return customHttpClient<PostContactsUserIdReactivate200>({ url: `/contacts/:userId/reactivate`, method: 'POST' });
};

export const getPostContactsUserIdReactivateMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postContactsUserIdReactivate>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof postContactsUserIdReactivate>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postContactsUserIdReactivate>>, void> = () => {
    return postContactsUserIdReactivate();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostContactsUserIdReactivateMutationResult = NonNullable<
  Awaited<ReturnType<typeof postContactsUserIdReactivate>>
>;

export type PostContactsUserIdReactivateMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostContactsUserIdReactivate = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postContactsUserIdReactivate>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPostContactsUserIdReactivateMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postContactsResumeSend = (postContactsResumeSendBody: PostContactsResumeSendBody) => {
  return customHttpClient<PostContactsResumeSend200>({
    url: `/contacts/resume/send`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postContactsResumeSendBody,
  });
};

export const getPostContactsResumeSendMutationOptions = <TError = Status400 | Status401, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postContactsResumeSend>>,
    TError,
    { data: PostContactsResumeSendBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postContactsResumeSend>>,
  TError,
  { data: PostContactsResumeSendBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postContactsResumeSend>>,
    { data: PostContactsResumeSendBody }
  > = (props) => {
    const { data } = props ?? {};

    return postContactsResumeSend(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostContactsResumeSendMutationResult = NonNullable<Awaited<ReturnType<typeof postContactsResumeSend>>>;
export type PostContactsResumeSendMutationBody = PostContactsResumeSendBody;
export type PostContactsResumeSendMutationError = Status400 | Status401;

export const usePostContactsResumeSend = <TError = Status400 | Status401, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postContactsResumeSend>>,
    TError,
    { data: PostContactsResumeSendBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostContactsResumeSendMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get an email template
 */
export const getEmailsTemplatesEmailTemplateId = (emailTemplateId: number, signal?: AbortSignal) => {
  return customHttpClient<GetEmailsTemplatesEmailTemplateId200>({
    url: `/emails/templates/${emailTemplateId}`,
    method: 'GET',
    signal,
  });
};

export const getGetEmailsTemplatesEmailTemplateIdQueryKey = (emailTemplateId: number) => {
  return [`/emails/templates/${emailTemplateId}`] as const;
};

export const getGetEmailsTemplatesEmailTemplateIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getEmailsTemplatesEmailTemplateId>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  emailTemplateId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getEmailsTemplatesEmailTemplateId>>, TError, TData> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEmailsTemplatesEmailTemplateIdQueryKey(emailTemplateId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmailsTemplatesEmailTemplateId>>> = ({ signal }) =>
    getEmailsTemplatesEmailTemplateId(emailTemplateId, signal);

  return { queryKey, queryFn, enabled: !!emailTemplateId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEmailsTemplatesEmailTemplateId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEmailsTemplatesEmailTemplateIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEmailsTemplatesEmailTemplateId>>
>;
export type GetEmailsTemplatesEmailTemplateIdQueryError = Status400 | Status401 | Status403 | Status404;

/**
 * @summary Get an email template
 */
export const useGetEmailsTemplatesEmailTemplateId = <
  TData = Awaited<ReturnType<typeof getEmailsTemplatesEmailTemplateId>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  emailTemplateId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getEmailsTemplatesEmailTemplateId>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetEmailsTemplatesEmailTemplateIdQueryOptions(emailTemplateId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Update an email template
 */
export const putEmailsTemplatesEmailTemplateId = (
  emailTemplateId: number,
  putEmailsTemplatesEmailTemplateIdBody: PutEmailsTemplatesEmailTemplateIdBody,
) => {
  return customHttpClient<PutEmailsTemplatesEmailTemplateId200>({
    url: `/emails/templates/${emailTemplateId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: putEmailsTemplatesEmailTemplateIdBody,
  });
};

export const getPutEmailsTemplatesEmailTemplateIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putEmailsTemplatesEmailTemplateId>>,
    TError,
    { emailTemplateId: number; data: PutEmailsTemplatesEmailTemplateIdBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putEmailsTemplatesEmailTemplateId>>,
  TError,
  { emailTemplateId: number; data: PutEmailsTemplatesEmailTemplateIdBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putEmailsTemplatesEmailTemplateId>>,
    { emailTemplateId: number; data: PutEmailsTemplatesEmailTemplateIdBody }
  > = (props) => {
    const { emailTemplateId, data } = props ?? {};

    return putEmailsTemplatesEmailTemplateId(emailTemplateId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutEmailsTemplatesEmailTemplateIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putEmailsTemplatesEmailTemplateId>>
>;
export type PutEmailsTemplatesEmailTemplateIdMutationBody = PutEmailsTemplatesEmailTemplateIdBody;
export type PutEmailsTemplatesEmailTemplateIdMutationError = Status400 | Status401 | Status403 | Status404;

/**
 * @summary Update an email template
 */
export const usePutEmailsTemplatesEmailTemplateId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putEmailsTemplatesEmailTemplateId>>,
    TError,
    { emailTemplateId: number; data: PutEmailsTemplatesEmailTemplateIdBody },
    TContext
  >;
}) => {
  const mutationOptions = getPutEmailsTemplatesEmailTemplateIdMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Delete an email template
 */
export const deleteEmailsTemplatesEmailTemplateId = (emailTemplateId: number) => {
  return customHttpClient<DeleteEmailsTemplatesEmailTemplateId200>({
    url: `/emails/templates/${emailTemplateId}`,
    method: 'DELETE',
  });
};

export const getDeleteEmailsTemplatesEmailTemplateIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteEmailsTemplatesEmailTemplateId>>,
    TError,
    { emailTemplateId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteEmailsTemplatesEmailTemplateId>>,
  TError,
  { emailTemplateId: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteEmailsTemplatesEmailTemplateId>>,
    { emailTemplateId: number }
  > = (props) => {
    const { emailTemplateId } = props ?? {};

    return deleteEmailsTemplatesEmailTemplateId(emailTemplateId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteEmailsTemplatesEmailTemplateIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteEmailsTemplatesEmailTemplateId>>
>;

export type DeleteEmailsTemplatesEmailTemplateIdMutationError = Status400 | Status401 | Status403 | Status404;

/**
 * @summary Delete an email template
 */
export const useDeleteEmailsTemplatesEmailTemplateId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteEmailsTemplatesEmailTemplateId>>,
    TError,
    { emailTemplateId: number },
    TContext
  >;
}) => {
  const mutationOptions = getDeleteEmailsTemplatesEmailTemplateIdMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Clone an email template
 */
export const postEmailsTemplatesEmailTemplateIdClone = (emailTemplateId: number) => {
  return customHttpClient<PostEmailsTemplatesEmailTemplateIdClone200>({
    url: `/emails/templates/${emailTemplateId}/clone`,
    method: 'POST',
  });
};

export const getPostEmailsTemplatesEmailTemplateIdCloneMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postEmailsTemplatesEmailTemplateIdClone>>,
    TError,
    { emailTemplateId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postEmailsTemplatesEmailTemplateIdClone>>,
  TError,
  { emailTemplateId: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postEmailsTemplatesEmailTemplateIdClone>>,
    { emailTemplateId: number }
  > = (props) => {
    const { emailTemplateId } = props ?? {};

    return postEmailsTemplatesEmailTemplateIdClone(emailTemplateId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostEmailsTemplatesEmailTemplateIdCloneMutationResult = NonNullable<
  Awaited<ReturnType<typeof postEmailsTemplatesEmailTemplateIdClone>>
>;

export type PostEmailsTemplatesEmailTemplateIdCloneMutationError = Status400 | Status401 | Status403 | Status404;

/**
 * @summary Clone an email template
 */
export const usePostEmailsTemplatesEmailTemplateIdClone = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postEmailsTemplatesEmailTemplateIdClone>>,
    TError,
    { emailTemplateId: number },
    TContext
  >;
}) => {
  const mutationOptions = getPostEmailsTemplatesEmailTemplateIdCloneMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Search email templates
 */
export const postEmailsTemplatesSearch = (postEmailsTemplatesSearchBody: PostEmailsTemplatesSearchBody) => {
  return customHttpClient<PostEmailsTemplatesSearch200>({
    url: `/emails/templates/search`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postEmailsTemplatesSearchBody,
  });
};

export const getPostEmailsTemplatesSearchMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postEmailsTemplatesSearch>>,
    TError,
    { data: PostEmailsTemplatesSearchBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postEmailsTemplatesSearch>>,
  TError,
  { data: PostEmailsTemplatesSearchBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postEmailsTemplatesSearch>>,
    { data: PostEmailsTemplatesSearchBody }
  > = (props) => {
    const { data } = props ?? {};

    return postEmailsTemplatesSearch(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostEmailsTemplatesSearchMutationResult = NonNullable<
  Awaited<ReturnType<typeof postEmailsTemplatesSearch>>
>;
export type PostEmailsTemplatesSearchMutationBody = PostEmailsTemplatesSearchBody;
export type PostEmailsTemplatesSearchMutationError = Status400 | Status401 | Status403 | Status404;

/**
 * @summary Search email templates
 */
export const usePostEmailsTemplatesSearch = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postEmailsTemplatesSearch>>,
    TError,
    { data: PostEmailsTemplatesSearchBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostEmailsTemplatesSearchMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Create an email template
 */
export const postEmailsTemplates = (postEmailsTemplatesBody: PostEmailsTemplatesBody) => {
  return customHttpClient<PostEmailsTemplates200>({
    url: `/emails/templates`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postEmailsTemplatesBody,
  });
};

export const getPostEmailsTemplatesMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postEmailsTemplates>>,
    TError,
    { data: PostEmailsTemplatesBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postEmailsTemplates>>,
  TError,
  { data: PostEmailsTemplatesBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postEmailsTemplates>>,
    { data: PostEmailsTemplatesBody }
  > = (props) => {
    const { data } = props ?? {};

    return postEmailsTemplates(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostEmailsTemplatesMutationResult = NonNullable<Awaited<ReturnType<typeof postEmailsTemplates>>>;
export type PostEmailsTemplatesMutationBody = PostEmailsTemplatesBody;
export type PostEmailsTemplatesMutationError = Status400 | Status401 | Status403 | Status404;

/**
 * @summary Create an email template
 */
export const usePostEmailsTemplates = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postEmailsTemplates>>,
    TError,
    { data: PostEmailsTemplatesBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostEmailsTemplatesMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getEmploymentTypes = (signal?: AbortSignal) => {
  return customHttpClient<GetEmploymentTypes200>({ url: `/employment-types`, method: 'GET', signal });
};

export const getGetEmploymentTypesQueryKey = () => {
  return [`/employment-types`] as const;
};

export const getGetEmploymentTypesQueryOptions = <
  TData = Awaited<ReturnType<typeof getEmploymentTypes>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getEmploymentTypes>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEmploymentTypesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmploymentTypes>>> = ({ signal }) =>
    getEmploymentTypes(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEmploymentTypes>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEmploymentTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getEmploymentTypes>>>;
export type GetEmploymentTypesQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetEmploymentTypes = <
  TData = Awaited<ReturnType<typeof getEmploymentTypes>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getEmploymentTypes>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetEmploymentTypesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const putEmploymentTypesEmploymentTypeId = () => {
  return customHttpClient<PutEmploymentTypesEmploymentTypeId200>({
    url: `/employment-types/:employmentTypeId`,
    method: 'PUT',
  });
};

export const getPutEmploymentTypesEmploymentTypeIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putEmploymentTypesEmploymentTypeId>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof putEmploymentTypesEmploymentTypeId>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof putEmploymentTypesEmploymentTypeId>>, void> = () => {
    return putEmploymentTypesEmploymentTypeId();
  };

  return { mutationFn, ...mutationOptions };
};

export type PutEmploymentTypesEmploymentTypeIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putEmploymentTypesEmploymentTypeId>>
>;

export type PutEmploymentTypesEmploymentTypeIdMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutEmploymentTypesEmploymentTypeId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putEmploymentTypesEmploymentTypeId>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPutEmploymentTypesEmploymentTypeIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postEmploymentTypesEmploymentTypeIdDeactivate = () => {
  return customHttpClient<PostEmploymentTypesEmploymentTypeIdDeactivate200>({
    url: `/employment-types/:employmentTypeId/deactivate`,
    method: 'POST',
  });
};

export const getPostEmploymentTypesEmploymentTypeIdDeactivateMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postEmploymentTypesEmploymentTypeIdDeactivate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postEmploymentTypesEmploymentTypeIdDeactivate>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postEmploymentTypesEmploymentTypeIdDeactivate>>,
    void
  > = () => {
    return postEmploymentTypesEmploymentTypeIdDeactivate();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostEmploymentTypesEmploymentTypeIdDeactivateMutationResult = NonNullable<
  Awaited<ReturnType<typeof postEmploymentTypesEmploymentTypeIdDeactivate>>
>;

export type PostEmploymentTypesEmploymentTypeIdDeactivateMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostEmploymentTypesEmploymentTypeIdDeactivate = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postEmploymentTypesEmploymentTypeIdDeactivate>>,
    TError,
    void,
    TContext
  >;
}) => {
  const mutationOptions = getPostEmploymentTypesEmploymentTypeIdDeactivateMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postEmploymentTypesEmploymentTypeIdActivate = () => {
  return customHttpClient<PostEmploymentTypesEmploymentTypeIdActivate200>({
    url: `/employment-types/:employmentTypeId/activate`,
    method: 'POST',
  });
};

export const getPostEmploymentTypesEmploymentTypeIdActivateMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postEmploymentTypesEmploymentTypeIdActivate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postEmploymentTypesEmploymentTypeIdActivate>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postEmploymentTypesEmploymentTypeIdActivate>>,
    void
  > = () => {
    return postEmploymentTypesEmploymentTypeIdActivate();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostEmploymentTypesEmploymentTypeIdActivateMutationResult = NonNullable<
  Awaited<ReturnType<typeof postEmploymentTypesEmploymentTypeIdActivate>>
>;

export type PostEmploymentTypesEmploymentTypeIdActivateMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostEmploymentTypesEmploymentTypeIdActivate = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postEmploymentTypesEmploymentTypeIdActivate>>,
    TError,
    void,
    TContext
  >;
}) => {
  const mutationOptions = getPostEmploymentTypesEmploymentTypeIdActivateMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postEntityGroups = () => {
  return customHttpClient<PostEntityGroups200>({ url: `/entity-groups`, method: 'POST' });
};

export const getPostEntityGroupsMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postEntityGroups>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof postEntityGroups>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEntityGroups>>, void> = () => {
    return postEntityGroups();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostEntityGroupsMutationResult = NonNullable<Awaited<ReturnType<typeof postEntityGroups>>>;

export type PostEntityGroupsMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostEntityGroups = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postEntityGroups>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPostEntityGroupsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getEntityGroups = (signal?: AbortSignal) => {
  return customHttpClient<GetEntityGroups200>({ url: `/entity-groups`, method: 'GET', signal });
};

export const getGetEntityGroupsQueryKey = () => {
  return [`/entity-groups`] as const;
};

export const getGetEntityGroupsQueryOptions = <
  TData = Awaited<ReturnType<typeof getEntityGroups>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getEntityGroups>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEntityGroupsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEntityGroups>>> = ({ signal }) => getEntityGroups(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEntityGroups>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEntityGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof getEntityGroups>>>;
export type GetEntityGroupsQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetEntityGroups = <
  TData = Awaited<ReturnType<typeof getEntityGroups>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getEntityGroups>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetEntityGroupsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const putEntityGroupsEntityGroupId = () => {
  return customHttpClient<PutEntityGroupsEntityGroupId200>({ url: `/entity-groups/:entityGroupId`, method: 'PUT' });
};

export const getPutEntityGroupsEntityGroupIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putEntityGroupsEntityGroupId>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof putEntityGroupsEntityGroupId>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof putEntityGroupsEntityGroupId>>, void> = () => {
    return putEntityGroupsEntityGroupId();
  };

  return { mutationFn, ...mutationOptions };
};

export type PutEntityGroupsEntityGroupIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putEntityGroupsEntityGroupId>>
>;

export type PutEntityGroupsEntityGroupIdMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutEntityGroupsEntityGroupId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putEntityGroupsEntityGroupId>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPutEntityGroupsEntityGroupIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteEntityGroupsEntityGroupId = () => {
  return customHttpClient<DeleteEntityGroupsEntityGroupId200>({
    url: `/entity-groups/:entityGroupId`,
    method: 'DELETE',
  });
};

export const getDeleteEntityGroupsEntityGroupIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof deleteEntityGroupsEntityGroupId>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof deleteEntityGroupsEntityGroupId>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEntityGroupsEntityGroupId>>, void> = () => {
    return deleteEntityGroupsEntityGroupId();
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteEntityGroupsEntityGroupIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteEntityGroupsEntityGroupId>>
>;

export type DeleteEntityGroupsEntityGroupIdMutationError = Status400 | Status401 | Status403 | Status404;

export const useDeleteEntityGroupsEntityGroupId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof deleteEntityGroupsEntityGroupId>>, TError, void, TContext>;
}) => {
  const mutationOptions = getDeleteEntityGroupsEntityGroupIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postEntityGroupsEntityGroupIdChildren = (
  entityGroupId: number,
  postEntityGroupsEntityGroupIdChildrenBody: PostEntityGroupsEntityGroupIdChildrenBody,
) => {
  return customHttpClient<PostEntityGroupsEntityGroupIdChildren200>({
    url: `/entity-groups/${entityGroupId}/children`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postEntityGroupsEntityGroupIdChildrenBody,
  });
};

export const getPostEntityGroupsEntityGroupIdChildrenMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postEntityGroupsEntityGroupIdChildren>>,
    TError,
    { entityGroupId: number; data: PostEntityGroupsEntityGroupIdChildrenBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postEntityGroupsEntityGroupIdChildren>>,
  TError,
  { entityGroupId: number; data: PostEntityGroupsEntityGroupIdChildrenBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postEntityGroupsEntityGroupIdChildren>>,
    { entityGroupId: number; data: PostEntityGroupsEntityGroupIdChildrenBody }
  > = (props) => {
    const { entityGroupId, data } = props ?? {};

    return postEntityGroupsEntityGroupIdChildren(entityGroupId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostEntityGroupsEntityGroupIdChildrenMutationResult = NonNullable<
  Awaited<ReturnType<typeof postEntityGroupsEntityGroupIdChildren>>
>;
export type PostEntityGroupsEntityGroupIdChildrenMutationBody = PostEntityGroupsEntityGroupIdChildrenBody;
export type PostEntityGroupsEntityGroupIdChildrenMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostEntityGroupsEntityGroupIdChildren = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postEntityGroupsEntityGroupIdChildren>>,
    TError,
    { entityGroupId: number; data: PostEntityGroupsEntityGroupIdChildrenBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostEntityGroupsEntityGroupIdChildrenMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getEvaVisualisationsVisualisationId = (signal?: AbortSignal) => {
  return customHttpClient<GetEvaVisualisationsVisualisationId200>({
    url: `/eva/visualisations/:visualisationId`,
    method: 'GET',
    signal,
  });
};

export const getGetEvaVisualisationsVisualisationIdQueryKey = () => {
  return [`/eva/visualisations/:visualisationId`] as const;
};

export const getGetEvaVisualisationsVisualisationIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getEvaVisualisationsVisualisationId>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getEvaVisualisationsVisualisationId>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEvaVisualisationsVisualisationIdQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEvaVisualisationsVisualisationId>>> = ({ signal }) =>
    getEvaVisualisationsVisualisationId(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEvaVisualisationsVisualisationId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEvaVisualisationsVisualisationIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEvaVisualisationsVisualisationId>>
>;
export type GetEvaVisualisationsVisualisationIdQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetEvaVisualisationsVisualisationId = <
  TData = Awaited<ReturnType<typeof getEvaVisualisationsVisualisationId>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getEvaVisualisationsVisualisationId>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetEvaVisualisationsVisualisationIdQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getEvaVisualisations = (signal?: AbortSignal) => {
  return customHttpClient<GetEvaVisualisations200>({ url: `/eva/visualisations/`, method: 'GET', signal });
};

export const getGetEvaVisualisationsQueryKey = () => {
  return [`/eva/visualisations/`] as const;
};

export const getGetEvaVisualisationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getEvaVisualisations>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getEvaVisualisations>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEvaVisualisationsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEvaVisualisations>>> = ({ signal }) =>
    getEvaVisualisations(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEvaVisualisations>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEvaVisualisationsQueryResult = NonNullable<Awaited<ReturnType<typeof getEvaVisualisations>>>;
export type GetEvaVisualisationsQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetEvaVisualisations = <
  TData = Awaited<ReturnType<typeof getEvaVisualisations>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getEvaVisualisations>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetEvaVisualisationsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getEvaSkills = (signal?: AbortSignal) => {
  return customHttpClient<GetEvaSkills200>({ url: `/eva/skills/`, method: 'GET', signal });
};

export const getGetEvaSkillsQueryKey = () => {
  return [`/eva/skills/`] as const;
};

export const getGetEvaSkillsQueryOptions = <
  TData = Awaited<ReturnType<typeof getEvaSkills>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getEvaSkills>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEvaSkillsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEvaSkills>>> = ({ signal }) => getEvaSkills(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEvaSkills>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEvaSkillsQueryResult = NonNullable<Awaited<ReturnType<typeof getEvaSkills>>>;
export type GetEvaSkillsQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetEvaSkills = <
  TData = Awaited<ReturnType<typeof getEvaSkills>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getEvaSkills>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetEvaSkillsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getEvaSkillsCode = (signal?: AbortSignal) => {
  return customHttpClient<GetEvaSkillsCode200>({ url: `/eva/skills/:code`, method: 'GET', signal });
};

export const getGetEvaSkillsCodeQueryKey = () => {
  return [`/eva/skills/:code`] as const;
};

export const getGetEvaSkillsCodeQueryOptions = <
  TData = Awaited<ReturnType<typeof getEvaSkillsCode>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getEvaSkillsCode>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEvaSkillsCodeQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEvaSkillsCode>>> = ({ signal }) => getEvaSkillsCode(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEvaSkillsCode>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEvaSkillsCodeQueryResult = NonNullable<Awaited<ReturnType<typeof getEvaSkillsCode>>>;
export type GetEvaSkillsCodeQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetEvaSkillsCode = <
  TData = Awaited<ReturnType<typeof getEvaSkillsCode>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getEvaSkillsCode>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetEvaSkillsCodeQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postEvaSkillsCodeToneOfVoiceIntent = () => {
  return customHttpClient<PostEvaSkillsCodeToneOfVoiceIntent200>({
    url: `/eva/skills/:code/tone-of-voice/:intent`,
    method: 'POST',
  });
};

export const getPostEvaSkillsCodeToneOfVoiceIntentMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postEvaSkillsCodeToneOfVoiceIntent>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof postEvaSkillsCodeToneOfVoiceIntent>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEvaSkillsCodeToneOfVoiceIntent>>, void> = () => {
    return postEvaSkillsCodeToneOfVoiceIntent();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostEvaSkillsCodeToneOfVoiceIntentMutationResult = NonNullable<
  Awaited<ReturnType<typeof postEvaSkillsCodeToneOfVoiceIntent>>
>;

export type PostEvaSkillsCodeToneOfVoiceIntentMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostEvaSkillsCodeToneOfVoiceIntent = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postEvaSkillsCodeToneOfVoiceIntent>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPostEvaSkillsCodeToneOfVoiceIntentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteEvaSkillsCodeToneOfVoiceIntent = () => {
  return customHttpClient<DeleteEvaSkillsCodeToneOfVoiceIntent200>({
    url: `/eva/skills/:code/tone-of-voice/:intent`,
    method: 'DELETE',
  });
};

export const getDeleteEvaSkillsCodeToneOfVoiceIntentMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteEvaSkillsCodeToneOfVoiceIntent>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<typeof deleteEvaSkillsCodeToneOfVoiceIntent>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEvaSkillsCodeToneOfVoiceIntent>>, void> = () => {
    return deleteEvaSkillsCodeToneOfVoiceIntent();
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteEvaSkillsCodeToneOfVoiceIntentMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteEvaSkillsCodeToneOfVoiceIntent>>
>;

export type DeleteEvaSkillsCodeToneOfVoiceIntentMutationError = Status400 | Status401 | Status403 | Status404;

export const useDeleteEvaSkillsCodeToneOfVoiceIntent = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteEvaSkillsCodeToneOfVoiceIntent>>,
    TError,
    void,
    TContext
  >;
}) => {
  const mutationOptions = getDeleteEvaSkillsCodeToneOfVoiceIntentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getEvaOnboardingEditOptions = (signal?: AbortSignal) => {
  return customHttpClient<GetEvaOnboardingEditOptions200>({
    url: `/eva/onboarding/edit-options`,
    method: 'GET',
    signal,
  });
};

export const getGetEvaOnboardingEditOptionsQueryKey = () => {
  return [`/eva/onboarding/edit-options`] as const;
};

export const getGetEvaOnboardingEditOptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getEvaOnboardingEditOptions>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getEvaOnboardingEditOptions>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEvaOnboardingEditOptionsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEvaOnboardingEditOptions>>> = ({ signal }) =>
    getEvaOnboardingEditOptions(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEvaOnboardingEditOptions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEvaOnboardingEditOptionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEvaOnboardingEditOptions>>
>;
export type GetEvaOnboardingEditOptionsQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetEvaOnboardingEditOptions = <
  TData = Awaited<ReturnType<typeof getEvaOnboardingEditOptions>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getEvaOnboardingEditOptions>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetEvaOnboardingEditOptionsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getEvaOnboarding = (signal?: AbortSignal) => {
  return customHttpClient<GetEvaOnboarding200>({ url: `/eva/onboarding`, method: 'GET', signal });
};

export const getGetEvaOnboardingQueryKey = () => {
  return [`/eva/onboarding`] as const;
};

export const getGetEvaOnboardingQueryOptions = <
  TData = Awaited<ReturnType<typeof getEvaOnboarding>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getEvaOnboarding>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEvaOnboardingQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEvaOnboarding>>> = ({ signal }) => getEvaOnboarding(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEvaOnboarding>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEvaOnboardingQueryResult = NonNullable<Awaited<ReturnType<typeof getEvaOnboarding>>>;
export type GetEvaOnboardingQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetEvaOnboarding = <
  TData = Awaited<ReturnType<typeof getEvaOnboarding>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getEvaOnboarding>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetEvaOnboardingQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const putEvaOnboarding = () => {
  return customHttpClient<PutEvaOnboarding200>({ url: `/eva/onboarding`, method: 'PUT' });
};

export const getPutEvaOnboardingMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putEvaOnboarding>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof putEvaOnboarding>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof putEvaOnboarding>>, void> = () => {
    return putEvaOnboarding();
  };

  return { mutationFn, ...mutationOptions };
};

export type PutEvaOnboardingMutationResult = NonNullable<Awaited<ReturnType<typeof putEvaOnboarding>>>;

export type PutEvaOnboardingMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutEvaOnboarding = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putEvaOnboarding>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPutEvaOnboardingMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getEvaBotCampaignsEvaBotCampaignId = (signal?: AbortSignal) => {
  return customHttpClient<GetEvaBotCampaignsEvaBotCampaignId200>({
    url: `/eva-bot-campaigns/:evaBotCampaignId`,
    method: 'GET',
    signal,
  });
};

export const getGetEvaBotCampaignsEvaBotCampaignIdQueryKey = () => {
  return [`/eva-bot-campaigns/:evaBotCampaignId`] as const;
};

export const getGetEvaBotCampaignsEvaBotCampaignIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getEvaBotCampaignsEvaBotCampaignId>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getEvaBotCampaignsEvaBotCampaignId>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEvaBotCampaignsEvaBotCampaignIdQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEvaBotCampaignsEvaBotCampaignId>>> = ({ signal }) =>
    getEvaBotCampaignsEvaBotCampaignId(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEvaBotCampaignsEvaBotCampaignId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEvaBotCampaignsEvaBotCampaignIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEvaBotCampaignsEvaBotCampaignId>>
>;
export type GetEvaBotCampaignsEvaBotCampaignIdQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetEvaBotCampaignsEvaBotCampaignId = <
  TData = Awaited<ReturnType<typeof getEvaBotCampaignsEvaBotCampaignId>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getEvaBotCampaignsEvaBotCampaignId>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetEvaBotCampaignsEvaBotCampaignIdQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postEvaBotCampaignsEvaBotCampaignIdCandidatesSearch = () => {
  return customHttpClient<PostEvaBotCampaignsEvaBotCampaignIdCandidatesSearch200>({
    url: `/eva-bot-campaigns/:evaBotCampaignId/candidates/search`,
    method: 'POST',
  });
};

export const getPostEvaBotCampaignsEvaBotCampaignIdCandidatesSearchMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postEvaBotCampaignsEvaBotCampaignIdCandidatesSearch>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postEvaBotCampaignsEvaBotCampaignIdCandidatesSearch>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postEvaBotCampaignsEvaBotCampaignIdCandidatesSearch>>,
    void
  > = () => {
    return postEvaBotCampaignsEvaBotCampaignIdCandidatesSearch();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostEvaBotCampaignsEvaBotCampaignIdCandidatesSearchMutationResult = NonNullable<
  Awaited<ReturnType<typeof postEvaBotCampaignsEvaBotCampaignIdCandidatesSearch>>
>;

export type PostEvaBotCampaignsEvaBotCampaignIdCandidatesSearchMutationError =
  | Status400
  | Status401
  | Status403
  | Status404;

export const usePostEvaBotCampaignsEvaBotCampaignIdCandidatesSearch = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postEvaBotCampaignsEvaBotCampaignIdCandidatesSearch>>,
    TError,
    void,
    TContext
  >;
}) => {
  const mutationOptions = getPostEvaBotCampaignsEvaBotCampaignIdCandidatesSearchMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getEvaBotCampaignsEvaBotCampaignIdVisualisation = (signal?: AbortSignal) => {
  return customHttpClient<GetEvaBotCampaignsEvaBotCampaignIdVisualisation200>({
    url: `/eva-bot-campaigns/:evaBotCampaignId/visualisation`,
    method: 'GET',
    signal,
  });
};

export const getGetEvaBotCampaignsEvaBotCampaignIdVisualisationQueryKey = () => {
  return [`/eva-bot-campaigns/:evaBotCampaignId/visualisation`] as const;
};

export const getGetEvaBotCampaignsEvaBotCampaignIdVisualisationQueryOptions = <
  TData = Awaited<ReturnType<typeof getEvaBotCampaignsEvaBotCampaignIdVisualisation>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getEvaBotCampaignsEvaBotCampaignIdVisualisation>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEvaBotCampaignsEvaBotCampaignIdVisualisationQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEvaBotCampaignsEvaBotCampaignIdVisualisation>>> = ({
    signal,
  }) => getEvaBotCampaignsEvaBotCampaignIdVisualisation(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEvaBotCampaignsEvaBotCampaignIdVisualisation>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEvaBotCampaignsEvaBotCampaignIdVisualisationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEvaBotCampaignsEvaBotCampaignIdVisualisation>>
>;
export type GetEvaBotCampaignsEvaBotCampaignIdVisualisationQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetEvaBotCampaignsEvaBotCampaignIdVisualisation = <
  TData = Awaited<ReturnType<typeof getEvaBotCampaignsEvaBotCampaignIdVisualisation>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getEvaBotCampaignsEvaBotCampaignIdVisualisation>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetEvaBotCampaignsEvaBotCampaignIdVisualisationQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getEntityLists = (params?: GetEntityListsParams, signal?: AbortSignal) => {
  return customHttpClient<GetEntityLists200>({ url: `/entity-lists`, method: 'GET', params, signal });
};

export const getGetEntityListsQueryKey = (params?: GetEntityListsParams) => {
  return [`/entity-lists`, ...(params ? [params] : [])] as const;
};

export const getGetEntityListsQueryOptions = <
  TData = Awaited<ReturnType<typeof getEntityLists>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  params?: GetEntityListsParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getEntityLists>>, TError, TData> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEntityListsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEntityLists>>> = ({ signal }) =>
    getEntityLists(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEntityLists>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEntityListsQueryResult = NonNullable<Awaited<ReturnType<typeof getEntityLists>>>;
export type GetEntityListsQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetEntityLists = <
  TData = Awaited<ReturnType<typeof getEntityLists>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  params?: GetEntityListsParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getEntityLists>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetEntityListsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postExternalResetCache = () => {
  return customHttpClient<PostExternalResetCache200>({ url: `/external/reset-cache`, method: 'POST' });
};

export const getPostExternalResetCacheMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postExternalResetCache>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof postExternalResetCache>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postExternalResetCache>>, void> = () => {
    return postExternalResetCache();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostExternalResetCacheMutationResult = NonNullable<Awaited<ReturnType<typeof postExternalResetCache>>>;

export type PostExternalResetCacheMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostExternalResetCache = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postExternalResetCache>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPostExternalResetCacheMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postExternalSubscription = () => {
  return customHttpClient<PostExternalSubscription200>({ url: `/external/subscription`, method: 'POST' });
};

export const getPostExternalSubscriptionMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postExternalSubscription>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof postExternalSubscription>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postExternalSubscription>>, void> = () => {
    return postExternalSubscription();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostExternalSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof postExternalSubscription>>>;

export type PostExternalSubscriptionMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostExternalSubscription = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postExternalSubscription>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPostExternalSubscriptionMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postFacebookWebhook = () => {
  return customHttpClient<PostFacebookWebhook200>({ url: `/facebook/webhook`, method: 'POST' });
};

export const getPostFacebookWebhookMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postFacebookWebhook>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof postFacebookWebhook>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFacebookWebhook>>, void> = () => {
    return postFacebookWebhook();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostFacebookWebhookMutationResult = NonNullable<Awaited<ReturnType<typeof postFacebookWebhook>>>;

export type PostFacebookWebhookMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostFacebookWebhook = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postFacebookWebhook>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPostFacebookWebhookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getFacebookWebhook = (signal?: AbortSignal) => {
  return customHttpClient<GetFacebookWebhook200>({ url: `/facebook/webhook`, method: 'GET', signal });
};

export const getGetFacebookWebhookQueryKey = () => {
  return [`/facebook/webhook`] as const;
};

export const getGetFacebookWebhookQueryOptions = <
  TData = Awaited<ReturnType<typeof getFacebookWebhook>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getFacebookWebhook>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFacebookWebhookQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFacebookWebhook>>> = ({ signal }) =>
    getFacebookWebhook(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getFacebookWebhook>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetFacebookWebhookQueryResult = NonNullable<Awaited<ReturnType<typeof getFacebookWebhook>>>;
export type GetFacebookWebhookQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetFacebookWebhook = <
  TData = Awaited<ReturnType<typeof getFacebookWebhook>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getFacebookWebhook>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFacebookWebhookQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postFacebookWebhookDevel = () => {
  return customHttpClient<PostFacebookWebhookDevel200>({ url: `/facebook/webhook-devel`, method: 'POST' });
};

export const getPostFacebookWebhookDevelMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postFacebookWebhookDevel>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof postFacebookWebhookDevel>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFacebookWebhookDevel>>, void> = () => {
    return postFacebookWebhookDevel();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostFacebookWebhookDevelMutationResult = NonNullable<Awaited<ReturnType<typeof postFacebookWebhookDevel>>>;

export type PostFacebookWebhookDevelMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostFacebookWebhookDevel = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postFacebookWebhookDevel>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPostFacebookWebhookDevelMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postFilesUrl = () => {
  return customHttpClient<PostFilesUrl200>({ url: `/files/url`, method: 'POST' });
};

export const getPostFilesUrlMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postFilesUrl>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof postFilesUrl>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFilesUrl>>, void> = () => {
    return postFilesUrl();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostFilesUrlMutationResult = NonNullable<Awaited<ReturnType<typeof postFilesUrl>>>;

export type PostFilesUrlMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostFilesUrl = <TError = Status400 | Status401 | Status403 | Status404, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postFilesUrl>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPostFilesUrlMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteImagesImageId = () => {
  return customHttpClient<DeleteImagesImageId200>({ url: `/images/:imageId`, method: 'DELETE' });
};

export const getDeleteImagesImageIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof deleteImagesImageId>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof deleteImagesImageId>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteImagesImageId>>, void> = () => {
    return deleteImagesImageId();
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteImagesImageIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteImagesImageId>>>;

export type DeleteImagesImageIdMutationError = Status400 | Status401 | Status403 | Status404;

export const useDeleteImagesImageId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof deleteImagesImageId>>, TError, void, TContext>;
}) => {
  const mutationOptions = getDeleteImagesImageIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postIntegrationsNationalitiesNormalise = (
  postIntegrationsNationalitiesNormaliseBody: PostIntegrationsNationalitiesNormaliseBody,
) => {
  return customHttpClient<PostIntegrationsNationalitiesNormalise200>({
    url: `/integrations/nationalities/normalise`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postIntegrationsNationalitiesNormaliseBody,
  });
};

export const getPostIntegrationsNationalitiesNormaliseMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postIntegrationsNationalitiesNormalise>>,
    TError,
    { data: PostIntegrationsNationalitiesNormaliseBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postIntegrationsNationalitiesNormalise>>,
  TError,
  { data: PostIntegrationsNationalitiesNormaliseBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postIntegrationsNationalitiesNormalise>>,
    { data: PostIntegrationsNationalitiesNormaliseBody }
  > = (props) => {
    const { data } = props ?? {};

    return postIntegrationsNationalitiesNormalise(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostIntegrationsNationalitiesNormaliseMutationResult = NonNullable<
  Awaited<ReturnType<typeof postIntegrationsNationalitiesNormalise>>
>;
export type PostIntegrationsNationalitiesNormaliseMutationBody = PostIntegrationsNationalitiesNormaliseBody;
export type PostIntegrationsNationalitiesNormaliseMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostIntegrationsNationalitiesNormalise = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postIntegrationsNationalitiesNormalise>>,
    TError,
    { data: PostIntegrationsNationalitiesNormaliseBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostIntegrationsNationalitiesNormaliseMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postIntegrationsPhonesNormalise = (
  postIntegrationsPhonesNormaliseBody: PostIntegrationsPhonesNormaliseBody,
) => {
  return customHttpClient<PostIntegrationsPhonesNormalise200>({
    url: `/integrations/phones/normalise`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postIntegrationsPhonesNormaliseBody,
  });
};

export const getPostIntegrationsPhonesNormaliseMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postIntegrationsPhonesNormalise>>,
    TError,
    { data: PostIntegrationsPhonesNormaliseBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postIntegrationsPhonesNormalise>>,
  TError,
  { data: PostIntegrationsPhonesNormaliseBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postIntegrationsPhonesNormalise>>,
    { data: PostIntegrationsPhonesNormaliseBody }
  > = (props) => {
    const { data } = props ?? {};

    return postIntegrationsPhonesNormalise(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostIntegrationsPhonesNormaliseMutationResult = NonNullable<
  Awaited<ReturnType<typeof postIntegrationsPhonesNormalise>>
>;
export type PostIntegrationsPhonesNormaliseMutationBody = PostIntegrationsPhonesNormaliseBody;
export type PostIntegrationsPhonesNormaliseMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostIntegrationsPhonesNormalise = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postIntegrationsPhonesNormalise>>,
    TError,
    { data: PostIntegrationsPhonesNormaliseBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostIntegrationsPhonesNormaliseMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postIntegrationsLanguagesNormalise = (
  postIntegrationsLanguagesNormaliseBody: PostIntegrationsLanguagesNormaliseBody,
) => {
  return customHttpClient<PostIntegrationsLanguagesNormalise200>({
    url: `/integrations/languages/normalise`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postIntegrationsLanguagesNormaliseBody,
  });
};

export const getPostIntegrationsLanguagesNormaliseMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postIntegrationsLanguagesNormalise>>,
    TError,
    { data: PostIntegrationsLanguagesNormaliseBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postIntegrationsLanguagesNormalise>>,
  TError,
  { data: PostIntegrationsLanguagesNormaliseBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postIntegrationsLanguagesNormalise>>,
    { data: PostIntegrationsLanguagesNormaliseBody }
  > = (props) => {
    const { data } = props ?? {};

    return postIntegrationsLanguagesNormalise(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostIntegrationsLanguagesNormaliseMutationResult = NonNullable<
  Awaited<ReturnType<typeof postIntegrationsLanguagesNormalise>>
>;
export type PostIntegrationsLanguagesNormaliseMutationBody = PostIntegrationsLanguagesNormaliseBody;
export type PostIntegrationsLanguagesNormaliseMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostIntegrationsLanguagesNormalise = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postIntegrationsLanguagesNormalise>>,
    TError,
    { data: PostIntegrationsLanguagesNormaliseBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostIntegrationsLanguagesNormaliseMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postIntegrationsCandidatesInternal = (
  postIntegrationsCandidatesInternalBody: PostIntegrationsCandidatesInternalBody,
) => {
  return customHttpClient<PostIntegrationsCandidatesInternal200>({
    url: `/integrations/candidates/internal`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postIntegrationsCandidatesInternalBody,
  });
};

export const getPostIntegrationsCandidatesInternalMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postIntegrationsCandidatesInternal>>,
    TError,
    { data: PostIntegrationsCandidatesInternalBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postIntegrationsCandidatesInternal>>,
  TError,
  { data: PostIntegrationsCandidatesInternalBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postIntegrationsCandidatesInternal>>,
    { data: PostIntegrationsCandidatesInternalBody }
  > = (props) => {
    const { data } = props ?? {};

    return postIntegrationsCandidatesInternal(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostIntegrationsCandidatesInternalMutationResult = NonNullable<
  Awaited<ReturnType<typeof postIntegrationsCandidatesInternal>>
>;
export type PostIntegrationsCandidatesInternalMutationBody = PostIntegrationsCandidatesInternalBody;
export type PostIntegrationsCandidatesInternalMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostIntegrationsCandidatesInternal = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postIntegrationsCandidatesInternal>>,
    TError,
    { data: PostIntegrationsCandidatesInternalBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostIntegrationsCandidatesInternalMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postIntegrationsCandidates = (postIntegrationsCandidatesBody: PostIntegrationsCandidatesBody) => {
  return customHttpClient<PostIntegrationsCandidates200>({
    url: `/integrations/candidates`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postIntegrationsCandidatesBody,
  });
};

export const getPostIntegrationsCandidatesMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postIntegrationsCandidates>>,
    TError,
    { data: PostIntegrationsCandidatesBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postIntegrationsCandidates>>,
  TError,
  { data: PostIntegrationsCandidatesBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postIntegrationsCandidates>>,
    { data: PostIntegrationsCandidatesBody }
  > = (props) => {
    const { data } = props ?? {};

    return postIntegrationsCandidates(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostIntegrationsCandidatesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postIntegrationsCandidates>>
>;
export type PostIntegrationsCandidatesMutationBody = PostIntegrationsCandidatesBody;
export type PostIntegrationsCandidatesMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostIntegrationsCandidates = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postIntegrationsCandidates>>,
    TError,
    { data: PostIntegrationsCandidatesBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostIntegrationsCandidatesMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putIntegrationsCandidatesId = (putIntegrationsCandidatesIdBody: PutIntegrationsCandidatesIdBody) => {
  return customHttpClient<PutIntegrationsCandidatesId200>({
    url: `/integrations/candidates/:id`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: putIntegrationsCandidatesIdBody,
  });
};

export const getPutIntegrationsCandidatesIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putIntegrationsCandidatesId>>,
    TError,
    { data: PutIntegrationsCandidatesIdBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putIntegrationsCandidatesId>>,
  TError,
  { data: PutIntegrationsCandidatesIdBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putIntegrationsCandidatesId>>,
    { data: PutIntegrationsCandidatesIdBody }
  > = (props) => {
    const { data } = props ?? {};

    return putIntegrationsCandidatesId(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutIntegrationsCandidatesIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putIntegrationsCandidatesId>>
>;
export type PutIntegrationsCandidatesIdMutationBody = PutIntegrationsCandidatesIdBody;
export type PutIntegrationsCandidatesIdMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutIntegrationsCandidatesId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putIntegrationsCandidatesId>>,
    TError,
    { data: PutIntegrationsCandidatesIdBody },
    TContext
  >;
}) => {
  const mutationOptions = getPutIntegrationsCandidatesIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postIntegrationsCompanies = (postIntegrationsCompaniesBody: PostIntegrationsCompaniesBody) => {
  return customHttpClient<PostIntegrationsCompanies200>({
    url: `/integrations/companies`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postIntegrationsCompaniesBody,
  });
};

export const getPostIntegrationsCompaniesMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postIntegrationsCompanies>>,
    TError,
    { data: PostIntegrationsCompaniesBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postIntegrationsCompanies>>,
  TError,
  { data: PostIntegrationsCompaniesBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postIntegrationsCompanies>>,
    { data: PostIntegrationsCompaniesBody }
  > = (props) => {
    const { data } = props ?? {};

    return postIntegrationsCompanies(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostIntegrationsCompaniesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postIntegrationsCompanies>>
>;
export type PostIntegrationsCompaniesMutationBody = PostIntegrationsCompaniesBody;
export type PostIntegrationsCompaniesMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostIntegrationsCompanies = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postIntegrationsCompanies>>,
    TError,
    { data: PostIntegrationsCompaniesBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostIntegrationsCompaniesMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putIntegrationsCompaniesCompanyId = (
  putIntegrationsCompaniesCompanyIdBody: PutIntegrationsCompaniesCompanyIdBody,
) => {
  return customHttpClient<PutIntegrationsCompaniesCompanyId200>({
    url: `/integrations/companies/:companyId`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: putIntegrationsCompaniesCompanyIdBody,
  });
};

export const getPutIntegrationsCompaniesCompanyIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putIntegrationsCompaniesCompanyId>>,
    TError,
    { data: PutIntegrationsCompaniesCompanyIdBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putIntegrationsCompaniesCompanyId>>,
  TError,
  { data: PutIntegrationsCompaniesCompanyIdBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putIntegrationsCompaniesCompanyId>>,
    { data: PutIntegrationsCompaniesCompanyIdBody }
  > = (props) => {
    const { data } = props ?? {};

    return putIntegrationsCompaniesCompanyId(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutIntegrationsCompaniesCompanyIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putIntegrationsCompaniesCompanyId>>
>;
export type PutIntegrationsCompaniesCompanyIdMutationBody = PutIntegrationsCompaniesCompanyIdBody;
export type PutIntegrationsCompaniesCompanyIdMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutIntegrationsCompaniesCompanyId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putIntegrationsCompaniesCompanyId>>,
    TError,
    { data: PutIntegrationsCompaniesCompanyIdBody },
    TContext
  >;
}) => {
  const mutationOptions = getPutIntegrationsCompaniesCompanyIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postIntegrationsContacts = (postIntegrationsContactsBody: PostIntegrationsContactsBody) => {
  return customHttpClient<PostIntegrationsContacts200>({
    url: `/integrations/contacts`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postIntegrationsContactsBody,
  });
};

export const getPostIntegrationsContactsMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postIntegrationsContacts>>,
    TError,
    { data: PostIntegrationsContactsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postIntegrationsContacts>>,
  TError,
  { data: PostIntegrationsContactsBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postIntegrationsContacts>>,
    { data: PostIntegrationsContactsBody }
  > = (props) => {
    const { data } = props ?? {};

    return postIntegrationsContacts(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostIntegrationsContactsMutationResult = NonNullable<Awaited<ReturnType<typeof postIntegrationsContacts>>>;
export type PostIntegrationsContactsMutationBody = PostIntegrationsContactsBody;
export type PostIntegrationsContactsMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostIntegrationsContacts = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postIntegrationsContacts>>,
    TError,
    { data: PostIntegrationsContactsBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostIntegrationsContactsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putIntegrationsContactsId = (putIntegrationsContactsIdBody: PutIntegrationsContactsIdBody) => {
  return customHttpClient<PutIntegrationsContactsId200>({
    url: `/integrations/contacts/:id`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: putIntegrationsContactsIdBody,
  });
};

export const getPutIntegrationsContactsIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putIntegrationsContactsId>>,
    TError,
    { data: PutIntegrationsContactsIdBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putIntegrationsContactsId>>,
  TError,
  { data: PutIntegrationsContactsIdBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putIntegrationsContactsId>>,
    { data: PutIntegrationsContactsIdBody }
  > = (props) => {
    const { data } = props ?? {};

    return putIntegrationsContactsId(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutIntegrationsContactsIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putIntegrationsContactsId>>
>;
export type PutIntegrationsContactsIdMutationBody = PutIntegrationsContactsIdBody;
export type PutIntegrationsContactsIdMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutIntegrationsContactsId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putIntegrationsContactsId>>,
    TError,
    { data: PutIntegrationsContactsIdBody },
    TContext
  >;
}) => {
  const mutationOptions = getPutIntegrationsContactsIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postIntegrationsJobs = (postIntegrationsJobsBody: PostIntegrationsJobsBody) => {
  return customHttpClient<PostIntegrationsJobs200>({
    url: `/integrations/jobs`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postIntegrationsJobsBody,
  });
};

export const getPostIntegrationsJobsMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postIntegrationsJobs>>,
    TError,
    { data: PostIntegrationsJobsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postIntegrationsJobs>>,
  TError,
  { data: PostIntegrationsJobsBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postIntegrationsJobs>>,
    { data: PostIntegrationsJobsBody }
  > = (props) => {
    const { data } = props ?? {};

    return postIntegrationsJobs(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostIntegrationsJobsMutationResult = NonNullable<Awaited<ReturnType<typeof postIntegrationsJobs>>>;
export type PostIntegrationsJobsMutationBody = PostIntegrationsJobsBody;
export type PostIntegrationsJobsMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostIntegrationsJobs = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postIntegrationsJobs>>,
    TError,
    { data: PostIntegrationsJobsBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostIntegrationsJobsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putIntegrationsJobsJobId = (jobId: number, putIntegrationsJobsJobIdBody: PutIntegrationsJobsJobIdBody) => {
  return customHttpClient<PutIntegrationsJobsJobId200>({
    url: `/integrations/jobs/${jobId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: putIntegrationsJobsJobIdBody,
  });
};

export const getPutIntegrationsJobsJobIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putIntegrationsJobsJobId>>,
    TError,
    { jobId: number; data: PutIntegrationsJobsJobIdBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putIntegrationsJobsJobId>>,
  TError,
  { jobId: number; data: PutIntegrationsJobsJobIdBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putIntegrationsJobsJobId>>,
    { jobId: number; data: PutIntegrationsJobsJobIdBody }
  > = (props) => {
    const { jobId, data } = props ?? {};

    return putIntegrationsJobsJobId(jobId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutIntegrationsJobsJobIdMutationResult = NonNullable<Awaited<ReturnType<typeof putIntegrationsJobsJobId>>>;
export type PutIntegrationsJobsJobIdMutationBody = PutIntegrationsJobsJobIdBody;
export type PutIntegrationsJobsJobIdMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutIntegrationsJobsJobId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putIntegrationsJobsJobId>>,
    TError,
    { jobId: number; data: PutIntegrationsJobsJobIdBody },
    TContext
  >;
}) => {
  const mutationOptions = getPutIntegrationsJobsJobIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postIntegrationsJobRequests = (postIntegrationsJobRequestsBody: PostIntegrationsJobRequestsBody) => {
  return customHttpClient<PostIntegrationsJobRequests200>({
    url: `/integrations/job-requests`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postIntegrationsJobRequestsBody,
  });
};

export const getPostIntegrationsJobRequestsMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postIntegrationsJobRequests>>,
    TError,
    { data: PostIntegrationsJobRequestsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postIntegrationsJobRequests>>,
  TError,
  { data: PostIntegrationsJobRequestsBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postIntegrationsJobRequests>>,
    { data: PostIntegrationsJobRequestsBody }
  > = (props) => {
    const { data } = props ?? {};

    return postIntegrationsJobRequests(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostIntegrationsJobRequestsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postIntegrationsJobRequests>>
>;
export type PostIntegrationsJobRequestsMutationBody = PostIntegrationsJobRequestsBody;
export type PostIntegrationsJobRequestsMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostIntegrationsJobRequests = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postIntegrationsJobRequests>>,
    TError,
    { data: PostIntegrationsJobRequestsBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostIntegrationsJobRequestsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putIntegrationsJobRequestsJobId = (
  putIntegrationsJobRequestsJobIdBody: PutIntegrationsJobRequestsJobIdBody,
) => {
  return customHttpClient<PutIntegrationsJobRequestsJobId200>({
    url: `/integrations/job-requests/:jobId`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: putIntegrationsJobRequestsJobIdBody,
  });
};

export const getPutIntegrationsJobRequestsJobIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putIntegrationsJobRequestsJobId>>,
    TError,
    { data: PutIntegrationsJobRequestsJobIdBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putIntegrationsJobRequestsJobId>>,
  TError,
  { data: PutIntegrationsJobRequestsJobIdBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putIntegrationsJobRequestsJobId>>,
    { data: PutIntegrationsJobRequestsJobIdBody }
  > = (props) => {
    const { data } = props ?? {};

    return putIntegrationsJobRequestsJobId(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutIntegrationsJobRequestsJobIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putIntegrationsJobRequestsJobId>>
>;
export type PutIntegrationsJobRequestsJobIdMutationBody = PutIntegrationsJobRequestsJobIdBody;
export type PutIntegrationsJobRequestsJobIdMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutIntegrationsJobRequestsJobId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putIntegrationsJobRequestsJobId>>,
    TError,
    { data: PutIntegrationsJobRequestsJobIdBody },
    TContext
  >;
}) => {
  const mutationOptions = getPutIntegrationsJobRequestsJobIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postIntegrationsActivityNotesNotes = (
  postIntegrationsActivityNotesNotesBody: PostIntegrationsActivityNotesNotesBody,
) => {
  return customHttpClient<PostIntegrationsActivityNotesNotes200>({
    url: `/integrations/activity-notes/notes`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postIntegrationsActivityNotesNotesBody,
  });
};

export const getPostIntegrationsActivityNotesNotesMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postIntegrationsActivityNotesNotes>>,
    TError,
    { data: PostIntegrationsActivityNotesNotesBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postIntegrationsActivityNotesNotes>>,
  TError,
  { data: PostIntegrationsActivityNotesNotesBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postIntegrationsActivityNotesNotes>>,
    { data: PostIntegrationsActivityNotesNotesBody }
  > = (props) => {
    const { data } = props ?? {};

    return postIntegrationsActivityNotesNotes(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostIntegrationsActivityNotesNotesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postIntegrationsActivityNotesNotes>>
>;
export type PostIntegrationsActivityNotesNotesMutationBody = PostIntegrationsActivityNotesNotesBody;
export type PostIntegrationsActivityNotesNotesMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostIntegrationsActivityNotesNotes = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postIntegrationsActivityNotesNotes>>,
    TError,
    { data: PostIntegrationsActivityNotesNotesBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostIntegrationsActivityNotesNotesMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putIntegrationsActivityNotesNotesId = (
  putIntegrationsActivityNotesNotesIdBody: PutIntegrationsActivityNotesNotesIdBody,
) => {
  return customHttpClient<PutIntegrationsActivityNotesNotesId200>({
    url: `/integrations/activity-notes/notes/:id`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: putIntegrationsActivityNotesNotesIdBody,
  });
};

export const getPutIntegrationsActivityNotesNotesIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putIntegrationsActivityNotesNotesId>>,
    TError,
    { data: PutIntegrationsActivityNotesNotesIdBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putIntegrationsActivityNotesNotesId>>,
  TError,
  { data: PutIntegrationsActivityNotesNotesIdBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putIntegrationsActivityNotesNotesId>>,
    { data: PutIntegrationsActivityNotesNotesIdBody }
  > = (props) => {
    const { data } = props ?? {};

    return putIntegrationsActivityNotesNotesId(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutIntegrationsActivityNotesNotesIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putIntegrationsActivityNotesNotesId>>
>;
export type PutIntegrationsActivityNotesNotesIdMutationBody = PutIntegrationsActivityNotesNotesIdBody;
export type PutIntegrationsActivityNotesNotesIdMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutIntegrationsActivityNotesNotesId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putIntegrationsActivityNotesNotesId>>,
    TError,
    { data: PutIntegrationsActivityNotesNotesIdBody },
    TContext
  >;
}) => {
  const mutationOptions = getPutIntegrationsActivityNotesNotesIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postIntegrationsPipelines = (postIntegrationsPipelinesBody: PostIntegrationsPipelinesBody) => {
  return customHttpClient<PostIntegrationsPipelines200>({
    url: `/integrations/pipelines`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postIntegrationsPipelinesBody,
  });
};

export const getPostIntegrationsPipelinesMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postIntegrationsPipelines>>,
    TError,
    { data: PostIntegrationsPipelinesBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postIntegrationsPipelines>>,
  TError,
  { data: PostIntegrationsPipelinesBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postIntegrationsPipelines>>,
    { data: PostIntegrationsPipelinesBody }
  > = (props) => {
    const { data } = props ?? {};

    return postIntegrationsPipelines(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostIntegrationsPipelinesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postIntegrationsPipelines>>
>;
export type PostIntegrationsPipelinesMutationBody = PostIntegrationsPipelinesBody;
export type PostIntegrationsPipelinesMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostIntegrationsPipelines = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postIntegrationsPipelines>>,
    TError,
    { data: PostIntegrationsPipelinesBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostIntegrationsPipelinesMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putIntegrationsEntityTypeEntityIdCustomFields = (
  entityId: string,
  putIntegrationsEntityTypeEntityIdCustomFieldsBody: PutIntegrationsEntityTypeEntityIdCustomFieldsBody,
) => {
  return customHttpClient<PutIntegrationsEntityTypeEntityIdCustomFields200>({
    url: `/integrations/:entityType/${entityId}/custom-fields`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: putIntegrationsEntityTypeEntityIdCustomFieldsBody,
  });
};

export const getPutIntegrationsEntityTypeEntityIdCustomFieldsMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putIntegrationsEntityTypeEntityIdCustomFields>>,
    TError,
    { entityId: string; data: PutIntegrationsEntityTypeEntityIdCustomFieldsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putIntegrationsEntityTypeEntityIdCustomFields>>,
  TError,
  { entityId: string; data: PutIntegrationsEntityTypeEntityIdCustomFieldsBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putIntegrationsEntityTypeEntityIdCustomFields>>,
    { entityId: string; data: PutIntegrationsEntityTypeEntityIdCustomFieldsBody }
  > = (props) => {
    const { entityId, data } = props ?? {};

    return putIntegrationsEntityTypeEntityIdCustomFields(entityId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutIntegrationsEntityTypeEntityIdCustomFieldsMutationResult = NonNullable<
  Awaited<ReturnType<typeof putIntegrationsEntityTypeEntityIdCustomFields>>
>;
export type PutIntegrationsEntityTypeEntityIdCustomFieldsMutationBody =
  PutIntegrationsEntityTypeEntityIdCustomFieldsBody;
export type PutIntegrationsEntityTypeEntityIdCustomFieldsMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutIntegrationsEntityTypeEntityIdCustomFields = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putIntegrationsEntityTypeEntityIdCustomFields>>,
    TError,
    { entityId: string; data: PutIntegrationsEntityTypeEntityIdCustomFieldsBody },
    TContext
  >;
}) => {
  const mutationOptions = getPutIntegrationsEntityTypeEntityIdCustomFieldsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postIntegrationsAgents = (postIntegrationsAgentsBody: PostIntegrationsAgentsBody) => {
  return customHttpClient<PostIntegrationsAgents200>({
    url: `/integrations/agents`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postIntegrationsAgentsBody,
  });
};

export const getPostIntegrationsAgentsMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postIntegrationsAgents>>,
    TError,
    { data: PostIntegrationsAgentsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postIntegrationsAgents>>,
  TError,
  { data: PostIntegrationsAgentsBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postIntegrationsAgents>>,
    { data: PostIntegrationsAgentsBody }
  > = (props) => {
    const { data } = props ?? {};

    return postIntegrationsAgents(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostIntegrationsAgentsMutationResult = NonNullable<Awaited<ReturnType<typeof postIntegrationsAgents>>>;
export type PostIntegrationsAgentsMutationBody = PostIntegrationsAgentsBody;
export type PostIntegrationsAgentsMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostIntegrationsAgents = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postIntegrationsAgents>>,
    TError,
    { data: PostIntegrationsAgentsBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostIntegrationsAgentsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putIntegrationsAgentsUserId = (putIntegrationsAgentsUserIdBody: PutIntegrationsAgentsUserIdBody) => {
  return customHttpClient<PutIntegrationsAgentsUserId200>({
    url: `/integrations/agents/:userId`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: putIntegrationsAgentsUserIdBody,
  });
};

export const getPutIntegrationsAgentsUserIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putIntegrationsAgentsUserId>>,
    TError,
    { data: PutIntegrationsAgentsUserIdBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putIntegrationsAgentsUserId>>,
  TError,
  { data: PutIntegrationsAgentsUserIdBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putIntegrationsAgentsUserId>>,
    { data: PutIntegrationsAgentsUserIdBody }
  > = (props) => {
    const { data } = props ?? {};

    return putIntegrationsAgentsUserId(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutIntegrationsAgentsUserIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putIntegrationsAgentsUserId>>
>;
export type PutIntegrationsAgentsUserIdMutationBody = PutIntegrationsAgentsUserIdBody;
export type PutIntegrationsAgentsUserIdMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutIntegrationsAgentsUserId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putIntegrationsAgentsUserId>>,
    TError,
    { data: PutIntegrationsAgentsUserIdBody },
    TContext
  >;
}) => {
  const mutationOptions = getPutIntegrationsAgentsUserIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getIntegrationsLastUnrecognised = (signal?: AbortSignal) => {
  return customHttpClient<GetIntegrationsLastUnrecognised200>({
    url: `/integrations/last-unrecognised`,
    method: 'GET',
    signal,
  });
};

export const getGetIntegrationsLastUnrecognisedQueryKey = () => {
  return [`/integrations/last-unrecognised`] as const;
};

export const getGetIntegrationsLastUnrecognisedQueryOptions = <
  TData = Awaited<ReturnType<typeof getIntegrationsLastUnrecognised>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsLastUnrecognised>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetIntegrationsLastUnrecognisedQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getIntegrationsLastUnrecognised>>> = ({ signal }) =>
    getIntegrationsLastUnrecognised(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getIntegrationsLastUnrecognised>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetIntegrationsLastUnrecognisedQueryResult = NonNullable<
  Awaited<ReturnType<typeof getIntegrationsLastUnrecognised>>
>;
export type GetIntegrationsLastUnrecognisedQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetIntegrationsLastUnrecognised = <
  TData = Awaited<ReturnType<typeof getIntegrationsLastUnrecognised>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsLastUnrecognised>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetIntegrationsLastUnrecognisedQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postIntegrationsWorkflowStateMove = (
  postIntegrationsWorkflowStateMoveBody: PostIntegrationsWorkflowStateMoveBody,
) => {
  return customHttpClient<PostIntegrationsWorkflowStateMove200>({
    url: `/integrations/workflow-state/move`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postIntegrationsWorkflowStateMoveBody,
  });
};

export const getPostIntegrationsWorkflowStateMoveMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postIntegrationsWorkflowStateMove>>,
    TError,
    { data: PostIntegrationsWorkflowStateMoveBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postIntegrationsWorkflowStateMove>>,
  TError,
  { data: PostIntegrationsWorkflowStateMoveBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postIntegrationsWorkflowStateMove>>,
    { data: PostIntegrationsWorkflowStateMoveBody }
  > = (props) => {
    const { data } = props ?? {};

    return postIntegrationsWorkflowStateMove(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostIntegrationsWorkflowStateMoveMutationResult = NonNullable<
  Awaited<ReturnType<typeof postIntegrationsWorkflowStateMove>>
>;
export type PostIntegrationsWorkflowStateMoveMutationBody = PostIntegrationsWorkflowStateMoveBody;
export type PostIntegrationsWorkflowStateMoveMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostIntegrationsWorkflowStateMove = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postIntegrationsWorkflowStateMove>>,
    TError,
    { data: PostIntegrationsWorkflowStateMoveBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostIntegrationsWorkflowStateMoveMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postIntegrationsEvaInitialiseWebchatIfNotDone = (
  postIntegrationsEvaInitialiseWebchatIfNotDoneBody: PostIntegrationsEvaInitialiseWebchatIfNotDoneBody,
) => {
  return customHttpClient<PostIntegrationsEvaInitialiseWebchatIfNotDone200>({
    url: `/integrations/eva/initialise-webchat-if-not-done`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postIntegrationsEvaInitialiseWebchatIfNotDoneBody,
  });
};

export const getPostIntegrationsEvaInitialiseWebchatIfNotDoneMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postIntegrationsEvaInitialiseWebchatIfNotDone>>,
    TError,
    { data: PostIntegrationsEvaInitialiseWebchatIfNotDoneBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postIntegrationsEvaInitialiseWebchatIfNotDone>>,
  TError,
  { data: PostIntegrationsEvaInitialiseWebchatIfNotDoneBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postIntegrationsEvaInitialiseWebchatIfNotDone>>,
    { data: PostIntegrationsEvaInitialiseWebchatIfNotDoneBody }
  > = (props) => {
    const { data } = props ?? {};

    return postIntegrationsEvaInitialiseWebchatIfNotDone(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostIntegrationsEvaInitialiseWebchatIfNotDoneMutationResult = NonNullable<
  Awaited<ReturnType<typeof postIntegrationsEvaInitialiseWebchatIfNotDone>>
>;
export type PostIntegrationsEvaInitialiseWebchatIfNotDoneMutationBody =
  PostIntegrationsEvaInitialiseWebchatIfNotDoneBody;
export type PostIntegrationsEvaInitialiseWebchatIfNotDoneMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostIntegrationsEvaInitialiseWebchatIfNotDone = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postIntegrationsEvaInitialiseWebchatIfNotDone>>,
    TError,
    { data: PostIntegrationsEvaInitialiseWebchatIfNotDoneBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostIntegrationsEvaInitialiseWebchatIfNotDoneMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postInterviewSchedulingContacts = () => {
  return customHttpClient<PostInterviewSchedulingContacts200>({
    url: `/interview-scheduling/contacts`,
    method: 'POST',
  });
};

export const getPostInterviewSchedulingContactsMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postInterviewSchedulingContacts>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof postInterviewSchedulingContacts>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postInterviewSchedulingContacts>>, void> = () => {
    return postInterviewSchedulingContacts();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostInterviewSchedulingContactsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postInterviewSchedulingContacts>>
>;

export type PostInterviewSchedulingContactsMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostInterviewSchedulingContacts = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postInterviewSchedulingContacts>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPostInterviewSchedulingContactsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getInterviewSchedulingCompanies = (signal?: AbortSignal) => {
  return customHttpClient<GetInterviewSchedulingCompanies200>({
    url: `/interview-scheduling/companies`,
    method: 'GET',
    signal,
  });
};

export const getGetInterviewSchedulingCompaniesQueryKey = () => {
  return [`/interview-scheduling/companies`] as const;
};

export const getGetInterviewSchedulingCompaniesQueryOptions = <
  TData = Awaited<ReturnType<typeof getInterviewSchedulingCompanies>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingCompanies>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetInterviewSchedulingCompaniesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getInterviewSchedulingCompanies>>> = ({ signal }) =>
    getInterviewSchedulingCompanies(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getInterviewSchedulingCompanies>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInterviewSchedulingCompaniesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInterviewSchedulingCompanies>>
>;
export type GetInterviewSchedulingCompaniesQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetInterviewSchedulingCompanies = <
  TData = Awaited<ReturnType<typeof getInterviewSchedulingCompanies>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingCompanies>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetInterviewSchedulingCompaniesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postInterviewSchedulingCandidates = () => {
  return customHttpClient<PostInterviewSchedulingCandidates200>({
    url: `/interview-scheduling/candidates`,
    method: 'POST',
  });
};

export const getPostInterviewSchedulingCandidatesMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postInterviewSchedulingCandidates>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof postInterviewSchedulingCandidates>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postInterviewSchedulingCandidates>>, void> = () => {
    return postInterviewSchedulingCandidates();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostInterviewSchedulingCandidatesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postInterviewSchedulingCandidates>>
>;

export type PostInterviewSchedulingCandidatesMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostInterviewSchedulingCandidates = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postInterviewSchedulingCandidates>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPostInterviewSchedulingCandidatesMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getInterviewSchedulingContactId = (signal?: AbortSignal) => {
  return customHttpClient<GetInterviewSchedulingContactId200>({
    url: `/interview-scheduling/:contactId`,
    method: 'GET',
    signal,
  });
};

export const getGetInterviewSchedulingContactIdQueryKey = () => {
  return [`/interview-scheduling/:contactId`] as const;
};

export const getGetInterviewSchedulingContactIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getInterviewSchedulingContactId>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingContactId>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetInterviewSchedulingContactIdQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getInterviewSchedulingContactId>>> = ({ signal }) =>
    getInterviewSchedulingContactId(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getInterviewSchedulingContactId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInterviewSchedulingContactIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInterviewSchedulingContactId>>
>;
export type GetInterviewSchedulingContactIdQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetInterviewSchedulingContactId = <
  TData = Awaited<ReturnType<typeof getInterviewSchedulingContactId>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingContactId>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetInterviewSchedulingContactIdQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postInterviewScheduling = () => {
  return customHttpClient<PostInterviewScheduling200>({ url: `/interview-scheduling`, method: 'POST' });
};

export const getPostInterviewSchedulingMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postInterviewScheduling>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof postInterviewScheduling>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postInterviewScheduling>>, void> = () => {
    return postInterviewScheduling();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostInterviewSchedulingMutationResult = NonNullable<Awaited<ReturnType<typeof postInterviewScheduling>>>;

export type PostInterviewSchedulingMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostInterviewScheduling = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postInterviewScheduling>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPostInterviewSchedulingMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putInterviewSchedulingId = () => {
  return customHttpClient<PutInterviewSchedulingId200>({ url: `/interview-scheduling/:id`, method: 'PUT' });
};

export const getPutInterviewSchedulingIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putInterviewSchedulingId>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof putInterviewSchedulingId>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof putInterviewSchedulingId>>, void> = () => {
    return putInterviewSchedulingId();
  };

  return { mutationFn, ...mutationOptions };
};

export type PutInterviewSchedulingIdMutationResult = NonNullable<Awaited<ReturnType<typeof putInterviewSchedulingId>>>;

export type PutInterviewSchedulingIdMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutInterviewSchedulingId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putInterviewSchedulingId>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPutInterviewSchedulingIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteInterviewSchedulingId = () => {
  return customHttpClient<DeleteInterviewSchedulingId200>({ url: `/interview-scheduling/:id`, method: 'DELETE' });
};

export const getDeleteInterviewSchedulingIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof deleteInterviewSchedulingId>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof deleteInterviewSchedulingId>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteInterviewSchedulingId>>, void> = () => {
    return deleteInterviewSchedulingId();
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteInterviewSchedulingIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteInterviewSchedulingId>>
>;

export type DeleteInterviewSchedulingIdMutationError = Status400 | Status401 | Status403 | Status404;

export const useDeleteInterviewSchedulingId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof deleteInterviewSchedulingId>>, TError, void, TContext>;
}) => {
  const mutationOptions = getDeleteInterviewSchedulingIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getJobsCustomFieldsModel = (signal?: AbortSignal) => {
  return customHttpClient<GetJobsCustomFieldsModel200>({ url: `/jobs/custom-fields/model`, method: 'GET', signal });
};

export const getGetJobsCustomFieldsModelQueryKey = () => {
  return [`/jobs/custom-fields/model`] as const;
};

export const getGetJobsCustomFieldsModelQueryOptions = <
  TData = Awaited<ReturnType<typeof getJobsCustomFieldsModel>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getJobsCustomFieldsModel>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetJobsCustomFieldsModelQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobsCustomFieldsModel>>> = ({ signal }) =>
    getJobsCustomFieldsModel(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getJobsCustomFieldsModel>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetJobsCustomFieldsModelQueryResult = NonNullable<Awaited<ReturnType<typeof getJobsCustomFieldsModel>>>;
export type GetJobsCustomFieldsModelQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetJobsCustomFieldsModel = <
  TData = Awaited<ReturnType<typeof getJobsCustomFieldsModel>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getJobsCustomFieldsModel>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetJobsCustomFieldsModelQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const putJobsCustomFieldsModel = () => {
  return customHttpClient<PutJobsCustomFieldsModel200>({ url: `/jobs/custom-fields/model`, method: 'PUT' });
};

export const getPutJobsCustomFieldsModelMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putJobsCustomFieldsModel>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof putJobsCustomFieldsModel>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof putJobsCustomFieldsModel>>, void> = () => {
    return putJobsCustomFieldsModel();
  };

  return { mutationFn, ...mutationOptions };
};

export type PutJobsCustomFieldsModelMutationResult = NonNullable<Awaited<ReturnType<typeof putJobsCustomFieldsModel>>>;

export type PutJobsCustomFieldsModelMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutJobsCustomFieldsModel = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putJobsCustomFieldsModel>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPutJobsCustomFieldsModelMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postJobsCustomFieldsValidate = () => {
  return customHttpClient<PostJobsCustomFieldsValidate200>({ url: `/jobs/custom-fields/validate`, method: 'POST' });
};

export const getPostJobsCustomFieldsValidateMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postJobsCustomFieldsValidate>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof postJobsCustomFieldsValidate>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postJobsCustomFieldsValidate>>, void> = () => {
    return postJobsCustomFieldsValidate();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostJobsCustomFieldsValidateMutationResult = NonNullable<
  Awaited<ReturnType<typeof postJobsCustomFieldsValidate>>
>;

export type PostJobsCustomFieldsValidateMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostJobsCustomFieldsValidate = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postJobsCustomFieldsValidate>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPostJobsCustomFieldsValidateMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getJobsEntityIdCustomFields = (entityId: string, signal?: AbortSignal) => {
  return customHttpClient<GetJobsEntityIdCustomFields200>({
    url: `/jobs/${entityId}/custom-fields`,
    method: 'GET',
    signal,
  });
};

export const getGetJobsEntityIdCustomFieldsQueryKey = (entityId: string) => {
  return [`/jobs/${entityId}/custom-fields`] as const;
};

export const getGetJobsEntityIdCustomFieldsQueryOptions = <
  TData = Awaited<ReturnType<typeof getJobsEntityIdCustomFields>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  entityId: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getJobsEntityIdCustomFields>>, TError, TData> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetJobsEntityIdCustomFieldsQueryKey(entityId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobsEntityIdCustomFields>>> = ({ signal }) =>
    getJobsEntityIdCustomFields(entityId, signal);

  return { queryKey, queryFn, enabled: !!entityId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getJobsEntityIdCustomFields>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetJobsEntityIdCustomFieldsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getJobsEntityIdCustomFields>>
>;
export type GetJobsEntityIdCustomFieldsQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetJobsEntityIdCustomFields = <
  TData = Awaited<ReturnType<typeof getJobsEntityIdCustomFields>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  entityId: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getJobsEntityIdCustomFields>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetJobsEntityIdCustomFieldsQueryOptions(entityId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const putJobsEntityIdCustomFields = (entityId: string) => {
  return customHttpClient<PutJobsEntityIdCustomFields200>({ url: `/jobs/${entityId}/custom-fields`, method: 'PUT' });
};

export const getPutJobsEntityIdCustomFieldsMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putJobsEntityIdCustomFields>>,
    TError,
    { entityId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putJobsEntityIdCustomFields>>,
  TError,
  { entityId: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof putJobsEntityIdCustomFields>>, { entityId: string }> = (
    props,
  ) => {
    const { entityId } = props ?? {};

    return putJobsEntityIdCustomFields(entityId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutJobsEntityIdCustomFieldsMutationResult = NonNullable<
  Awaited<ReturnType<typeof putJobsEntityIdCustomFields>>
>;

export type PutJobsEntityIdCustomFieldsMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutJobsEntityIdCustomFields = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putJobsEntityIdCustomFields>>,
    TError,
    { entityId: string },
    TContext
  >;
}) => {
  const mutationOptions = getPutJobsEntityIdCustomFieldsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putJobsEntityIdCustomFieldsExtend = (
  entityId: string,
  putJobsEntityIdCustomFieldsExtendBody: PutJobsEntityIdCustomFieldsExtendBody,
) => {
  return customHttpClient<PutJobsEntityIdCustomFieldsExtend200>({
    url: `/jobs/${entityId}/custom-fields/extend`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: putJobsEntityIdCustomFieldsExtendBody,
  });
};

export const getPutJobsEntityIdCustomFieldsExtendMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putJobsEntityIdCustomFieldsExtend>>,
    TError,
    { entityId: string; data: PutJobsEntityIdCustomFieldsExtendBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putJobsEntityIdCustomFieldsExtend>>,
  TError,
  { entityId: string; data: PutJobsEntityIdCustomFieldsExtendBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putJobsEntityIdCustomFieldsExtend>>,
    { entityId: string; data: PutJobsEntityIdCustomFieldsExtendBody }
  > = (props) => {
    const { entityId, data } = props ?? {};

    return putJobsEntityIdCustomFieldsExtend(entityId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutJobsEntityIdCustomFieldsExtendMutationResult = NonNullable<
  Awaited<ReturnType<typeof putJobsEntityIdCustomFieldsExtend>>
>;
export type PutJobsEntityIdCustomFieldsExtendMutationBody = PutJobsEntityIdCustomFieldsExtendBody;
export type PutJobsEntityIdCustomFieldsExtendMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutJobsEntityIdCustomFieldsExtend = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putJobsEntityIdCustomFieldsExtend>>,
    TError,
    { entityId: string; data: PutJobsEntityIdCustomFieldsExtendBody },
    TContext
  >;
}) => {
  const mutationOptions = getPutJobsEntityIdCustomFieldsExtendMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postJobsLists = () => {
  return customHttpClient<PostJobsLists200>({ url: `/jobs/lists`, method: 'POST' });
};

export const getPostJobsListsMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postJobsLists>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof postJobsLists>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postJobsLists>>, void> = () => {
    return postJobsLists();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostJobsListsMutationResult = NonNullable<Awaited<ReturnType<typeof postJobsLists>>>;

export type PostJobsListsMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostJobsLists = <TError = Status400 | Status401 | Status403 | Status404, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postJobsLists>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPostJobsListsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getJobsLists = (signal?: AbortSignal) => {
  return customHttpClient<GetJobsLists200>({ url: `/jobs/lists`, method: 'GET', signal });
};

export const getGetJobsListsQueryKey = () => {
  return [`/jobs/lists`] as const;
};

export const getGetJobsListsQueryOptions = <
  TData = Awaited<ReturnType<typeof getJobsLists>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getJobsLists>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetJobsListsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobsLists>>> = ({ signal }) => getJobsLists(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getJobsLists>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetJobsListsQueryResult = NonNullable<Awaited<ReturnType<typeof getJobsLists>>>;
export type GetJobsListsQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetJobsLists = <
  TData = Awaited<ReturnType<typeof getJobsLists>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getJobsLists>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetJobsListsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postJobsListsEntityListIdCreateNewEntity = () => {
  return customHttpClient<PostJobsListsEntityListIdCreateNewEntity200>({
    url: `/jobs/lists/:entityListId/create-new-entity`,
    method: 'POST',
  });
};

export const getPostJobsListsEntityListIdCreateNewEntityMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsListsEntityListIdCreateNewEntity>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postJobsListsEntityListIdCreateNewEntity>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postJobsListsEntityListIdCreateNewEntity>>,
    void
  > = () => {
    return postJobsListsEntityListIdCreateNewEntity();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostJobsListsEntityListIdCreateNewEntityMutationResult = NonNullable<
  Awaited<ReturnType<typeof postJobsListsEntityListIdCreateNewEntity>>
>;

export type PostJobsListsEntityListIdCreateNewEntityMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostJobsListsEntityListIdCreateNewEntity = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsListsEntityListIdCreateNewEntity>>,
    TError,
    void,
    TContext
  >;
}) => {
  const mutationOptions = getPostJobsListsEntityListIdCreateNewEntityMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getJobsListsEntityListId = (signal?: AbortSignal) => {
  return customHttpClient<GetJobsListsEntityListId200>({ url: `/jobs/lists/:entityListId`, method: 'GET', signal });
};

export const getGetJobsListsEntityListIdQueryKey = () => {
  return [`/jobs/lists/:entityListId`] as const;
};

export const getGetJobsListsEntityListIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getJobsListsEntityListId>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getJobsListsEntityListId>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetJobsListsEntityListIdQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobsListsEntityListId>>> = ({ signal }) =>
    getJobsListsEntityListId(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getJobsListsEntityListId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetJobsListsEntityListIdQueryResult = NonNullable<Awaited<ReturnType<typeof getJobsListsEntityListId>>>;
export type GetJobsListsEntityListIdQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetJobsListsEntityListId = <
  TData = Awaited<ReturnType<typeof getJobsListsEntityListId>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getJobsListsEntityListId>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetJobsListsEntityListIdQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const putJobsListsEntityListId = () => {
  return customHttpClient<PutJobsListsEntityListId200>({ url: `/jobs/lists/:entityListId`, method: 'PUT' });
};

export const getPutJobsListsEntityListIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putJobsListsEntityListId>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof putJobsListsEntityListId>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof putJobsListsEntityListId>>, void> = () => {
    return putJobsListsEntityListId();
  };

  return { mutationFn, ...mutationOptions };
};

export type PutJobsListsEntityListIdMutationResult = NonNullable<Awaited<ReturnType<typeof putJobsListsEntityListId>>>;

export type PutJobsListsEntityListIdMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutJobsListsEntityListId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putJobsListsEntityListId>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPutJobsListsEntityListIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteJobsListsEntityListId = () => {
  return customHttpClient<DeleteJobsListsEntityListId200>({ url: `/jobs/lists/:entityListId`, method: 'DELETE' });
};

export const getDeleteJobsListsEntityListIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof deleteJobsListsEntityListId>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof deleteJobsListsEntityListId>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteJobsListsEntityListId>>, void> = () => {
    return deleteJobsListsEntityListId();
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteJobsListsEntityListIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteJobsListsEntityListId>>
>;

export type DeleteJobsListsEntityListIdMutationError = Status400 | Status401 | Status403 | Status404;

export const useDeleteJobsListsEntityListId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof deleteJobsListsEntityListId>>, TError, void, TContext>;
}) => {
  const mutationOptions = getDeleteJobsListsEntityListIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getJobsListsEntityListIdJobs = (signal?: AbortSignal) => {
  return customHttpClient<GetJobsListsEntityListIdJobs200>({
    url: `/jobs/lists/:entityListId/jobs`,
    method: 'GET',
    signal,
  });
};

export const getGetJobsListsEntityListIdJobsQueryKey = () => {
  return [`/jobs/lists/:entityListId/jobs`] as const;
};

export const getGetJobsListsEntityListIdJobsQueryOptions = <
  TData = Awaited<ReturnType<typeof getJobsListsEntityListIdJobs>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getJobsListsEntityListIdJobs>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetJobsListsEntityListIdJobsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobsListsEntityListIdJobs>>> = ({ signal }) =>
    getJobsListsEntityListIdJobs(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getJobsListsEntityListIdJobs>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetJobsListsEntityListIdJobsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getJobsListsEntityListIdJobs>>
>;
export type GetJobsListsEntityListIdJobsQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetJobsListsEntityListIdJobs = <
  TData = Awaited<ReturnType<typeof getJobsListsEntityListIdJobs>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getJobsListsEntityListIdJobs>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetJobsListsEntityListIdJobsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postJobsListsEntityListIdAdd = () => {
  return customHttpClient<PostJobsListsEntityListIdAdd200>({ url: `/jobs/lists/:entityListId/add`, method: 'POST' });
};

export const getPostJobsListsEntityListIdAddMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postJobsListsEntityListIdAdd>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof postJobsListsEntityListIdAdd>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postJobsListsEntityListIdAdd>>, void> = () => {
    return postJobsListsEntityListIdAdd();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostJobsListsEntityListIdAddMutationResult = NonNullable<
  Awaited<ReturnType<typeof postJobsListsEntityListIdAdd>>
>;

export type PostJobsListsEntityListIdAddMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostJobsListsEntityListIdAdd = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postJobsListsEntityListIdAdd>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPostJobsListsEntityListIdAddMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postJobsListsEntityListIdRemove = () => {
  return customHttpClient<PostJobsListsEntityListIdRemove200>({
    url: `/jobs/lists/:entityListId/remove`,
    method: 'POST',
  });
};

export const getPostJobsListsEntityListIdRemoveMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postJobsListsEntityListIdRemove>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof postJobsListsEntityListIdRemove>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postJobsListsEntityListIdRemove>>, void> = () => {
    return postJobsListsEntityListIdRemove();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostJobsListsEntityListIdRemoveMutationResult = NonNullable<
  Awaited<ReturnType<typeof postJobsListsEntityListIdRemove>>
>;

export type PostJobsListsEntityListIdRemoveMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostJobsListsEntityListIdRemove = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postJobsListsEntityListIdRemove>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPostJobsListsEntityListIdRemoveMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postJobsListsEntityListIdReorder = (
  postJobsListsEntityListIdReorderBody: PostJobsListsEntityListIdReorderBody,
) => {
  return customHttpClient<PostJobsListsEntityListIdReorder200>({
    url: `/jobs/lists/:entityListId/reorder`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postJobsListsEntityListIdReorderBody,
  });
};

export const getPostJobsListsEntityListIdReorderMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsListsEntityListIdReorder>>,
    TError,
    { data: PostJobsListsEntityListIdReorderBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postJobsListsEntityListIdReorder>>,
  TError,
  { data: PostJobsListsEntityListIdReorderBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postJobsListsEntityListIdReorder>>,
    { data: PostJobsListsEntityListIdReorderBody }
  > = (props) => {
    const { data } = props ?? {};

    return postJobsListsEntityListIdReorder(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostJobsListsEntityListIdReorderMutationResult = NonNullable<
  Awaited<ReturnType<typeof postJobsListsEntityListIdReorder>>
>;
export type PostJobsListsEntityListIdReorderMutationBody = PostJobsListsEntityListIdReorderBody;
export type PostJobsListsEntityListIdReorderMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostJobsListsEntityListIdReorder = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsListsEntityListIdReorder>>,
    TError,
    { data: PostJobsListsEntityListIdReorderBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostJobsListsEntityListIdReorderMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postJobsListsEntityListIdUserGroups = (
  postJobsListsEntityListIdUserGroupsBody: PostJobsListsEntityListIdUserGroupsBody,
) => {
  return customHttpClient<PostJobsListsEntityListIdUserGroups200>({
    url: `/jobs/lists/:entityListId/user-groups`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postJobsListsEntityListIdUserGroupsBody,
  });
};

export const getPostJobsListsEntityListIdUserGroupsMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsListsEntityListIdUserGroups>>,
    TError,
    { data: PostJobsListsEntityListIdUserGroupsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postJobsListsEntityListIdUserGroups>>,
  TError,
  { data: PostJobsListsEntityListIdUserGroupsBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postJobsListsEntityListIdUserGroups>>,
    { data: PostJobsListsEntityListIdUserGroupsBody }
  > = (props) => {
    const { data } = props ?? {};

    return postJobsListsEntityListIdUserGroups(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostJobsListsEntityListIdUserGroupsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postJobsListsEntityListIdUserGroups>>
>;
export type PostJobsListsEntityListIdUserGroupsMutationBody = PostJobsListsEntityListIdUserGroupsBody;
export type PostJobsListsEntityListIdUserGroupsMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostJobsListsEntityListIdUserGroups = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsListsEntityListIdUserGroups>>,
    TError,
    { data: PostJobsListsEntityListIdUserGroupsBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostJobsListsEntityListIdUserGroupsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postJobsEntityIdLists = (entityId: string, postJobsEntityIdListsBody: PostJobsEntityIdListsBody) => {
  return customHttpClient<PostJobsEntityIdLists200>({
    url: `/jobs/${entityId}/lists`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postJobsEntityIdListsBody,
  });
};

export const getPostJobsEntityIdListsMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsEntityIdLists>>,
    TError,
    { entityId: string; data: PostJobsEntityIdListsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postJobsEntityIdLists>>,
  TError,
  { entityId: string; data: PostJobsEntityIdListsBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postJobsEntityIdLists>>,
    { entityId: string; data: PostJobsEntityIdListsBody }
  > = (props) => {
    const { entityId, data } = props ?? {};

    return postJobsEntityIdLists(entityId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostJobsEntityIdListsMutationResult = NonNullable<Awaited<ReturnType<typeof postJobsEntityIdLists>>>;
export type PostJobsEntityIdListsMutationBody = PostJobsEntityIdListsBody;
export type PostJobsEntityIdListsMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostJobsEntityIdLists = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsEntityIdLists>>,
    TError,
    { entityId: string; data: PostJobsEntityIdListsBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostJobsEntityIdListsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putJobsEntityIdNotesPanel = (entityId: string) => {
  return customHttpClient<PutJobsEntityIdNotesPanel200>({ url: `/jobs/${entityId}/notes/panel`, method: 'PUT' });
};

export const getPutJobsEntityIdNotesPanelMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putJobsEntityIdNotesPanel>>,
    TError,
    { entityId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putJobsEntityIdNotesPanel>>,
  TError,
  { entityId: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof putJobsEntityIdNotesPanel>>, { entityId: string }> = (
    props,
  ) => {
    const { entityId } = props ?? {};

    return putJobsEntityIdNotesPanel(entityId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutJobsEntityIdNotesPanelMutationResult = NonNullable<
  Awaited<ReturnType<typeof putJobsEntityIdNotesPanel>>
>;

export type PutJobsEntityIdNotesPanelMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutJobsEntityIdNotesPanel = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putJobsEntityIdNotesPanel>>,
    TError,
    { entityId: string },
    TContext
  >;
}) => {
  const mutationOptions = getPutJobsEntityIdNotesPanelMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteJobsEntityIdNotesPanel = (entityId: string) => {
  return customHttpClient<DeleteJobsEntityIdNotesPanel200>({ url: `/jobs/${entityId}/notes/panel`, method: 'DELETE' });
};

export const getDeleteJobsEntityIdNotesPanelMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteJobsEntityIdNotesPanel>>,
    TError,
    { entityId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteJobsEntityIdNotesPanel>>,
  TError,
  { entityId: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteJobsEntityIdNotesPanel>>, { entityId: string }> = (
    props,
  ) => {
    const { entityId } = props ?? {};

    return deleteJobsEntityIdNotesPanel(entityId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteJobsEntityIdNotesPanelMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteJobsEntityIdNotesPanel>>
>;

export type DeleteJobsEntityIdNotesPanelMutationError = Status400 | Status401 | Status403 | Status404;

export const useDeleteJobsEntityIdNotesPanel = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteJobsEntityIdNotesPanel>>,
    TError,
    { entityId: string },
    TContext
  >;
}) => {
  const mutationOptions = getDeleteJobsEntityIdNotesPanelMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getJobsJobIdMatchCandidatesCatererDefaultFilter = (jobId: number, signal?: AbortSignal) => {
  return customHttpClient<GetJobsJobIdMatchCandidatesCatererDefaultFilter200>({
    url: `/jobs/${jobId}/match/candidates/caterer/default-filter`,
    method: 'GET',
    signal,
  });
};

export const getGetJobsJobIdMatchCandidatesCatererDefaultFilterQueryKey = (jobId: number) => {
  return [`/jobs/${jobId}/match/candidates/caterer/default-filter`] as const;
};

export const getGetJobsJobIdMatchCandidatesCatererDefaultFilterQueryOptions = <
  TData = Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesCatererDefaultFilter>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  jobId: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesCatererDefaultFilter>>, TError, TData>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetJobsJobIdMatchCandidatesCatererDefaultFilterQueryKey(jobId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesCatererDefaultFilter>>> = ({
    signal,
  }) => getJobsJobIdMatchCandidatesCatererDefaultFilter(jobId, signal);

  return { queryKey, queryFn, enabled: !!jobId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesCatererDefaultFilter>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetJobsJobIdMatchCandidatesCatererDefaultFilterQueryResult = NonNullable<
  Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesCatererDefaultFilter>>
>;
export type GetJobsJobIdMatchCandidatesCatererDefaultFilterQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetJobsJobIdMatchCandidatesCatererDefaultFilter = <
  TData = Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesCatererDefaultFilter>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  jobId: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesCatererDefaultFilter>>, TError, TData>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetJobsJobIdMatchCandidatesCatererDefaultFilterQueryOptions(jobId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postJobsJobIdMatchCandidatesCatererSearch = (
  jobId: number,
  postJobsJobIdMatchCandidatesCatererSearchBody: PostJobsJobIdMatchCandidatesCatererSearchBody,
) => {
  return customHttpClient<PostJobsJobIdMatchCandidatesCatererSearch200>({
    url: `/jobs/${jobId}/match/candidates/caterer/search`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postJobsJobIdMatchCandidatesCatererSearchBody,
  });
};

export const getPostJobsJobIdMatchCandidatesCatererSearchMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesCatererSearch>>,
    TError,
    { jobId: number; data: PostJobsJobIdMatchCandidatesCatererSearchBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesCatererSearch>>,
  TError,
  { jobId: number; data: PostJobsJobIdMatchCandidatesCatererSearchBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesCatererSearch>>,
    { jobId: number; data: PostJobsJobIdMatchCandidatesCatererSearchBody }
  > = (props) => {
    const { jobId, data } = props ?? {};

    return postJobsJobIdMatchCandidatesCatererSearch(jobId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostJobsJobIdMatchCandidatesCatererSearchMutationResult = NonNullable<
  Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesCatererSearch>>
>;
export type PostJobsJobIdMatchCandidatesCatererSearchMutationBody = PostJobsJobIdMatchCandidatesCatererSearchBody;
export type PostJobsJobIdMatchCandidatesCatererSearchMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostJobsJobIdMatchCandidatesCatererSearch = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesCatererSearch>>,
    TError,
    { jobId: number; data: PostJobsJobIdMatchCandidatesCatererSearchBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostJobsJobIdMatchCandidatesCatererSearchMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postJobsJobIdMatchCandidatesCatererExternalCandidateIdReject = (
  jobId: number,
  postJobsJobIdMatchCandidatesCatererExternalCandidateIdRejectBody: PostJobsJobIdMatchCandidatesCatererExternalCandidateIdRejectBody,
) => {
  return customHttpClient<PostJobsJobIdMatchCandidatesCatererExternalCandidateIdReject200>({
    url: `/jobs/${jobId}/match/candidates/caterer/:externalCandidateId/reject`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postJobsJobIdMatchCandidatesCatererExternalCandidateIdRejectBody,
  });
};

export const getPostJobsJobIdMatchCandidatesCatererExternalCandidateIdRejectMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesCatererExternalCandidateIdReject>>,
    TError,
    { jobId: number; data: PostJobsJobIdMatchCandidatesCatererExternalCandidateIdRejectBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesCatererExternalCandidateIdReject>>,
  TError,
  { jobId: number; data: PostJobsJobIdMatchCandidatesCatererExternalCandidateIdRejectBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesCatererExternalCandidateIdReject>>,
    { jobId: number; data: PostJobsJobIdMatchCandidatesCatererExternalCandidateIdRejectBody }
  > = (props) => {
    const { jobId, data } = props ?? {};

    return postJobsJobIdMatchCandidatesCatererExternalCandidateIdReject(jobId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostJobsJobIdMatchCandidatesCatererExternalCandidateIdRejectMutationResult = NonNullable<
  Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesCatererExternalCandidateIdReject>>
>;
export type PostJobsJobIdMatchCandidatesCatererExternalCandidateIdRejectMutationBody =
  PostJobsJobIdMatchCandidatesCatererExternalCandidateIdRejectBody;
export type PostJobsJobIdMatchCandidatesCatererExternalCandidateIdRejectMutationError =
  | Status400
  | Status401
  | Status403
  | Status404;

export const usePostJobsJobIdMatchCandidatesCatererExternalCandidateIdReject = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesCatererExternalCandidateIdReject>>,
    TError,
    { jobId: number; data: PostJobsJobIdMatchCandidatesCatererExternalCandidateIdRejectBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostJobsJobIdMatchCandidatesCatererExternalCandidateIdRejectMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getJobsJobIdMatchCandidatesJobsiteDefaultFilter = (jobId: number, signal?: AbortSignal) => {
  return customHttpClient<GetJobsJobIdMatchCandidatesJobsiteDefaultFilter200>({
    url: `/jobs/${jobId}/match/candidates/jobsite/default-filter`,
    method: 'GET',
    signal,
  });
};

export const getGetJobsJobIdMatchCandidatesJobsiteDefaultFilterQueryKey = (jobId: number) => {
  return [`/jobs/${jobId}/match/candidates/jobsite/default-filter`] as const;
};

export const getGetJobsJobIdMatchCandidatesJobsiteDefaultFilterQueryOptions = <
  TData = Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesJobsiteDefaultFilter>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  jobId: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesJobsiteDefaultFilter>>, TError, TData>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetJobsJobIdMatchCandidatesJobsiteDefaultFilterQueryKey(jobId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesJobsiteDefaultFilter>>> = ({
    signal,
  }) => getJobsJobIdMatchCandidatesJobsiteDefaultFilter(jobId, signal);

  return { queryKey, queryFn, enabled: !!jobId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesJobsiteDefaultFilter>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetJobsJobIdMatchCandidatesJobsiteDefaultFilterQueryResult = NonNullable<
  Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesJobsiteDefaultFilter>>
>;
export type GetJobsJobIdMatchCandidatesJobsiteDefaultFilterQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetJobsJobIdMatchCandidatesJobsiteDefaultFilter = <
  TData = Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesJobsiteDefaultFilter>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  jobId: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesJobsiteDefaultFilter>>, TError, TData>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetJobsJobIdMatchCandidatesJobsiteDefaultFilterQueryOptions(jobId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postJobsJobIdMatchCandidatesJobsiteSearch = (
  jobId: number,
  postJobsJobIdMatchCandidatesJobsiteSearchBody: PostJobsJobIdMatchCandidatesJobsiteSearchBody,
) => {
  return customHttpClient<PostJobsJobIdMatchCandidatesJobsiteSearch200>({
    url: `/jobs/${jobId}/match/candidates/jobsite/search`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postJobsJobIdMatchCandidatesJobsiteSearchBody,
  });
};

export const getPostJobsJobIdMatchCandidatesJobsiteSearchMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesJobsiteSearch>>,
    TError,
    { jobId: number; data: PostJobsJobIdMatchCandidatesJobsiteSearchBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesJobsiteSearch>>,
  TError,
  { jobId: number; data: PostJobsJobIdMatchCandidatesJobsiteSearchBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesJobsiteSearch>>,
    { jobId: number; data: PostJobsJobIdMatchCandidatesJobsiteSearchBody }
  > = (props) => {
    const { jobId, data } = props ?? {};

    return postJobsJobIdMatchCandidatesJobsiteSearch(jobId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostJobsJobIdMatchCandidatesJobsiteSearchMutationResult = NonNullable<
  Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesJobsiteSearch>>
>;
export type PostJobsJobIdMatchCandidatesJobsiteSearchMutationBody = PostJobsJobIdMatchCandidatesJobsiteSearchBody;
export type PostJobsJobIdMatchCandidatesJobsiteSearchMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostJobsJobIdMatchCandidatesJobsiteSearch = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesJobsiteSearch>>,
    TError,
    { jobId: number; data: PostJobsJobIdMatchCandidatesJobsiteSearchBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostJobsJobIdMatchCandidatesJobsiteSearchMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postJobsJobIdMatchCandidatesJobsiteExternalCandidateIdReject = (
  jobId: number,
  postJobsJobIdMatchCandidatesJobsiteExternalCandidateIdRejectBody: PostJobsJobIdMatchCandidatesJobsiteExternalCandidateIdRejectBody,
) => {
  return customHttpClient<PostJobsJobIdMatchCandidatesJobsiteExternalCandidateIdReject200>({
    url: `/jobs/${jobId}/match/candidates/jobsite/:externalCandidateId/reject`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postJobsJobIdMatchCandidatesJobsiteExternalCandidateIdRejectBody,
  });
};

export const getPostJobsJobIdMatchCandidatesJobsiteExternalCandidateIdRejectMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesJobsiteExternalCandidateIdReject>>,
    TError,
    { jobId: number; data: PostJobsJobIdMatchCandidatesJobsiteExternalCandidateIdRejectBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesJobsiteExternalCandidateIdReject>>,
  TError,
  { jobId: number; data: PostJobsJobIdMatchCandidatesJobsiteExternalCandidateIdRejectBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesJobsiteExternalCandidateIdReject>>,
    { jobId: number; data: PostJobsJobIdMatchCandidatesJobsiteExternalCandidateIdRejectBody }
  > = (props) => {
    const { jobId, data } = props ?? {};

    return postJobsJobIdMatchCandidatesJobsiteExternalCandidateIdReject(jobId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostJobsJobIdMatchCandidatesJobsiteExternalCandidateIdRejectMutationResult = NonNullable<
  Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesJobsiteExternalCandidateIdReject>>
>;
export type PostJobsJobIdMatchCandidatesJobsiteExternalCandidateIdRejectMutationBody =
  PostJobsJobIdMatchCandidatesJobsiteExternalCandidateIdRejectBody;
export type PostJobsJobIdMatchCandidatesJobsiteExternalCandidateIdRejectMutationError =
  | Status400
  | Status401
  | Status403
  | Status404;

export const usePostJobsJobIdMatchCandidatesJobsiteExternalCandidateIdReject = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesJobsiteExternalCandidateIdReject>>,
    TError,
    { jobId: number; data: PostJobsJobIdMatchCandidatesJobsiteExternalCandidateIdRejectBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostJobsJobIdMatchCandidatesJobsiteExternalCandidateIdRejectMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getJobsJobIdMatchCandidatesEMedCareersDefaultFilter = (jobId: number, signal?: AbortSignal) => {
  return customHttpClient<GetJobsJobIdMatchCandidatesEMedCareersDefaultFilter200>({
    url: `/jobs/${jobId}/match/candidates/e-med-careers/default-filter`,
    method: 'GET',
    signal,
  });
};

export const getGetJobsJobIdMatchCandidatesEMedCareersDefaultFilterQueryKey = (jobId: number) => {
  return [`/jobs/${jobId}/match/candidates/e-med-careers/default-filter`] as const;
};

export const getGetJobsJobIdMatchCandidatesEMedCareersDefaultFilterQueryOptions = <
  TData = Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesEMedCareersDefaultFilter>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  jobId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesEMedCareersDefaultFilter>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetJobsJobIdMatchCandidatesEMedCareersDefaultFilterQueryKey(jobId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesEMedCareersDefaultFilter>>> = ({
    signal,
  }) => getJobsJobIdMatchCandidatesEMedCareersDefaultFilter(jobId, signal);

  return { queryKey, queryFn, enabled: !!jobId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesEMedCareersDefaultFilter>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetJobsJobIdMatchCandidatesEMedCareersDefaultFilterQueryResult = NonNullable<
  Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesEMedCareersDefaultFilter>>
>;
export type GetJobsJobIdMatchCandidatesEMedCareersDefaultFilterQueryError =
  | Status400
  | Status401
  | Status403
  | Status404;

export const useGetJobsJobIdMatchCandidatesEMedCareersDefaultFilter = <
  TData = Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesEMedCareersDefaultFilter>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  jobId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesEMedCareersDefaultFilter>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetJobsJobIdMatchCandidatesEMedCareersDefaultFilterQueryOptions(jobId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postJobsJobIdMatchCandidatesEMedCareersSearch = (
  jobId: number,
  postJobsJobIdMatchCandidatesEMedCareersSearchBody: PostJobsJobIdMatchCandidatesEMedCareersSearchBody,
) => {
  return customHttpClient<PostJobsJobIdMatchCandidatesEMedCareersSearch200>({
    url: `/jobs/${jobId}/match/candidates/e-med-careers/search`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postJobsJobIdMatchCandidatesEMedCareersSearchBody,
  });
};

export const getPostJobsJobIdMatchCandidatesEMedCareersSearchMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesEMedCareersSearch>>,
    TError,
    { jobId: number; data: PostJobsJobIdMatchCandidatesEMedCareersSearchBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesEMedCareersSearch>>,
  TError,
  { jobId: number; data: PostJobsJobIdMatchCandidatesEMedCareersSearchBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesEMedCareersSearch>>,
    { jobId: number; data: PostJobsJobIdMatchCandidatesEMedCareersSearchBody }
  > = (props) => {
    const { jobId, data } = props ?? {};

    return postJobsJobIdMatchCandidatesEMedCareersSearch(jobId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostJobsJobIdMatchCandidatesEMedCareersSearchMutationResult = NonNullable<
  Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesEMedCareersSearch>>
>;
export type PostJobsJobIdMatchCandidatesEMedCareersSearchMutationBody =
  PostJobsJobIdMatchCandidatesEMedCareersSearchBody;
export type PostJobsJobIdMatchCandidatesEMedCareersSearchMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostJobsJobIdMatchCandidatesEMedCareersSearch = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesEMedCareersSearch>>,
    TError,
    { jobId: number; data: PostJobsJobIdMatchCandidatesEMedCareersSearchBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostJobsJobIdMatchCandidatesEMedCareersSearchMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postJobsJobIdMatchCandidatesEMedCareersExternalCandidateIdReject = (
  jobId: number,
  postJobsJobIdMatchCandidatesEMedCareersExternalCandidateIdRejectBody: PostJobsJobIdMatchCandidatesEMedCareersExternalCandidateIdRejectBody,
) => {
  return customHttpClient<PostJobsJobIdMatchCandidatesEMedCareersExternalCandidateIdReject200>({
    url: `/jobs/${jobId}/match/candidates/e-med-careers/:externalCandidateId/reject`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postJobsJobIdMatchCandidatesEMedCareersExternalCandidateIdRejectBody,
  });
};

export const getPostJobsJobIdMatchCandidatesEMedCareersExternalCandidateIdRejectMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesEMedCareersExternalCandidateIdReject>>,
    TError,
    { jobId: number; data: PostJobsJobIdMatchCandidatesEMedCareersExternalCandidateIdRejectBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesEMedCareersExternalCandidateIdReject>>,
  TError,
  { jobId: number; data: PostJobsJobIdMatchCandidatesEMedCareersExternalCandidateIdRejectBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesEMedCareersExternalCandidateIdReject>>,
    { jobId: number; data: PostJobsJobIdMatchCandidatesEMedCareersExternalCandidateIdRejectBody }
  > = (props) => {
    const { jobId, data } = props ?? {};

    return postJobsJobIdMatchCandidatesEMedCareersExternalCandidateIdReject(jobId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostJobsJobIdMatchCandidatesEMedCareersExternalCandidateIdRejectMutationResult = NonNullable<
  Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesEMedCareersExternalCandidateIdReject>>
>;
export type PostJobsJobIdMatchCandidatesEMedCareersExternalCandidateIdRejectMutationBody =
  PostJobsJobIdMatchCandidatesEMedCareersExternalCandidateIdRejectBody;
export type PostJobsJobIdMatchCandidatesEMedCareersExternalCandidateIdRejectMutationError =
  | Status400
  | Status401
  | Status403
  | Status404;

export const usePostJobsJobIdMatchCandidatesEMedCareersExternalCandidateIdReject = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesEMedCareersExternalCandidateIdReject>>,
    TError,
    { jobId: number; data: PostJobsJobIdMatchCandidatesEMedCareersExternalCandidateIdRejectBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostJobsJobIdMatchCandidatesEMedCareersExternalCandidateIdRejectMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getJobsJobIdMatchCandidatesReedDefaultFilter = (jobId: number, signal?: AbortSignal) => {
  return customHttpClient<GetJobsJobIdMatchCandidatesReedDefaultFilter200>({
    url: `/jobs/${jobId}/match/candidates/reed/default-filter`,
    method: 'GET',
    signal,
  });
};

export const getGetJobsJobIdMatchCandidatesReedDefaultFilterQueryKey = (jobId: number) => {
  return [`/jobs/${jobId}/match/candidates/reed/default-filter`] as const;
};

export const getGetJobsJobIdMatchCandidatesReedDefaultFilterQueryOptions = <
  TData = Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesReedDefaultFilter>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  jobId: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesReedDefaultFilter>>, TError, TData>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetJobsJobIdMatchCandidatesReedDefaultFilterQueryKey(jobId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesReedDefaultFilter>>> = ({
    signal,
  }) => getJobsJobIdMatchCandidatesReedDefaultFilter(jobId, signal);

  return { queryKey, queryFn, enabled: !!jobId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesReedDefaultFilter>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetJobsJobIdMatchCandidatesReedDefaultFilterQueryResult = NonNullable<
  Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesReedDefaultFilter>>
>;
export type GetJobsJobIdMatchCandidatesReedDefaultFilterQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetJobsJobIdMatchCandidatesReedDefaultFilter = <
  TData = Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesReedDefaultFilter>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  jobId: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesReedDefaultFilter>>, TError, TData>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetJobsJobIdMatchCandidatesReedDefaultFilterQueryOptions(jobId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postJobsJobIdMatchCandidatesReedSearch = (
  jobId: number,
  postJobsJobIdMatchCandidatesReedSearchBody: PostJobsJobIdMatchCandidatesReedSearchBody,
) => {
  return customHttpClient<PostJobsJobIdMatchCandidatesReedSearch200>({
    url: `/jobs/${jobId}/match/candidates/reed/search`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postJobsJobIdMatchCandidatesReedSearchBody,
  });
};

export const getPostJobsJobIdMatchCandidatesReedSearchMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesReedSearch>>,
    TError,
    { jobId: number; data: PostJobsJobIdMatchCandidatesReedSearchBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesReedSearch>>,
  TError,
  { jobId: number; data: PostJobsJobIdMatchCandidatesReedSearchBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesReedSearch>>,
    { jobId: number; data: PostJobsJobIdMatchCandidatesReedSearchBody }
  > = (props) => {
    const { jobId, data } = props ?? {};

    return postJobsJobIdMatchCandidatesReedSearch(jobId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostJobsJobIdMatchCandidatesReedSearchMutationResult = NonNullable<
  Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesReedSearch>>
>;
export type PostJobsJobIdMatchCandidatesReedSearchMutationBody = PostJobsJobIdMatchCandidatesReedSearchBody;
export type PostJobsJobIdMatchCandidatesReedSearchMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostJobsJobIdMatchCandidatesReedSearch = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesReedSearch>>,
    TError,
    { jobId: number; data: PostJobsJobIdMatchCandidatesReedSearchBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostJobsJobIdMatchCandidatesReedSearchMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postJobsJobIdMatchCandidatesReedExternalCandidateIdReject = (
  jobId: number,
  postJobsJobIdMatchCandidatesReedExternalCandidateIdRejectBody: PostJobsJobIdMatchCandidatesReedExternalCandidateIdRejectBody,
) => {
  return customHttpClient<PostJobsJobIdMatchCandidatesReedExternalCandidateIdReject200>({
    url: `/jobs/${jobId}/match/candidates/reed/:externalCandidateId/reject`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postJobsJobIdMatchCandidatesReedExternalCandidateIdRejectBody,
  });
};

export const getPostJobsJobIdMatchCandidatesReedExternalCandidateIdRejectMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesReedExternalCandidateIdReject>>,
    TError,
    { jobId: number; data: PostJobsJobIdMatchCandidatesReedExternalCandidateIdRejectBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesReedExternalCandidateIdReject>>,
  TError,
  { jobId: number; data: PostJobsJobIdMatchCandidatesReedExternalCandidateIdRejectBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesReedExternalCandidateIdReject>>,
    { jobId: number; data: PostJobsJobIdMatchCandidatesReedExternalCandidateIdRejectBody }
  > = (props) => {
    const { jobId, data } = props ?? {};

    return postJobsJobIdMatchCandidatesReedExternalCandidateIdReject(jobId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostJobsJobIdMatchCandidatesReedExternalCandidateIdRejectMutationResult = NonNullable<
  Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesReedExternalCandidateIdReject>>
>;
export type PostJobsJobIdMatchCandidatesReedExternalCandidateIdRejectMutationBody =
  PostJobsJobIdMatchCandidatesReedExternalCandidateIdRejectBody;
export type PostJobsJobIdMatchCandidatesReedExternalCandidateIdRejectMutationError =
  | Status400
  | Status401
  | Status403
  | Status404;

export const usePostJobsJobIdMatchCandidatesReedExternalCandidateIdReject = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesReedExternalCandidateIdReject>>,
    TError,
    { jobId: number; data: PostJobsJobIdMatchCandidatesReedExternalCandidateIdRejectBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostJobsJobIdMatchCandidatesReedExternalCandidateIdRejectMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getJobsJobIdMatchCandidatesTotaljobsDefaultFilter = (jobId: number, signal?: AbortSignal) => {
  return customHttpClient<GetJobsJobIdMatchCandidatesTotaljobsDefaultFilter200>({
    url: `/jobs/${jobId}/match/candidates/totaljobs/default-filter`,
    method: 'GET',
    signal,
  });
};

export const getGetJobsJobIdMatchCandidatesTotaljobsDefaultFilterQueryKey = (jobId: number) => {
  return [`/jobs/${jobId}/match/candidates/totaljobs/default-filter`] as const;
};

export const getGetJobsJobIdMatchCandidatesTotaljobsDefaultFilterQueryOptions = <
  TData = Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesTotaljobsDefaultFilter>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  jobId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesTotaljobsDefaultFilter>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetJobsJobIdMatchCandidatesTotaljobsDefaultFilterQueryKey(jobId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesTotaljobsDefaultFilter>>> = ({
    signal,
  }) => getJobsJobIdMatchCandidatesTotaljobsDefaultFilter(jobId, signal);

  return { queryKey, queryFn, enabled: !!jobId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesTotaljobsDefaultFilter>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetJobsJobIdMatchCandidatesTotaljobsDefaultFilterQueryResult = NonNullable<
  Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesTotaljobsDefaultFilter>>
>;
export type GetJobsJobIdMatchCandidatesTotaljobsDefaultFilterQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetJobsJobIdMatchCandidatesTotaljobsDefaultFilter = <
  TData = Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesTotaljobsDefaultFilter>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  jobId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesTotaljobsDefaultFilter>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetJobsJobIdMatchCandidatesTotaljobsDefaultFilterQueryOptions(jobId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postJobsJobIdMatchCandidatesTotaljobsSearch = (
  jobId: number,
  postJobsJobIdMatchCandidatesTotaljobsSearchBody: PostJobsJobIdMatchCandidatesTotaljobsSearchBody,
) => {
  return customHttpClient<PostJobsJobIdMatchCandidatesTotaljobsSearch200>({
    url: `/jobs/${jobId}/match/candidates/totaljobs/search`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postJobsJobIdMatchCandidatesTotaljobsSearchBody,
  });
};

export const getPostJobsJobIdMatchCandidatesTotaljobsSearchMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesTotaljobsSearch>>,
    TError,
    { jobId: number; data: PostJobsJobIdMatchCandidatesTotaljobsSearchBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesTotaljobsSearch>>,
  TError,
  { jobId: number; data: PostJobsJobIdMatchCandidatesTotaljobsSearchBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesTotaljobsSearch>>,
    { jobId: number; data: PostJobsJobIdMatchCandidatesTotaljobsSearchBody }
  > = (props) => {
    const { jobId, data } = props ?? {};

    return postJobsJobIdMatchCandidatesTotaljobsSearch(jobId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostJobsJobIdMatchCandidatesTotaljobsSearchMutationResult = NonNullable<
  Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesTotaljobsSearch>>
>;
export type PostJobsJobIdMatchCandidatesTotaljobsSearchMutationBody = PostJobsJobIdMatchCandidatesTotaljobsSearchBody;
export type PostJobsJobIdMatchCandidatesTotaljobsSearchMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostJobsJobIdMatchCandidatesTotaljobsSearch = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesTotaljobsSearch>>,
    TError,
    { jobId: number; data: PostJobsJobIdMatchCandidatesTotaljobsSearchBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostJobsJobIdMatchCandidatesTotaljobsSearchMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postJobsJobIdMatchCandidatesTotaljobsExternalCandidateIdReject = (
  jobId: number,
  postJobsJobIdMatchCandidatesTotaljobsExternalCandidateIdRejectBody: PostJobsJobIdMatchCandidatesTotaljobsExternalCandidateIdRejectBody,
) => {
  return customHttpClient<PostJobsJobIdMatchCandidatesTotaljobsExternalCandidateIdReject200>({
    url: `/jobs/${jobId}/match/candidates/totaljobs/:externalCandidateId/reject`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postJobsJobIdMatchCandidatesTotaljobsExternalCandidateIdRejectBody,
  });
};

export const getPostJobsJobIdMatchCandidatesTotaljobsExternalCandidateIdRejectMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesTotaljobsExternalCandidateIdReject>>,
    TError,
    { jobId: number; data: PostJobsJobIdMatchCandidatesTotaljobsExternalCandidateIdRejectBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesTotaljobsExternalCandidateIdReject>>,
  TError,
  { jobId: number; data: PostJobsJobIdMatchCandidatesTotaljobsExternalCandidateIdRejectBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesTotaljobsExternalCandidateIdReject>>,
    { jobId: number; data: PostJobsJobIdMatchCandidatesTotaljobsExternalCandidateIdRejectBody }
  > = (props) => {
    const { jobId, data } = props ?? {};

    return postJobsJobIdMatchCandidatesTotaljobsExternalCandidateIdReject(jobId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostJobsJobIdMatchCandidatesTotaljobsExternalCandidateIdRejectMutationResult = NonNullable<
  Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesTotaljobsExternalCandidateIdReject>>
>;
export type PostJobsJobIdMatchCandidatesTotaljobsExternalCandidateIdRejectMutationBody =
  PostJobsJobIdMatchCandidatesTotaljobsExternalCandidateIdRejectBody;
export type PostJobsJobIdMatchCandidatesTotaljobsExternalCandidateIdRejectMutationError =
  | Status400
  | Status401
  | Status403
  | Status404;

export const usePostJobsJobIdMatchCandidatesTotaljobsExternalCandidateIdReject = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesTotaljobsExternalCandidateIdReject>>,
    TError,
    { jobId: number; data: PostJobsJobIdMatchCandidatesTotaljobsExternalCandidateIdRejectBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostJobsJobIdMatchCandidatesTotaljobsExternalCandidateIdRejectMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getJobsJobIdMatchCandidatesMatchGptDefaultFilter = (jobId: number, signal?: AbortSignal) => {
  return customHttpClient<GetJobsJobIdMatchCandidatesMatchGptDefaultFilter200>({
    url: `/jobs/${jobId}/match/candidates/match-gpt/default-filter`,
    method: 'GET',
    signal,
  });
};

export const getGetJobsJobIdMatchCandidatesMatchGptDefaultFilterQueryKey = (jobId: number) => {
  return [`/jobs/${jobId}/match/candidates/match-gpt/default-filter`] as const;
};

export const getGetJobsJobIdMatchCandidatesMatchGptDefaultFilterQueryOptions = <
  TData = Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesMatchGptDefaultFilter>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  jobId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesMatchGptDefaultFilter>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetJobsJobIdMatchCandidatesMatchGptDefaultFilterQueryKey(jobId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesMatchGptDefaultFilter>>> = ({
    signal,
  }) => getJobsJobIdMatchCandidatesMatchGptDefaultFilter(jobId, signal);

  return { queryKey, queryFn, enabled: !!jobId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesMatchGptDefaultFilter>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetJobsJobIdMatchCandidatesMatchGptDefaultFilterQueryResult = NonNullable<
  Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesMatchGptDefaultFilter>>
>;
export type GetJobsJobIdMatchCandidatesMatchGptDefaultFilterQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetJobsJobIdMatchCandidatesMatchGptDefaultFilter = <
  TData = Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesMatchGptDefaultFilter>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  jobId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesMatchGptDefaultFilter>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetJobsJobIdMatchCandidatesMatchGptDefaultFilterQueryOptions(jobId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getJobsJobIdMatchCandidatesMatchGptFilterOptions = (jobId: number, signal?: AbortSignal) => {
  return customHttpClient<GetJobsJobIdMatchCandidatesMatchGptFilterOptions200>({
    url: `/jobs/${jobId}/match/candidates/match-gpt/filter-options`,
    method: 'GET',
    signal,
  });
};

export const getGetJobsJobIdMatchCandidatesMatchGptFilterOptionsQueryKey = (jobId: number) => {
  return [`/jobs/${jobId}/match/candidates/match-gpt/filter-options`] as const;
};

export const getGetJobsJobIdMatchCandidatesMatchGptFilterOptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesMatchGptFilterOptions>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  jobId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesMatchGptFilterOptions>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetJobsJobIdMatchCandidatesMatchGptFilterOptionsQueryKey(jobId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesMatchGptFilterOptions>>> = ({
    signal,
  }) => getJobsJobIdMatchCandidatesMatchGptFilterOptions(jobId, signal);

  return { queryKey, queryFn, enabled: !!jobId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesMatchGptFilterOptions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetJobsJobIdMatchCandidatesMatchGptFilterOptionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesMatchGptFilterOptions>>
>;
export type GetJobsJobIdMatchCandidatesMatchGptFilterOptionsQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetJobsJobIdMatchCandidatesMatchGptFilterOptions = <
  TData = Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesMatchGptFilterOptions>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  jobId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesMatchGptFilterOptions>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetJobsJobIdMatchCandidatesMatchGptFilterOptionsQueryOptions(jobId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postJobsJobIdMatchCandidatesMatchGptSearch = (
  jobId: number,
  postJobsJobIdMatchCandidatesMatchGptSearchBody: PostJobsJobIdMatchCandidatesMatchGptSearchBody,
) => {
  return customHttpClient<PostJobsJobIdMatchCandidatesMatchGptSearch200>({
    url: `/jobs/${jobId}/match/candidates/match-gpt/search`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postJobsJobIdMatchCandidatesMatchGptSearchBody,
  });
};

export const getPostJobsJobIdMatchCandidatesMatchGptSearchMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesMatchGptSearch>>,
    TError,
    { jobId: number; data: PostJobsJobIdMatchCandidatesMatchGptSearchBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesMatchGptSearch>>,
  TError,
  { jobId: number; data: PostJobsJobIdMatchCandidatesMatchGptSearchBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesMatchGptSearch>>,
    { jobId: number; data: PostJobsJobIdMatchCandidatesMatchGptSearchBody }
  > = (props) => {
    const { jobId, data } = props ?? {};

    return postJobsJobIdMatchCandidatesMatchGptSearch(jobId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostJobsJobIdMatchCandidatesMatchGptSearchMutationResult = NonNullable<
  Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesMatchGptSearch>>
>;
export type PostJobsJobIdMatchCandidatesMatchGptSearchMutationBody = PostJobsJobIdMatchCandidatesMatchGptSearchBody;
export type PostJobsJobIdMatchCandidatesMatchGptSearchMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostJobsJobIdMatchCandidatesMatchGptSearch = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesMatchGptSearch>>,
    TError,
    { jobId: number; data: PostJobsJobIdMatchCandidatesMatchGptSearchBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostJobsJobIdMatchCandidatesMatchGptSearchMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postJobsJobIdMatchCandidatesMatchGptExternalCandidateIdReject = (
  jobId: number,
  postJobsJobIdMatchCandidatesMatchGptExternalCandidateIdRejectBody: PostJobsJobIdMatchCandidatesMatchGptExternalCandidateIdRejectBody,
) => {
  return customHttpClient<PostJobsJobIdMatchCandidatesMatchGptExternalCandidateIdReject200>({
    url: `/jobs/${jobId}/match/candidates/match-gpt/:externalCandidateId/reject`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postJobsJobIdMatchCandidatesMatchGptExternalCandidateIdRejectBody,
  });
};

export const getPostJobsJobIdMatchCandidatesMatchGptExternalCandidateIdRejectMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesMatchGptExternalCandidateIdReject>>,
    TError,
    { jobId: number; data: PostJobsJobIdMatchCandidatesMatchGptExternalCandidateIdRejectBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesMatchGptExternalCandidateIdReject>>,
  TError,
  { jobId: number; data: PostJobsJobIdMatchCandidatesMatchGptExternalCandidateIdRejectBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesMatchGptExternalCandidateIdReject>>,
    { jobId: number; data: PostJobsJobIdMatchCandidatesMatchGptExternalCandidateIdRejectBody }
  > = (props) => {
    const { jobId, data } = props ?? {};

    return postJobsJobIdMatchCandidatesMatchGptExternalCandidateIdReject(jobId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostJobsJobIdMatchCandidatesMatchGptExternalCandidateIdRejectMutationResult = NonNullable<
  Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesMatchGptExternalCandidateIdReject>>
>;
export type PostJobsJobIdMatchCandidatesMatchGptExternalCandidateIdRejectMutationBody =
  PostJobsJobIdMatchCandidatesMatchGptExternalCandidateIdRejectBody;
export type PostJobsJobIdMatchCandidatesMatchGptExternalCandidateIdRejectMutationError =
  | Status400
  | Status401
  | Status403
  | Status404;

export const usePostJobsJobIdMatchCandidatesMatchGptExternalCandidateIdReject = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesMatchGptExternalCandidateIdReject>>,
    TError,
    { jobId: number; data: PostJobsJobIdMatchCandidatesMatchGptExternalCandidateIdRejectBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostJobsJobIdMatchCandidatesMatchGptExternalCandidateIdRejectMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getJobsJobIdMatchCandidatesTotaljobsGroupDefaultFilter = (jobId: number, signal?: AbortSignal) => {
  return customHttpClient<GetJobsJobIdMatchCandidatesTotaljobsGroupDefaultFilter200>({
    url: `/jobs/${jobId}/match/candidates/totaljobs-group/default-filter`,
    method: 'GET',
    signal,
  });
};

export const getGetJobsJobIdMatchCandidatesTotaljobsGroupDefaultFilterQueryKey = (jobId: number) => {
  return [`/jobs/${jobId}/match/candidates/totaljobs-group/default-filter`] as const;
};

export const getGetJobsJobIdMatchCandidatesTotaljobsGroupDefaultFilterQueryOptions = <
  TData = Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesTotaljobsGroupDefaultFilter>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  jobId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesTotaljobsGroupDefaultFilter>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetJobsJobIdMatchCandidatesTotaljobsGroupDefaultFilterQueryKey(jobId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesTotaljobsGroupDefaultFilter>>> = ({
    signal,
  }) => getJobsJobIdMatchCandidatesTotaljobsGroupDefaultFilter(jobId, signal);

  return { queryKey, queryFn, enabled: !!jobId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesTotaljobsGroupDefaultFilter>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetJobsJobIdMatchCandidatesTotaljobsGroupDefaultFilterQueryResult = NonNullable<
  Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesTotaljobsGroupDefaultFilter>>
>;
export type GetJobsJobIdMatchCandidatesTotaljobsGroupDefaultFilterQueryError =
  | Status400
  | Status401
  | Status403
  | Status404;

export const useGetJobsJobIdMatchCandidatesTotaljobsGroupDefaultFilter = <
  TData = Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesTotaljobsGroupDefaultFilter>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  jobId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesTotaljobsGroupDefaultFilter>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetJobsJobIdMatchCandidatesTotaljobsGroupDefaultFilterQueryOptions(jobId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postJobsJobIdMatchCandidatesTotaljobsGroupSearch = (
  jobId: number,
  postJobsJobIdMatchCandidatesTotaljobsGroupSearchBody: PostJobsJobIdMatchCandidatesTotaljobsGroupSearchBody,
) => {
  return customHttpClient<PostJobsJobIdMatchCandidatesTotaljobsGroupSearch200>({
    url: `/jobs/${jobId}/match/candidates/totaljobs-group/search`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postJobsJobIdMatchCandidatesTotaljobsGroupSearchBody,
  });
};

export const getPostJobsJobIdMatchCandidatesTotaljobsGroupSearchMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesTotaljobsGroupSearch>>,
    TError,
    { jobId: number; data: PostJobsJobIdMatchCandidatesTotaljobsGroupSearchBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesTotaljobsGroupSearch>>,
  TError,
  { jobId: number; data: PostJobsJobIdMatchCandidatesTotaljobsGroupSearchBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesTotaljobsGroupSearch>>,
    { jobId: number; data: PostJobsJobIdMatchCandidatesTotaljobsGroupSearchBody }
  > = (props) => {
    const { jobId, data } = props ?? {};

    return postJobsJobIdMatchCandidatesTotaljobsGroupSearch(jobId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostJobsJobIdMatchCandidatesTotaljobsGroupSearchMutationResult = NonNullable<
  Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesTotaljobsGroupSearch>>
>;
export type PostJobsJobIdMatchCandidatesTotaljobsGroupSearchMutationBody =
  PostJobsJobIdMatchCandidatesTotaljobsGroupSearchBody;
export type PostJobsJobIdMatchCandidatesTotaljobsGroupSearchMutationError =
  | Status400
  | Status401
  | Status403
  | Status404;

export const usePostJobsJobIdMatchCandidatesTotaljobsGroupSearch = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesTotaljobsGroupSearch>>,
    TError,
    { jobId: number; data: PostJobsJobIdMatchCandidatesTotaljobsGroupSearchBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostJobsJobIdMatchCandidatesTotaljobsGroupSearchMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postJobsJobIdMatchCandidatesTotaljobsGroupExternalCandidateIdReject = (
  jobId: number,
  postJobsJobIdMatchCandidatesTotaljobsGroupExternalCandidateIdRejectBody: PostJobsJobIdMatchCandidatesTotaljobsGroupExternalCandidateIdRejectBody,
) => {
  return customHttpClient<PostJobsJobIdMatchCandidatesTotaljobsGroupExternalCandidateIdReject200>({
    url: `/jobs/${jobId}/match/candidates/totaljobs-group/:externalCandidateId/reject`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postJobsJobIdMatchCandidatesTotaljobsGroupExternalCandidateIdRejectBody,
  });
};

export const getPostJobsJobIdMatchCandidatesTotaljobsGroupExternalCandidateIdRejectMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesTotaljobsGroupExternalCandidateIdReject>>,
    TError,
    { jobId: number; data: PostJobsJobIdMatchCandidatesTotaljobsGroupExternalCandidateIdRejectBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesTotaljobsGroupExternalCandidateIdReject>>,
  TError,
  { jobId: number; data: PostJobsJobIdMatchCandidatesTotaljobsGroupExternalCandidateIdRejectBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesTotaljobsGroupExternalCandidateIdReject>>,
    { jobId: number; data: PostJobsJobIdMatchCandidatesTotaljobsGroupExternalCandidateIdRejectBody }
  > = (props) => {
    const { jobId, data } = props ?? {};

    return postJobsJobIdMatchCandidatesTotaljobsGroupExternalCandidateIdReject(jobId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostJobsJobIdMatchCandidatesTotaljobsGroupExternalCandidateIdRejectMutationResult = NonNullable<
  Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesTotaljobsGroupExternalCandidateIdReject>>
>;
export type PostJobsJobIdMatchCandidatesTotaljobsGroupExternalCandidateIdRejectMutationBody =
  PostJobsJobIdMatchCandidatesTotaljobsGroupExternalCandidateIdRejectBody;
export type PostJobsJobIdMatchCandidatesTotaljobsGroupExternalCandidateIdRejectMutationError =
  | Status400
  | Status401
  | Status403
  | Status404;

export const usePostJobsJobIdMatchCandidatesTotaljobsGroupExternalCandidateIdReject = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesTotaljobsGroupExternalCandidateIdReject>>,
    TError,
    { jobId: number; data: PostJobsJobIdMatchCandidatesTotaljobsGroupExternalCandidateIdRejectBody },
    TContext
  >;
}) => {
  const mutationOptions =
    getPostJobsJobIdMatchCandidatesTotaljobsGroupExternalCandidateIdRejectMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getJobsJobIdMatchCandidatesCvLibraryDefaultFilter = (jobId: number, signal?: AbortSignal) => {
  return customHttpClient<GetJobsJobIdMatchCandidatesCvLibraryDefaultFilter200>({
    url: `/jobs/${jobId}/match/candidates/cv-library/default-filter`,
    method: 'GET',
    signal,
  });
};

export const getGetJobsJobIdMatchCandidatesCvLibraryDefaultFilterQueryKey = (jobId: number) => {
  return [`/jobs/${jobId}/match/candidates/cv-library/default-filter`] as const;
};

export const getGetJobsJobIdMatchCandidatesCvLibraryDefaultFilterQueryOptions = <
  TData = Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesCvLibraryDefaultFilter>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  jobId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesCvLibraryDefaultFilter>>,
      TError,
      TData
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetJobsJobIdMatchCandidatesCvLibraryDefaultFilterQueryKey(jobId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesCvLibraryDefaultFilter>>> = ({
    signal,
  }) => getJobsJobIdMatchCandidatesCvLibraryDefaultFilter(jobId, signal);

  return { queryKey, queryFn, enabled: !!jobId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesCvLibraryDefaultFilter>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetJobsJobIdMatchCandidatesCvLibraryDefaultFilterQueryResult = NonNullable<
  Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesCvLibraryDefaultFilter>>
>;
export type GetJobsJobIdMatchCandidatesCvLibraryDefaultFilterQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetJobsJobIdMatchCandidatesCvLibraryDefaultFilter = <
  TData = Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesCvLibraryDefaultFilter>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  jobId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getJobsJobIdMatchCandidatesCvLibraryDefaultFilter>>,
      TError,
      TData
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetJobsJobIdMatchCandidatesCvLibraryDefaultFilterQueryOptions(jobId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postJobsJobIdMatchCandidatesCvLibrarySearch = (
  jobId: number,
  postJobsJobIdMatchCandidatesCvLibrarySearchBody: PostJobsJobIdMatchCandidatesCvLibrarySearchBody,
) => {
  return customHttpClient<PostJobsJobIdMatchCandidatesCvLibrarySearch200>({
    url: `/jobs/${jobId}/match/candidates/cv-library/search`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postJobsJobIdMatchCandidatesCvLibrarySearchBody,
  });
};

export const getPostJobsJobIdMatchCandidatesCvLibrarySearchMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesCvLibrarySearch>>,
    TError,
    { jobId: number; data: PostJobsJobIdMatchCandidatesCvLibrarySearchBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesCvLibrarySearch>>,
  TError,
  { jobId: number; data: PostJobsJobIdMatchCandidatesCvLibrarySearchBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesCvLibrarySearch>>,
    { jobId: number; data: PostJobsJobIdMatchCandidatesCvLibrarySearchBody }
  > = (props) => {
    const { jobId, data } = props ?? {};

    return postJobsJobIdMatchCandidatesCvLibrarySearch(jobId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostJobsJobIdMatchCandidatesCvLibrarySearchMutationResult = NonNullable<
  Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesCvLibrarySearch>>
>;
export type PostJobsJobIdMatchCandidatesCvLibrarySearchMutationBody = PostJobsJobIdMatchCandidatesCvLibrarySearchBody;
export type PostJobsJobIdMatchCandidatesCvLibrarySearchMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostJobsJobIdMatchCandidatesCvLibrarySearch = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesCvLibrarySearch>>,
    TError,
    { jobId: number; data: PostJobsJobIdMatchCandidatesCvLibrarySearchBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostJobsJobIdMatchCandidatesCvLibrarySearchMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postJobsJobIdMatchCandidatesCvLibraryExternalCandidateIdReject = (
  jobId: number,
  postJobsJobIdMatchCandidatesCvLibraryExternalCandidateIdRejectBody: PostJobsJobIdMatchCandidatesCvLibraryExternalCandidateIdRejectBody,
) => {
  return customHttpClient<PostJobsJobIdMatchCandidatesCvLibraryExternalCandidateIdReject200>({
    url: `/jobs/${jobId}/match/candidates/cv-library/:externalCandidateId/reject`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postJobsJobIdMatchCandidatesCvLibraryExternalCandidateIdRejectBody,
  });
};

export const getPostJobsJobIdMatchCandidatesCvLibraryExternalCandidateIdRejectMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesCvLibraryExternalCandidateIdReject>>,
    TError,
    { jobId: number; data: PostJobsJobIdMatchCandidatesCvLibraryExternalCandidateIdRejectBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesCvLibraryExternalCandidateIdReject>>,
  TError,
  { jobId: number; data: PostJobsJobIdMatchCandidatesCvLibraryExternalCandidateIdRejectBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesCvLibraryExternalCandidateIdReject>>,
    { jobId: number; data: PostJobsJobIdMatchCandidatesCvLibraryExternalCandidateIdRejectBody }
  > = (props) => {
    const { jobId, data } = props ?? {};

    return postJobsJobIdMatchCandidatesCvLibraryExternalCandidateIdReject(jobId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostJobsJobIdMatchCandidatesCvLibraryExternalCandidateIdRejectMutationResult = NonNullable<
  Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesCvLibraryExternalCandidateIdReject>>
>;
export type PostJobsJobIdMatchCandidatesCvLibraryExternalCandidateIdRejectMutationBody =
  PostJobsJobIdMatchCandidatesCvLibraryExternalCandidateIdRejectBody;
export type PostJobsJobIdMatchCandidatesCvLibraryExternalCandidateIdRejectMutationError =
  | Status400
  | Status401
  | Status403
  | Status404;

export const usePostJobsJobIdMatchCandidatesCvLibraryExternalCandidateIdReject = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdMatchCandidatesCvLibraryExternalCandidateIdReject>>,
    TError,
    { jobId: number; data: PostJobsJobIdMatchCandidatesCvLibraryExternalCandidateIdRejectBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostJobsJobIdMatchCandidatesCvLibraryExternalCandidateIdRejectMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getJobsMatchCandidatesCatererFilterOptions = (signal?: AbortSignal) => {
  return customHttpClient<GetJobsMatchCandidatesCatererFilterOptions200>({
    url: `/jobs/match/candidates/caterer/filter-options`,
    method: 'GET',
    signal,
  });
};

export const getGetJobsMatchCandidatesCatererFilterOptionsQueryKey = () => {
  return [`/jobs/match/candidates/caterer/filter-options`] as const;
};

export const getGetJobsMatchCandidatesCatererFilterOptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getJobsMatchCandidatesCatererFilterOptions>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getJobsMatchCandidatesCatererFilterOptions>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetJobsMatchCandidatesCatererFilterOptionsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobsMatchCandidatesCatererFilterOptions>>> = ({ signal }) =>
    getJobsMatchCandidatesCatererFilterOptions(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getJobsMatchCandidatesCatererFilterOptions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetJobsMatchCandidatesCatererFilterOptionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getJobsMatchCandidatesCatererFilterOptions>>
>;
export type GetJobsMatchCandidatesCatererFilterOptionsQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetJobsMatchCandidatesCatererFilterOptions = <
  TData = Awaited<ReturnType<typeof getJobsMatchCandidatesCatererFilterOptions>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getJobsMatchCandidatesCatererFilterOptions>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetJobsMatchCandidatesCatererFilterOptionsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getJobsMatchCandidatesJobsiteFilterOptions = (signal?: AbortSignal) => {
  return customHttpClient<GetJobsMatchCandidatesJobsiteFilterOptions200>({
    url: `/jobs/match/candidates/jobsite/filter-options`,
    method: 'GET',
    signal,
  });
};

export const getGetJobsMatchCandidatesJobsiteFilterOptionsQueryKey = () => {
  return [`/jobs/match/candidates/jobsite/filter-options`] as const;
};

export const getGetJobsMatchCandidatesJobsiteFilterOptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getJobsMatchCandidatesJobsiteFilterOptions>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getJobsMatchCandidatesJobsiteFilterOptions>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetJobsMatchCandidatesJobsiteFilterOptionsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobsMatchCandidatesJobsiteFilterOptions>>> = ({ signal }) =>
    getJobsMatchCandidatesJobsiteFilterOptions(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getJobsMatchCandidatesJobsiteFilterOptions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetJobsMatchCandidatesJobsiteFilterOptionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getJobsMatchCandidatesJobsiteFilterOptions>>
>;
export type GetJobsMatchCandidatesJobsiteFilterOptionsQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetJobsMatchCandidatesJobsiteFilterOptions = <
  TData = Awaited<ReturnType<typeof getJobsMatchCandidatesJobsiteFilterOptions>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getJobsMatchCandidatesJobsiteFilterOptions>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetJobsMatchCandidatesJobsiteFilterOptionsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getJobsMatchCandidatesEMedCareersFilterOptions = (signal?: AbortSignal) => {
  return customHttpClient<GetJobsMatchCandidatesEMedCareersFilterOptions200>({
    url: `/jobs/match/candidates/e-med-careers/filter-options`,
    method: 'GET',
    signal,
  });
};

export const getGetJobsMatchCandidatesEMedCareersFilterOptionsQueryKey = () => {
  return [`/jobs/match/candidates/e-med-careers/filter-options`] as const;
};

export const getGetJobsMatchCandidatesEMedCareersFilterOptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getJobsMatchCandidatesEMedCareersFilterOptions>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getJobsMatchCandidatesEMedCareersFilterOptions>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetJobsMatchCandidatesEMedCareersFilterOptionsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobsMatchCandidatesEMedCareersFilterOptions>>> = ({
    signal,
  }) => getJobsMatchCandidatesEMedCareersFilterOptions(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getJobsMatchCandidatesEMedCareersFilterOptions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetJobsMatchCandidatesEMedCareersFilterOptionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getJobsMatchCandidatesEMedCareersFilterOptions>>
>;
export type GetJobsMatchCandidatesEMedCareersFilterOptionsQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetJobsMatchCandidatesEMedCareersFilterOptions = <
  TData = Awaited<ReturnType<typeof getJobsMatchCandidatesEMedCareersFilterOptions>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getJobsMatchCandidatesEMedCareersFilterOptions>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetJobsMatchCandidatesEMedCareersFilterOptionsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getJobsMatchCandidatesReedFilterOptions = (signal?: AbortSignal) => {
  return customHttpClient<GetJobsMatchCandidatesReedFilterOptions200>({
    url: `/jobs/match/candidates/reed/filter-options`,
    method: 'GET',
    signal,
  });
};

export const getGetJobsMatchCandidatesReedFilterOptionsQueryKey = () => {
  return [`/jobs/match/candidates/reed/filter-options`] as const;
};

export const getGetJobsMatchCandidatesReedFilterOptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getJobsMatchCandidatesReedFilterOptions>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getJobsMatchCandidatesReedFilterOptions>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetJobsMatchCandidatesReedFilterOptionsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobsMatchCandidatesReedFilterOptions>>> = ({ signal }) =>
    getJobsMatchCandidatesReedFilterOptions(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getJobsMatchCandidatesReedFilterOptions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetJobsMatchCandidatesReedFilterOptionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getJobsMatchCandidatesReedFilterOptions>>
>;
export type GetJobsMatchCandidatesReedFilterOptionsQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetJobsMatchCandidatesReedFilterOptions = <
  TData = Awaited<ReturnType<typeof getJobsMatchCandidatesReedFilterOptions>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getJobsMatchCandidatesReedFilterOptions>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetJobsMatchCandidatesReedFilterOptionsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getJobsMatchCandidatesTotaljobsFilterOptions = (signal?: AbortSignal) => {
  return customHttpClient<GetJobsMatchCandidatesTotaljobsFilterOptions200>({
    url: `/jobs/match/candidates/totaljobs/filter-options`,
    method: 'GET',
    signal,
  });
};

export const getGetJobsMatchCandidatesTotaljobsFilterOptionsQueryKey = () => {
  return [`/jobs/match/candidates/totaljobs/filter-options`] as const;
};

export const getGetJobsMatchCandidatesTotaljobsFilterOptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getJobsMatchCandidatesTotaljobsFilterOptions>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getJobsMatchCandidatesTotaljobsFilterOptions>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetJobsMatchCandidatesTotaljobsFilterOptionsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobsMatchCandidatesTotaljobsFilterOptions>>> = ({
    signal,
  }) => getJobsMatchCandidatesTotaljobsFilterOptions(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getJobsMatchCandidatesTotaljobsFilterOptions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetJobsMatchCandidatesTotaljobsFilterOptionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getJobsMatchCandidatesTotaljobsFilterOptions>>
>;
export type GetJobsMatchCandidatesTotaljobsFilterOptionsQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetJobsMatchCandidatesTotaljobsFilterOptions = <
  TData = Awaited<ReturnType<typeof getJobsMatchCandidatesTotaljobsFilterOptions>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getJobsMatchCandidatesTotaljobsFilterOptions>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetJobsMatchCandidatesTotaljobsFilterOptionsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getJobsMatchCandidatesTotaljobsGroupFilterOptions = (signal?: AbortSignal) => {
  return customHttpClient<GetJobsMatchCandidatesTotaljobsGroupFilterOptions200>({
    url: `/jobs/match/candidates/totaljobs-group/filter-options`,
    method: 'GET',
    signal,
  });
};

export const getGetJobsMatchCandidatesTotaljobsGroupFilterOptionsQueryKey = () => {
  return [`/jobs/match/candidates/totaljobs-group/filter-options`] as const;
};

export const getGetJobsMatchCandidatesTotaljobsGroupFilterOptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getJobsMatchCandidatesTotaljobsGroupFilterOptions>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getJobsMatchCandidatesTotaljobsGroupFilterOptions>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetJobsMatchCandidatesTotaljobsGroupFilterOptionsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobsMatchCandidatesTotaljobsGroupFilterOptions>>> = ({
    signal,
  }) => getJobsMatchCandidatesTotaljobsGroupFilterOptions(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getJobsMatchCandidatesTotaljobsGroupFilterOptions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetJobsMatchCandidatesTotaljobsGroupFilterOptionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getJobsMatchCandidatesTotaljobsGroupFilterOptions>>
>;
export type GetJobsMatchCandidatesTotaljobsGroupFilterOptionsQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetJobsMatchCandidatesTotaljobsGroupFilterOptions = <
  TData = Awaited<ReturnType<typeof getJobsMatchCandidatesTotaljobsGroupFilterOptions>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getJobsMatchCandidatesTotaljobsGroupFilterOptions>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetJobsMatchCandidatesTotaljobsGroupFilterOptionsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getJobsMatchCandidatesCvLibraryFilterOptions = (signal?: AbortSignal) => {
  return customHttpClient<GetJobsMatchCandidatesCvLibraryFilterOptions200>({
    url: `/jobs/match/candidates/cv-library/filter-options`,
    method: 'GET',
    signal,
  });
};

export const getGetJobsMatchCandidatesCvLibraryFilterOptionsQueryKey = () => {
  return [`/jobs/match/candidates/cv-library/filter-options`] as const;
};

export const getGetJobsMatchCandidatesCvLibraryFilterOptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getJobsMatchCandidatesCvLibraryFilterOptions>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getJobsMatchCandidatesCvLibraryFilterOptions>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetJobsMatchCandidatesCvLibraryFilterOptionsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobsMatchCandidatesCvLibraryFilterOptions>>> = ({
    signal,
  }) => getJobsMatchCandidatesCvLibraryFilterOptions(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getJobsMatchCandidatesCvLibraryFilterOptions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetJobsMatchCandidatesCvLibraryFilterOptionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getJobsMatchCandidatesCvLibraryFilterOptions>>
>;
export type GetJobsMatchCandidatesCvLibraryFilterOptionsQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetJobsMatchCandidatesCvLibraryFilterOptions = <
  TData = Awaited<ReturnType<typeof getJobsMatchCandidatesCvLibraryFilterOptions>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getJobsMatchCandidatesCvLibraryFilterOptions>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetJobsMatchCandidatesCvLibraryFilterOptionsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postJobsMatchSearch = (postJobsMatchSearchBody: PostJobsMatchSearchBody) => {
  return customHttpClient<PostJobsMatchSearch200>({
    url: `/jobs/match/search`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postJobsMatchSearchBody,
  });
};

export const getPostJobsMatchSearchMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsMatchSearch>>,
    TError,
    { data: PostJobsMatchSearchBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postJobsMatchSearch>>,
  TError,
  { data: PostJobsMatchSearchBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postJobsMatchSearch>>,
    { data: PostJobsMatchSearchBody }
  > = (props) => {
    const { data } = props ?? {};

    return postJobsMatchSearch(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostJobsMatchSearchMutationResult = NonNullable<Awaited<ReturnType<typeof postJobsMatchSearch>>>;
export type PostJobsMatchSearchMutationBody = PostJobsMatchSearchBody;
export type PostJobsMatchSearchMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostJobsMatchSearch = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsMatchSearch>>,
    TError,
    { data: PostJobsMatchSearchBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostJobsMatchSearchMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getJobsPipelinesFilterOptions = (signal?: AbortSignal) => {
  return customHttpClient<GetJobsPipelinesFilterOptions200>({
    url: `/jobs/pipelines/filter-options`,
    method: 'GET',
    signal,
  });
};

export const getGetJobsPipelinesFilterOptionsQueryKey = () => {
  return [`/jobs/pipelines/filter-options`] as const;
};

export const getGetJobsPipelinesFilterOptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getJobsPipelinesFilterOptions>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getJobsPipelinesFilterOptions>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetJobsPipelinesFilterOptionsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobsPipelinesFilterOptions>>> = ({ signal }) =>
    getJobsPipelinesFilterOptions(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getJobsPipelinesFilterOptions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetJobsPipelinesFilterOptionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getJobsPipelinesFilterOptions>>
>;
export type GetJobsPipelinesFilterOptionsQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetJobsPipelinesFilterOptions = <
  TData = Awaited<ReturnType<typeof getJobsPipelinesFilterOptions>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getJobsPipelinesFilterOptions>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetJobsPipelinesFilterOptionsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postJobsPipelinesSearch = (postJobsPipelinesSearchBody: PostJobsPipelinesSearchBody) => {
  return customHttpClient<PostJobsPipelinesSearch200>({
    url: `/jobs/pipelines/search`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postJobsPipelinesSearchBody,
  });
};

export const getPostJobsPipelinesSearchMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsPipelinesSearch>>,
    TError,
    { data: PostJobsPipelinesSearchBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postJobsPipelinesSearch>>,
  TError,
  { data: PostJobsPipelinesSearchBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postJobsPipelinesSearch>>,
    { data: PostJobsPipelinesSearchBody }
  > = (props) => {
    const { data } = props ?? {};

    return postJobsPipelinesSearch(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostJobsPipelinesSearchMutationResult = NonNullable<Awaited<ReturnType<typeof postJobsPipelinesSearch>>>;
export type PostJobsPipelinesSearchMutationBody = PostJobsPipelinesSearchBody;
export type PostJobsPipelinesSearchMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostJobsPipelinesSearch = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsPipelinesSearch>>,
    TError,
    { data: PostJobsPipelinesSearchBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostJobsPipelinesSearchMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postJobsTeamtailorPublish = (postJobsTeamtailorPublishBody: PostJobsTeamtailorPublishBody) => {
  return customHttpClient<PostJobsTeamtailorPublish200>({
    url: `/jobs/teamtailor/publish`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postJobsTeamtailorPublishBody,
  });
};

export const getPostJobsTeamtailorPublishMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsTeamtailorPublish>>,
    TError,
    { data: PostJobsTeamtailorPublishBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postJobsTeamtailorPublish>>,
  TError,
  { data: PostJobsTeamtailorPublishBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postJobsTeamtailorPublish>>,
    { data: PostJobsTeamtailorPublishBody }
  > = (props) => {
    const { data } = props ?? {};

    return postJobsTeamtailorPublish(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostJobsTeamtailorPublishMutationResult = NonNullable<
  Awaited<ReturnType<typeof postJobsTeamtailorPublish>>
>;
export type PostJobsTeamtailorPublishMutationBody = PostJobsTeamtailorPublishBody;
export type PostJobsTeamtailorPublishMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostJobsTeamtailorPublish = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsTeamtailorPublish>>,
    TError,
    { data: PostJobsTeamtailorPublishBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostJobsTeamtailorPublishMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postJobsTeamtailorUnpublish = (postJobsTeamtailorUnpublishBody: PostJobsTeamtailorUnpublishBody) => {
  return customHttpClient<PostJobsTeamtailorUnpublish200>({
    url: `/jobs/teamtailor/unpublish`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postJobsTeamtailorUnpublishBody,
  });
};

export const getPostJobsTeamtailorUnpublishMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsTeamtailorUnpublish>>,
    TError,
    { data: PostJobsTeamtailorUnpublishBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postJobsTeamtailorUnpublish>>,
  TError,
  { data: PostJobsTeamtailorUnpublishBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postJobsTeamtailorUnpublish>>,
    { data: PostJobsTeamtailorUnpublishBody }
  > = (props) => {
    const { data } = props ?? {};

    return postJobsTeamtailorUnpublish(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostJobsTeamtailorUnpublishMutationResult = NonNullable<
  Awaited<ReturnType<typeof postJobsTeamtailorUnpublish>>
>;
export type PostJobsTeamtailorUnpublishMutationBody = PostJobsTeamtailorUnpublishBody;
export type PostJobsTeamtailorUnpublishMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostJobsTeamtailorUnpublish = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsTeamtailorUnpublish>>,
    TError,
    { data: PostJobsTeamtailorUnpublishBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostJobsTeamtailorUnpublishMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getJobsScoresCandidate = (signal?: AbortSignal) => {
  return customHttpClient<GetJobsScoresCandidate200>({ url: `/jobs/scores/:candidate`, method: 'GET', signal });
};

export const getGetJobsScoresCandidateQueryKey = () => {
  return [`/jobs/scores/:candidate`] as const;
};

export const getGetJobsScoresCandidateQueryOptions = <
  TData = Awaited<ReturnType<typeof getJobsScoresCandidate>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getJobsScoresCandidate>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetJobsScoresCandidateQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobsScoresCandidate>>> = ({ signal }) =>
    getJobsScoresCandidate(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getJobsScoresCandidate>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetJobsScoresCandidateQueryResult = NonNullable<Awaited<ReturnType<typeof getJobsScoresCandidate>>>;
export type GetJobsScoresCandidateQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetJobsScoresCandidate = <
  TData = Awaited<ReturnType<typeof getJobsScoresCandidate>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getJobsScoresCandidate>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetJobsScoresCandidateQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postJobsJobIdInterimAvailability = (
  jobId: number,
  postJobsJobIdInterimAvailabilityBody: PostJobsJobIdInterimAvailabilityBody,
) => {
  return customHttpClient<PostJobsJobIdInterimAvailability200>({
    url: `/jobs/${jobId}/interim-availability`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postJobsJobIdInterimAvailabilityBody,
  });
};

export const getPostJobsJobIdInterimAvailabilityMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdInterimAvailability>>,
    TError,
    { jobId: number; data: PostJobsJobIdInterimAvailabilityBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postJobsJobIdInterimAvailability>>,
  TError,
  { jobId: number; data: PostJobsJobIdInterimAvailabilityBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postJobsJobIdInterimAvailability>>,
    { jobId: number; data: PostJobsJobIdInterimAvailabilityBody }
  > = (props) => {
    const { jobId, data } = props ?? {};

    return postJobsJobIdInterimAvailability(jobId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostJobsJobIdInterimAvailabilityMutationResult = NonNullable<
  Awaited<ReturnType<typeof postJobsJobIdInterimAvailability>>
>;
export type PostJobsJobIdInterimAvailabilityMutationBody = PostJobsJobIdInterimAvailabilityBody;
export type PostJobsJobIdInterimAvailabilityMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostJobsJobIdInterimAvailability = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdInterimAvailability>>,
    TError,
    { jobId: number; data: PostJobsJobIdInterimAvailabilityBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostJobsJobIdInterimAvailabilityMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postJobsJobIdExternalBroadbeanUrl = (
  jobId: number,
  postJobsJobIdExternalBroadbeanUrlBody: PostJobsJobIdExternalBroadbeanUrlBody,
) => {
  return customHttpClient<PostJobsJobIdExternalBroadbeanUrl200>({
    url: `/jobs/${jobId}/external/broadbean/url`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postJobsJobIdExternalBroadbeanUrlBody,
  });
};

export const getPostJobsJobIdExternalBroadbeanUrlMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdExternalBroadbeanUrl>>,
    TError,
    { jobId: number; data: PostJobsJobIdExternalBroadbeanUrlBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postJobsJobIdExternalBroadbeanUrl>>,
  TError,
  { jobId: number; data: PostJobsJobIdExternalBroadbeanUrlBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postJobsJobIdExternalBroadbeanUrl>>,
    { jobId: number; data: PostJobsJobIdExternalBroadbeanUrlBody }
  > = (props) => {
    const { jobId, data } = props ?? {};

    return postJobsJobIdExternalBroadbeanUrl(jobId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostJobsJobIdExternalBroadbeanUrlMutationResult = NonNullable<
  Awaited<ReturnType<typeof postJobsJobIdExternalBroadbeanUrl>>
>;
export type PostJobsJobIdExternalBroadbeanUrlMutationBody = PostJobsJobIdExternalBroadbeanUrlBody;
export type PostJobsJobIdExternalBroadbeanUrlMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostJobsJobIdExternalBroadbeanUrl = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdExternalBroadbeanUrl>>,
    TError,
    { jobId: number; data: PostJobsJobIdExternalBroadbeanUrlBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostJobsJobIdExternalBroadbeanUrlMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postJobsJobIdImagesOrder = (jobId: number, postJobsJobIdImagesOrderBody: PostJobsJobIdImagesOrderBody) => {
  return customHttpClient<PostJobsJobIdImagesOrder200>({
    url: `/jobs/${jobId}/images/order`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postJobsJobIdImagesOrderBody,
  });
};

export const getPostJobsJobIdImagesOrderMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdImagesOrder>>,
    TError,
    { jobId: number; data: PostJobsJobIdImagesOrderBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postJobsJobIdImagesOrder>>,
  TError,
  { jobId: number; data: PostJobsJobIdImagesOrderBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postJobsJobIdImagesOrder>>,
    { jobId: number; data: PostJobsJobIdImagesOrderBody }
  > = (props) => {
    const { jobId, data } = props ?? {};

    return postJobsJobIdImagesOrder(jobId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostJobsJobIdImagesOrderMutationResult = NonNullable<Awaited<ReturnType<typeof postJobsJobIdImagesOrder>>>;
export type PostJobsJobIdImagesOrderMutationBody = PostJobsJobIdImagesOrderBody;
export type PostJobsJobIdImagesOrderMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostJobsJobIdImagesOrder = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdImagesOrder>>,
    TError,
    { jobId: number; data: PostJobsJobIdImagesOrderBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostJobsJobIdImagesOrderMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postJobsJobIdImages = (jobId: number, postJobsJobIdImagesBody: PostJobsJobIdImagesBody) => {
  return customHttpClient<PostJobsJobIdImages200>({
    url: `/jobs/${jobId}/images/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postJobsJobIdImagesBody,
  });
};

export const getPostJobsJobIdImagesMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdImages>>,
    TError,
    { jobId: number; data: PostJobsJobIdImagesBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postJobsJobIdImages>>,
  TError,
  { jobId: number; data: PostJobsJobIdImagesBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postJobsJobIdImages>>,
    { jobId: number; data: PostJobsJobIdImagesBody }
  > = (props) => {
    const { jobId, data } = props ?? {};

    return postJobsJobIdImages(jobId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostJobsJobIdImagesMutationResult = NonNullable<Awaited<ReturnType<typeof postJobsJobIdImages>>>;
export type PostJobsJobIdImagesMutationBody = PostJobsJobIdImagesBody;
export type PostJobsJobIdImagesMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostJobsJobIdImages = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdImages>>,
    TError,
    { jobId: number; data: PostJobsJobIdImagesBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostJobsJobIdImagesMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getJobsJobIdImages = (jobId: number, signal?: AbortSignal) => {
  return customHttpClient<GetJobsJobIdImages200>({ url: `/jobs/${jobId}/images/`, method: 'GET', signal });
};

export const getGetJobsJobIdImagesQueryKey = (jobId: number) => {
  return [`/jobs/${jobId}/images/`] as const;
};

export const getGetJobsJobIdImagesQueryOptions = <
  TData = Awaited<ReturnType<typeof getJobsJobIdImages>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  jobId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getJobsJobIdImages>>, TError, TData> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetJobsJobIdImagesQueryKey(jobId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobsJobIdImages>>> = ({ signal }) =>
    getJobsJobIdImages(jobId, signal);

  return { queryKey, queryFn, enabled: !!jobId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getJobsJobIdImages>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetJobsJobIdImagesQueryResult = NonNullable<Awaited<ReturnType<typeof getJobsJobIdImages>>>;
export type GetJobsJobIdImagesQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetJobsJobIdImages = <
  TData = Awaited<ReturnType<typeof getJobsJobIdImages>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  jobId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getJobsJobIdImages>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetJobsJobIdImagesQueryOptions(jobId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const deleteJobsJobIdAttachmentsAttachmentId = (jobId: number) => {
  return customHttpClient<DeleteJobsJobIdAttachmentsAttachmentId200>({
    url: `/jobs/${jobId}/attachments/:attachmentId`,
    method: 'DELETE',
  });
};

export const getDeleteJobsJobIdAttachmentsAttachmentIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteJobsJobIdAttachmentsAttachmentId>>,
    TError,
    { jobId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteJobsJobIdAttachmentsAttachmentId>>,
  TError,
  { jobId: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteJobsJobIdAttachmentsAttachmentId>>,
    { jobId: number }
  > = (props) => {
    const { jobId } = props ?? {};

    return deleteJobsJobIdAttachmentsAttachmentId(jobId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteJobsJobIdAttachmentsAttachmentIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteJobsJobIdAttachmentsAttachmentId>>
>;

export type DeleteJobsJobIdAttachmentsAttachmentIdMutationError = Status400 | Status401 | Status403 | Status404;

export const useDeleteJobsJobIdAttachmentsAttachmentId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteJobsJobIdAttachmentsAttachmentId>>,
    TError,
    { jobId: number },
    TContext
  >;
}) => {
  const mutationOptions = getDeleteJobsJobIdAttachmentsAttachmentIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postJobsJobIdAttachments = (jobId: number, postJobsJobIdAttachmentsBody: PostJobsJobIdAttachmentsBody) => {
  return customHttpClient<PostJobsJobIdAttachments200>({
    url: `/jobs/${jobId}/attachments/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postJobsJobIdAttachmentsBody,
  });
};

export const getPostJobsJobIdAttachmentsMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdAttachments>>,
    TError,
    { jobId: number; data: PostJobsJobIdAttachmentsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postJobsJobIdAttachments>>,
  TError,
  { jobId: number; data: PostJobsJobIdAttachmentsBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postJobsJobIdAttachments>>,
    { jobId: number; data: PostJobsJobIdAttachmentsBody }
  > = (props) => {
    const { jobId, data } = props ?? {};

    return postJobsJobIdAttachments(jobId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostJobsJobIdAttachmentsMutationResult = NonNullable<Awaited<ReturnType<typeof postJobsJobIdAttachments>>>;
export type PostJobsJobIdAttachmentsMutationBody = PostJobsJobIdAttachmentsBody;
export type PostJobsJobIdAttachmentsMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostJobsJobIdAttachments = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdAttachments>>,
    TError,
    { jobId: number; data: PostJobsJobIdAttachmentsBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostJobsJobIdAttachmentsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postJobsJobIdLanguages = (jobId: number, postJobsJobIdLanguagesBody: PostJobsJobIdLanguagesBody) => {
  return customHttpClient<PostJobsJobIdLanguages200>({
    url: `/jobs/${jobId}/languages`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postJobsJobIdLanguagesBody,
  });
};

export const getPostJobsJobIdLanguagesMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdLanguages>>,
    TError,
    { jobId: number; data: PostJobsJobIdLanguagesBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postJobsJobIdLanguages>>,
  TError,
  { jobId: number; data: PostJobsJobIdLanguagesBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postJobsJobIdLanguages>>,
    { jobId: number; data: PostJobsJobIdLanguagesBody }
  > = (props) => {
    const { jobId, data } = props ?? {};

    return postJobsJobIdLanguages(jobId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostJobsJobIdLanguagesMutationResult = NonNullable<Awaited<ReturnType<typeof postJobsJobIdLanguages>>>;
export type PostJobsJobIdLanguagesMutationBody = PostJobsJobIdLanguagesBody;
export type PostJobsJobIdLanguagesMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostJobsJobIdLanguages = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdLanguages>>,
    TError,
    { jobId: number; data: PostJobsJobIdLanguagesBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostJobsJobIdLanguagesMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putJobsJobIdLanguagesJobRequiredLanguageId = (jobId: number) => {
  return customHttpClient<PutJobsJobIdLanguagesJobRequiredLanguageId200>({
    url: `/jobs/${jobId}/languages/:jobRequiredLanguageId`,
    method: 'PUT',
  });
};

export const getPutJobsJobIdLanguagesJobRequiredLanguageIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putJobsJobIdLanguagesJobRequiredLanguageId>>,
    TError,
    { jobId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putJobsJobIdLanguagesJobRequiredLanguageId>>,
  TError,
  { jobId: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putJobsJobIdLanguagesJobRequiredLanguageId>>,
    { jobId: number }
  > = (props) => {
    const { jobId } = props ?? {};

    return putJobsJobIdLanguagesJobRequiredLanguageId(jobId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutJobsJobIdLanguagesJobRequiredLanguageIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putJobsJobIdLanguagesJobRequiredLanguageId>>
>;

export type PutJobsJobIdLanguagesJobRequiredLanguageIdMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutJobsJobIdLanguagesJobRequiredLanguageId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putJobsJobIdLanguagesJobRequiredLanguageId>>,
    TError,
    { jobId: number },
    TContext
  >;
}) => {
  const mutationOptions = getPutJobsJobIdLanguagesJobRequiredLanguageIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteJobsJobIdLanguagesJobRequiredLanguageId = (jobId: number) => {
  return customHttpClient<DeleteJobsJobIdLanguagesJobRequiredLanguageId200>({
    url: `/jobs/${jobId}/languages/:jobRequiredLanguageId`,
    method: 'DELETE',
  });
};

export const getDeleteJobsJobIdLanguagesJobRequiredLanguageIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteJobsJobIdLanguagesJobRequiredLanguageId>>,
    TError,
    { jobId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteJobsJobIdLanguagesJobRequiredLanguageId>>,
  TError,
  { jobId: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteJobsJobIdLanguagesJobRequiredLanguageId>>,
    { jobId: number }
  > = (props) => {
    const { jobId } = props ?? {};

    return deleteJobsJobIdLanguagesJobRequiredLanguageId(jobId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteJobsJobIdLanguagesJobRequiredLanguageIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteJobsJobIdLanguagesJobRequiredLanguageId>>
>;

export type DeleteJobsJobIdLanguagesJobRequiredLanguageIdMutationError = Status400 | Status401 | Status403 | Status404;

export const useDeleteJobsJobIdLanguagesJobRequiredLanguageId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteJobsJobIdLanguagesJobRequiredLanguageId>>,
    TError,
    { jobId: number },
    TContext
  >;
}) => {
  const mutationOptions = getDeleteJobsJobIdLanguagesJobRequiredLanguageIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postJobsJobIdZipRecruiterPublish = (
  jobId: number,
  postJobsJobIdZipRecruiterPublishBody: PostJobsJobIdZipRecruiterPublishBody,
) => {
  return customHttpClient<PostJobsJobIdZipRecruiterPublish200>({
    url: `/jobs/${jobId}/zip-recruiter-publish`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postJobsJobIdZipRecruiterPublishBody,
  });
};

export const getPostJobsJobIdZipRecruiterPublishMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdZipRecruiterPublish>>,
    TError,
    { jobId: number; data: PostJobsJobIdZipRecruiterPublishBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postJobsJobIdZipRecruiterPublish>>,
  TError,
  { jobId: number; data: PostJobsJobIdZipRecruiterPublishBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postJobsJobIdZipRecruiterPublish>>,
    { jobId: number; data: PostJobsJobIdZipRecruiterPublishBody }
  > = (props) => {
    const { jobId, data } = props ?? {};

    return postJobsJobIdZipRecruiterPublish(jobId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostJobsJobIdZipRecruiterPublishMutationResult = NonNullable<
  Awaited<ReturnType<typeof postJobsJobIdZipRecruiterPublish>>
>;
export type PostJobsJobIdZipRecruiterPublishMutationBody = PostJobsJobIdZipRecruiterPublishBody;
export type PostJobsJobIdZipRecruiterPublishMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostJobsJobIdZipRecruiterPublish = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdZipRecruiterPublish>>,
    TError,
    { jobId: number; data: PostJobsJobIdZipRecruiterPublishBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostJobsJobIdZipRecruiterPublishMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postJobsJobIdZipRecruiterUnpublish = (
  jobId: number,
  postJobsJobIdZipRecruiterUnpublishBody: PostJobsJobIdZipRecruiterUnpublishBody,
) => {
  return customHttpClient<PostJobsJobIdZipRecruiterUnpublish200>({
    url: `/jobs/${jobId}/zip-recruiter-unpublish`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postJobsJobIdZipRecruiterUnpublishBody,
  });
};

export const getPostJobsJobIdZipRecruiterUnpublishMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdZipRecruiterUnpublish>>,
    TError,
    { jobId: number; data: PostJobsJobIdZipRecruiterUnpublishBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postJobsJobIdZipRecruiterUnpublish>>,
  TError,
  { jobId: number; data: PostJobsJobIdZipRecruiterUnpublishBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postJobsJobIdZipRecruiterUnpublish>>,
    { jobId: number; data: PostJobsJobIdZipRecruiterUnpublishBody }
  > = (props) => {
    const { jobId, data } = props ?? {};

    return postJobsJobIdZipRecruiterUnpublish(jobId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostJobsJobIdZipRecruiterUnpublishMutationResult = NonNullable<
  Awaited<ReturnType<typeof postJobsJobIdZipRecruiterUnpublish>>
>;
export type PostJobsJobIdZipRecruiterUnpublishMutationBody = PostJobsJobIdZipRecruiterUnpublishBody;
export type PostJobsJobIdZipRecruiterUnpublishMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostJobsJobIdZipRecruiterUnpublish = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdZipRecruiterUnpublish>>,
    TError,
    { jobId: number; data: PostJobsJobIdZipRecruiterUnpublishBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostJobsJobIdZipRecruiterUnpublishMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postJobsJobIdPrivateModeEnable = (
  jobId: number,
  postJobsJobIdPrivateModeEnableBody: PostJobsJobIdPrivateModeEnableBody,
) => {
  return customHttpClient<PostJobsJobIdPrivateModeEnable200>({
    url: `/jobs/${jobId}/private-mode/enable`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postJobsJobIdPrivateModeEnableBody,
  });
};

export const getPostJobsJobIdPrivateModeEnableMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdPrivateModeEnable>>,
    TError,
    { jobId: number; data: PostJobsJobIdPrivateModeEnableBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postJobsJobIdPrivateModeEnable>>,
  TError,
  { jobId: number; data: PostJobsJobIdPrivateModeEnableBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postJobsJobIdPrivateModeEnable>>,
    { jobId: number; data: PostJobsJobIdPrivateModeEnableBody }
  > = (props) => {
    const { jobId, data } = props ?? {};

    return postJobsJobIdPrivateModeEnable(jobId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostJobsJobIdPrivateModeEnableMutationResult = NonNullable<
  Awaited<ReturnType<typeof postJobsJobIdPrivateModeEnable>>
>;
export type PostJobsJobIdPrivateModeEnableMutationBody = PostJobsJobIdPrivateModeEnableBody;
export type PostJobsJobIdPrivateModeEnableMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostJobsJobIdPrivateModeEnable = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdPrivateModeEnable>>,
    TError,
    { jobId: number; data: PostJobsJobIdPrivateModeEnableBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostJobsJobIdPrivateModeEnableMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postJobsJobIdPrivateModeDisable = (
  jobId: number,
  postJobsJobIdPrivateModeDisableBody: PostJobsJobIdPrivateModeDisableBody,
) => {
  return customHttpClient<PostJobsJobIdPrivateModeDisable200>({
    url: `/jobs/${jobId}/private-mode/disable`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postJobsJobIdPrivateModeDisableBody,
  });
};

export const getPostJobsJobIdPrivateModeDisableMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdPrivateModeDisable>>,
    TError,
    { jobId: number; data: PostJobsJobIdPrivateModeDisableBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postJobsJobIdPrivateModeDisable>>,
  TError,
  { jobId: number; data: PostJobsJobIdPrivateModeDisableBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postJobsJobIdPrivateModeDisable>>,
    { jobId: number; data: PostJobsJobIdPrivateModeDisableBody }
  > = (props) => {
    const { jobId, data } = props ?? {};

    return postJobsJobIdPrivateModeDisable(jobId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostJobsJobIdPrivateModeDisableMutationResult = NonNullable<
  Awaited<ReturnType<typeof postJobsJobIdPrivateModeDisable>>
>;
export type PostJobsJobIdPrivateModeDisableMutationBody = PostJobsJobIdPrivateModeDisableBody;
export type PostJobsJobIdPrivateModeDisableMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostJobsJobIdPrivateModeDisable = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJobsJobIdPrivateModeDisable>>,
    TError,
    { jobId: number; data: PostJobsJobIdPrivateModeDisableBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostJobsJobIdPrivateModeDisableMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getJobsFeed = (signal?: AbortSignal) => {
  return customHttpClient<GetJobsFeed200>({ url: `/jobs-feed`, method: 'GET', signal });
};

export const getGetJobsFeedQueryKey = () => {
  return [`/jobs-feed`] as const;
};

export const getGetJobsFeedQueryOptions = <
  TData = Awaited<ReturnType<typeof getJobsFeed>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getJobsFeed>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetJobsFeedQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobsFeed>>> = ({ signal }) => getJobsFeed(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getJobsFeed>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetJobsFeedQueryResult = NonNullable<Awaited<ReturnType<typeof getJobsFeed>>>;
export type GetJobsFeedQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetJobsFeed = <
  TData = Awaited<ReturnType<typeof getJobsFeed>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getJobsFeed>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetJobsFeedQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const putJobsWorkflowProcessesWorkflowProcessIdParticipants = (
  workflowProcessId: number,
  putJobsWorkflowProcessesWorkflowProcessIdParticipantsBody: PutJobsWorkflowProcessesWorkflowProcessIdParticipantsBody,
) => {
  return customHttpClient<PutJobsWorkflowProcessesWorkflowProcessIdParticipants200>({
    url: `/jobs/workflow-processes/${workflowProcessId}/participants`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: putJobsWorkflowProcessesWorkflowProcessIdParticipantsBody,
  });
};

export const getPutJobsWorkflowProcessesWorkflowProcessIdParticipantsMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putJobsWorkflowProcessesWorkflowProcessIdParticipants>>,
    TError,
    { workflowProcessId: number; data: PutJobsWorkflowProcessesWorkflowProcessIdParticipantsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putJobsWorkflowProcessesWorkflowProcessIdParticipants>>,
  TError,
  { workflowProcessId: number; data: PutJobsWorkflowProcessesWorkflowProcessIdParticipantsBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putJobsWorkflowProcessesWorkflowProcessIdParticipants>>,
    { workflowProcessId: number; data: PutJobsWorkflowProcessesWorkflowProcessIdParticipantsBody }
  > = (props) => {
    const { workflowProcessId, data } = props ?? {};

    return putJobsWorkflowProcessesWorkflowProcessIdParticipants(workflowProcessId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutJobsWorkflowProcessesWorkflowProcessIdParticipantsMutationResult = NonNullable<
  Awaited<ReturnType<typeof putJobsWorkflowProcessesWorkflowProcessIdParticipants>>
>;
export type PutJobsWorkflowProcessesWorkflowProcessIdParticipantsMutationBody =
  PutJobsWorkflowProcessesWorkflowProcessIdParticipantsBody;
export type PutJobsWorkflowProcessesWorkflowProcessIdParticipantsMutationError =
  | Status400
  | Status401
  | Status403
  | Status404;

export const usePutJobsWorkflowProcessesWorkflowProcessIdParticipants = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putJobsWorkflowProcessesWorkflowProcessIdParticipants>>,
    TError,
    { workflowProcessId: number; data: PutJobsWorkflowProcessesWorkflowProcessIdParticipantsBody },
    TContext
  >;
}) => {
  const mutationOptions = getPutJobsWorkflowProcessesWorkflowProcessIdParticipantsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getMyReqUser = (signal?: AbortSignal) => {
  return customHttpClient<GetMyReqUser200>({ url: `/my/req-user`, method: 'GET', signal });
};

export const getGetMyReqUserQueryKey = () => {
  return [`/my/req-user`] as const;
};

export const getGetMyReqUserQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyReqUser>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMyReqUser>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyReqUserQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyReqUser>>> = ({ signal }) => getMyReqUser(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyReqUser>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMyReqUserQueryResult = NonNullable<Awaited<ReturnType<typeof getMyReqUser>>>;
export type GetMyReqUserQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetMyReqUser = <
  TData = Awaited<ReturnType<typeof getMyReqUser>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMyReqUser>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetMyReqUserQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getNotificationsCounters = (signal?: AbortSignal) => {
  return customHttpClient<GetNotificationsCounters200>({ url: `/notifications/counters`, method: 'GET', signal });
};

export const getGetNotificationsCountersQueryKey = () => {
  return [`/notifications/counters`] as const;
};

export const getGetNotificationsCountersQueryOptions = <
  TData = Awaited<ReturnType<typeof getNotificationsCounters>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getNotificationsCounters>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetNotificationsCountersQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotificationsCounters>>> = ({ signal }) =>
    getNotificationsCounters(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNotificationsCounters>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetNotificationsCountersQueryResult = NonNullable<Awaited<ReturnType<typeof getNotificationsCounters>>>;
export type GetNotificationsCountersQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetNotificationsCounters = <
  TData = Awaited<ReturnType<typeof getNotificationsCounters>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getNotificationsCounters>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetNotificationsCountersQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postNotificationsMarkRead = (postNotificationsMarkReadBody: PostNotificationsMarkReadBody) => {
  return customHttpClient<PostNotificationsMarkRead200>({
    url: `/notifications/mark-read`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postNotificationsMarkReadBody,
  });
};

export const getPostNotificationsMarkReadMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postNotificationsMarkRead>>,
    TError,
    { data: PostNotificationsMarkReadBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postNotificationsMarkRead>>,
  TError,
  { data: PostNotificationsMarkReadBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postNotificationsMarkRead>>,
    { data: PostNotificationsMarkReadBody }
  > = (props) => {
    const { data } = props ?? {};

    return postNotificationsMarkRead(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostNotificationsMarkReadMutationResult = NonNullable<
  Awaited<ReturnType<typeof postNotificationsMarkRead>>
>;
export type PostNotificationsMarkReadMutationBody = PostNotificationsMarkReadBody;
export type PostNotificationsMarkReadMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostNotificationsMarkRead = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postNotificationsMarkRead>>,
    TError,
    { data: PostNotificationsMarkReadBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostNotificationsMarkReadMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postNotificationsMarkUnread = (postNotificationsMarkUnreadBody: PostNotificationsMarkUnreadBody) => {
  return customHttpClient<PostNotificationsMarkUnread200>({
    url: `/notifications/mark-unread`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postNotificationsMarkUnreadBody,
  });
};

export const getPostNotificationsMarkUnreadMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postNotificationsMarkUnread>>,
    TError,
    { data: PostNotificationsMarkUnreadBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postNotificationsMarkUnread>>,
  TError,
  { data: PostNotificationsMarkUnreadBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postNotificationsMarkUnread>>,
    { data: PostNotificationsMarkUnreadBody }
  > = (props) => {
    const { data } = props ?? {};

    return postNotificationsMarkUnread(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostNotificationsMarkUnreadMutationResult = NonNullable<
  Awaited<ReturnType<typeof postNotificationsMarkUnread>>
>;
export type PostNotificationsMarkUnreadMutationBody = PostNotificationsMarkUnreadBody;
export type PostNotificationsMarkUnreadMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostNotificationsMarkUnread = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postNotificationsMarkUnread>>,
    TError,
    { data: PostNotificationsMarkUnreadBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostNotificationsMarkUnreadMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getOmnichatsConversationId = (signal?: AbortSignal) => {
  return customHttpClient<GetOmnichatsConversationId200>({ url: `/omnichats/:conversationId`, method: 'GET', signal });
};

export const getGetOmnichatsConversationIdQueryKey = () => {
  return [`/omnichats/:conversationId`] as const;
};

export const getGetOmnichatsConversationIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getOmnichatsConversationId>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getOmnichatsConversationId>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOmnichatsConversationIdQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOmnichatsConversationId>>> = ({ signal }) =>
    getOmnichatsConversationId(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOmnichatsConversationId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOmnichatsConversationIdQueryResult = NonNullable<Awaited<ReturnType<typeof getOmnichatsConversationId>>>;
export type GetOmnichatsConversationIdQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetOmnichatsConversationId = <
  TData = Awaited<ReturnType<typeof getOmnichatsConversationId>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getOmnichatsConversationId>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetOmnichatsConversationIdQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getOmnichatsUsersCandidateUserId = (userId: number, signal?: AbortSignal) => {
  return customHttpClient<GetOmnichatsUsersCandidateUserId200>({
    url: `/omnichats/users/candidate/${userId}`,
    method: 'GET',
    signal,
  });
};

export const getGetOmnichatsUsersCandidateUserIdQueryKey = (userId: number) => {
  return [`/omnichats/users/candidate/${userId}`] as const;
};

export const getGetOmnichatsUsersCandidateUserIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getOmnichatsUsersCandidateUserId>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  userId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getOmnichatsUsersCandidateUserId>>, TError, TData> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOmnichatsUsersCandidateUserIdQueryKey(userId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOmnichatsUsersCandidateUserId>>> = ({ signal }) =>
    getOmnichatsUsersCandidateUserId(userId, signal);

  return { queryKey, queryFn, enabled: !!userId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOmnichatsUsersCandidateUserId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOmnichatsUsersCandidateUserIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOmnichatsUsersCandidateUserId>>
>;
export type GetOmnichatsUsersCandidateUserIdQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetOmnichatsUsersCandidateUserId = <
  TData = Awaited<ReturnType<typeof getOmnichatsUsersCandidateUserId>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  userId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getOmnichatsUsersCandidateUserId>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetOmnichatsUsersCandidateUserIdQueryOptions(userId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getOmnichatsUsersContactUserId = (userId: number, signal?: AbortSignal) => {
  return customHttpClient<GetOmnichatsUsersContactUserId200>({
    url: `/omnichats/users/contact/${userId}`,
    method: 'GET',
    signal,
  });
};

export const getGetOmnichatsUsersContactUserIdQueryKey = (userId: number) => {
  return [`/omnichats/users/contact/${userId}`] as const;
};

export const getGetOmnichatsUsersContactUserIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getOmnichatsUsersContactUserId>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  userId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getOmnichatsUsersContactUserId>>, TError, TData> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOmnichatsUsersContactUserIdQueryKey(userId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOmnichatsUsersContactUserId>>> = ({ signal }) =>
    getOmnichatsUsersContactUserId(userId, signal);

  return { queryKey, queryFn, enabled: !!userId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOmnichatsUsersContactUserId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOmnichatsUsersContactUserIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOmnichatsUsersContactUserId>>
>;
export type GetOmnichatsUsersContactUserIdQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetOmnichatsUsersContactUserId = <
  TData = Awaited<ReturnType<typeof getOmnichatsUsersContactUserId>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  userId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getOmnichatsUsersContactUserId>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetOmnichatsUsersContactUserIdQueryOptions(userId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getOmnichatsConversationIdMessages = (signal?: AbortSignal) => {
  return customHttpClient<GetOmnichatsConversationIdMessages200>({
    url: `/omnichats/:conversationId/messages`,
    method: 'GET',
    signal,
  });
};

export const getGetOmnichatsConversationIdMessagesQueryKey = () => {
  return [`/omnichats/:conversationId/messages`] as const;
};

export const getGetOmnichatsConversationIdMessagesQueryOptions = <
  TData = Awaited<ReturnType<typeof getOmnichatsConversationIdMessages>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getOmnichatsConversationIdMessages>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOmnichatsConversationIdMessagesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOmnichatsConversationIdMessages>>> = ({ signal }) =>
    getOmnichatsConversationIdMessages(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOmnichatsConversationIdMessages>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOmnichatsConversationIdMessagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOmnichatsConversationIdMessages>>
>;
export type GetOmnichatsConversationIdMessagesQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetOmnichatsConversationIdMessages = <
  TData = Awaited<ReturnType<typeof getOmnichatsConversationIdMessages>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getOmnichatsConversationIdMessages>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetOmnichatsConversationIdMessagesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postOmnichatsConversationIdRead = (
  postOmnichatsConversationIdReadBody: PostOmnichatsConversationIdReadBody,
) => {
  return customHttpClient<PostOmnichatsConversationIdRead200>({
    url: `/omnichats/:conversationId/read`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postOmnichatsConversationIdReadBody,
  });
};

export const getPostOmnichatsConversationIdReadMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postOmnichatsConversationIdRead>>,
    TError,
    { data: PostOmnichatsConversationIdReadBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postOmnichatsConversationIdRead>>,
  TError,
  { data: PostOmnichatsConversationIdReadBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postOmnichatsConversationIdRead>>,
    { data: PostOmnichatsConversationIdReadBody }
  > = (props) => {
    const { data } = props ?? {};

    return postOmnichatsConversationIdRead(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostOmnichatsConversationIdReadMutationResult = NonNullable<
  Awaited<ReturnType<typeof postOmnichatsConversationIdRead>>
>;
export type PostOmnichatsConversationIdReadMutationBody = PostOmnichatsConversationIdReadBody;
export type PostOmnichatsConversationIdReadMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostOmnichatsConversationIdRead = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postOmnichatsConversationIdRead>>,
    TError,
    { data: PostOmnichatsConversationIdReadBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostOmnichatsConversationIdReadMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getOmnichats = (signal?: AbortSignal) => {
  return customHttpClient<GetOmnichats200>({ url: `/omnichats`, method: 'GET', signal });
};

export const getGetOmnichatsQueryKey = () => {
  return [`/omnichats`] as const;
};

export const getGetOmnichatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getOmnichats>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getOmnichats>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOmnichatsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOmnichats>>> = ({ signal }) => getOmnichats(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOmnichats>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOmnichatsQueryResult = NonNullable<Awaited<ReturnType<typeof getOmnichats>>>;
export type GetOmnichatsQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetOmnichats = <
  TData = Awaited<ReturnType<typeof getOmnichats>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getOmnichats>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetOmnichatsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postPeopleLookupImportLinkedIn = (
  postPeopleLookupImportLinkedInBody: PostPeopleLookupImportLinkedInBody,
) => {
  return customHttpClient<PostPeopleLookupImportLinkedIn200>({
    url: `/people-lookup/import/linked-in`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postPeopleLookupImportLinkedInBody,
  });
};

export const getPostPeopleLookupImportLinkedInMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPeopleLookupImportLinkedIn>>,
    TError,
    { data: PostPeopleLookupImportLinkedInBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postPeopleLookupImportLinkedIn>>,
  TError,
  { data: PostPeopleLookupImportLinkedInBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postPeopleLookupImportLinkedIn>>,
    { data: PostPeopleLookupImportLinkedInBody }
  > = (props) => {
    const { data } = props ?? {};

    return postPeopleLookupImportLinkedIn(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostPeopleLookupImportLinkedInMutationResult = NonNullable<
  Awaited<ReturnType<typeof postPeopleLookupImportLinkedIn>>
>;
export type PostPeopleLookupImportLinkedInMutationBody = PostPeopleLookupImportLinkedInBody;
export type PostPeopleLookupImportLinkedInMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostPeopleLookupImportLinkedIn = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPeopleLookupImportLinkedIn>>,
    TError,
    { data: PostPeopleLookupImportLinkedInBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostPeopleLookupImportLinkedInMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postPeopleLookupLookupLinkedIn = (
  postPeopleLookupLookupLinkedInBody: PostPeopleLookupLookupLinkedInBody,
) => {
  return customHttpClient<PostPeopleLookupLookupLinkedIn200>({
    url: `/people-lookup/lookup/linked-in`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postPeopleLookupLookupLinkedInBody,
  });
};

export const getPostPeopleLookupLookupLinkedInMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPeopleLookupLookupLinkedIn>>,
    TError,
    { data: PostPeopleLookupLookupLinkedInBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postPeopleLookupLookupLinkedIn>>,
  TError,
  { data: PostPeopleLookupLookupLinkedInBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postPeopleLookupLookupLinkedIn>>,
    { data: PostPeopleLookupLookupLinkedInBody }
  > = (props) => {
    const { data } = props ?? {};

    return postPeopleLookupLookupLinkedIn(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostPeopleLookupLookupLinkedInMutationResult = NonNullable<
  Awaited<ReturnType<typeof postPeopleLookupLookupLinkedIn>>
>;
export type PostPeopleLookupLookupLinkedInMutationBody = PostPeopleLookupLookupLinkedInBody;
export type PostPeopleLookupLookupLinkedInMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostPeopleLookupLookupLinkedIn = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPeopleLookupLookupLinkedIn>>,
    TError,
    { data: PostPeopleLookupLookupLinkedInBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostPeopleLookupLookupLinkedInMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postPhonesLookupDuplicates = (postPhonesLookupDuplicatesBody: PostPhonesLookupDuplicatesBody) => {
  return customHttpClient<PostPhonesLookupDuplicates200>({
    url: `/phones/lookup-duplicates`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postPhonesLookupDuplicatesBody,
  });
};

export const getPostPhonesLookupDuplicatesMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPhonesLookupDuplicates>>,
    TError,
    { data: PostPhonesLookupDuplicatesBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postPhonesLookupDuplicates>>,
  TError,
  { data: PostPhonesLookupDuplicatesBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postPhonesLookupDuplicates>>,
    { data: PostPhonesLookupDuplicatesBody }
  > = (props) => {
    const { data } = props ?? {};

    return postPhonesLookupDuplicates(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostPhonesLookupDuplicatesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postPhonesLookupDuplicates>>
>;
export type PostPhonesLookupDuplicatesMutationBody = PostPhonesLookupDuplicatesBody;
export type PostPhonesLookupDuplicatesMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostPhonesLookupDuplicates = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPhonesLookupDuplicates>>,
    TError,
    { data: PostPhonesLookupDuplicatesBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostPhonesLookupDuplicatesMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getPhonesFormatPhone = (signal?: AbortSignal) => {
  return customHttpClient<GetPhonesFormatPhone200>({ url: `/phones/format/:phone`, method: 'GET', signal });
};

export const getGetPhonesFormatPhoneQueryKey = () => {
  return [`/phones/format/:phone`] as const;
};

export const getGetPhonesFormatPhoneQueryOptions = <
  TData = Awaited<ReturnType<typeof getPhonesFormatPhone>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getPhonesFormatPhone>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPhonesFormatPhoneQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPhonesFormatPhone>>> = ({ signal }) =>
    getPhonesFormatPhone(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPhonesFormatPhone>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPhonesFormatPhoneQueryResult = NonNullable<Awaited<ReturnType<typeof getPhonesFormatPhone>>>;
export type GetPhonesFormatPhoneQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetPhonesFormatPhone = <
  TData = Awaited<ReturnType<typeof getPhonesFormatPhone>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getPhonesFormatPhone>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetPhonesFormatPhoneQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postPipelinesWorkflowProcessMoveManually = (
  postPipelinesWorkflowProcessMoveManuallyBody: PostPipelinesWorkflowProcessMoveManuallyBody,
) => {
  return customHttpClient<PostPipelinesWorkflowProcessMoveManually200>({
    url: `/pipelines/workflow-process/move-manually`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postPipelinesWorkflowProcessMoveManuallyBody,
  });
};

export const getPostPipelinesWorkflowProcessMoveManuallyMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPipelinesWorkflowProcessMoveManually>>,
    TError,
    { data: PostPipelinesWorkflowProcessMoveManuallyBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postPipelinesWorkflowProcessMoveManually>>,
  TError,
  { data: PostPipelinesWorkflowProcessMoveManuallyBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postPipelinesWorkflowProcessMoveManually>>,
    { data: PostPipelinesWorkflowProcessMoveManuallyBody }
  > = (props) => {
    const { data } = props ?? {};

    return postPipelinesWorkflowProcessMoveManually(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostPipelinesWorkflowProcessMoveManuallyMutationResult = NonNullable<
  Awaited<ReturnType<typeof postPipelinesWorkflowProcessMoveManually>>
>;
export type PostPipelinesWorkflowProcessMoveManuallyMutationBody = PostPipelinesWorkflowProcessMoveManuallyBody;
export type PostPipelinesWorkflowProcessMoveManuallyMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostPipelinesWorkflowProcessMoveManually = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPipelinesWorkflowProcessMoveManually>>,
    TError,
    { data: PostPipelinesWorkflowProcessMoveManuallyBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostPipelinesWorkflowProcessMoveManuallyMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getPipelinesCustomFieldsModel = (signal?: AbortSignal) => {
  return customHttpClient<GetPipelinesCustomFieldsModel200>({
    url: `/pipelines/custom-fields/model`,
    method: 'GET',
    signal,
  });
};

export const getGetPipelinesCustomFieldsModelQueryKey = () => {
  return [`/pipelines/custom-fields/model`] as const;
};

export const getGetPipelinesCustomFieldsModelQueryOptions = <
  TData = Awaited<ReturnType<typeof getPipelinesCustomFieldsModel>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getPipelinesCustomFieldsModel>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPipelinesCustomFieldsModelQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPipelinesCustomFieldsModel>>> = ({ signal }) =>
    getPipelinesCustomFieldsModel(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPipelinesCustomFieldsModel>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPipelinesCustomFieldsModelQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPipelinesCustomFieldsModel>>
>;
export type GetPipelinesCustomFieldsModelQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetPipelinesCustomFieldsModel = <
  TData = Awaited<ReturnType<typeof getPipelinesCustomFieldsModel>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getPipelinesCustomFieldsModel>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetPipelinesCustomFieldsModelQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const putPipelinesCustomFieldsModel = () => {
  return customHttpClient<PutPipelinesCustomFieldsModel200>({ url: `/pipelines/custom-fields/model`, method: 'PUT' });
};

export const getPutPipelinesCustomFieldsModelMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putPipelinesCustomFieldsModel>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof putPipelinesCustomFieldsModel>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof putPipelinesCustomFieldsModel>>, void> = () => {
    return putPipelinesCustomFieldsModel();
  };

  return { mutationFn, ...mutationOptions };
};

export type PutPipelinesCustomFieldsModelMutationResult = NonNullable<
  Awaited<ReturnType<typeof putPipelinesCustomFieldsModel>>
>;

export type PutPipelinesCustomFieldsModelMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutPipelinesCustomFieldsModel = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putPipelinesCustomFieldsModel>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPutPipelinesCustomFieldsModelMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postPipelinesCustomFieldsValidate = (
  postPipelinesCustomFieldsValidateBody: PostPipelinesCustomFieldsValidateBody,
) => {
  return customHttpClient<PostPipelinesCustomFieldsValidate200>({
    url: `/pipelines/custom-fields/validate`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postPipelinesCustomFieldsValidateBody,
  });
};

export const getPostPipelinesCustomFieldsValidateMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPipelinesCustomFieldsValidate>>,
    TError,
    { data: PostPipelinesCustomFieldsValidateBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postPipelinesCustomFieldsValidate>>,
  TError,
  { data: PostPipelinesCustomFieldsValidateBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postPipelinesCustomFieldsValidate>>,
    { data: PostPipelinesCustomFieldsValidateBody }
  > = (props) => {
    const { data } = props ?? {};

    return postPipelinesCustomFieldsValidate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostPipelinesCustomFieldsValidateMutationResult = NonNullable<
  Awaited<ReturnType<typeof postPipelinesCustomFieldsValidate>>
>;
export type PostPipelinesCustomFieldsValidateMutationBody = PostPipelinesCustomFieldsValidateBody;
export type PostPipelinesCustomFieldsValidateMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostPipelinesCustomFieldsValidate = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPipelinesCustomFieldsValidate>>,
    TError,
    { data: PostPipelinesCustomFieldsValidateBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostPipelinesCustomFieldsValidateMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getPipelinesEntityIdCustomFields = (entityId: string, signal?: AbortSignal) => {
  return customHttpClient<GetPipelinesEntityIdCustomFields200>({
    url: `/pipelines/${entityId}/custom-fields`,
    method: 'GET',
    signal,
  });
};

export const getGetPipelinesEntityIdCustomFieldsQueryKey = (entityId: string) => {
  return [`/pipelines/${entityId}/custom-fields`] as const;
};

export const getGetPipelinesEntityIdCustomFieldsQueryOptions = <
  TData = Awaited<ReturnType<typeof getPipelinesEntityIdCustomFields>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  entityId: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getPipelinesEntityIdCustomFields>>, TError, TData> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPipelinesEntityIdCustomFieldsQueryKey(entityId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPipelinesEntityIdCustomFields>>> = ({ signal }) =>
    getPipelinesEntityIdCustomFields(entityId, signal);

  return { queryKey, queryFn, enabled: !!entityId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPipelinesEntityIdCustomFields>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPipelinesEntityIdCustomFieldsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPipelinesEntityIdCustomFields>>
>;
export type GetPipelinesEntityIdCustomFieldsQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetPipelinesEntityIdCustomFields = <
  TData = Awaited<ReturnType<typeof getPipelinesEntityIdCustomFields>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(
  entityId: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getPipelinesEntityIdCustomFields>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetPipelinesEntityIdCustomFieldsQueryOptions(entityId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const putPipelinesEntityIdCustomFields = (entityId: string) => {
  return customHttpClient<PutPipelinesEntityIdCustomFields200>({
    url: `/pipelines/${entityId}/custom-fields`,
    method: 'PUT',
  });
};

export const getPutPipelinesEntityIdCustomFieldsMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putPipelinesEntityIdCustomFields>>,
    TError,
    { entityId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putPipelinesEntityIdCustomFields>>,
  TError,
  { entityId: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putPipelinesEntityIdCustomFields>>,
    { entityId: string }
  > = (props) => {
    const { entityId } = props ?? {};

    return putPipelinesEntityIdCustomFields(entityId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutPipelinesEntityIdCustomFieldsMutationResult = NonNullable<
  Awaited<ReturnType<typeof putPipelinesEntityIdCustomFields>>
>;

export type PutPipelinesEntityIdCustomFieldsMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutPipelinesEntityIdCustomFields = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putPipelinesEntityIdCustomFields>>,
    TError,
    { entityId: string },
    TContext
  >;
}) => {
  const mutationOptions = getPutPipelinesEntityIdCustomFieldsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putPipelinesEntityIdCustomFieldsExtend = (
  entityId: string,
  putPipelinesEntityIdCustomFieldsExtendBody: PutPipelinesEntityIdCustomFieldsExtendBody,
) => {
  return customHttpClient<PutPipelinesEntityIdCustomFieldsExtend200>({
    url: `/pipelines/${entityId}/custom-fields/extend`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: putPipelinesEntityIdCustomFieldsExtendBody,
  });
};

export const getPutPipelinesEntityIdCustomFieldsExtendMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putPipelinesEntityIdCustomFieldsExtend>>,
    TError,
    { entityId: string; data: PutPipelinesEntityIdCustomFieldsExtendBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putPipelinesEntityIdCustomFieldsExtend>>,
  TError,
  { entityId: string; data: PutPipelinesEntityIdCustomFieldsExtendBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putPipelinesEntityIdCustomFieldsExtend>>,
    { entityId: string; data: PutPipelinesEntityIdCustomFieldsExtendBody }
  > = (props) => {
    const { entityId, data } = props ?? {};

    return putPipelinesEntityIdCustomFieldsExtend(entityId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutPipelinesEntityIdCustomFieldsExtendMutationResult = NonNullable<
  Awaited<ReturnType<typeof putPipelinesEntityIdCustomFieldsExtend>>
>;
export type PutPipelinesEntityIdCustomFieldsExtendMutationBody = PutPipelinesEntityIdCustomFieldsExtendBody;
export type PutPipelinesEntityIdCustomFieldsExtendMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutPipelinesEntityIdCustomFieldsExtend = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putPipelinesEntityIdCustomFieldsExtend>>,
    TError,
    { entityId: string; data: PutPipelinesEntityIdCustomFieldsExtendBody },
    TContext
  >;
}) => {
  const mutationOptions = getPutPipelinesEntityIdCustomFieldsExtendMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postPipelinesLists = (postPipelinesListsBody: PostPipelinesListsBody) => {
  return customHttpClient<PostPipelinesLists200>({
    url: `/pipelines/lists`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postPipelinesListsBody,
  });
};

export const getPostPipelinesListsMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPipelinesLists>>,
    TError,
    { data: PostPipelinesListsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postPipelinesLists>>,
  TError,
  { data: PostPipelinesListsBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postPipelinesLists>>,
    { data: PostPipelinesListsBody }
  > = (props) => {
    const { data } = props ?? {};

    return postPipelinesLists(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostPipelinesListsMutationResult = NonNullable<Awaited<ReturnType<typeof postPipelinesLists>>>;
export type PostPipelinesListsMutationBody = PostPipelinesListsBody;
export type PostPipelinesListsMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostPipelinesLists = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPipelinesLists>>,
    TError,
    { data: PostPipelinesListsBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostPipelinesListsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getPipelinesLists = (signal?: AbortSignal) => {
  return customHttpClient<GetPipelinesLists200>({ url: `/pipelines/lists`, method: 'GET', signal });
};

export const getGetPipelinesListsQueryKey = () => {
  return [`/pipelines/lists`] as const;
};

export const getGetPipelinesListsQueryOptions = <
  TData = Awaited<ReturnType<typeof getPipelinesLists>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getPipelinesLists>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPipelinesListsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPipelinesLists>>> = ({ signal }) =>
    getPipelinesLists(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPipelinesLists>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPipelinesListsQueryResult = NonNullable<Awaited<ReturnType<typeof getPipelinesLists>>>;
export type GetPipelinesListsQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetPipelinesLists = <
  TData = Awaited<ReturnType<typeof getPipelinesLists>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getPipelinesLists>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetPipelinesListsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postPipelinesListsEntityListIdCreateNewEntity = (
  postPipelinesListsEntityListIdCreateNewEntityBody: PostPipelinesListsEntityListIdCreateNewEntityBody,
) => {
  return customHttpClient<PostPipelinesListsEntityListIdCreateNewEntity200>({
    url: `/pipelines/lists/:entityListId/create-new-entity`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postPipelinesListsEntityListIdCreateNewEntityBody,
  });
};

export const getPostPipelinesListsEntityListIdCreateNewEntityMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPipelinesListsEntityListIdCreateNewEntity>>,
    TError,
    { data: PostPipelinesListsEntityListIdCreateNewEntityBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postPipelinesListsEntityListIdCreateNewEntity>>,
  TError,
  { data: PostPipelinesListsEntityListIdCreateNewEntityBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postPipelinesListsEntityListIdCreateNewEntity>>,
    { data: PostPipelinesListsEntityListIdCreateNewEntityBody }
  > = (props) => {
    const { data } = props ?? {};

    return postPipelinesListsEntityListIdCreateNewEntity(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostPipelinesListsEntityListIdCreateNewEntityMutationResult = NonNullable<
  Awaited<ReturnType<typeof postPipelinesListsEntityListIdCreateNewEntity>>
>;
export type PostPipelinesListsEntityListIdCreateNewEntityMutationBody =
  PostPipelinesListsEntityListIdCreateNewEntityBody;
export type PostPipelinesListsEntityListIdCreateNewEntityMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostPipelinesListsEntityListIdCreateNewEntity = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPipelinesListsEntityListIdCreateNewEntity>>,
    TError,
    { data: PostPipelinesListsEntityListIdCreateNewEntityBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostPipelinesListsEntityListIdCreateNewEntityMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getPipelinesListsEntityListId = (signal?: AbortSignal) => {
  return customHttpClient<GetPipelinesListsEntityListId200>({
    url: `/pipelines/lists/:entityListId`,
    method: 'GET',
    signal,
  });
};

export const getGetPipelinesListsEntityListIdQueryKey = () => {
  return [`/pipelines/lists/:entityListId`] as const;
};

export const getGetPipelinesListsEntityListIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getPipelinesListsEntityListId>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getPipelinesListsEntityListId>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPipelinesListsEntityListIdQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPipelinesListsEntityListId>>> = ({ signal }) =>
    getPipelinesListsEntityListId(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPipelinesListsEntityListId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPipelinesListsEntityListIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPipelinesListsEntityListId>>
>;
export type GetPipelinesListsEntityListIdQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetPipelinesListsEntityListId = <
  TData = Awaited<ReturnType<typeof getPipelinesListsEntityListId>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getPipelinesListsEntityListId>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetPipelinesListsEntityListIdQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const putPipelinesListsEntityListId = () => {
  return customHttpClient<PutPipelinesListsEntityListId200>({ url: `/pipelines/lists/:entityListId`, method: 'PUT' });
};

export const getPutPipelinesListsEntityListIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putPipelinesListsEntityListId>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof putPipelinesListsEntityListId>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof putPipelinesListsEntityListId>>, void> = () => {
    return putPipelinesListsEntityListId();
  };

  return { mutationFn, ...mutationOptions };
};

export type PutPipelinesListsEntityListIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putPipelinesListsEntityListId>>
>;

export type PutPipelinesListsEntityListIdMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutPipelinesListsEntityListId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putPipelinesListsEntityListId>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPutPipelinesListsEntityListIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deletePipelinesListsEntityListId = () => {
  return customHttpClient<DeletePipelinesListsEntityListId200>({
    url: `/pipelines/lists/:entityListId`,
    method: 'DELETE',
  });
};

export const getDeletePipelinesListsEntityListIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof deletePipelinesListsEntityListId>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof deletePipelinesListsEntityListId>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePipelinesListsEntityListId>>, void> = () => {
    return deletePipelinesListsEntityListId();
  };

  return { mutationFn, ...mutationOptions };
};

export type DeletePipelinesListsEntityListIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deletePipelinesListsEntityListId>>
>;

export type DeletePipelinesListsEntityListIdMutationError = Status400 | Status401 | Status403 | Status404;

export const useDeletePipelinesListsEntityListId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof deletePipelinesListsEntityListId>>, TError, void, TContext>;
}) => {
  const mutationOptions = getDeletePipelinesListsEntityListIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getPipelinesListsEntityListIdPipelines = (signal?: AbortSignal) => {
  return customHttpClient<GetPipelinesListsEntityListIdPipelines200>({
    url: `/pipelines/lists/:entityListId/pipelines`,
    method: 'GET',
    signal,
  });
};

export const getGetPipelinesListsEntityListIdPipelinesQueryKey = () => {
  return [`/pipelines/lists/:entityListId/pipelines`] as const;
};

export const getGetPipelinesListsEntityListIdPipelinesQueryOptions = <
  TData = Awaited<ReturnType<typeof getPipelinesListsEntityListIdPipelines>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getPipelinesListsEntityListIdPipelines>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPipelinesListsEntityListIdPipelinesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPipelinesListsEntityListIdPipelines>>> = ({ signal }) =>
    getPipelinesListsEntityListIdPipelines(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPipelinesListsEntityListIdPipelines>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPipelinesListsEntityListIdPipelinesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPipelinesListsEntityListIdPipelines>>
>;
export type GetPipelinesListsEntityListIdPipelinesQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetPipelinesListsEntityListIdPipelines = <
  TData = Awaited<ReturnType<typeof getPipelinesListsEntityListIdPipelines>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getPipelinesListsEntityListIdPipelines>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetPipelinesListsEntityListIdPipelinesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postPipelinesListsEntityListIdAdd = (
  postPipelinesListsEntityListIdAddBody: PostPipelinesListsEntityListIdAddBody,
) => {
  return customHttpClient<PostPipelinesListsEntityListIdAdd200>({
    url: `/pipelines/lists/:entityListId/add`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postPipelinesListsEntityListIdAddBody,
  });
};

export const getPostPipelinesListsEntityListIdAddMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPipelinesListsEntityListIdAdd>>,
    TError,
    { data: PostPipelinesListsEntityListIdAddBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postPipelinesListsEntityListIdAdd>>,
  TError,
  { data: PostPipelinesListsEntityListIdAddBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postPipelinesListsEntityListIdAdd>>,
    { data: PostPipelinesListsEntityListIdAddBody }
  > = (props) => {
    const { data } = props ?? {};

    return postPipelinesListsEntityListIdAdd(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostPipelinesListsEntityListIdAddMutationResult = NonNullable<
  Awaited<ReturnType<typeof postPipelinesListsEntityListIdAdd>>
>;
export type PostPipelinesListsEntityListIdAddMutationBody = PostPipelinesListsEntityListIdAddBody;
export type PostPipelinesListsEntityListIdAddMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostPipelinesListsEntityListIdAdd = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPipelinesListsEntityListIdAdd>>,
    TError,
    { data: PostPipelinesListsEntityListIdAddBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostPipelinesListsEntityListIdAddMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postPipelinesListsEntityListIdRemove = (
  postPipelinesListsEntityListIdRemoveBody: PostPipelinesListsEntityListIdRemoveBody,
) => {
  return customHttpClient<PostPipelinesListsEntityListIdRemove200>({
    url: `/pipelines/lists/:entityListId/remove`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postPipelinesListsEntityListIdRemoveBody,
  });
};

export const getPostPipelinesListsEntityListIdRemoveMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPipelinesListsEntityListIdRemove>>,
    TError,
    { data: PostPipelinesListsEntityListIdRemoveBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postPipelinesListsEntityListIdRemove>>,
  TError,
  { data: PostPipelinesListsEntityListIdRemoveBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postPipelinesListsEntityListIdRemove>>,
    { data: PostPipelinesListsEntityListIdRemoveBody }
  > = (props) => {
    const { data } = props ?? {};

    return postPipelinesListsEntityListIdRemove(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostPipelinesListsEntityListIdRemoveMutationResult = NonNullable<
  Awaited<ReturnType<typeof postPipelinesListsEntityListIdRemove>>
>;
export type PostPipelinesListsEntityListIdRemoveMutationBody = PostPipelinesListsEntityListIdRemoveBody;
export type PostPipelinesListsEntityListIdRemoveMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostPipelinesListsEntityListIdRemove = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPipelinesListsEntityListIdRemove>>,
    TError,
    { data: PostPipelinesListsEntityListIdRemoveBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostPipelinesListsEntityListIdRemoveMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postPipelinesListsEntityListIdReorder = (
  postPipelinesListsEntityListIdReorderBody: PostPipelinesListsEntityListIdReorderBody,
) => {
  return customHttpClient<PostPipelinesListsEntityListIdReorder200>({
    url: `/pipelines/lists/:entityListId/reorder`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postPipelinesListsEntityListIdReorderBody,
  });
};

export const getPostPipelinesListsEntityListIdReorderMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPipelinesListsEntityListIdReorder>>,
    TError,
    { data: PostPipelinesListsEntityListIdReorderBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postPipelinesListsEntityListIdReorder>>,
  TError,
  { data: PostPipelinesListsEntityListIdReorderBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postPipelinesListsEntityListIdReorder>>,
    { data: PostPipelinesListsEntityListIdReorderBody }
  > = (props) => {
    const { data } = props ?? {};

    return postPipelinesListsEntityListIdReorder(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostPipelinesListsEntityListIdReorderMutationResult = NonNullable<
  Awaited<ReturnType<typeof postPipelinesListsEntityListIdReorder>>
>;
export type PostPipelinesListsEntityListIdReorderMutationBody = PostPipelinesListsEntityListIdReorderBody;
export type PostPipelinesListsEntityListIdReorderMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostPipelinesListsEntityListIdReorder = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPipelinesListsEntityListIdReorder>>,
    TError,
    { data: PostPipelinesListsEntityListIdReorderBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostPipelinesListsEntityListIdReorderMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postPipelinesListsEntityListIdUserGroups = (
  postPipelinesListsEntityListIdUserGroupsBody: PostPipelinesListsEntityListIdUserGroupsBody,
) => {
  return customHttpClient<PostPipelinesListsEntityListIdUserGroups200>({
    url: `/pipelines/lists/:entityListId/user-groups`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postPipelinesListsEntityListIdUserGroupsBody,
  });
};

export const getPostPipelinesListsEntityListIdUserGroupsMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPipelinesListsEntityListIdUserGroups>>,
    TError,
    { data: PostPipelinesListsEntityListIdUserGroupsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postPipelinesListsEntityListIdUserGroups>>,
  TError,
  { data: PostPipelinesListsEntityListIdUserGroupsBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postPipelinesListsEntityListIdUserGroups>>,
    { data: PostPipelinesListsEntityListIdUserGroupsBody }
  > = (props) => {
    const { data } = props ?? {};

    return postPipelinesListsEntityListIdUserGroups(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostPipelinesListsEntityListIdUserGroupsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postPipelinesListsEntityListIdUserGroups>>
>;
export type PostPipelinesListsEntityListIdUserGroupsMutationBody = PostPipelinesListsEntityListIdUserGroupsBody;
export type PostPipelinesListsEntityListIdUserGroupsMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostPipelinesListsEntityListIdUserGroups = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPipelinesListsEntityListIdUserGroups>>,
    TError,
    { data: PostPipelinesListsEntityListIdUserGroupsBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostPipelinesListsEntityListIdUserGroupsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postPipelinesEntityIdLists = (
  entityId: string,
  postPipelinesEntityIdListsBody: PostPipelinesEntityIdListsBody,
) => {
  return customHttpClient<PostPipelinesEntityIdLists200>({
    url: `/pipelines/${entityId}/lists`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postPipelinesEntityIdListsBody,
  });
};

export const getPostPipelinesEntityIdListsMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPipelinesEntityIdLists>>,
    TError,
    { entityId: string; data: PostPipelinesEntityIdListsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postPipelinesEntityIdLists>>,
  TError,
  { entityId: string; data: PostPipelinesEntityIdListsBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postPipelinesEntityIdLists>>,
    { entityId: string; data: PostPipelinesEntityIdListsBody }
  > = (props) => {
    const { entityId, data } = props ?? {};

    return postPipelinesEntityIdLists(entityId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostPipelinesEntityIdListsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postPipelinesEntityIdLists>>
>;
export type PostPipelinesEntityIdListsMutationBody = PostPipelinesEntityIdListsBody;
export type PostPipelinesEntityIdListsMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostPipelinesEntityIdLists = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPipelinesEntityIdLists>>,
    TError,
    { entityId: string; data: PostPipelinesEntityIdListsBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostPipelinesEntityIdListsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postPipelinesMove = (postPipelinesMoveBody: PostPipelinesMoveBody) => {
  return customHttpClient<PostPipelinesMove200>({
    url: `/pipelines/move`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postPipelinesMoveBody,
  });
};

export const getPostPipelinesMoveMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPipelinesMove>>,
    TError,
    { data: PostPipelinesMoveBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postPipelinesMove>>,
  TError,
  { data: PostPipelinesMoveBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPipelinesMove>>, { data: PostPipelinesMoveBody }> = (
    props,
  ) => {
    const { data } = props ?? {};

    return postPipelinesMove(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostPipelinesMoveMutationResult = NonNullable<Awaited<ReturnType<typeof postPipelinesMove>>>;
export type PostPipelinesMoveMutationBody = PostPipelinesMoveBody;
export type PostPipelinesMoveMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostPipelinesMove = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPipelinesMove>>,
    TError,
    { data: PostPipelinesMoveBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostPipelinesMoveMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postPipelinesMoveBulk = (postPipelinesMoveBulkBody: PostPipelinesMoveBulkBody) => {
  return customHttpClient<PostPipelinesMoveBulk200>({
    url: `/pipelines/move-bulk`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postPipelinesMoveBulkBody,
  });
};

export const getPostPipelinesMoveBulkMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPipelinesMoveBulk>>,
    TError,
    { data: PostPipelinesMoveBulkBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postPipelinesMoveBulk>>,
  TError,
  { data: PostPipelinesMoveBulkBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postPipelinesMoveBulk>>,
    { data: PostPipelinesMoveBulkBody }
  > = (props) => {
    const { data } = props ?? {};

    return postPipelinesMoveBulk(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostPipelinesMoveBulkMutationResult = NonNullable<Awaited<ReturnType<typeof postPipelinesMoveBulk>>>;
export type PostPipelinesMoveBulkMutationBody = PostPipelinesMoveBulkBody;
export type PostPipelinesMoveBulkMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostPipelinesMoveBulk = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPipelinesMoveBulk>>,
    TError,
    { data: PostPipelinesMoveBulkBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostPipelinesMoveBulkMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postPipelinesMoveManually = (postPipelinesMoveManuallyBody: PostPipelinesMoveManuallyBody) => {
  return customHttpClient<PostPipelinesMoveManually200>({
    url: `/pipelines/move-manually`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postPipelinesMoveManuallyBody,
  });
};

export const getPostPipelinesMoveManuallyMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPipelinesMoveManually>>,
    TError,
    { data: PostPipelinesMoveManuallyBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postPipelinesMoveManually>>,
  TError,
  { data: PostPipelinesMoveManuallyBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postPipelinesMoveManually>>,
    { data: PostPipelinesMoveManuallyBody }
  > = (props) => {
    const { data } = props ?? {};

    return postPipelinesMoveManually(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostPipelinesMoveManuallyMutationResult = NonNullable<
  Awaited<ReturnType<typeof postPipelinesMoveManually>>
>;
export type PostPipelinesMoveManuallyMutationBody = PostPipelinesMoveManuallyBody;
export type PostPipelinesMoveManuallyMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostPipelinesMoveManually = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPipelinesMoveManually>>,
    TError,
    { data: PostPipelinesMoveManuallyBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostPipelinesMoveManuallyMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postPipelinesPipelineIdMove = (postPipelinesPipelineIdMoveBody: PostPipelinesPipelineIdMoveBody) => {
  return customHttpClient<PostPipelinesPipelineIdMove200>({
    url: `/pipelines/:pipelineId/move`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postPipelinesPipelineIdMoveBody,
  });
};

export const getPostPipelinesPipelineIdMoveMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPipelinesPipelineIdMove>>,
    TError,
    { data: PostPipelinesPipelineIdMoveBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postPipelinesPipelineIdMove>>,
  TError,
  { data: PostPipelinesPipelineIdMoveBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postPipelinesPipelineIdMove>>,
    { data: PostPipelinesPipelineIdMoveBody }
  > = (props) => {
    const { data } = props ?? {};

    return postPipelinesPipelineIdMove(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostPipelinesPipelineIdMoveMutationResult = NonNullable<
  Awaited<ReturnType<typeof postPipelinesPipelineIdMove>>
>;
export type PostPipelinesPipelineIdMoveMutationBody = PostPipelinesPipelineIdMoveBody;
export type PostPipelinesPipelineIdMoveMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostPipelinesPipelineIdMove = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPipelinesPipelineIdMove>>,
    TError,
    { data: PostPipelinesPipelineIdMoveBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostPipelinesPipelineIdMoveMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postPipelinesJobApplyJobCode = (postPipelinesJobApplyJobCodeBody: PostPipelinesJobApplyJobCodeBody) => {
  return customHttpClient<PostPipelinesJobApplyJobCode200>({
    url: `/pipelines/job-apply/:jobCode`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postPipelinesJobApplyJobCodeBody,
  });
};

export const getPostPipelinesJobApplyJobCodeMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPipelinesJobApplyJobCode>>,
    TError,
    { data: PostPipelinesJobApplyJobCodeBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postPipelinesJobApplyJobCode>>,
  TError,
  { data: PostPipelinesJobApplyJobCodeBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postPipelinesJobApplyJobCode>>,
    { data: PostPipelinesJobApplyJobCodeBody }
  > = (props) => {
    const { data } = props ?? {};

    return postPipelinesJobApplyJobCode(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostPipelinesJobApplyJobCodeMutationResult = NonNullable<
  Awaited<ReturnType<typeof postPipelinesJobApplyJobCode>>
>;
export type PostPipelinesJobApplyJobCodeMutationBody = PostPipelinesJobApplyJobCodeBody;
export type PostPipelinesJobApplyJobCodeMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostPipelinesJobApplyJobCode = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPipelinesJobApplyJobCode>>,
    TError,
    { data: PostPipelinesJobApplyJobCodeBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostPipelinesJobApplyJobCodeMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getPublicJobsCodePipelinesEditOptions = (signal?: AbortSignal) => {
  return customHttpClient<GetPublicJobsCodePipelinesEditOptions200>({
    url: `/public-jobs/:code/pipelines/edit-options`,
    method: 'GET',
    signal,
  });
};

export const getGetPublicJobsCodePipelinesEditOptionsQueryKey = () => {
  return [`/public-jobs/:code/pipelines/edit-options`] as const;
};

export const getGetPublicJobsCodePipelinesEditOptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getPublicJobsCodePipelinesEditOptions>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getPublicJobsCodePipelinesEditOptions>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPublicJobsCodePipelinesEditOptionsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicJobsCodePipelinesEditOptions>>> = ({ signal }) =>
    getPublicJobsCodePipelinesEditOptions(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPublicJobsCodePipelinesEditOptions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPublicJobsCodePipelinesEditOptionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPublicJobsCodePipelinesEditOptions>>
>;
export type GetPublicJobsCodePipelinesEditOptionsQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetPublicJobsCodePipelinesEditOptions = <
  TData = Awaited<ReturnType<typeof getPublicJobsCodePipelinesEditOptions>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getPublicJobsCodePipelinesEditOptions>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetPublicJobsCodePipelinesEditOptionsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getPublicJobsMyCode = (signal?: AbortSignal) => {
  return customHttpClient<GetPublicJobsMyCode200>({ url: `/public-jobs/my/:code`, method: 'GET', signal });
};

export const getGetPublicJobsMyCodeQueryKey = () => {
  return [`/public-jobs/my/:code`] as const;
};

export const getGetPublicJobsMyCodeQueryOptions = <
  TData = Awaited<ReturnType<typeof getPublicJobsMyCode>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getPublicJobsMyCode>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPublicJobsMyCodeQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicJobsMyCode>>> = ({ signal }) =>
    getPublicJobsMyCode(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPublicJobsMyCode>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPublicJobsMyCodeQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicJobsMyCode>>>;
export type GetPublicJobsMyCodeQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetPublicJobsMyCode = <
  TData = Awaited<ReturnType<typeof getPublicJobsMyCode>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getPublicJobsMyCode>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetPublicJobsMyCodeQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postPublicJobsApplyCode = (postPublicJobsApplyCodeBody: PostPublicJobsApplyCodeBody) => {
  return customHttpClient<PostPublicJobsApplyCode200>({
    url: `/public-jobs/apply/:code`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postPublicJobsApplyCodeBody,
  });
};

export const getPostPublicJobsApplyCodeMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPublicJobsApplyCode>>,
    TError,
    { data: PostPublicJobsApplyCodeBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postPublicJobsApplyCode>>,
  TError,
  { data: PostPublicJobsApplyCodeBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postPublicJobsApplyCode>>,
    { data: PostPublicJobsApplyCodeBody }
  > = (props) => {
    const { data } = props ?? {};

    return postPublicJobsApplyCode(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostPublicJobsApplyCodeMutationResult = NonNullable<Awaited<ReturnType<typeof postPublicJobsApplyCode>>>;
export type PostPublicJobsApplyCodeMutationBody = PostPublicJobsApplyCodeBody;
export type PostPublicJobsApplyCodeMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostPublicJobsApplyCode = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPublicJobsApplyCode>>,
    TError,
    { data: PostPublicJobsApplyCodeBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostPublicJobsApplyCodeMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postRecognitionEvaRecognitionIdFeedback = (
  postRecognitionEvaRecognitionIdFeedbackBody: PostRecognitionEvaRecognitionIdFeedbackBody,
) => {
  return customHttpClient<PostRecognitionEvaRecognitionIdFeedback200>({
    url: `/recognition/:evaRecognitionId/feedback`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postRecognitionEvaRecognitionIdFeedbackBody,
  });
};

export const getPostRecognitionEvaRecognitionIdFeedbackMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postRecognitionEvaRecognitionIdFeedback>>,
    TError,
    { data: PostRecognitionEvaRecognitionIdFeedbackBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postRecognitionEvaRecognitionIdFeedback>>,
  TError,
  { data: PostRecognitionEvaRecognitionIdFeedbackBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postRecognitionEvaRecognitionIdFeedback>>,
    { data: PostRecognitionEvaRecognitionIdFeedbackBody }
  > = (props) => {
    const { data } = props ?? {};

    return postRecognitionEvaRecognitionIdFeedback(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostRecognitionEvaRecognitionIdFeedbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof postRecognitionEvaRecognitionIdFeedback>>
>;
export type PostRecognitionEvaRecognitionIdFeedbackMutationBody = PostRecognitionEvaRecognitionIdFeedbackBody;
export type PostRecognitionEvaRecognitionIdFeedbackMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostRecognitionEvaRecognitionIdFeedback = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postRecognitionEvaRecognitionIdFeedback>>,
    TError,
    { data: PostRecognitionEvaRecognitionIdFeedbackBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostRecognitionEvaRecognitionIdFeedbackMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postRecognitionOmnichatIdConversationFeedback = (
  postRecognitionOmnichatIdConversationFeedbackBody: PostRecognitionOmnichatIdConversationFeedbackBody,
) => {
  return customHttpClient<PostRecognitionOmnichatIdConversationFeedback200>({
    url: `/recognition/:omnichatId/conversation-feedback`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postRecognitionOmnichatIdConversationFeedbackBody,
  });
};

export const getPostRecognitionOmnichatIdConversationFeedbackMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postRecognitionOmnichatIdConversationFeedback>>,
    TError,
    { data: PostRecognitionOmnichatIdConversationFeedbackBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postRecognitionOmnichatIdConversationFeedback>>,
  TError,
  { data: PostRecognitionOmnichatIdConversationFeedbackBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postRecognitionOmnichatIdConversationFeedback>>,
    { data: PostRecognitionOmnichatIdConversationFeedbackBody }
  > = (props) => {
    const { data } = props ?? {};

    return postRecognitionOmnichatIdConversationFeedback(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostRecognitionOmnichatIdConversationFeedbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof postRecognitionOmnichatIdConversationFeedback>>
>;
export type PostRecognitionOmnichatIdConversationFeedbackMutationBody =
  PostRecognitionOmnichatIdConversationFeedbackBody;
export type PostRecognitionOmnichatIdConversationFeedbackMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostRecognitionOmnichatIdConversationFeedback = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postRecognitionOmnichatIdConversationFeedback>>,
    TError,
    { data: PostRecognitionOmnichatIdConversationFeedbackBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostRecognitionOmnichatIdConversationFeedbackMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getRecognitionIntents = (signal?: AbortSignal) => {
  return customHttpClient<GetRecognitionIntents200>({ url: `/recognition/intents`, method: 'GET', signal });
};

export const getGetRecognitionIntentsQueryKey = () => {
  return [`/recognition/intents`] as const;
};

export const getGetRecognitionIntentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getRecognitionIntents>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getRecognitionIntents>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetRecognitionIntentsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRecognitionIntents>>> = ({ signal }) =>
    getRecognitionIntents(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRecognitionIntents>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetRecognitionIntentsQueryResult = NonNullable<Awaited<ReturnType<typeof getRecognitionIntents>>>;
export type GetRecognitionIntentsQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetRecognitionIntents = <
  TData = Awaited<ReturnType<typeof getRecognitionIntents>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getRecognitionIntents>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetRecognitionIntentsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getCbeSettings = (signal?: AbortSignal) => {
  return customHttpClient<GetCbeSettings200>({ url: `/cbe/settings`, method: 'GET', signal });
};

export const getGetCbeSettingsQueryKey = () => {
  return [`/cbe/settings`] as const;
};

export const getGetCbeSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCbeSettings>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCbeSettings>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCbeSettingsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCbeSettings>>> = ({ signal }) => getCbeSettings(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCbeSettings>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCbeSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getCbeSettings>>>;
export type GetCbeSettingsQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetCbeSettings = <
  TData = Awaited<ReturnType<typeof getCbeSettings>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCbeSettings>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCbeSettingsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getCbeSettingsConstants = (signal?: AbortSignal) => {
  return customHttpClient<GetCbeSettingsConstants200>({ url: `/cbe/settings/constants`, method: 'GET', signal });
};

export const getGetCbeSettingsConstantsQueryKey = () => {
  return [`/cbe/settings/constants`] as const;
};

export const getGetCbeSettingsConstantsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCbeSettingsConstants>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCbeSettingsConstants>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCbeSettingsConstantsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCbeSettingsConstants>>> = ({ signal }) =>
    getCbeSettingsConstants(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCbeSettingsConstants>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCbeSettingsConstantsQueryResult = NonNullable<Awaited<ReturnType<typeof getCbeSettingsConstants>>>;
export type GetCbeSettingsConstantsQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetCbeSettingsConstants = <
  TData = Awaited<ReturnType<typeof getCbeSettingsConstants>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCbeSettingsConstants>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCbeSettingsConstantsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postCbeSettingsLogosLogoType = (postCbeSettingsLogosLogoTypeBody: PostCbeSettingsLogosLogoTypeBody) => {
  return customHttpClient<PostCbeSettingsLogosLogoType200>({
    url: `/cbe/settings/logos/:logoType`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postCbeSettingsLogosLogoTypeBody,
  });
};

export const getPostCbeSettingsLogosLogoTypeMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCbeSettingsLogosLogoType>>,
    TError,
    { data: PostCbeSettingsLogosLogoTypeBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCbeSettingsLogosLogoType>>,
  TError,
  { data: PostCbeSettingsLogosLogoTypeBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCbeSettingsLogosLogoType>>,
    { data: PostCbeSettingsLogosLogoTypeBody }
  > = (props) => {
    const { data } = props ?? {};

    return postCbeSettingsLogosLogoType(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCbeSettingsLogosLogoTypeMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCbeSettingsLogosLogoType>>
>;
export type PostCbeSettingsLogosLogoTypeMutationBody = PostCbeSettingsLogosLogoTypeBody;
export type PostCbeSettingsLogosLogoTypeMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostCbeSettingsLogosLogoType = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCbeSettingsLogosLogoType>>,
    TError,
    { data: PostCbeSettingsLogosLogoTypeBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostCbeSettingsLogosLogoTypeMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postCbeSettingsCvPdf = (postCbeSettingsCvPdfBody: PostCbeSettingsCvPdfBody) => {
  return customHttpClient<PostCbeSettingsCvPdf200>({
    url: `/cbe/settings/cv-pdf`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postCbeSettingsCvPdfBody,
  });
};

export const getPostCbeSettingsCvPdfMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCbeSettingsCvPdf>>,
    TError,
    { data: PostCbeSettingsCvPdfBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCbeSettingsCvPdf>>,
  TError,
  { data: PostCbeSettingsCvPdfBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCbeSettingsCvPdf>>,
    { data: PostCbeSettingsCvPdfBody }
  > = (props) => {
    const { data } = props ?? {};

    return postCbeSettingsCvPdf(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCbeSettingsCvPdfMutationResult = NonNullable<Awaited<ReturnType<typeof postCbeSettingsCvPdf>>>;
export type PostCbeSettingsCvPdfMutationBody = PostCbeSettingsCvPdfBody;
export type PostCbeSettingsCvPdfMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostCbeSettingsCvPdf = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCbeSettingsCvPdf>>,
    TError,
    { data: PostCbeSettingsCvPdfBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostCbeSettingsCvPdfMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getCbeSettingsCvPdf = (signal?: AbortSignal) => {
  return customHttpClient<GetCbeSettingsCvPdf200>({ url: `/cbe/settings/cv-pdf`, method: 'GET', signal });
};

export const getGetCbeSettingsCvPdfQueryKey = () => {
  return [`/cbe/settings/cv-pdf`] as const;
};

export const getGetCbeSettingsCvPdfQueryOptions = <
  TData = Awaited<ReturnType<typeof getCbeSettingsCvPdf>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCbeSettingsCvPdf>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCbeSettingsCvPdfQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCbeSettingsCvPdf>>> = ({ signal }) =>
    getCbeSettingsCvPdf(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCbeSettingsCvPdf>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCbeSettingsCvPdfQueryResult = NonNullable<Awaited<ReturnType<typeof getCbeSettingsCvPdf>>>;
export type GetCbeSettingsCvPdfQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetCbeSettingsCvPdf = <
  TData = Awaited<ReturnType<typeof getCbeSettingsCvPdf>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCbeSettingsCvPdf>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCbeSettingsCvPdfQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postCbeSettingsCvPdfPath = (postCbeSettingsCvPdfPathBody: PostCbeSettingsCvPdfPathBody) => {
  return customHttpClient<PostCbeSettingsCvPdfPath200>({
    url: `/cbe/settings/cv-pdf/:path`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postCbeSettingsCvPdfPathBody,
  });
};

export const getPostCbeSettingsCvPdfPathMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCbeSettingsCvPdfPath>>,
    TError,
    { data: PostCbeSettingsCvPdfPathBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCbeSettingsCvPdfPath>>,
  TError,
  { data: PostCbeSettingsCvPdfPathBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCbeSettingsCvPdfPath>>,
    { data: PostCbeSettingsCvPdfPathBody }
  > = (props) => {
    const { data } = props ?? {};

    return postCbeSettingsCvPdfPath(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCbeSettingsCvPdfPathMutationResult = NonNullable<Awaited<ReturnType<typeof postCbeSettingsCvPdfPath>>>;
export type PostCbeSettingsCvPdfPathMutationBody = PostCbeSettingsCvPdfPathBody;
export type PostCbeSettingsCvPdfPathMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostCbeSettingsCvPdfPath = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCbeSettingsCvPdfPath>>,
    TError,
    { data: PostCbeSettingsCvPdfPathBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostCbeSettingsCvPdfPathMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getCbeSettingsCvPdfRandomCandidate = (signal?: AbortSignal) => {
  return customHttpClient<GetCbeSettingsCvPdfRandomCandidate200>({
    url: `/cbe/settings/cv-pdf/random-candidate`,
    method: 'GET',
    signal,
  });
};

export const getGetCbeSettingsCvPdfRandomCandidateQueryKey = () => {
  return [`/cbe/settings/cv-pdf/random-candidate`] as const;
};

export const getGetCbeSettingsCvPdfRandomCandidateQueryOptions = <
  TData = Awaited<ReturnType<typeof getCbeSettingsCvPdfRandomCandidate>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCbeSettingsCvPdfRandomCandidate>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCbeSettingsCvPdfRandomCandidateQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCbeSettingsCvPdfRandomCandidate>>> = ({ signal }) =>
    getCbeSettingsCvPdfRandomCandidate(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCbeSettingsCvPdfRandomCandidate>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCbeSettingsCvPdfRandomCandidateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCbeSettingsCvPdfRandomCandidate>>
>;
export type GetCbeSettingsCvPdfRandomCandidateQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetCbeSettingsCvPdfRandomCandidate = <
  TData = Awaited<ReturnType<typeof getCbeSettingsCvPdfRandomCandidate>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCbeSettingsCvPdfRandomCandidate>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCbeSettingsCvPdfRandomCandidateQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getCbeSettingsQuotas = (signal?: AbortSignal) => {
  return customHttpClient<GetCbeSettingsQuotas200>({ url: `/cbe/settings/quotas`, method: 'GET', signal });
};

export const getGetCbeSettingsQuotasQueryKey = () => {
  return [`/cbe/settings/quotas`] as const;
};

export const getGetCbeSettingsQuotasQueryOptions = <
  TData = Awaited<ReturnType<typeof getCbeSettingsQuotas>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCbeSettingsQuotas>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCbeSettingsQuotasQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCbeSettingsQuotas>>> = ({ signal }) =>
    getCbeSettingsQuotas(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCbeSettingsQuotas>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCbeSettingsQuotasQueryResult = NonNullable<Awaited<ReturnType<typeof getCbeSettingsQuotas>>>;
export type GetCbeSettingsQuotasQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetCbeSettingsQuotas = <
  TData = Awaited<ReturnType<typeof getCbeSettingsQuotas>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCbeSettingsQuotas>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCbeSettingsQuotasQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const putCbeSettingsQuotasCode = () => {
  return customHttpClient<PutCbeSettingsQuotasCode200>({ url: `/cbe/settings/quotas/:code`, method: 'PUT' });
};

export const getPutCbeSettingsQuotasCodeMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putCbeSettingsQuotasCode>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof putCbeSettingsQuotasCode>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof putCbeSettingsQuotasCode>>, void> = () => {
    return putCbeSettingsQuotasCode();
  };

  return { mutationFn, ...mutationOptions };
};

export type PutCbeSettingsQuotasCodeMutationResult = NonNullable<Awaited<ReturnType<typeof putCbeSettingsQuotasCode>>>;

export type PutCbeSettingsQuotasCodeMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutCbeSettingsQuotasCode = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putCbeSettingsQuotasCode>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPutCbeSettingsQuotasCodeMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getCbeSettingsQuotasEditModel = (signal?: AbortSignal) => {
  return customHttpClient<GetCbeSettingsQuotasEditModel200>({
    url: `/cbe/settings/quotas/edit-model`,
    method: 'GET',
    signal,
  });
};

export const getGetCbeSettingsQuotasEditModelQueryKey = () => {
  return [`/cbe/settings/quotas/edit-model`] as const;
};

export const getGetCbeSettingsQuotasEditModelQueryOptions = <
  TData = Awaited<ReturnType<typeof getCbeSettingsQuotasEditModel>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCbeSettingsQuotasEditModel>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCbeSettingsQuotasEditModelQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCbeSettingsQuotasEditModel>>> = ({ signal }) =>
    getCbeSettingsQuotasEditModel(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCbeSettingsQuotasEditModel>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCbeSettingsQuotasEditModelQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCbeSettingsQuotasEditModel>>
>;
export type GetCbeSettingsQuotasEditModelQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetCbeSettingsQuotasEditModel = <
  TData = Awaited<ReturnType<typeof getCbeSettingsQuotasEditModel>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCbeSettingsQuotasEditModel>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCbeSettingsQuotasEditModelQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const putCbeSettingsGeneral = () => {
  return customHttpClient<PutCbeSettingsGeneral200>({ url: `/cbe/settings/general`, method: 'PUT' });
};

export const getPutCbeSettingsGeneralMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putCbeSettingsGeneral>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof putCbeSettingsGeneral>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof putCbeSettingsGeneral>>, void> = () => {
    return putCbeSettingsGeneral();
  };

  return { mutationFn, ...mutationOptions };
};

export type PutCbeSettingsGeneralMutationResult = NonNullable<Awaited<ReturnType<typeof putCbeSettingsGeneral>>>;

export type PutCbeSettingsGeneralMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutCbeSettingsGeneral = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putCbeSettingsGeneral>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPutCbeSettingsGeneralMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putCbeSettingsCandidateBranding = () => {
  return customHttpClient<PutCbeSettingsCandidateBranding200>({
    url: `/cbe/settings/candidate-branding`,
    method: 'PUT',
  });
};

export const getPutCbeSettingsCandidateBrandingMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putCbeSettingsCandidateBranding>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof putCbeSettingsCandidateBranding>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof putCbeSettingsCandidateBranding>>, void> = () => {
    return putCbeSettingsCandidateBranding();
  };

  return { mutationFn, ...mutationOptions };
};

export type PutCbeSettingsCandidateBrandingMutationResult = NonNullable<
  Awaited<ReturnType<typeof putCbeSettingsCandidateBranding>>
>;

export type PutCbeSettingsCandidateBrandingMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutCbeSettingsCandidateBranding = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putCbeSettingsCandidateBranding>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPutCbeSettingsCandidateBrandingMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postCbeSettingsCrudsDefaultsEntitiesType = (
  postCbeSettingsCrudsDefaultsEntitiesTypeBody: PostCbeSettingsCrudsDefaultsEntitiesTypeBody,
) => {
  return customHttpClient<PostCbeSettingsCrudsDefaultsEntitiesType200>({
    url: `/cbe/settings/cruds-defaults/:entitiesType`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postCbeSettingsCrudsDefaultsEntitiesTypeBody,
  });
};

export const getPostCbeSettingsCrudsDefaultsEntitiesTypeMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCbeSettingsCrudsDefaultsEntitiesType>>,
    TError,
    { data: PostCbeSettingsCrudsDefaultsEntitiesTypeBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCbeSettingsCrudsDefaultsEntitiesType>>,
  TError,
  { data: PostCbeSettingsCrudsDefaultsEntitiesTypeBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCbeSettingsCrudsDefaultsEntitiesType>>,
    { data: PostCbeSettingsCrudsDefaultsEntitiesTypeBody }
  > = (props) => {
    const { data } = props ?? {};

    return postCbeSettingsCrudsDefaultsEntitiesType(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCbeSettingsCrudsDefaultsEntitiesTypeMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCbeSettingsCrudsDefaultsEntitiesType>>
>;
export type PostCbeSettingsCrudsDefaultsEntitiesTypeMutationBody = PostCbeSettingsCrudsDefaultsEntitiesTypeBody;
export type PostCbeSettingsCrudsDefaultsEntitiesTypeMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostCbeSettingsCrudsDefaultsEntitiesType = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCbeSettingsCrudsDefaultsEntitiesType>>,
    TError,
    { data: PostCbeSettingsCrudsDefaultsEntitiesTypeBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostCbeSettingsCrudsDefaultsEntitiesTypeMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getCbeSettingsTermsAndConditions = (signal?: AbortSignal) => {
  return customHttpClient<GetCbeSettingsTermsAndConditions200>({
    url: `/cbe/settings/terms-and-conditions`,
    method: 'GET',
    signal,
  });
};

export const getGetCbeSettingsTermsAndConditionsQueryKey = () => {
  return [`/cbe/settings/terms-and-conditions`] as const;
};

export const getGetCbeSettingsTermsAndConditionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCbeSettingsTermsAndConditions>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCbeSettingsTermsAndConditions>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCbeSettingsTermsAndConditionsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCbeSettingsTermsAndConditions>>> = ({ signal }) =>
    getCbeSettingsTermsAndConditions(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCbeSettingsTermsAndConditions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCbeSettingsTermsAndConditionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCbeSettingsTermsAndConditions>>
>;
export type GetCbeSettingsTermsAndConditionsQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetCbeSettingsTermsAndConditions = <
  TData = Awaited<ReturnType<typeof getCbeSettingsTermsAndConditions>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCbeSettingsTermsAndConditions>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCbeSettingsTermsAndConditionsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const putCbeSettingsTermsAndConditions = () => {
  return customHttpClient<PutCbeSettingsTermsAndConditions200>({
    url: `/cbe/settings/terms-and-conditions`,
    method: 'PUT',
  });
};

export const getPutCbeSettingsTermsAndConditionsMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putCbeSettingsTermsAndConditions>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof putCbeSettingsTermsAndConditions>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof putCbeSettingsTermsAndConditions>>, void> = () => {
    return putCbeSettingsTermsAndConditions();
  };

  return { mutationFn, ...mutationOptions };
};

export type PutCbeSettingsTermsAndConditionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof putCbeSettingsTermsAndConditions>>
>;

export type PutCbeSettingsTermsAndConditionsMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutCbeSettingsTermsAndConditions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putCbeSettingsTermsAndConditions>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPutCbeSettingsTermsAndConditionsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getCbeSettingsMatchSubscriptions = (signal?: AbortSignal) => {
  return customHttpClient<GetCbeSettingsMatchSubscriptions200>({
    url: `/cbe/settings/match-subscriptions`,
    method: 'GET',
    signal,
  });
};

export const getGetCbeSettingsMatchSubscriptionsQueryKey = () => {
  return [`/cbe/settings/match-subscriptions`] as const;
};

export const getGetCbeSettingsMatchSubscriptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCbeSettingsMatchSubscriptions>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCbeSettingsMatchSubscriptions>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCbeSettingsMatchSubscriptionsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCbeSettingsMatchSubscriptions>>> = ({ signal }) =>
    getCbeSettingsMatchSubscriptions(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCbeSettingsMatchSubscriptions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCbeSettingsMatchSubscriptionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCbeSettingsMatchSubscriptions>>
>;
export type GetCbeSettingsMatchSubscriptionsQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetCbeSettingsMatchSubscriptions = <
  TData = Awaited<ReturnType<typeof getCbeSettingsMatchSubscriptions>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCbeSettingsMatchSubscriptions>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCbeSettingsMatchSubscriptionsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const putCbeSettingsMatchSubscriptions = () => {
  return customHttpClient<PutCbeSettingsMatchSubscriptions200>({
    url: `/cbe/settings/match-subscriptions`,
    method: 'PUT',
  });
};

export const getPutCbeSettingsMatchSubscriptionsMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putCbeSettingsMatchSubscriptions>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof putCbeSettingsMatchSubscriptions>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof putCbeSettingsMatchSubscriptions>>, void> = () => {
    return putCbeSettingsMatchSubscriptions();
  };

  return { mutationFn, ...mutationOptions };
};

export type PutCbeSettingsMatchSubscriptionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof putCbeSettingsMatchSubscriptions>>
>;

export type PutCbeSettingsMatchSubscriptionsMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutCbeSettingsMatchSubscriptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putCbeSettingsMatchSubscriptions>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPutCbeSettingsMatchSubscriptionsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putCbeSettingsUpdateConstants = () => {
  return customHttpClient<PutCbeSettingsUpdateConstants200>({ url: `/cbe/settings/update-constants`, method: 'PUT' });
};

export const getPutCbeSettingsUpdateConstantsMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putCbeSettingsUpdateConstants>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof putCbeSettingsUpdateConstants>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof putCbeSettingsUpdateConstants>>, void> = () => {
    return putCbeSettingsUpdateConstants();
  };

  return { mutationFn, ...mutationOptions };
};

export type PutCbeSettingsUpdateConstantsMutationResult = NonNullable<
  Awaited<ReturnType<typeof putCbeSettingsUpdateConstants>>
>;

export type PutCbeSettingsUpdateConstantsMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutCbeSettingsUpdateConstants = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putCbeSettingsUpdateConstants>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPutCbeSettingsUpdateConstantsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postCbeSettingsTrackUsage = (postCbeSettingsTrackUsageBody: PostCbeSettingsTrackUsageBody) => {
  return customHttpClient<PostCbeSettingsTrackUsage200>({
    url: `/cbe/settings/track-usage`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postCbeSettingsTrackUsageBody,
  });
};

export const getPostCbeSettingsTrackUsageMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCbeSettingsTrackUsage>>,
    TError,
    { data: PostCbeSettingsTrackUsageBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCbeSettingsTrackUsage>>,
  TError,
  { data: PostCbeSettingsTrackUsageBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCbeSettingsTrackUsage>>,
    { data: PostCbeSettingsTrackUsageBody }
  > = (props) => {
    const { data } = props ?? {};

    return postCbeSettingsTrackUsage(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCbeSettingsTrackUsageMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCbeSettingsTrackUsage>>
>;
export type PostCbeSettingsTrackUsageMutationBody = PostCbeSettingsTrackUsageBody;
export type PostCbeSettingsTrackUsageMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostCbeSettingsTrackUsage = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCbeSettingsTrackUsage>>,
    TError,
    { data: PostCbeSettingsTrackUsageBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostCbeSettingsTrackUsageMutationOptions(options);

  return useMutation(mutationOptions);
};

export const putCbeSettingsPublicJobBodyTemplate = (
  putCbeSettingsPublicJobBodyTemplateBody: PutCbeSettingsPublicJobBodyTemplateBody,
) => {
  return customHttpClient<Success>({
    url: `/cbe/settings/public-job-body-template`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: putCbeSettingsPublicJobBodyTemplateBody,
  });
};

export const getPutCbeSettingsPublicJobBodyTemplateMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putCbeSettingsPublicJobBodyTemplate>>,
    TError,
    { data: PutCbeSettingsPublicJobBodyTemplateBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putCbeSettingsPublicJobBodyTemplate>>,
  TError,
  { data: PutCbeSettingsPublicJobBodyTemplateBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putCbeSettingsPublicJobBodyTemplate>>,
    { data: PutCbeSettingsPublicJobBodyTemplateBody }
  > = (props) => {
    const { data } = props ?? {};

    return putCbeSettingsPublicJobBodyTemplate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutCbeSettingsPublicJobBodyTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof putCbeSettingsPublicJobBodyTemplate>>
>;
export type PutCbeSettingsPublicJobBodyTemplateMutationBody = PutCbeSettingsPublicJobBodyTemplateBody;
export type PutCbeSettingsPublicJobBodyTemplateMutationError = Status400 | Status401 | Status403 | Status404;

export const usePutCbeSettingsPublicJobBodyTemplate = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putCbeSettingsPublicJobBodyTemplate>>,
    TError,
    { data: PutCbeSettingsPublicJobBodyTemplateBody },
    TContext
  >;
}) => {
  const mutationOptions = getPutCbeSettingsPublicJobBodyTemplateMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getCbeSettingsPublicJobBodyTemplate = (signal?: AbortSignal) => {
  return customHttpClient<GetCbeSettingsPublicJobBodyTemplate200>({
    url: `/cbe/settings/public-job-body-template`,
    method: 'GET',
    signal,
  });
};

export const getGetCbeSettingsPublicJobBodyTemplateQueryKey = () => {
  return [`/cbe/settings/public-job-body-template`] as const;
};

export const getGetCbeSettingsPublicJobBodyTemplateQueryOptions = <
  TData = Awaited<ReturnType<typeof getCbeSettingsPublicJobBodyTemplate>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCbeSettingsPublicJobBodyTemplate>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCbeSettingsPublicJobBodyTemplateQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCbeSettingsPublicJobBodyTemplate>>> = ({ signal }) =>
    getCbeSettingsPublicJobBodyTemplate(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCbeSettingsPublicJobBodyTemplate>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCbeSettingsPublicJobBodyTemplateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCbeSettingsPublicJobBodyTemplate>>
>;
export type GetCbeSettingsPublicJobBodyTemplateQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetCbeSettingsPublicJobBodyTemplate = <
  TData = Awaited<ReturnType<typeof getCbeSettingsPublicJobBodyTemplate>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getCbeSettingsPublicJobBodyTemplate>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCbeSettingsPublicJobBodyTemplateQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postSmsSendAutomaticSms = (postSmsSendAutomaticSmsBody: PostSmsSendAutomaticSmsBody) => {
  return customHttpClient<PostSmsSendAutomaticSms200>({
    url: `/sms/send-automatic-sms`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postSmsSendAutomaticSmsBody,
  });
};

export const getPostSmsSendAutomaticSmsMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSmsSendAutomaticSms>>,
    TError,
    { data: PostSmsSendAutomaticSmsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSmsSendAutomaticSms>>,
  TError,
  { data: PostSmsSendAutomaticSmsBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSmsSendAutomaticSms>>,
    { data: PostSmsSendAutomaticSmsBody }
  > = (props) => {
    const { data } = props ?? {};

    return postSmsSendAutomaticSms(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostSmsSendAutomaticSmsMutationResult = NonNullable<Awaited<ReturnType<typeof postSmsSendAutomaticSms>>>;
export type PostSmsSendAutomaticSmsMutationBody = PostSmsSendAutomaticSmsBody;
export type PostSmsSendAutomaticSmsMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostSmsSendAutomaticSms = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSmsSendAutomaticSms>>,
    TError,
    { data: PostSmsSendAutomaticSmsBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostSmsSendAutomaticSmsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postTwilioConnect = (postTwilioConnectBody: PostTwilioConnectBody) => {
  return customHttpClient<PostTwilioConnect200>({
    url: `/twilio/connect`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postTwilioConnectBody,
  });
};

export const getPostTwilioConnectMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTwilioConnect>>,
    TError,
    { data: PostTwilioConnectBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postTwilioConnect>>,
  TError,
  { data: PostTwilioConnectBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTwilioConnect>>, { data: PostTwilioConnectBody }> = (
    props,
  ) => {
    const { data } = props ?? {};

    return postTwilioConnect(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostTwilioConnectMutationResult = NonNullable<Awaited<ReturnType<typeof postTwilioConnect>>>;
export type PostTwilioConnectMutationBody = PostTwilioConnectBody;
export type PostTwilioConnectMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostTwilioConnect = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTwilioConnect>>,
    TError,
    { data: PostTwilioConnectBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostTwilioConnectMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postTwilioAction = (postTwilioActionBody: PostTwilioActionBody) => {
  return customHttpClient<PostTwilioAction200>({
    url: `/twilio/action`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postTwilioActionBody,
  });
};

export const getPostTwilioActionMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTwilioAction>>,
    TError,
    { data: PostTwilioActionBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postTwilioAction>>,
  TError,
  { data: PostTwilioActionBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTwilioAction>>, { data: PostTwilioActionBody }> = (
    props,
  ) => {
    const { data } = props ?? {};

    return postTwilioAction(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostTwilioActionMutationResult = NonNullable<Awaited<ReturnType<typeof postTwilioAction>>>;
export type PostTwilioActionMutationBody = PostTwilioActionBody;
export type PostTwilioActionMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostTwilioAction = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTwilioAction>>,
    TError,
    { data: PostTwilioActionBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostTwilioActionMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postTwilioStatus = (postTwilioStatusBody: PostTwilioStatusBody) => {
  return customHttpClient<PostTwilioStatus200>({
    url: `/twilio/status`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postTwilioStatusBody,
  });
};

export const getPostTwilioStatusMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTwilioStatus>>,
    TError,
    { data: PostTwilioStatusBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postTwilioStatus>>,
  TError,
  { data: PostTwilioStatusBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTwilioStatus>>, { data: PostTwilioStatusBody }> = (
    props,
  ) => {
    const { data } = props ?? {};

    return postTwilioStatus(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostTwilioStatusMutationResult = NonNullable<Awaited<ReturnType<typeof postTwilioStatus>>>;
export type PostTwilioStatusMutationBody = PostTwilioStatusBody;
export type PostTwilioStatusMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostTwilioStatus = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTwilioStatus>>,
    TError,
    { data: PostTwilioStatusBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostTwilioStatusMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postTwilioForwardTargetAgentId = (
  postTwilioForwardTargetAgentIdBody: PostTwilioForwardTargetAgentIdBody,
) => {
  return customHttpClient<PostTwilioForwardTargetAgentId200>({
    url: `/twilio/forward/:targetAgentId`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postTwilioForwardTargetAgentIdBody,
  });
};

export const getPostTwilioForwardTargetAgentIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTwilioForwardTargetAgentId>>,
    TError,
    { data: PostTwilioForwardTargetAgentIdBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postTwilioForwardTargetAgentId>>,
  TError,
  { data: PostTwilioForwardTargetAgentIdBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postTwilioForwardTargetAgentId>>,
    { data: PostTwilioForwardTargetAgentIdBody }
  > = (props) => {
    const { data } = props ?? {};

    return postTwilioForwardTargetAgentId(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostTwilioForwardTargetAgentIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof postTwilioForwardTargetAgentId>>
>;
export type PostTwilioForwardTargetAgentIdMutationBody = PostTwilioForwardTargetAgentIdBody;
export type PostTwilioForwardTargetAgentIdMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostTwilioForwardTargetAgentId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTwilioForwardTargetAgentId>>,
    TError,
    { data: PostTwilioForwardTargetAgentIdBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostTwilioForwardTargetAgentIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postTwilioFallback = (postTwilioFallbackBody: PostTwilioFallbackBody) => {
  return customHttpClient<PostTwilioFallback200>({
    url: `/twilio/fallback`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postTwilioFallbackBody,
  });
};

export const getPostTwilioFallbackMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTwilioFallback>>,
    TError,
    { data: PostTwilioFallbackBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postTwilioFallback>>,
  TError,
  { data: PostTwilioFallbackBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postTwilioFallback>>,
    { data: PostTwilioFallbackBody }
  > = (props) => {
    const { data } = props ?? {};

    return postTwilioFallback(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostTwilioFallbackMutationResult = NonNullable<Awaited<ReturnType<typeof postTwilioFallback>>>;
export type PostTwilioFallbackMutationBody = PostTwilioFallbackBody;
export type PostTwilioFallbackMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostTwilioFallback = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTwilioFallback>>,
    TError,
    { data: PostTwilioFallbackBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostTwilioFallbackMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postTwilioReachability = (postTwilioReachabilityBody: PostTwilioReachabilityBody) => {
  return customHttpClient<PostTwilioReachability200>({
    url: `/twilio/reachability`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postTwilioReachabilityBody,
  });
};

export const getPostTwilioReachabilityMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTwilioReachability>>,
    TError,
    { data: PostTwilioReachabilityBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postTwilioReachability>>,
  TError,
  { data: PostTwilioReachabilityBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postTwilioReachability>>,
    { data: PostTwilioReachabilityBody }
  > = (props) => {
    const { data } = props ?? {};

    return postTwilioReachability(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostTwilioReachabilityMutationResult = NonNullable<Awaited<ReturnType<typeof postTwilioReachability>>>;
export type PostTwilioReachabilityMutationBody = PostTwilioReachabilityBody;
export type PostTwilioReachabilityMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostTwilioReachability = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTwilioReachability>>,
    TError,
    { data: PostTwilioReachabilityBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostTwilioReachabilityMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postTwilioSmsConnect = (postTwilioSmsConnectBody: PostTwilioSmsConnectBody) => {
  return customHttpClient<PostTwilioSmsConnect200>({
    url: `/twilio/sms/connect`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postTwilioSmsConnectBody,
  });
};

export const getPostTwilioSmsConnectMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTwilioSmsConnect>>,
    TError,
    { data: PostTwilioSmsConnectBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postTwilioSmsConnect>>,
  TError,
  { data: PostTwilioSmsConnectBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postTwilioSmsConnect>>,
    { data: PostTwilioSmsConnectBody }
  > = (props) => {
    const { data } = props ?? {};

    return postTwilioSmsConnect(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostTwilioSmsConnectMutationResult = NonNullable<Awaited<ReturnType<typeof postTwilioSmsConnect>>>;
export type PostTwilioSmsConnectMutationBody = PostTwilioSmsConnectBody;
export type PostTwilioSmsConnectMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostTwilioSmsConnect = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTwilioSmsConnect>>,
    TError,
    { data: PostTwilioSmsConnectBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostTwilioSmsConnectMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postTwilioSmsAction = (postTwilioSmsActionBody: PostTwilioSmsActionBody) => {
  return customHttpClient<PostTwilioSmsAction200>({
    url: `/twilio/sms/action`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postTwilioSmsActionBody,
  });
};

export const getPostTwilioSmsActionMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTwilioSmsAction>>,
    TError,
    { data: PostTwilioSmsActionBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postTwilioSmsAction>>,
  TError,
  { data: PostTwilioSmsActionBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postTwilioSmsAction>>,
    { data: PostTwilioSmsActionBody }
  > = (props) => {
    const { data } = props ?? {};

    return postTwilioSmsAction(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostTwilioSmsActionMutationResult = NonNullable<Awaited<ReturnType<typeof postTwilioSmsAction>>>;
export type PostTwilioSmsActionMutationBody = PostTwilioSmsActionBody;
export type PostTwilioSmsActionMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostTwilioSmsAction = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTwilioSmsAction>>,
    TError,
    { data: PostTwilioSmsActionBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostTwilioSmsActionMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postTwilioSmsStatus = (postTwilioSmsStatusBody: PostTwilioSmsStatusBody) => {
  return customHttpClient<PostTwilioSmsStatus200>({
    url: `/twilio/sms/status`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postTwilioSmsStatusBody,
  });
};

export const getPostTwilioSmsStatusMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTwilioSmsStatus>>,
    TError,
    { data: PostTwilioSmsStatusBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postTwilioSmsStatus>>,
  TError,
  { data: PostTwilioSmsStatusBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postTwilioSmsStatus>>,
    { data: PostTwilioSmsStatusBody }
  > = (props) => {
    const { data } = props ?? {};

    return postTwilioSmsStatus(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostTwilioSmsStatusMutationResult = NonNullable<Awaited<ReturnType<typeof postTwilioSmsStatus>>>;
export type PostTwilioSmsStatusMutationBody = PostTwilioSmsStatusBody;
export type PostTwilioSmsStatusMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostTwilioSmsStatus = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTwilioSmsStatus>>,
    TError,
    { data: PostTwilioSmsStatusBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostTwilioSmsStatusMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postTwilioSmsFallback = (postTwilioSmsFallbackBody: PostTwilioSmsFallbackBody) => {
  return customHttpClient<PostTwilioSmsFallback200>({
    url: `/twilio/sms/fallback`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postTwilioSmsFallbackBody,
  });
};

export const getPostTwilioSmsFallbackMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTwilioSmsFallback>>,
    TError,
    { data: PostTwilioSmsFallbackBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postTwilioSmsFallback>>,
  TError,
  { data: PostTwilioSmsFallbackBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postTwilioSmsFallback>>,
    { data: PostTwilioSmsFallbackBody }
  > = (props) => {
    const { data } = props ?? {};

    return postTwilioSmsFallback(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostTwilioSmsFallbackMutationResult = NonNullable<Awaited<ReturnType<typeof postTwilioSmsFallback>>>;
export type PostTwilioSmsFallbackMutationBody = PostTwilioSmsFallbackBody;
export type PostTwilioSmsFallbackMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostTwilioSmsFallback = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTwilioSmsFallback>>,
    TError,
    { data: PostTwilioSmsFallbackBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostTwilioSmsFallbackMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postTwilioSmsReachability = (postTwilioSmsReachabilityBody: PostTwilioSmsReachabilityBody) => {
  return customHttpClient<PostTwilioSmsReachability200>({
    url: `/twilio/sms/reachability`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postTwilioSmsReachabilityBody,
  });
};

export const getPostTwilioSmsReachabilityMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTwilioSmsReachability>>,
    TError,
    { data: PostTwilioSmsReachabilityBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postTwilioSmsReachability>>,
  TError,
  { data: PostTwilioSmsReachabilityBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postTwilioSmsReachability>>,
    { data: PostTwilioSmsReachabilityBody }
  > = (props) => {
    const { data } = props ?? {};

    return postTwilioSmsReachability(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostTwilioSmsReachabilityMutationResult = NonNullable<
  Awaited<ReturnType<typeof postTwilioSmsReachability>>
>;
export type PostTwilioSmsReachabilityMutationBody = PostTwilioSmsReachabilityBody;
export type PostTwilioSmsReachabilityMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostTwilioSmsReachability = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTwilioSmsReachability>>,
    TError,
    { data: PostTwilioSmsReachabilityBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostTwilioSmsReachabilityMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postTwilioGenerate = (postTwilioGenerateBody: PostTwilioGenerateBody) => {
  return customHttpClient<PostTwilioGenerate200>({
    url: `/twilio/generate`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postTwilioGenerateBody,
  });
};

export const getPostTwilioGenerateMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTwilioGenerate>>,
    TError,
    { data: PostTwilioGenerateBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postTwilioGenerate>>,
  TError,
  { data: PostTwilioGenerateBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postTwilioGenerate>>,
    { data: PostTwilioGenerateBody }
  > = (props) => {
    const { data } = props ?? {};

    return postTwilioGenerate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostTwilioGenerateMutationResult = NonNullable<Awaited<ReturnType<typeof postTwilioGenerate>>>;
export type PostTwilioGenerateMutationBody = PostTwilioGenerateBody;
export type PostTwilioGenerateMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostTwilioGenerate = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTwilioGenerate>>,
    TError,
    { data: PostTwilioGenerateBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostTwilioGenerateMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postTwilioRedirectCall = (postTwilioRedirectCallBody: PostTwilioRedirectCallBody) => {
  return customHttpClient<PostTwilioRedirectCall200>({
    url: `/twilio/redirect-call`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postTwilioRedirectCallBody,
  });
};

export const getPostTwilioRedirectCallMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTwilioRedirectCall>>,
    TError,
    { data: PostTwilioRedirectCallBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postTwilioRedirectCall>>,
  TError,
  { data: PostTwilioRedirectCallBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postTwilioRedirectCall>>,
    { data: PostTwilioRedirectCallBody }
  > = (props) => {
    const { data } = props ?? {};

    return postTwilioRedirectCall(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostTwilioRedirectCallMutationResult = NonNullable<Awaited<ReturnType<typeof postTwilioRedirectCall>>>;
export type PostTwilioRedirectCallMutationBody = PostTwilioRedirectCallBody;
export type PostTwilioRedirectCallMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostTwilioRedirectCall = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTwilioRedirectCall>>,
    TError,
    { data: PostTwilioRedirectCallBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostTwilioRedirectCallMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postUtilsSetGettingStartedPageStaticPageId = (
  postUtilsSetGettingStartedPageStaticPageIdBody: PostUtilsSetGettingStartedPageStaticPageIdBody,
) => {
  return customHttpClient<PostUtilsSetGettingStartedPageStaticPageId200>({
    url: `/utils/set-getting-started-page/:staticPageId`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postUtilsSetGettingStartedPageStaticPageIdBody,
  });
};

export const getPostUtilsSetGettingStartedPageStaticPageIdMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postUtilsSetGettingStartedPageStaticPageId>>,
    TError,
    { data: PostUtilsSetGettingStartedPageStaticPageIdBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postUtilsSetGettingStartedPageStaticPageId>>,
  TError,
  { data: PostUtilsSetGettingStartedPageStaticPageIdBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postUtilsSetGettingStartedPageStaticPageId>>,
    { data: PostUtilsSetGettingStartedPageStaticPageIdBody }
  > = (props) => {
    const { data } = props ?? {};

    return postUtilsSetGettingStartedPageStaticPageId(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostUtilsSetGettingStartedPageStaticPageIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof postUtilsSetGettingStartedPageStaticPageId>>
>;
export type PostUtilsSetGettingStartedPageStaticPageIdMutationBody = PostUtilsSetGettingStartedPageStaticPageIdBody;
export type PostUtilsSetGettingStartedPageStaticPageIdMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostUtilsSetGettingStartedPageStaticPageId = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postUtilsSetGettingStartedPageStaticPageId>>,
    TError,
    { data: PostUtilsSetGettingStartedPageStaticPageIdBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostUtilsSetGettingStartedPageStaticPageIdMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postUtilsEvaGreetings = (postUtilsEvaGreetingsBody: PostUtilsEvaGreetingsBody) => {
  return customHttpClient<PostUtilsEvaGreetings200>({
    url: `/utils/eva-greetings`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postUtilsEvaGreetingsBody,
  });
};

export const getPostUtilsEvaGreetingsMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postUtilsEvaGreetings>>,
    TError,
    { data: PostUtilsEvaGreetingsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postUtilsEvaGreetings>>,
  TError,
  { data: PostUtilsEvaGreetingsBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postUtilsEvaGreetings>>,
    { data: PostUtilsEvaGreetingsBody }
  > = (props) => {
    const { data } = props ?? {};

    return postUtilsEvaGreetings(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostUtilsEvaGreetingsMutationResult = NonNullable<Awaited<ReturnType<typeof postUtilsEvaGreetings>>>;
export type PostUtilsEvaGreetingsMutationBody = PostUtilsEvaGreetingsBody;
export type PostUtilsEvaGreetingsMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostUtilsEvaGreetings = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postUtilsEvaGreetings>>,
    TError,
    { data: PostUtilsEvaGreetingsBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostUtilsEvaGreetingsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postUtilsResetGettingStartedPage = (
  postUtilsResetGettingStartedPageBody: PostUtilsResetGettingStartedPageBody,
) => {
  return customHttpClient<PostUtilsResetGettingStartedPage200>({
    url: `/utils/reset-getting-started-page`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postUtilsResetGettingStartedPageBody,
  });
};

export const getPostUtilsResetGettingStartedPageMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postUtilsResetGettingStartedPage>>,
    TError,
    { data: PostUtilsResetGettingStartedPageBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postUtilsResetGettingStartedPage>>,
  TError,
  { data: PostUtilsResetGettingStartedPageBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postUtilsResetGettingStartedPage>>,
    { data: PostUtilsResetGettingStartedPageBody }
  > = (props) => {
    const { data } = props ?? {};

    return postUtilsResetGettingStartedPage(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostUtilsResetGettingStartedPageMutationResult = NonNullable<
  Awaited<ReturnType<typeof postUtilsResetGettingStartedPage>>
>;
export type PostUtilsResetGettingStartedPageMutationBody = PostUtilsResetGettingStartedPageBody;
export type PostUtilsResetGettingStartedPageMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostUtilsResetGettingStartedPage = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postUtilsResetGettingStartedPage>>,
    TError,
    { data: PostUtilsResetGettingStartedPageBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostUtilsResetGettingStartedPageMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postUtilsResetCache = (postUtilsResetCacheBody: PostUtilsResetCacheBody) => {
  return customHttpClient<PostUtilsResetCache200>({
    url: `/utils/reset-cache`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postUtilsResetCacheBody,
  });
};

export const getPostUtilsResetCacheMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postUtilsResetCache>>,
    TError,
    { data: PostUtilsResetCacheBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postUtilsResetCache>>,
  TError,
  { data: PostUtilsResetCacheBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postUtilsResetCache>>,
    { data: PostUtilsResetCacheBody }
  > = (props) => {
    const { data } = props ?? {};

    return postUtilsResetCache(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostUtilsResetCacheMutationResult = NonNullable<Awaited<ReturnType<typeof postUtilsResetCache>>>;
export type PostUtilsResetCacheMutationBody = PostUtilsResetCacheBody;
export type PostUtilsResetCacheMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostUtilsResetCache = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postUtilsResetCache>>,
    TError,
    { data: PostUtilsResetCacheBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostUtilsResetCacheMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postUtilsResetTenantsCache = (postUtilsResetTenantsCacheBody: PostUtilsResetTenantsCacheBody) => {
  return customHttpClient<PostUtilsResetTenantsCache200>({
    url: `/utils/reset-tenants-cache`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postUtilsResetTenantsCacheBody,
  });
};

export const getPostUtilsResetTenantsCacheMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postUtilsResetTenantsCache>>,
    TError,
    { data: PostUtilsResetTenantsCacheBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postUtilsResetTenantsCache>>,
  TError,
  { data: PostUtilsResetTenantsCacheBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postUtilsResetTenantsCache>>,
    { data: PostUtilsResetTenantsCacheBody }
  > = (props) => {
    const { data } = props ?? {};

    return postUtilsResetTenantsCache(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostUtilsResetTenantsCacheMutationResult = NonNullable<
  Awaited<ReturnType<typeof postUtilsResetTenantsCache>>
>;
export type PostUtilsResetTenantsCacheMutationBody = PostUtilsResetTenantsCacheBody;
export type PostUtilsResetTenantsCacheMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostUtilsResetTenantsCache = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postUtilsResetTenantsCache>>,
    TError,
    { data: PostUtilsResetTenantsCacheBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostUtilsResetTenantsCacheMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postUtilsFailureTest = () => {
  return customHttpClient<PostUtilsFailureTest200>({ url: `/utils/failure-test`, method: 'POST' });
};

export const getPostUtilsFailureTestMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postUtilsFailureTest>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof postUtilsFailureTest>>, TError, void, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUtilsFailureTest>>, void> = () => {
    return postUtilsFailureTest();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostUtilsFailureTestMutationResult = NonNullable<Awaited<ReturnType<typeof postUtilsFailureTest>>>;

export type PostUtilsFailureTestMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostUtilsFailureTest = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postUtilsFailureTest>>, TError, void, TContext>;
}) => {
  const mutationOptions = getPostUtilsFailureTestMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postUtilsFeatures = (postUtilsFeaturesBody: PostUtilsFeaturesBody) => {
  return customHttpClient<PostUtilsFeatures200>({
    url: `/utils/features`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postUtilsFeaturesBody,
  });
};

export const getPostUtilsFeaturesMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postUtilsFeatures>>,
    TError,
    { data: PostUtilsFeaturesBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postUtilsFeatures>>,
  TError,
  { data: PostUtilsFeaturesBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUtilsFeatures>>, { data: PostUtilsFeaturesBody }> = (
    props,
  ) => {
    const { data } = props ?? {};

    return postUtilsFeatures(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostUtilsFeaturesMutationResult = NonNullable<Awaited<ReturnType<typeof postUtilsFeatures>>>;
export type PostUtilsFeaturesMutationBody = PostUtilsFeaturesBody;
export type PostUtilsFeaturesMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostUtilsFeatures = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postUtilsFeatures>>,
    TError,
    { data: PostUtilsFeaturesBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostUtilsFeaturesMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postUtilsWorkerTaskTask = (postUtilsWorkerTaskTaskBody: PostUtilsWorkerTaskTaskBody) => {
  return customHttpClient<PostUtilsWorkerTaskTask200>({
    url: `/utils/worker/task/:task`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postUtilsWorkerTaskTaskBody,
  });
};

export const getPostUtilsWorkerTaskTaskMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postUtilsWorkerTaskTask>>,
    TError,
    { data: PostUtilsWorkerTaskTaskBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postUtilsWorkerTaskTask>>,
  TError,
  { data: PostUtilsWorkerTaskTaskBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postUtilsWorkerTaskTask>>,
    { data: PostUtilsWorkerTaskTaskBody }
  > = (props) => {
    const { data } = props ?? {};

    return postUtilsWorkerTaskTask(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostUtilsWorkerTaskTaskMutationResult = NonNullable<Awaited<ReturnType<typeof postUtilsWorkerTaskTask>>>;
export type PostUtilsWorkerTaskTaskMutationBody = PostUtilsWorkerTaskTaskBody;
export type PostUtilsWorkerTaskTaskMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostUtilsWorkerTaskTask = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postUtilsWorkerTaskTask>>,
    TError,
    { data: PostUtilsWorkerTaskTaskBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostUtilsWorkerTaskTaskMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postWebchatsRead = (postWebchatsReadBody: PostWebchatsReadBody) => {
  return customHttpClient<PostWebchatsRead200>({
    url: `/webchats/read`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postWebchatsReadBody,
  });
};

export const getPostWebchatsReadMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postWebchatsRead>>,
    TError,
    { data: PostWebchatsReadBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postWebchatsRead>>,
  TError,
  { data: PostWebchatsReadBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postWebchatsRead>>, { data: PostWebchatsReadBody }> = (
    props,
  ) => {
    const { data } = props ?? {};

    return postWebchatsRead(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostWebchatsReadMutationResult = NonNullable<Awaited<ReturnType<typeof postWebchatsRead>>>;
export type PostWebchatsReadMutationBody = PostWebchatsReadBody;
export type PostWebchatsReadMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostWebchatsRead = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postWebchatsRead>>,
    TError,
    { data: PostWebchatsReadBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostWebchatsReadMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getWebchatsMessages = (signal?: AbortSignal) => {
  return customHttpClient<GetWebchatsMessages200>({ url: `/webchats/messages`, method: 'GET', signal });
};

export const getGetWebchatsMessagesQueryKey = () => {
  return [`/webchats/messages`] as const;
};

export const getGetWebchatsMessagesQueryOptions = <
  TData = Awaited<ReturnType<typeof getWebchatsMessages>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getWebchatsMessages>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetWebchatsMessagesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getWebchatsMessages>>> = ({ signal }) =>
    getWebchatsMessages(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getWebchatsMessages>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWebchatsMessagesQueryResult = NonNullable<Awaited<ReturnType<typeof getWebchatsMessages>>>;
export type GetWebchatsMessagesQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetWebchatsMessages = <
  TData = Awaited<ReturnType<typeof getWebchatsMessages>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getWebchatsMessages>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetWebchatsMessagesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getWebhooksLastUnrecognised = (signal?: AbortSignal) => {
  return customHttpClient<GetWebhooksLastUnrecognised200>({
    url: `/webhooks/last-unrecognised`,
    method: 'GET',
    signal,
  });
};

export const getGetWebhooksLastUnrecognisedQueryKey = () => {
  return [`/webhooks/last-unrecognised`] as const;
};

export const getGetWebhooksLastUnrecognisedQueryOptions = <
  TData = Awaited<ReturnType<typeof getWebhooksLastUnrecognised>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getWebhooksLastUnrecognised>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetWebhooksLastUnrecognisedQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getWebhooksLastUnrecognised>>> = ({ signal }) =>
    getWebhooksLastUnrecognised(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getWebhooksLastUnrecognised>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWebhooksLastUnrecognisedQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWebhooksLastUnrecognised>>
>;
export type GetWebhooksLastUnrecognisedQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetWebhooksLastUnrecognised = <
  TData = Awaited<ReturnType<typeof getWebhooksLastUnrecognised>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getWebhooksLastUnrecognised>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetWebhooksLastUnrecognisedQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getZipRecruiterJobsFeed = (signal?: AbortSignal) => {
  return customHttpClient<GetZipRecruiterJobsFeed200>({ url: `/zip-recruiter/jobs-feed`, method: 'GET', signal });
};

export const getGetZipRecruiterJobsFeedQueryKey = () => {
  return [`/zip-recruiter/jobs-feed`] as const;
};

export const getGetZipRecruiterJobsFeedQueryOptions = <
  TData = Awaited<ReturnType<typeof getZipRecruiterJobsFeed>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getZipRecruiterJobsFeed>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetZipRecruiterJobsFeedQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getZipRecruiterJobsFeed>>> = ({ signal }) =>
    getZipRecruiterJobsFeed(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getZipRecruiterJobsFeed>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetZipRecruiterJobsFeedQueryResult = NonNullable<Awaited<ReturnType<typeof getZipRecruiterJobsFeed>>>;
export type GetZipRecruiterJobsFeedQueryError = Status400 | Status401 | Status403 | Status404;

export const useGetZipRecruiterJobsFeed = <
  TData = Awaited<ReturnType<typeof getZipRecruiterJobsFeed>>,
  TError = Status400 | Status401 | Status403 | Status404,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getZipRecruiterJobsFeed>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetZipRecruiterJobsFeedQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const postZipRecruiterCandidateApply = (
  postZipRecruiterCandidateApplyBody: PostZipRecruiterCandidateApplyBody,
) => {
  return customHttpClient<PostZipRecruiterCandidateApply200>({
    url: `/zip-recruiter/candidate-apply`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postZipRecruiterCandidateApplyBody,
  });
};

export const getPostZipRecruiterCandidateApplyMutationOptions = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postZipRecruiterCandidateApply>>,
    TError,
    { data: PostZipRecruiterCandidateApplyBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postZipRecruiterCandidateApply>>,
  TError,
  { data: PostZipRecruiterCandidateApplyBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postZipRecruiterCandidateApply>>,
    { data: PostZipRecruiterCandidateApplyBody }
  > = (props) => {
    const { data } = props ?? {};

    return postZipRecruiterCandidateApply(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostZipRecruiterCandidateApplyMutationResult = NonNullable<
  Awaited<ReturnType<typeof postZipRecruiterCandidateApply>>
>;
export type PostZipRecruiterCandidateApplyMutationBody = PostZipRecruiterCandidateApplyBody;
export type PostZipRecruiterCandidateApplyMutationError = Status400 | Status401 | Status403 | Status404;

export const usePostZipRecruiterCandidateApply = <
  TError = Status400 | Status401 | Status403 | Status404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postZipRecruiterCandidateApply>>,
    TError,
    { data: PostZipRecruiterCandidateApplyBody },
    TContext
  >;
}) => {
  const mutationOptions = getPostZipRecruiterCandidateApplyMutationOptions(options);

  return useMutation(mutationOptions);
};
